import {
  createAnnotatedEnumSerializer20ay4pme9p2h9 as createAnnotatedEnumSerializer,
  createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import {
  lazy1261dae0bgscp as lazy,
  lazy2hsh8ze7j6ikd as lazy_0,
} from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../../lightning-server-shared/com/lightningkite/UUID.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
  $serializer_getInstance3n2rtjb4no11s as $serializer_getInstance,
  $serializer_getInstance1m1pty9fgkr0g as $serializer_getInstance_0,
  $serializer_getInstancegem3nsjl63vn as $serializer_getInstance_1,
  $serializer_getInstance3qhgvjcaya2da as $serializer_getInstance_2,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  _MonetaryValue___init__impl__jsc11x21b8u6q6nd7yd as _MonetaryValue___init__impl__jsc11x,
  $serializer_getInstance3fydoi3p4w54x as $serializer_getInstance_3,
  $serializer_getInstancet3nsskmepj66 as $serializer_getInstance_4,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__hashCode_impl_fhcsz25lnxnw796huh as MonetaryValue__hashCode_impl_fhcsz2,
  LineItemInterface2ct3y0vtnbxod as LineItemInterface,
  $serializer_getInstance1wv5hjws0bfh6 as $serializer_getInstance_5,
  $serializer_getInstance5xj5u9f3kifs as $serializer_getInstance_6,
  $serializer_getInstance24oainjoildlv as $serializer_getInstance_7,
  get_withdrawn1jcms7jq46kqk as get_withdrawn,
  ItemChangeInterface3dt2mjp367emm as ItemChangeInterface,
  ChangeRequestItem25pmay5za3qvv as ChangeRequestItem,
  $serializer_getInstancelpjkd3aykg3n as $serializer_getInstance_8,
  DrawTableItemvon7hn1chfhu as DrawTableItem,
  $serializer_getInstancempe4dljrfaa1 as $serializer_getInstance_9,
  $serializer_getInstancephvhog69rda1 as $serializer_getInstance_10,
  Companion_getInstance3c3yiwvq39b64 as Companion_getInstance_0,
  copy$defaultre0p5zwdb0iv as copy$default,
  SpecViewgfdgv6h7w5ti as SpecView,
  ScopeGroupsc04cnao6ys4 as ScopeGroup,
  $serializer_getInstance3ili9vinccewy as $serializer_getInstance_11,
  $serializer_getInstance36u72gmfjreba as $serializer_getInstance_12,
} from './supportModels.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  Multilineo47h3baoeckd as Multiline,
  Denormalizedb7mfi9hagcb1 as Denormalized,
  Index19x9ylte4qic1 as Index,
  References1cc2ge45k8vol as References,
  MultipleReferences1olws9tt2t5e6 as MultipleReferences,
  Unique2l35ftvvs34wx as Unique,
  AdminViewOnly2m1t9bs9xa6rn as AdminViewOnly,
  IndexSet1wbu7in7fosv3 as IndexSet,
  UniqueSet327q26ziuapen as UniqueSet,
  Description2bxny7ww0bbw3 as Description,
  AdminTableColumns2kd3zhffh08h8 as AdminTableColumns,
} from '../../../lightning-server-shared/com/lightningkite/lightningdb/Annotations.mjs';
import {
  Companion_instance1i4n4o7mef2za as Companion_instance_0,
  System_instance3dr57gee6r420 as System_instance,
} from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  DoubleSerializer_getInstance3da4hv5ndgjlx as DoubleSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
  FloatSerializer_getInstance2fspe61zbqree as FloatSerializer_getInstance,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  throwArrayMissingFieldExceptionbk1mj238w44a as throwArrayMissingFieldException,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../lightning-server-shared/com/lightningkite/lightningdb/HasId.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import {
  Companion_getInstance68aky2bnsasg as Companion_getInstance_1,
  LineItemState_NotStarted_getInstance3brd4lyoananz as LineItemState_NotStarted_getInstance,
  Companion_getInstance1i8v5a4alj7fe as Companion_getInstance_2,
  Companion_getInstance24kv293bymss5 as Companion_getInstance_3,
  Companion_getInstancex9879gcn3f42 as Companion_getInstance_4,
  PreferredTitle_Contractor_getInstance1vu9hnmofbdy6 as PreferredTitle_Contractor_getInstance,
  ContractorStatus_Registering_getInstance9wzvdghru4x2 as ContractorStatus_Registering_getInstance,
  Companion_getInstance3oueq6ubvzdqu as Companion_getInstance_5,
  IncidentState_Filed_getInstanceg9puzn4wq1pv as IncidentState_Filed_getInstance,
  ChangeType_Modify_getInstance2320ide7eqjcd as ChangeType_Modify_getInstance,
  ChangeType_Remove_getInstance2qh3m0yr0lh4w as ChangeType_Remove_getInstance,
  Companion_getInstance3bhagfzu8ngcb as Companion_getInstance_6,
  ChangeType_New_getInstance3fouji82nef8w as ChangeType_New_getInstance,
  Companion_getInstance1toq7c46z6qs1 as Companion_getInstance_7,
  ProjectState_Creating_getInstancegu71uom71mst as ProjectState_Creating_getInstance,
  Companion_getInstance3jlmhbtm50921 as Companion_getInstance_8,
  Companion_getInstance3soflne3we53q as Companion_getInstance_9,
  Companion_getInstance8z0585d1ojl8 as Companion_getInstance_10,
} from './enums.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { MonetaryRange1i296pttqy20q as MonetaryRange } from './annotations.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { ReadByDataModel1nk4gz5mxza5s as ReadByDataModel } from './readReceipts.mjs';
import {
  Reorderable3ea4zkahqiq6k as Reorderable,
  compareTobo60qch4pcdz as compareTo,
} from './Reorderable.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter,
  isBlank1dvkhjjvox3p0 as isBlank,
  padStart36w1507hs626a as padStart,
} from '../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { plus18eogev54fmsa as plus } from '../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  ServerFile__hashCode_impl_qj0ii515d8xjm2d7n5l as ServerFile__hashCode_impl_qj0ii5,
  ServerFile__toString_impl_4rulpa1zv5xkbnowbd9 as ServerFile__toString_impl_4rulpa,
} from '../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import {
  Companion_getInstance240fx64zw6f6d as Companion_getInstance_11,
  ClientConcern_Other_getInstancezoo09lwnn20e as ClientConcern_Other_getInstance,
} from './incidentResponse/IncidentResponseType.mjs';
import {
  $serializer_getInstance11as8uk2vr4gi as $serializer_getInstance_13,
  parseResponsezbt0whvcgfcx as parseResponse,
} from './incidentResponse/serialization.mjs';
import {
  $serializer_getInstance31wv99ymyppht as $serializer_getInstance_14,
  parseResponse1q1zzu6g2wzqi as parseResponse_0,
} from './completionResponse/serialization.mjs';
import { coerceAtLeast3jlgfquiyquc9 as coerceAtLeast } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { Companion_getInstance2n82k3fb4nex0 as Companion_getInstance_12 } from './paymentModels.mjs';
import {
  Duration5ynfiptaqcrg as Duration,
  Duration__hashCode_impl_u4exz629donm5f9ouki as Duration__hashCode_impl_u4exz6,
} from '../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationSerializer_getInstanceo50ej00g6vz5 as DurationSerializer_getInstance } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import {
  EmailAddressSerializer_getInstanceu3ltgmcd8ai as EmailAddressSerializer_getInstance,
  EmailAddress1n0o8cqqfp9qz as EmailAddress,
  PhoneNumberSerializer_getInstance2oi38jtxahgwm as PhoneNumberSerializer_getInstance,
  PhoneNumber2x98iurnwvnj9 as PhoneNumber,
  EmailAddress__toString_impl_artjh32mgb4pan49acs as EmailAddress__toString_impl_artjh3,
  PhoneNumber__toString_impl_7i2x3q276u0h00tg72g as PhoneNumber__toString_impl_7i2x3q,
  EmailAddress__hashCode_impl_wizg9y17d6wnfa2ztdr as EmailAddress__hashCode_impl_wizg9y,
  PhoneNumber__hashCode_impl_t98twl1f2h2fisb0rc2 as PhoneNumber__hashCode_impl_t98twl,
} from '../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { compareTo3ankvs086tmwq as compareTo_0 } from '../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { toString1h6jjoch8cjt8 as toString_1 } from '../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { Default_getInstance3u4i6y54ri5cn as Default_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { LocalDateIso8601Serializer_getInstanceny1y5h6nyej8 as LocalDateIso8601Serializer_getInstance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.u8r_1.f2();
}
function CrowPayLegalDocument$Type$Companion$_anonymous__ut8r8() {
  var tmp = values();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = ['terms-and-conditions', 'privacy-policy'];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [null, null];
  return createAnnotatedEnumSerializer('com.crowpay.CrowPayLegalDocument.Type', tmp, tmp_0, tmp$ret$5, null);
}
var Type_TermsAndConditions_instance;
var Type_PrivacyPolicy_instance;
function values() {
  return [Type_TermsAndConditions_getInstance(), Type_PrivacyPolicy_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.u8r_1 = lazy(tmp_0, CrowPayLegalDocument$Type$Companion$_anonymous__ut8r8);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance_13() {
  Type_initEntries();
  if (Companion_instance_1 === VOID)
    new (Companion())();
  return Companion_instance_1;
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_TermsAndConditions_instance = Type().f91('TermsAndConditions', 0, 'Stoze Terms And Conditions');
  Type_PrivacyPolicy_instance = Type().f91('PrivacyPolicy', 1, 'Privacy Policy');
  Companion_getInstance_13();
}
var $ENTRIES;
function CrowPayLegalDocument$Companion$$childSerializers$_anonymous__f5bx6h() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function CrowPayLegalDocument$Companion$$childSerializers$_anonymous__f5bx6h_0() {
  return Companion_getInstance_13().m2a();
}
function CrowPayLegalDocument$Companion$$childSerializers$_anonymous__f5bx6h_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var TypeClass;
function Type() {
  if (TypeClass === VOID) {
    class $ extends Enum() {
      static f91(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.e91_1 = displayName;
        return $this;
      }
      g90() {
        return this.e91_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'Type', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_13});
    TypeClass = $;
  }
  return TypeClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, CrowPayLegalDocument$Companion$$childSerializers$_anonymous__f5bx6h);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, CrowPayLegalDocument$Companion$$childSerializers$_anonymous__f5bx6h_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.t5u_1 = [tmp_1, tmp_3, lazy(tmp_4, CrowPayLegalDocument$Companion$$childSerializers$_anonymous__f5bx6h_1), null, null];
      }
      m2a() {
        return $serializer_getInstance_15();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_2;
function Companion_getInstance_14() {
  if (Companion_instance_2 === VOID)
    new (Companion_0())();
  return Companion_instance_2;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.CrowPayLegalDocument', this, 5);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('type', true);
        tmp0_serialDesc.c1b('establishedAt', true);
        tmp0_serialDesc.c1b('contents', false);
        tmp0_serialDesc.d1b(new (Multiline())());
        tmp0_serialDesc.c1b('version', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        this.g91_1 = tmp0_serialDesc;
      }
      h91(encoder, value) {
        var tmp0_desc = this.g91_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_14().t5u_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.a5v_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.a5v_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !value.b5v_1.equals(Type_TermsAndConditions_getInstance())) {
          tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.b5v_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 2)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp = !value.c5v_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.c5v_1);
        }
        tmp1_output.a15(tmp0_desc, 3, value.d5v_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.e5v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, StringSerializer_getInstance(), value.e5v_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.h91(encoder, value instanceof CrowPayLegalDocument() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.g91_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_14().t5u_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, tmp10_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, tmp10_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, tmp10_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, tmp10_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return CrowPayLegalDocument().i91(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.g91_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_14().t5u_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_15() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function Type_TermsAndConditions_getInstance() {
  Type_initEntries();
  return Type_TermsAndConditions_instance;
}
function Type_PrivacyPolicy_getInstance() {
  Type_initEntries();
  return Type_PrivacyPolicy_instance;
}
var CrowPayLegalDocumentClass;
function CrowPayLegalDocument() {
  if (CrowPayLegalDocumentClass === VOID) {
    class $ {
      constructor(_id, type, establishedAt, contents, version) {
        Companion_getInstance_14();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        type = type === VOID ? Type_TermsAndConditions_getInstance() : type;
        var tmp;
        if (establishedAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = establishedAt;
        }
        establishedAt = tmp;
        version = version === VOID ? null : version;
        this.a5v_1 = _id;
        this.b5v_1 = type;
        this.c5v_1 = establishedAt;
        this.d5v_1 = contents;
        this.e5v_1 = version;
      }
      h40() {
        return this.a5v_1;
      }
      j91(_id, type, establishedAt, contents, version) {
        return new (CrowPayLegalDocument())(_id, type, establishedAt, contents, version);
      }
      g5v(_id, type, establishedAt, contents, version, $super) {
        _id = _id === VOID ? this.a5v_1 : _id;
        type = type === VOID ? this.b5v_1 : type;
        establishedAt = establishedAt === VOID ? this.c5v_1 : establishedAt;
        contents = contents === VOID ? this.d5v_1 : contents;
        version = version === VOID ? this.e5v_1 : version;
        return $super === VOID ? this.j91(_id, type, establishedAt, contents, version) : $super.j91.call(this, _id, type, establishedAt, contents, version);
      }
      toString() {
        return 'CrowPayLegalDocument(_id=' + this.a5v_1.toString() + ', type=' + toString(this.b5v_1) + ', establishedAt=' + this.c5v_1.toString() + ', contents=' + this.d5v_1 + ', version=' + this.e5v_1 + ')';
      }
      hashCode() {
        var result = this.a5v_1.hashCode();
        result = imul(result, 31) + this.b5v_1.hashCode() | 0;
        result = imul(result, 31) + this.c5v_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.d5v_1) | 0;
        result = imul(result, 31) + (this.e5v_1 == null ? 0 : getStringHashCode(this.e5v_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CrowPayLegalDocument()))
          return false;
        if (!this.a5v_1.equals(other.a5v_1))
          return false;
        if (!this.b5v_1.equals(other.b5v_1))
          return false;
        if (!this.c5v_1.equals(other.c5v_1))
          return false;
        if (!(this.d5v_1 === other.d5v_1))
          return false;
        if (!(this.e5v_1 == other.e5v_1))
          return false;
        return true;
      }
      static i91(seen0, _id, type, establishedAt, contents, version, serializationConstructorMarker) {
        Companion_getInstance_14();
        if (!(8 === (8 & seen0))) {
          throwMissingFieldException(seen0, 8, $serializer_getInstance_15().g91_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.a5v_1 = Companion_getInstance().m2p();
        else
          $this.a5v_1 = _id;
        if (0 === (seen0 & 2))
          $this.b5v_1 = Type_TermsAndConditions_getInstance();
        else
          $this.b5v_1 = type;
        if (0 === (seen0 & 4)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.c5v_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.c5v_1 = establishedAt;
        $this.d5v_1 = contents;
        if (0 === (seen0 & 16))
          $this.e5v_1 = null;
        else
          $this.e5v_1 = version;
        return $this;
      }
    }
    initMetadataForClass($, 'CrowPayLegalDocument', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_15});
    CrowPayLegalDocumentClass = $;
  }
  return CrowPayLegalDocumentClass;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.k91_1 = function_0;
      }
      wi(a, b) {
        return this.k91_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.k91_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_3() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_5() {
  return Companion_getInstance_1().m2a();
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_6() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_7() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_8() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_9() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_10() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_11() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$comparator$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.o6k_1;
  var tmp$ret$1 = b.o6k_1;
  return compareValues(tmp, tmp$ret$1);
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, LineItem$Companion$$childSerializers$_anonymous__30lg5f);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, LineItem$Companion$$childSerializers$_anonymous__30lg5f_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, LineItem$Companion$$childSerializers$_anonymous__30lg5f_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, LineItem$Companion$$childSerializers$_anonymous__30lg5f_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, LineItem$Companion$$childSerializers$_anonymous__30lg5f_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, LineItem$Companion$$childSerializers$_anonymous__30lg5f_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, LineItem$Companion$$childSerializers$_anonymous__30lg5f_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_15 = lazy(tmp_14, LineItem$Companion$$childSerializers$_anonymous__30lg5f_6);
        var tmp_16 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_17 = lazy(tmp_16, LineItem$Companion$$childSerializers$_anonymous__30lg5f_7);
        var tmp_18 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_19 = lazy(tmp_18, LineItem$Companion$$childSerializers$_anonymous__30lg5f_8);
        var tmp_20 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_21 = lazy(tmp_20, LineItem$Companion$$childSerializers$_anonymous__30lg5f_9);
        var tmp_22 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_23 = lazy(tmp_22, LineItem$Companion$$childSerializers$_anonymous__30lg5f_10);
        var tmp_24 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.x6j_1 = [tmp_1, tmp_3, null, tmp_5, tmp_7, null, null, null, null, tmp_9, tmp_11, tmp_13, null, null, null, null, null, tmp_15, null, tmp_17, tmp_19, tmp_21, null, tmp_23, lazy(tmp_24, LineItem$Companion$$childSerializers$_anonymous__30lg5f_11)];
        var tmp_25 = this;
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_26 = LineItem$Companion$comparator$lambda;
        // Inline function 'kotlin.comparisons.thenBy' call
        var this_0 = new (sam$kotlin_Comparator$0())(tmp_26);
        var tmp_27 = (a, b) => {
          var previousCompare = this_0.compare(a, b);
          var tmp;
          if (!(previousCompare === 0)) {
            tmp = previousCompare;
          } else {
            // Inline function 'kotlin.comparisons.compareValuesBy' call
            var tmp_0 = a.l6k_1;
            var tmp$ret$5 = b.l6k_1;
            tmp = compareValues(tmp_0, tmp$ret$5);
          }
          return tmp;
        };
        tmp_25.y6j_1 = new (sam$kotlin_Comparator$0())(tmp_27);
        this.z6j_1 = Regex().qh(' \\(\\d+(?:\\.\\d+)? [a-zA-Z]+(?: [a-zA-Z]+)*\\)$');
      }
      m2a() {
        return $serializer_getInstance_16();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_3;
function Companion_getInstance_15() {
  if (Companion_instance_3 === VOID)
    new (Companion_1())();
  return Companion_instance_3;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.LineItem', this, 25);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('changeRequest', true);
        tmp0_serialDesc.c1b('scopeView', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(ScopeView())));
        tmp0_serialDesc.c1b('scopeSet', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.d1b(new (References())(getKClass(ScopeView())));
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.c1b('name', true);
        tmp0_serialDesc.c1b('description', true);
        tmp0_serialDesc.c1b('originalPrice', true);
        tmp0_serialDesc.d1b(new (MonetaryRange())(0n, 2147483647n));
        tmp0_serialDesc.c1b('order', true);
        tmp0_serialDesc.c1b('files', true);
        tmp0_serialDesc.c1b('started', true);
        tmp0_serialDesc.c1b('state', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('acceptedPriceChange', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('allowRaiseIssue', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('allowFileDispute', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('allowLockProject', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('issue', true);
        tmp0_serialDesc.c1b('credits', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('complete', true);
        tmp0_serialDesc.c1b('ledgerItems', true);
        tmp0_serialDesc.d1b(new (MultipleReferences())(getKClass(ProjectLedgerItem())));
        tmp0_serialDesc.c1b('cancelled', true);
        tmp0_serialDesc.c1b('created', true);
        tmp0_serialDesc.c1b('contractorDeposits', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('lastModifiedBy', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.d1b(new (References())(getKClass(User())));
        this.l91_1 = tmp0_serialDesc;
      }
      m91(encoder, value) {
        var tmp0_desc = this.l91_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_15().x6j_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.g6k_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.g6k_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.h6k_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.i6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, $serializer_getInstance_1(), value.i6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.j6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.j6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.k6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.k6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.l6k_1 === '')) {
          tmp1_output.a15(tmp0_desc, 5, value.l6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.m6k_1 === '')) {
          tmp1_output.a15(tmp0_desc, 6, value.m6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.n6k_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 7, $serializer_getInstance_2(), new (MonetaryValue())(value.n6k_1));
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.o6k_1, 0.5)) {
          tmp1_output.y14(tmp0_desc, 8, value.o6k_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 9)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.p6k_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.p6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.q6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, tmp2_cached[10].f2(), value.q6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !value.r6k_1.equals(LineItemState_NotStarted_getInstance())) {
          tmp1_output.c15(tmp0_desc, 11, tmp2_cached[11].f2(), value.r6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 12) ? true : !(value.s6k_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 12, $serializer_getInstance_2(), new (MonetaryValue())(value.s6k_1));
        }
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !(value.t6k_1 === false)) {
          tmp1_output.s14(tmp0_desc, 13, value.t6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 14) ? true : !(value.u6k_1 === false)) {
          tmp1_output.s14(tmp0_desc, 14, value.u6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 15) ? true : !(value.v6k_1 === false)) {
          tmp1_output.s14(tmp0_desc, 15, value.v6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 16) ? true : !(value.w6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 16, $serializer_getInstance_3(), value.w6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 17) ? true : !equals(value.x6k_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 17, tmp2_cached[17].f2(), value.x6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 18) ? true : !(value.y6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 18, $serializer_getInstance_4(), value.y6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 19) ? true : !equals(value.z6k_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 19, tmp2_cached[19].f2(), value.z6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 20) ? true : !(value.a6l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 20, tmp2_cached[20].f2(), value.a6l_1);
        }
        var tmp_0;
        if (tmp1_output.h15(tmp0_desc, 21)) {
          tmp_0 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$1 = get_default(Companion_instance_0).d1m();
          tmp_0 = !value.b6l_1.equals(tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.c15(tmp0_desc, 21, tmp2_cached[21].f2(), value.b6l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 22) ? true : !(value.c6l_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 22, $serializer_getInstance_2(), new (MonetaryValue())(value.c6l_1));
        }
        if (tmp1_output.h15(tmp0_desc, 23) ? true : !equals(value.d6l_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 23, tmp2_cached[23].f2(), value.d6l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 24) ? true : !(value.e6l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 24, tmp2_cached[24].f2(), value.e6l_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.m91(encoder, value instanceof LineItem() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.l91_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = 0.0;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = false;
        var tmp18_local14 = false;
        var tmp19_local15 = false;
        var tmp20_local16 = null;
        var tmp21_local17 = null;
        var tmp22_local18 = null;
        var tmp23_local19 = null;
        var tmp24_local20 = null;
        var tmp25_local21 = null;
        var tmp26_local22 = null;
        var tmp27_local23 = null;
        var tmp28_local24 = null;
        var tmp31_input = decoder.l13(tmp0_desc);
        var tmp32_cached = Companion_getInstance_15().x6j_1;
        if (tmp31_input.a14()) {
          tmp4_local0 = tmp31_input.x13(tmp0_desc, 0, tmp32_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp31_input.x13(tmp0_desc, 1, tmp32_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp31_input.z13(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp31_input.z13(tmp0_desc, 3, tmp32_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp31_input.z13(tmp0_desc, 4, tmp32_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp31_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp31_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp11_local7;
          var tmp_1 = tmp31_input.x13(tmp0_desc, 7, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp11_local7 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp31_input.t13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp31_input.x13(tmp0_desc, 9, tmp32_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp31_input.z13(tmp0_desc, 10, tmp32_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp31_input.x13(tmp0_desc, 11, tmp32_cached[11].f2(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          var tmp_2 = $serializer_getInstance_2();
          var tmp_3 = tmp16_local12;
          var tmp_4 = tmp31_input.x13(tmp0_desc, 12, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp16_local12 = tmp_4 == null ? null : tmp_4.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp31_input.n13(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp31_input.n13(tmp0_desc, 14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp31_input.n13(tmp0_desc, 15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          tmp20_local16 = tmp31_input.z13(tmp0_desc, 16, $serializer_getInstance_3(), tmp20_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          tmp21_local17 = tmp31_input.x13(tmp0_desc, 17, tmp32_cached[17].f2(), tmp21_local17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          tmp22_local18 = tmp31_input.z13(tmp0_desc, 18, $serializer_getInstance_4(), tmp22_local18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          tmp23_local19 = tmp31_input.x13(tmp0_desc, 19, tmp32_cached[19].f2(), tmp23_local19);
          tmp3_bitMask0 = tmp3_bitMask0 | 524288;
          tmp24_local20 = tmp31_input.z13(tmp0_desc, 20, tmp32_cached[20].f2(), tmp24_local20);
          tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
          tmp25_local21 = tmp31_input.x13(tmp0_desc, 21, tmp32_cached[21].f2(), tmp25_local21);
          tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
          var tmp_5 = $serializer_getInstance_2();
          var tmp_6 = tmp26_local22;
          var tmp_7 = tmp31_input.x13(tmp0_desc, 22, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
          tmp26_local22 = tmp_7 == null ? null : tmp_7.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
          tmp27_local23 = tmp31_input.x13(tmp0_desc, 23, tmp32_cached[23].f2(), tmp27_local23);
          tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
          tmp28_local24 = tmp31_input.z13(tmp0_desc, 24, tmp32_cached[24].f2(), tmp28_local24);
          tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp31_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp31_input.x13(tmp0_desc, 0, tmp32_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp31_input.x13(tmp0_desc, 1, tmp32_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp31_input.z13(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp31_input.z13(tmp0_desc, 3, tmp32_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp31_input.z13(tmp0_desc, 4, tmp32_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp31_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp31_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_8 = $serializer_getInstance_2();
                var tmp_9 = tmp11_local7;
                var tmp_10 = tmp31_input.x13(tmp0_desc, 7, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
                tmp11_local7 = tmp_10 == null ? null : tmp_10.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp31_input.t13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp31_input.x13(tmp0_desc, 9, tmp32_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp31_input.z13(tmp0_desc, 10, tmp32_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp31_input.x13(tmp0_desc, 11, tmp32_cached[11].f2(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                var tmp_11 = $serializer_getInstance_2();
                var tmp_12 = tmp16_local12;
                var tmp_13 = tmp31_input.x13(tmp0_desc, 12, tmp_11, tmp_12 == null ? null : new (MonetaryValue())(tmp_12));
                tmp16_local12 = tmp_13 == null ? null : tmp_13.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp31_input.n13(tmp0_desc, 13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp31_input.n13(tmp0_desc, 14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp31_input.n13(tmp0_desc, 15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              case 16:
                tmp20_local16 = tmp31_input.z13(tmp0_desc, 16, $serializer_getInstance_3(), tmp20_local16);
                tmp3_bitMask0 = tmp3_bitMask0 | 65536;
                break;
              case 17:
                tmp21_local17 = tmp31_input.x13(tmp0_desc, 17, tmp32_cached[17].f2(), tmp21_local17);
                tmp3_bitMask0 = tmp3_bitMask0 | 131072;
                break;
              case 18:
                tmp22_local18 = tmp31_input.z13(tmp0_desc, 18, $serializer_getInstance_4(), tmp22_local18);
                tmp3_bitMask0 = tmp3_bitMask0 | 262144;
                break;
              case 19:
                tmp23_local19 = tmp31_input.x13(tmp0_desc, 19, tmp32_cached[19].f2(), tmp23_local19);
                tmp3_bitMask0 = tmp3_bitMask0 | 524288;
                break;
              case 20:
                tmp24_local20 = tmp31_input.z13(tmp0_desc, 20, tmp32_cached[20].f2(), tmp24_local20);
                tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
                break;
              case 21:
                tmp25_local21 = tmp31_input.x13(tmp0_desc, 21, tmp32_cached[21].f2(), tmp25_local21);
                tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
                break;
              case 22:
                var tmp_14 = $serializer_getInstance_2();
                var tmp_15 = tmp26_local22;
                var tmp_16 = tmp31_input.x13(tmp0_desc, 22, tmp_14, tmp_15 == null ? null : new (MonetaryValue())(tmp_15));
                tmp26_local22 = tmp_16 == null ? null : tmp_16.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
                break;
              case 23:
                tmp27_local23 = tmp31_input.x13(tmp0_desc, 23, tmp32_cached[23].f2(), tmp27_local23);
                tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
                break;
              case 24:
                tmp28_local24 = tmp31_input.z13(tmp0_desc, 24, tmp32_cached[24].f2(), tmp28_local24);
                tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp31_input.m13(tmp0_desc);
        return LineItem().n91(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, null);
      }
      az() {
        return this.l91_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_15().x6j_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable($serializer_getInstance_1()), get_nullable(tmp0_cached[3].f2()), get_nullable(tmp0_cached[4].f2()), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_2(), DoubleSerializer_getInstance(), tmp0_cached[9].f2(), get_nullable(tmp0_cached[10].f2()), tmp0_cached[11].f2(), $serializer_getInstance_2(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_3()), tmp0_cached[17].f2(), get_nullable($serializer_getInstance_4()), tmp0_cached[19].f2(), get_nullable(tmp0_cached[20].f2()), tmp0_cached[21].f2(), $serializer_getInstance_2(), tmp0_cached[23].f2(), get_nullable(tmp0_cached[24].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_16() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
function LineItem$_get_remainingFunds_$ref_m55iyn() {
  return (p0) => new (MonetaryValue())(p0.o91());
}
var LineItemClass;
function LineItem() {
  if (LineItemClass === VOID) {
    class $ {
      constructor(_id, project, changeRequest, scopeView, scopeSet, name, description, originalPrice, order, files, started, state, acceptedPriceChange, allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, contractorDeposits, readBy, lastModifiedBy) {
        Companion_getInstance_15();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        changeRequest = changeRequest === VOID ? null : changeRequest;
        scopeView = scopeView === VOID ? null : scopeView;
        scopeSet = scopeSet === VOID ? null : scopeSet;
        name = name === VOID ? '' : name;
        description = description === VOID ? '' : description;
        originalPrice = originalPrice === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : originalPrice;
        order = order === VOID ? 0.5 : order;
        var tmp;
        if (files === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = files;
        }
        files = tmp;
        started = started === VOID ? null : started;
        state = state === VOID ? LineItemState_NotStarted_getInstance() : state;
        acceptedPriceChange = acceptedPriceChange === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : acceptedPriceChange;
        allowRaiseIssue = allowRaiseIssue === VOID ? false : allowRaiseIssue;
        allowFileDispute = allowFileDispute === VOID ? false : allowFileDispute;
        allowLockProject = allowLockProject === VOID ? false : allowLockProject;
        issue = issue === VOID ? null : issue;
        credits = credits === VOID ? emptyList() : credits;
        complete = complete === VOID ? null : complete;
        ledgerItems = ledgerItems === VOID ? emptySet() : ledgerItems;
        cancelled = cancelled === VOID ? null : cancelled;
        var tmp_0;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance_0).d1m();
        } else {
          tmp_0 = created;
        }
        created = tmp_0;
        contractorDeposits = contractorDeposits === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : contractorDeposits;
        readBy = readBy === VOID ? emptySet() : readBy;
        lastModifiedBy = lastModifiedBy === VOID ? null : lastModifiedBy;
        this.g6k_1 = _id;
        this.h6k_1 = project;
        this.i6k_1 = changeRequest;
        this.j6k_1 = scopeView;
        this.k6k_1 = scopeSet;
        this.l6k_1 = name;
        this.m6k_1 = description;
        this.n6k_1 = originalPrice;
        this.o6k_1 = order;
        this.p6k_1 = files;
        this.q6k_1 = started;
        this.r6k_1 = state;
        this.s6k_1 = acceptedPriceChange;
        this.t6k_1 = allowRaiseIssue;
        this.u6k_1 = allowFileDispute;
        this.v6k_1 = allowLockProject;
        this.w6k_1 = issue;
        this.x6k_1 = credits;
        this.y6k_1 = complete;
        this.z6k_1 = ledgerItems;
        this.a6l_1 = cancelled;
        this.b6l_1 = created;
        this.c6l_1 = contractorDeposits;
        this.d6l_1 = readBy;
        this.e6l_1 = lastModifiedBy;
        var tmp_1 = this;
        var tmp_2 = MonetaryValue__plus_impl_c1ylt(this.n6k_1, this.s6k_1);
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var this_0 = this.x6k_1;
        var sum = Companion_instance.p91(0n);
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp_3 = sum;
          var tmp$ret$2 = element.a5r_1;
          sum = MonetaryValue__plus_impl_c1ylt(tmp_3, tmp$ret$2);
        }
        var tmp$ret$3 = sum;
        tmp_1.f6l_1 = MonetaryValue__minus_impl_jw9qyp(tmp_2, tmp$ret$3);
        var tmp_4 = this;
        tmp_4.g6l_1 = lazy_0(() => new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(this.f6l_1, this.c6l_1)));
      }
      h40() {
        return this.g6k_1;
      }
      k20() {
        return this.l6k_1;
      }
      q91() {
        return this.m6k_1;
      }
      k8v() {
        return this.o6k_1;
      }
      r91() {
        return this.p6k_1;
      }
      s91() {
        return this.x6k_1;
      }
      t91() {
        return this.d6l_1;
      }
      u91() {
        var tmp0 = this.l6k_1;
        // Inline function 'kotlin.text.replace' call
        return Companion_getInstance_15().z6j_1.wh(tmp0, '');
      }
      l8v(order) {
        return this.i6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, order);
      }
      v91() {
        return this.f6l_1;
      }
      o91() {
        var tmp0 = this.g6l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('remainingFunds', 1, tmp, LineItem$_get_remainingFunds_$ref_m55iyn(), null);
        return tmp0.f2().a5s_1;
      }
      w91() {
        return this.y6k_1 == null && this.a6l_1 == null && MonetaryValue__compareTo_impl_w7ul1r(this.o91(), Companion_instance.o62(0)) > 0;
      }
      x91(other) {
        return Companion_getInstance_15().y6j_1.compare(this, other);
      }
      d(other) {
        return this.x91(other instanceof LineItem() ? other : THROW_CCE());
      }
      m8v(other) {
        return this.x91(other instanceof LineItem() ? other : THROW_CCE());
      }
      y91() {
        return !(this.j6k_1 == null);
      }
      z91(_id, project, changeRequest, scopeView, scopeSet, name, description, originalPrice, order, files, started, state, acceptedPriceChange, allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, contractorDeposits, readBy, lastModifiedBy) {
        return new (LineItem())(_id, project, changeRequest, scopeView, scopeSet, name, description, originalPrice, order, files, started, state, acceptedPriceChange, allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, contractorDeposits, readBy, lastModifiedBy);
      }
      i6l(_id, project, changeRequest, scopeView, scopeSet, name, description, originalPrice, order, files, started, state, acceptedPriceChange, allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, contractorDeposits, readBy, lastModifiedBy, $super) {
        _id = _id === VOID ? this.g6k_1 : _id;
        project = project === VOID ? this.h6k_1 : project;
        changeRequest = changeRequest === VOID ? this.i6k_1 : changeRequest;
        scopeView = scopeView === VOID ? this.j6k_1 : scopeView;
        scopeSet = scopeSet === VOID ? this.k6k_1 : scopeSet;
        name = name === VOID ? this.l6k_1 : name;
        description = description === VOID ? this.m6k_1 : description;
        originalPrice = originalPrice === VOID ? this.n6k_1 : originalPrice;
        order = order === VOID ? this.o6k_1 : order;
        files = files === VOID ? this.p6k_1 : files;
        started = started === VOID ? this.q6k_1 : started;
        state = state === VOID ? this.r6k_1 : state;
        acceptedPriceChange = acceptedPriceChange === VOID ? this.s6k_1 : acceptedPriceChange;
        allowRaiseIssue = allowRaiseIssue === VOID ? this.t6k_1 : allowRaiseIssue;
        allowFileDispute = allowFileDispute === VOID ? this.u6k_1 : allowFileDispute;
        allowLockProject = allowLockProject === VOID ? this.v6k_1 : allowLockProject;
        issue = issue === VOID ? this.w6k_1 : issue;
        credits = credits === VOID ? this.x6k_1 : credits;
        complete = complete === VOID ? this.y6k_1 : complete;
        ledgerItems = ledgerItems === VOID ? this.z6k_1 : ledgerItems;
        cancelled = cancelled === VOID ? this.a6l_1 : cancelled;
        created = created === VOID ? this.b6l_1 : created;
        contractorDeposits = contractorDeposits === VOID ? this.c6l_1 : contractorDeposits;
        readBy = readBy === VOID ? this.d6l_1 : readBy;
        lastModifiedBy = lastModifiedBy === VOID ? this.e6l_1 : lastModifiedBy;
        return $super === VOID ? this.z91(_id, project, changeRequest, scopeView, scopeSet, name, description, originalPrice, order, files, started, state, acceptedPriceChange, allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, contractorDeposits, readBy, lastModifiedBy) : $super.z91.call(this, _id, project, changeRequest, scopeView, scopeSet, name, description, new (MonetaryValue())(originalPrice), order, files, started, state, new (MonetaryValue())(acceptedPriceChange), allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, new (MonetaryValue())(contractorDeposits), readBy, lastModifiedBy);
      }
      toString() {
        return 'LineItem(_id=' + this.g6k_1.toString() + ', project=' + this.h6k_1.toString() + ', changeRequest=' + toString_0(this.i6k_1) + ', scopeView=' + toString_0(this.j6k_1) + ', scopeSet=' + toString_0(this.k6k_1) + ', name=' + this.l6k_1 + ', description=' + this.m6k_1 + ', originalPrice=' + MonetaryValue__toString_impl_xslc77(this.n6k_1) + ', order=' + this.o6k_1 + ', files=' + toString(this.p6k_1) + ', started=' + toString_0(this.q6k_1) + ', state=' + this.r6k_1.toString() + ', acceptedPriceChange=' + MonetaryValue__toString_impl_xslc77(this.s6k_1) + ', allowRaiseIssue=' + this.t6k_1 + ', allowFileDispute=' + this.u6k_1 + ', allowLockProject=' + this.v6k_1 + ', issue=' + toString_0(this.w6k_1) + ', credits=' + toString(this.x6k_1) + ', complete=' + toString_0(this.y6k_1) + ', ledgerItems=' + toString(this.z6k_1) + ', cancelled=' + toString_0(this.a6l_1) + ', created=' + this.b6l_1.toString() + ', contractorDeposits=' + MonetaryValue__toString_impl_xslc77(this.c6l_1) + ', readBy=' + toString(this.d6l_1) + ', lastModifiedBy=' + toString_0(this.e6l_1) + ')';
      }
      hashCode() {
        var result = this.g6k_1.hashCode();
        result = imul(result, 31) + this.h6k_1.hashCode() | 0;
        result = imul(result, 31) + (this.i6k_1 == null ? 0 : this.i6k_1.hashCode()) | 0;
        result = imul(result, 31) + (this.j6k_1 == null ? 0 : this.j6k_1.hashCode()) | 0;
        result = imul(result, 31) + (this.k6k_1 == null ? 0 : this.k6k_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.l6k_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m6k_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.n6k_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.o6k_1) | 0;
        result = imul(result, 31) + hashCode(this.p6k_1) | 0;
        result = imul(result, 31) + (this.q6k_1 == null ? 0 : this.q6k_1.hashCode()) | 0;
        result = imul(result, 31) + this.r6k_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.s6k_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.t6k_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.u6k_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.v6k_1) | 0;
        result = imul(result, 31) + (this.w6k_1 == null ? 0 : this.w6k_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.x6k_1) | 0;
        result = imul(result, 31) + (this.y6k_1 == null ? 0 : this.y6k_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.z6k_1) | 0;
        result = imul(result, 31) + (this.a6l_1 == null ? 0 : this.a6l_1.hashCode()) | 0;
        result = imul(result, 31) + this.b6l_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.c6l_1) | 0;
        result = imul(result, 31) + hashCode(this.d6l_1) | 0;
        result = imul(result, 31) + (this.e6l_1 == null ? 0 : this.e6l_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LineItem()))
          return false;
        if (!this.g6k_1.equals(other.g6k_1))
          return false;
        if (!this.h6k_1.equals(other.h6k_1))
          return false;
        if (!equals(this.i6k_1, other.i6k_1))
          return false;
        if (!equals(this.j6k_1, other.j6k_1))
          return false;
        if (!equals(this.k6k_1, other.k6k_1))
          return false;
        if (!(this.l6k_1 === other.l6k_1))
          return false;
        if (!(this.m6k_1 === other.m6k_1))
          return false;
        if (!(this.n6k_1 === other.n6k_1))
          return false;
        if (!equals(this.o6k_1, other.o6k_1))
          return false;
        if (!equals(this.p6k_1, other.p6k_1))
          return false;
        if (!equals(this.q6k_1, other.q6k_1))
          return false;
        if (!this.r6k_1.equals(other.r6k_1))
          return false;
        if (!(this.s6k_1 === other.s6k_1))
          return false;
        if (!(this.t6k_1 === other.t6k_1))
          return false;
        if (!(this.u6k_1 === other.u6k_1))
          return false;
        if (!(this.v6k_1 === other.v6k_1))
          return false;
        if (!equals(this.w6k_1, other.w6k_1))
          return false;
        if (!equals(this.x6k_1, other.x6k_1))
          return false;
        if (!equals(this.y6k_1, other.y6k_1))
          return false;
        if (!equals(this.z6k_1, other.z6k_1))
          return false;
        if (!equals(this.a6l_1, other.a6l_1))
          return false;
        if (!this.b6l_1.equals(other.b6l_1))
          return false;
        if (!(this.c6l_1 === other.c6l_1))
          return false;
        if (!equals(this.d6l_1, other.d6l_1))
          return false;
        if (!equals(this.e6l_1, other.e6l_1))
          return false;
        return true;
      }
      static n91(seen0, _id, project, changeRequest, scopeView, scopeSet, name, description, originalPrice, order, files, started, state, acceptedPriceChange, allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, contractorDeposits, readBy, lastModifiedBy, serializationConstructorMarker) {
        Companion_getInstance_15();
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_16().l91_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.g6k_1 = Companion_getInstance().m2p();
        else
          $this.g6k_1 = _id;
        $this.h6k_1 = project;
        if (0 === (seen0 & 4))
          $this.i6k_1 = null;
        else
          $this.i6k_1 = changeRequest;
        if (0 === (seen0 & 8))
          $this.j6k_1 = null;
        else
          $this.j6k_1 = scopeView;
        if (0 === (seen0 & 16))
          $this.k6k_1 = null;
        else
          $this.k6k_1 = scopeSet;
        if (0 === (seen0 & 32))
          $this.l6k_1 = '';
        else
          $this.l6k_1 = name;
        if (0 === (seen0 & 64))
          $this.m6k_1 = '';
        else
          $this.m6k_1 = description;
        if (0 === (seen0 & 128))
          $this.n6k_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.n6k_1 = originalPrice;
        if (0 === (seen0 & 256))
          $this.o6k_1 = 0.5;
        else
          $this.o6k_1 = order;
        if (0 === (seen0 & 512)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.p6k_1 = emptyList();
        } else
          $this.p6k_1 = files;
        if (0 === (seen0 & 1024))
          $this.q6k_1 = null;
        else
          $this.q6k_1 = started;
        if (0 === (seen0 & 2048))
          $this.r6k_1 = LineItemState_NotStarted_getInstance();
        else
          $this.r6k_1 = state;
        if (0 === (seen0 & 4096))
          $this.s6k_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.s6k_1 = acceptedPriceChange;
        if (0 === (seen0 & 8192))
          $this.t6k_1 = false;
        else
          $this.t6k_1 = allowRaiseIssue;
        if (0 === (seen0 & 16384))
          $this.u6k_1 = false;
        else
          $this.u6k_1 = allowFileDispute;
        if (0 === (seen0 & 32768))
          $this.v6k_1 = false;
        else
          $this.v6k_1 = allowLockProject;
        if (0 === (seen0 & 65536))
          $this.w6k_1 = null;
        else
          $this.w6k_1 = issue;
        if (0 === (seen0 & 131072))
          $this.x6k_1 = emptyList();
        else
          $this.x6k_1 = credits;
        if (0 === (seen0 & 262144))
          $this.y6k_1 = null;
        else
          $this.y6k_1 = complete;
        if (0 === (seen0 & 524288))
          $this.z6k_1 = emptySet();
        else
          $this.z6k_1 = ledgerItems;
        if (0 === (seen0 & 1048576))
          $this.a6l_1 = null;
        else
          $this.a6l_1 = cancelled;
        if (0 === (seen0 & 2097152)) {
          var tmp_0 = $this;
          // Inline function 'com.lightningkite.now' call
          tmp_0.b6l_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.b6l_1 = created;
        if (0 === (seen0 & 4194304))
          $this.c6l_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.c6l_1 = contractorDeposits;
        if (0 === (seen0 & 8388608))
          $this.d6l_1 = emptySet();
        else
          $this.d6l_1 = readBy;
        if (0 === (seen0 & 16777216))
          $this.e6l_1 = null;
        else
          $this.e6l_1 = lastModifiedBy;
        var tmp_1 = $this;
        var tmp_2 = MonetaryValue__plus_impl_c1ylt($this.n6k_1, $this.s6k_1);
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var this_0 = $this.x6k_1;
        var sum = Companion_instance.p91(0n);
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp_3 = sum;
          var tmp$ret$2 = element.a5r_1;
          sum = MonetaryValue__plus_impl_c1ylt(tmp_3, tmp$ret$2);
        }
        var tmp$ret$3 = sum;
        tmp_1.f6l_1 = MonetaryValue__minus_impl_jw9qyp(tmp_2, tmp$ret$3);
        var tmp_4 = $this;
        tmp_4.g6l_1 = lazy_0(() => new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp($this.f6l_1, $this.c6l_1)));
        return $this;
      }
    }
    initMetadataForClass($, 'LineItem', VOID, VOID, [HasId(), LineItemInterface(), ReadByDataModel(), Reorderable()], VOID, VOID, {0: $serializer_getInstance_16});
    LineItemClass = $;
  }
  return LineItemClass;
}
function ApprovedState$Companion$$childSerializers$_anonymous__9fp9dc() {
  return Companion_getInstance_2().m2a();
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.u56_1 = [lazy(tmp_0, ApprovedState$Companion$$childSerializers$_anonymous__9fp9dc), null];
      }
      m2a() {
        return $serializer_getInstance_17();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_4;
function Companion_getInstance_16() {
  if (Companion_instance_4 === VOID)
    new (Companion_2())();
  return Companion_instance_4;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ApprovedState', this, 2);
        tmp0_serialDesc.c1b('_id', false);
        tmp0_serialDesc.c1b('approved', true);
        this.a92_1 = tmp0_serialDesc;
      }
      b92(encoder, value) {
        var tmp0_desc = this.a92_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_16().u56_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.b57_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.c57_1 === false)) {
          tmp1_output.s14(tmp0_desc, 1, value.c57_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.b92(encoder, value instanceof ApprovedState() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.a92_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_16().u56_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.n13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.n13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return ApprovedState().c92(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.a92_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_16().u56_1[0].f2(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_17() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var ApprovedStateClass;
function ApprovedState() {
  if (ApprovedStateClass === VOID) {
    class $ {
      constructor(_id, approved) {
        Companion_getInstance_16();
        approved = approved === VOID ? false : approved;
        this.b57_1 = _id;
        this.c57_1 = approved;
      }
      h40() {
        return this.b57_1;
      }
      d92(_id, approved) {
        return new (ApprovedState())(_id, approved);
      }
      e57(_id, approved, $super) {
        _id = _id === VOID ? this.b57_1 : _id;
        approved = approved === VOID ? this.c57_1 : approved;
        return $super === VOID ? this.d92(_id, approved) : $super.d92.call(this, _id, approved);
      }
      toString() {
        return 'ApprovedState(_id=' + this.b57_1.toString() + ', approved=' + this.c57_1 + ')';
      }
      hashCode() {
        var result = this.b57_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.c57_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ApprovedState()))
          return false;
        if (!this.b57_1.equals(other.b57_1))
          return false;
        if (!(this.c57_1 === other.c57_1))
          return false;
        return true;
      }
      static c92(seen0, _id, approved, serializationConstructorMarker) {
        Companion_getInstance_16();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_17().a92_1);
        }
        var $this = createThis(this);
        $this.b57_1 = _id;
        if (0 === (seen0 & 2))
          $this.c57_1 = false;
        else
          $this.c57_1 = approved;
        return $this;
      }
    }
    initMetadataForClass($, 'ApprovedState', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_17});
    ApprovedStateClass = $;
  }
  return ApprovedStateClass;
}
function ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_2() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_3() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_5 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.j57_1 = [tmp_1, tmp_3, null, null, null, tmp_5, null, null, null, null, null, null, tmp_7, lazy(tmp_8, ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_3)];
      }
      m2a() {
        return $serializer_getInstance_18();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_5;
function Companion_getInstance_17() {
  if (Companion_instance_5 === VOID)
    new (Companion_3())();
  return Companion_instance_5;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ChangeRequest', this, 14);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('title', true);
        tmp0_serialDesc.c1b('description', false);
        tmp0_serialDesc.c1b('projectDescription', true);
        tmp0_serialDesc.c1b('published', true);
        tmp0_serialDesc.c1b('cardinalChange', true);
        tmp0_serialDesc.c1b('linkItems', true);
        tmp0_serialDesc.c1b('scopeSet', true);
        tmp0_serialDesc.c1b('fullyLinked', true);
        tmp0_serialDesc.c1b('pending', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('number', false);
        tmp0_serialDesc.c1b('created', true);
        tmp0_serialDesc.c1b('readBy', true);
        this.e92_1 = tmp0_serialDesc;
      }
      f92(encoder, value) {
        var tmp0_desc = this.e92_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_17().j57_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.q57_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.q57_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.r57_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.s57_1 === '')) {
          tmp1_output.a15(tmp0_desc, 2, value.s57_1);
        }
        tmp1_output.a15(tmp0_desc, 3, value.t57_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.u57_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, StringSerializer_getInstance(), value.u57_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.v57_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, tmp2_cached[5].f2(), value.v57_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.w57_1 === false)) {
          tmp1_output.s14(tmp0_desc, 6, value.w57_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.x57_1 === false)) {
          tmp1_output.s14(tmp0_desc, 7, value.x57_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.y57_1 === false)) {
          tmp1_output.s14(tmp0_desc, 8, value.y57_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.z57_1 === false)) {
          tmp1_output.s14(tmp0_desc, 9, value.z57_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.a58_1 === 0)) {
          tmp1_output.v14(tmp0_desc, 10, value.a58_1);
        }
        tmp1_output.a15(tmp0_desc, 11, value.b58_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 12)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp = !value.c58_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 12, tmp2_cached[12].f2(), value.c58_1);
        }
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !equals(value.d58_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 13, tmp2_cached[13].f2(), value.d58_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.f92(encoder, value instanceof ChangeRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.e92_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_local7 = false;
        var tmp12_local8 = false;
        var tmp13_local9 = false;
        var tmp14_local10 = 0;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_input = decoder.l13(tmp0_desc);
        var tmp19_cached = Companion_getInstance_17().j57_1;
        if (tmp18_input.a14()) {
          tmp4_local0 = tmp18_input.x13(tmp0_desc, 0, tmp19_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp18_input.x13(tmp0_desc, 1, tmp19_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp18_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp18_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp18_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp18_input.z13(tmp0_desc, 5, tmp19_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp18_input.n13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp18_input.n13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp18_input.n13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp18_input.n13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp18_input.q13(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp18_input.v13(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp18_input.x13(tmp0_desc, 12, tmp19_cached[12].f2(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp18_input.x13(tmp0_desc, 13, tmp19_cached[13].f2(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp18_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp18_input.x13(tmp0_desc, 0, tmp19_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp18_input.x13(tmp0_desc, 1, tmp19_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp18_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp18_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp18_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp18_input.z13(tmp0_desc, 5, tmp19_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp18_input.n13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp18_input.n13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp18_input.n13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp18_input.n13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp18_input.q13(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp18_input.v13(tmp0_desc, 11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp18_input.x13(tmp0_desc, 12, tmp19_cached[12].f2(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp18_input.x13(tmp0_desc, 13, tmp19_cached[13].f2(), tmp17_local13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp18_input.m13(tmp0_desc);
        return ChangeRequest().g92(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, null);
      }
      az() {
        return this.e92_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_17().j57_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[5].f2()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[12].f2(), tmp0_cached[13].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_18() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var ChangeRequestClass;
function ChangeRequest() {
  if (ChangeRequestClass === VOID) {
    class $ {
      constructor(_id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy) {
        Companion_getInstance_17();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        title = title === VOID ? '' : title;
        projectDescription = projectDescription === VOID ? null : projectDescription;
        published = published === VOID ? null : published;
        cardinalChange = cardinalChange === VOID ? false : cardinalChange;
        linkItems = linkItems === VOID ? false : linkItems;
        scopeSet = scopeSet === VOID ? false : scopeSet;
        fullyLinked = fullyLinked === VOID ? false : fullyLinked;
        pending = pending === VOID ? 0 : pending;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = created;
        }
        created = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.q57_1 = _id;
        this.r57_1 = project;
        this.s57_1 = title;
        this.t57_1 = description;
        this.u57_1 = projectDescription;
        this.v57_1 = published;
        this.w57_1 = cardinalChange;
        this.x57_1 = linkItems;
        this.y57_1 = scopeSet;
        this.z57_1 = fullyLinked;
        this.a58_1 = pending;
        this.b58_1 = number;
        this.c58_1 = created;
        this.d58_1 = readBy;
      }
      h40() {
        return this.q57_1;
      }
      t91() {
        return this.d58_1;
      }
      h92(_id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy) {
        return new (ChangeRequest())(_id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy);
      }
      f58(_id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy, $super) {
        _id = _id === VOID ? this.q57_1 : _id;
        project = project === VOID ? this.r57_1 : project;
        title = title === VOID ? this.s57_1 : title;
        description = description === VOID ? this.t57_1 : description;
        projectDescription = projectDescription === VOID ? this.u57_1 : projectDescription;
        published = published === VOID ? this.v57_1 : published;
        cardinalChange = cardinalChange === VOID ? this.w57_1 : cardinalChange;
        linkItems = linkItems === VOID ? this.x57_1 : linkItems;
        scopeSet = scopeSet === VOID ? this.y57_1 : scopeSet;
        fullyLinked = fullyLinked === VOID ? this.z57_1 : fullyLinked;
        pending = pending === VOID ? this.a58_1 : pending;
        number = number === VOID ? this.b58_1 : number;
        created = created === VOID ? this.c58_1 : created;
        readBy = readBy === VOID ? this.d58_1 : readBy;
        return $super === VOID ? this.h92(_id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy) : $super.h92.call(this, _id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy);
      }
      toString() {
        return 'ChangeRequest(_id=' + this.q57_1.toString() + ', project=' + this.r57_1.toString() + ', title=' + this.s57_1 + ', description=' + this.t57_1 + ', projectDescription=' + this.u57_1 + ', published=' + toString_0(this.v57_1) + ', cardinalChange=' + this.w57_1 + ', linkItems=' + this.x57_1 + ', scopeSet=' + this.y57_1 + ', fullyLinked=' + this.z57_1 + ', pending=' + this.a58_1 + ', number=' + this.b58_1 + ', created=' + this.c58_1.toString() + ', readBy=' + toString(this.d58_1) + ')';
      }
      hashCode() {
        var result = this.q57_1.hashCode();
        result = imul(result, 31) + this.r57_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.s57_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t57_1) | 0;
        result = imul(result, 31) + (this.u57_1 == null ? 0 : getStringHashCode(this.u57_1)) | 0;
        result = imul(result, 31) + (this.v57_1 == null ? 0 : this.v57_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.w57_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.x57_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.y57_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.z57_1) | 0;
        result = imul(result, 31) + this.a58_1 | 0;
        result = imul(result, 31) + getStringHashCode(this.b58_1) | 0;
        result = imul(result, 31) + this.c58_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.d58_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ChangeRequest()))
          return false;
        if (!this.q57_1.equals(other.q57_1))
          return false;
        if (!this.r57_1.equals(other.r57_1))
          return false;
        if (!(this.s57_1 === other.s57_1))
          return false;
        if (!(this.t57_1 === other.t57_1))
          return false;
        if (!(this.u57_1 == other.u57_1))
          return false;
        if (!equals(this.v57_1, other.v57_1))
          return false;
        if (!(this.w57_1 === other.w57_1))
          return false;
        if (!(this.x57_1 === other.x57_1))
          return false;
        if (!(this.y57_1 === other.y57_1))
          return false;
        if (!(this.z57_1 === other.z57_1))
          return false;
        if (!(this.a58_1 === other.a58_1))
          return false;
        if (!(this.b58_1 === other.b58_1))
          return false;
        if (!this.c58_1.equals(other.c58_1))
          return false;
        if (!equals(this.d58_1, other.d58_1))
          return false;
        return true;
      }
      static g92(seen0, _id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy, serializationConstructorMarker) {
        Companion_getInstance_17();
        if (!(2058 === (2058 & seen0))) {
          throwMissingFieldException(seen0, 2058, $serializer_getInstance_18().e92_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.q57_1 = Companion_getInstance().m2p();
        else
          $this.q57_1 = _id;
        $this.r57_1 = project;
        if (0 === (seen0 & 4))
          $this.s57_1 = '';
        else
          $this.s57_1 = title;
        $this.t57_1 = description;
        if (0 === (seen0 & 16))
          $this.u57_1 = null;
        else
          $this.u57_1 = projectDescription;
        if (0 === (seen0 & 32))
          $this.v57_1 = null;
        else
          $this.v57_1 = published;
        if (0 === (seen0 & 64))
          $this.w57_1 = false;
        else
          $this.w57_1 = cardinalChange;
        if (0 === (seen0 & 128))
          $this.x57_1 = false;
        else
          $this.x57_1 = linkItems;
        if (0 === (seen0 & 256))
          $this.y57_1 = false;
        else
          $this.y57_1 = scopeSet;
        if (0 === (seen0 & 512))
          $this.z57_1 = false;
        else
          $this.z57_1 = fullyLinked;
        if (0 === (seen0 & 1024))
          $this.a58_1 = 0;
        else
          $this.a58_1 = pending;
        $this.b58_1 = number;
        if (0 === (seen0 & 4096)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.c58_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.c58_1 = created;
        if (0 === (seen0 & 8192))
          $this.d58_1 = emptySet();
        else
          $this.d58_1 = readBy;
        return $this;
      }
    }
    initMetadataForClass($, 'ChangeRequest', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_18});
    ChangeRequestClass = $;
  }
  return ChangeRequestClass;
}
function Client$Companion$$childSerializers$_anonymous__j6t4kf() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Client$Companion$$childSerializers$_anonymous__j6t4kf_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Client$Companion$$childSerializers$_anonymous__j6t4kf);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.w5b_1 = [tmp_1, lazy(tmp_2, Client$Companion$$childSerializers$_anonymous__j6t4kf_0), null, null, null, null, null, null];
      }
      m2a() {
        return $serializer_getInstance_19();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_6;
function Companion_getInstance_18() {
  if (Companion_instance_6 === VOID)
    new (Companion_4())();
  return Companion_instance_6;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Client', this, 8);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('contractor', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.c1b('name', false);
        tmp0_serialDesc.c1b('userFirstName', true);
        tmp0_serialDesc.c1b('userLastName', true);
        tmp0_serialDesc.c1b('email', false);
        tmp0_serialDesc.c1b('phoneNumber', false);
        tmp0_serialDesc.c1b('address', false);
        this.i92_1 = tmp0_serialDesc;
      }
      j92(encoder, value) {
        var tmp0_desc = this.i92_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_18().w5b_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.d5c_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.d5c_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.e5c_1);
        tmp1_output.a15(tmp0_desc, 2, value.f5c_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.g5c_1 === substringBefore(value.f5c_1, _Char___init__impl__6a9atx(32)))) {
          tmp1_output.a15(tmp0_desc, 3, value.g5c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.h5c_1 === substringAfter(value.f5c_1, _Char___init__impl__6a9atx(32)))) {
          tmp1_output.a15(tmp0_desc, 4, value.h5c_1);
        }
        tmp1_output.a15(tmp0_desc, 5, value.i5c_1);
        tmp1_output.a15(tmp0_desc, 6, value.j5c_1);
        tmp1_output.c15(tmp0_desc, 7, $serializer_getInstance_5(), value.k5c_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.j92(encoder, value instanceof Client() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.i92_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.l13(tmp0_desc);
        var tmp13_cached = Companion_getInstance_18().w5b_1;
        if (tmp12_input.a14()) {
          tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.x13(tmp0_desc, 7, $serializer_getInstance_5(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.x13(tmp0_desc, 7, $serializer_getInstance_5(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp12_input.m13(tmp0_desc);
        return Client().k92(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      az() {
        return this.i92_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_18().w5b_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_5()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_19() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var ClientClass;
function Client() {
  if (ClientClass === VOID) {
    class $ {
      constructor(_id, contractor, name, userFirstName, userLastName, email, phoneNumber, address) {
        Companion_getInstance_18();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        userFirstName = userFirstName === VOID ? substringBefore(name, _Char___init__impl__6a9atx(32)) : userFirstName;
        userLastName = userLastName === VOID ? substringAfter(name, _Char___init__impl__6a9atx(32)) : userLastName;
        this.d5c_1 = _id;
        this.e5c_1 = contractor;
        this.f5c_1 = name;
        this.g5c_1 = userFirstName;
        this.h5c_1 = userLastName;
        this.i5c_1 = email;
        this.j5c_1 = phoneNumber;
        this.k5c_1 = address;
      }
      h40() {
        return this.d5c_1;
      }
      k20() {
        return this.f5c_1;
      }
      l92() {
        return this.i5c_1;
      }
      m92() {
        return this.j5c_1;
      }
      n92() {
        return this.g5c_1 + ' ' + this.h5c_1;
      }
      o92() {
        return null;
      }
      p92(_id, contractor, name, userFirstName, userLastName, email, phoneNumber, address) {
        return new (Client())(_id, contractor, name, userFirstName, userLastName, email, phoneNumber, address);
      }
      m5c(_id, contractor, name, userFirstName, userLastName, email, phoneNumber, address, $super) {
        _id = _id === VOID ? this.d5c_1 : _id;
        contractor = contractor === VOID ? this.e5c_1 : contractor;
        name = name === VOID ? this.f5c_1 : name;
        userFirstName = userFirstName === VOID ? this.g5c_1 : userFirstName;
        userLastName = userLastName === VOID ? this.h5c_1 : userLastName;
        email = email === VOID ? this.i5c_1 : email;
        phoneNumber = phoneNumber === VOID ? this.j5c_1 : phoneNumber;
        address = address === VOID ? this.k5c_1 : address;
        return $super === VOID ? this.p92(_id, contractor, name, userFirstName, userLastName, email, phoneNumber, address) : $super.p92.call(this, _id, contractor, name, userFirstName, userLastName, email, phoneNumber, address);
      }
      toString() {
        return 'Client(_id=' + this.d5c_1.toString() + ', contractor=' + this.e5c_1.toString() + ', name=' + this.f5c_1 + ', userFirstName=' + this.g5c_1 + ', userLastName=' + this.h5c_1 + ', email=' + this.i5c_1 + ', phoneNumber=' + this.j5c_1 + ', address=' + this.k5c_1.toString() + ')';
      }
      hashCode() {
        var result = this.d5c_1.hashCode();
        result = imul(result, 31) + this.e5c_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.f5c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g5c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h5c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i5c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j5c_1) | 0;
        result = imul(result, 31) + this.k5c_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Client()))
          return false;
        if (!this.d5c_1.equals(other.d5c_1))
          return false;
        if (!this.e5c_1.equals(other.e5c_1))
          return false;
        if (!(this.f5c_1 === other.f5c_1))
          return false;
        if (!(this.g5c_1 === other.g5c_1))
          return false;
        if (!(this.h5c_1 === other.h5c_1))
          return false;
        if (!(this.i5c_1 === other.i5c_1))
          return false;
        if (!(this.j5c_1 === other.j5c_1))
          return false;
        if (!this.k5c_1.equals(other.k5c_1))
          return false;
        return true;
      }
      static k92(seen0, _id, contractor, name, userFirstName, userLastName, email, phoneNumber, address, serializationConstructorMarker) {
        Companion_getInstance_18();
        if (!(230 === (230 & seen0))) {
          throwMissingFieldException(seen0, 230, $serializer_getInstance_19().i92_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.d5c_1 = Companion_getInstance().m2p();
        else
          $this.d5c_1 = _id;
        $this.e5c_1 = contractor;
        $this.f5c_1 = name;
        if (0 === (seen0 & 8))
          $this.g5c_1 = substringBefore($this.f5c_1, _Char___init__impl__6a9atx(32));
        else
          $this.g5c_1 = userFirstName;
        if (0 === (seen0 & 16))
          $this.h5c_1 = substringAfter($this.f5c_1, _Char___init__impl__6a9atx(32));
        else
          $this.h5c_1 = userLastName;
        $this.i5c_1 = email;
        $this.j5c_1 = phoneNumber;
        $this.k5c_1 = address;
        return $this;
      }
    }
    initMetadataForClass($, 'Client', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_19});
    ClientClass = $;
  }
  return ClientClass;
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_3() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_5() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      constructor() {
        Companion_instance_7 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.k5d_1 = [tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, null, null, null, tmp_11, lazy(tmp_12, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_5)];
      }
      m2a() {
        return $serializer_getInstance_20();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_7;
function Companion_getInstance_19() {
  if (Companion_instance_7 === VOID)
    new (Companion_5())();
  return Companion_instance_7;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.CompletionMessageComment', this, 10);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('completionMessage', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItemCompletionMessage())));
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('lineItem', false);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.c1b('sender', false);
        tmp0_serialDesc.c1b('senderName', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('clientMessage', false);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('message', false);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('created', true);
        this.q92_1 = tmp0_serialDesc;
      }
      r92(encoder, value) {
        var tmp0_desc = this.q92_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_19().k5d_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.p5d_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.p5d_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.q5d_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.r5d_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.s5d_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.t5d_1);
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.u5d_1 === '')) {
          tmp1_output.a15(tmp0_desc, 5, value.u5d_1);
        }
        tmp1_output.s14(tmp0_desc, 6, value.v5d_1);
        tmp1_output.a15(tmp0_desc, 7, value.w5d_1);
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.x5d_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.x5d_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 9)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp = !value.y5d_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.y5d_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.r92(encoder, value instanceof CompletionMessageComment() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.q92_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_input = decoder.l13(tmp0_desc);
        var tmp15_cached = Companion_getInstance_19().k5d_1;
        if (tmp14_input.a14()) {
          tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.x13(tmp0_desc, 2, tmp15_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.x13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.x13(tmp0_desc, 4, tmp15_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.n13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.x13(tmp0_desc, 9, tmp15_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.x13(tmp0_desc, 2, tmp15_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.x13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.x13(tmp0_desc, 4, tmp15_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.n13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.x13(tmp0_desc, 9, tmp15_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp14_input.m13(tmp0_desc);
        return CompletionMessageComment().s92(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      az() {
        return this.q92_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_19().k5d_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), tmp0_cached[4].f2(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[8].f2(), tmp0_cached[9].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_20() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var CompletionMessageCommentClass;
function CompletionMessageComment() {
  if (CompletionMessageCommentClass === VOID) {
    class $ {
      constructor(_id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created) {
        Companion_getInstance_19();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        senderName = senderName === VOID ? '' : senderName;
        readBy = readBy === VOID ? emptySet() : readBy;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = created;
        }
        created = tmp;
        this.p5d_1 = _id;
        this.q5d_1 = completionMessage;
        this.r5d_1 = project;
        this.s5d_1 = lineItem;
        this.t5d_1 = sender;
        this.u5d_1 = senderName;
        this.v5d_1 = clientMessage;
        this.w5d_1 = message;
        this.x5d_1 = readBy;
        this.y5d_1 = created;
      }
      h40() {
        return this.p5d_1;
      }
      t91() {
        return this.x5d_1;
      }
      t92() {
        return plus(this.x5d_1, this.t5d_1);
      }
      u92(_id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created) {
        return new (CompletionMessageComment())(_id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created);
      }
      a5e(_id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created, $super) {
        _id = _id === VOID ? this.p5d_1 : _id;
        completionMessage = completionMessage === VOID ? this.q5d_1 : completionMessage;
        project = project === VOID ? this.r5d_1 : project;
        lineItem = lineItem === VOID ? this.s5d_1 : lineItem;
        sender = sender === VOID ? this.t5d_1 : sender;
        senderName = senderName === VOID ? this.u5d_1 : senderName;
        clientMessage = clientMessage === VOID ? this.v5d_1 : clientMessage;
        message = message === VOID ? this.w5d_1 : message;
        readBy = readBy === VOID ? this.x5d_1 : readBy;
        created = created === VOID ? this.y5d_1 : created;
        return $super === VOID ? this.u92(_id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created) : $super.u92.call(this, _id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created);
      }
      toString() {
        return 'CompletionMessageComment(_id=' + this.p5d_1.toString() + ', completionMessage=' + this.q5d_1.toString() + ', project=' + this.r5d_1.toString() + ', lineItem=' + this.s5d_1.toString() + ', sender=' + this.t5d_1.toString() + ', senderName=' + this.u5d_1 + ', clientMessage=' + this.v5d_1 + ', message=' + this.w5d_1 + ', readBy=' + toString(this.x5d_1) + ', created=' + this.y5d_1.toString() + ')';
      }
      hashCode() {
        var result = this.p5d_1.hashCode();
        result = imul(result, 31) + this.q5d_1.hashCode() | 0;
        result = imul(result, 31) + this.r5d_1.hashCode() | 0;
        result = imul(result, 31) + this.s5d_1.hashCode() | 0;
        result = imul(result, 31) + this.t5d_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.u5d_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.v5d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w5d_1) | 0;
        result = imul(result, 31) + hashCode(this.x5d_1) | 0;
        result = imul(result, 31) + this.y5d_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CompletionMessageComment()))
          return false;
        if (!this.p5d_1.equals(other.p5d_1))
          return false;
        if (!this.q5d_1.equals(other.q5d_1))
          return false;
        if (!this.r5d_1.equals(other.r5d_1))
          return false;
        if (!this.s5d_1.equals(other.s5d_1))
          return false;
        if (!this.t5d_1.equals(other.t5d_1))
          return false;
        if (!(this.u5d_1 === other.u5d_1))
          return false;
        if (!(this.v5d_1 === other.v5d_1))
          return false;
        if (!(this.w5d_1 === other.w5d_1))
          return false;
        if (!equals(this.x5d_1, other.x5d_1))
          return false;
        if (!this.y5d_1.equals(other.y5d_1))
          return false;
        return true;
      }
      static s92(seen0, _id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created, serializationConstructorMarker) {
        Companion_getInstance_19();
        if (!(222 === (222 & seen0))) {
          throwMissingFieldException(seen0, 222, $serializer_getInstance_20().q92_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.p5d_1 = Companion_getInstance().m2p();
        else
          $this.p5d_1 = _id;
        $this.q5d_1 = completionMessage;
        $this.r5d_1 = project;
        $this.s5d_1 = lineItem;
        $this.t5d_1 = sender;
        if (0 === (seen0 & 32))
          $this.u5d_1 = '';
        else
          $this.u5d_1 = senderName;
        $this.v5d_1 = clientMessage;
        $this.w5d_1 = message;
        if (0 === (seen0 & 256))
          $this.x5d_1 = emptySet();
        else
          $this.x5d_1 = readBy;
        if (0 === (seen0 & 512)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.y5d_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.y5d_1 = created;
        return $this;
      }
    }
    initMetadataForClass($, 'CompletionMessageComment', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_20});
    CompletionMessageCommentClass = $;
  }
  return CompletionMessageCommentClass;
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_0() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_1() {
  return Companion_getInstance_3().m2a();
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_2() {
  return new (LinkedHashSetSerializer())(Companion_getInstance_2().m2a());
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_3() {
  return new (ArrayListSerializer())($serializer_getInstance_59());
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_4() {
  return Companion_getInstance_4().m2a();
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_5() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_6() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      constructor() {
        Companion_instance_8 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Contractor$Companion$$childSerializers$_anonymous__2zvvwr);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.q5i_1 = [tmp_1, null, null, null, null, null, null, tmp_3, tmp_5, null, null, null, null, null, null, null, tmp_7, null, null, null, null, null, null, tmp_9, tmp_11, null, tmp_13, lazy(tmp_14, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_6)];
      }
      m2a() {
        return $serializer_getInstance_21();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_8;
function Companion_getInstance_20() {
  if (Companion_instance_8 === VOID)
    new (Companion_6())();
  return Companion_instance_8;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Contractor', this, 28);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('shortId', true);
        tmp0_serialDesc.d1b(new (Unique())());
        tmp0_serialDesc.c1b('name', false);
        tmp0_serialDesc.c1b('legalName', false);
        tmp0_serialDesc.c1b('email', false);
        tmp0_serialDesc.c1b('phoneNumber', false);
        tmp0_serialDesc.c1b('address', false);
        tmp0_serialDesc.c1b('image', true);
        tmp0_serialDesc.c1b('preferredTitle', true);
        tmp0_serialDesc.c1b('trade', true);
        tmp0_serialDesc.c1b('entityType', true);
        tmp0_serialDesc.c1b('contactFirstName', false);
        tmp0_serialDesc.c1b('contactLastName', false);
        tmp0_serialDesc.c1b('contactEmail', false);
        tmp0_serialDesc.c1b('contactPhoneNumber', false);
        tmp0_serialDesc.c1b('contactAddress', false);
        tmp0_serialDesc.c1b('operationStates', true);
        tmp0_serialDesc.c1b('annualRevenue', true);
        tmp0_serialDesc.c1b('averageJobSize', true);
        tmp0_serialDesc.c1b('employeeCount', true);
        tmp0_serialDesc.c1b('otherBusinessData', true);
        tmp0_serialDesc.c1b('stateEntityNumber', false);
        tmp0_serialDesc.c1b('ein', false);
        tmp0_serialDesc.c1b('owners', true);
        tmp0_serialDesc.c1b('status', true);
        tmp0_serialDesc.c1b('paymentId', true);
        tmp0_serialDesc.c1b('created', true);
        tmp0_serialDesc.c1b('readBy', true);
        this.v92_1 = tmp0_serialDesc;
      }
      w92(encoder, value) {
        var tmp0_desc = this.v92_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_20().q5i_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.v5i_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.v5i_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.w5i_1 === Companion_instance_47.k5n())) {
          tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_58(), new (ShortId())(value.w5i_1));
        }
        tmp1_output.a15(tmp0_desc, 2, value.x5i_1);
        tmp1_output.a15(tmp0_desc, 3, value.y5i_1);
        tmp1_output.a15(tmp0_desc, 4, value.z5i_1);
        tmp1_output.a15(tmp0_desc, 5, value.a5j_1);
        tmp1_output.c15(tmp0_desc, 6, $serializer_getInstance_5(), value.b5j_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 7)) {
          tmp = true;
        } else {
          var tmp_0 = value.c5j_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = tmp2_cached[7].f2();
          var tmp_2 = value.c5j_1;
          tmp1_output.d15(tmp0_desc, 7, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !value.d5j_1.equals(PreferredTitle_Contractor_getInstance())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.d5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.e5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, StringSerializer_getInstance(), value.e5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.f5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, StringSerializer_getInstance(), value.f5j_1);
        }
        tmp1_output.a15(tmp0_desc, 11, value.g5j_1);
        tmp1_output.a15(tmp0_desc, 12, value.h5j_1);
        tmp1_output.a15(tmp0_desc, 13, value.i5j_1);
        tmp1_output.a15(tmp0_desc, 14, value.j5j_1);
        tmp1_output.c15(tmp0_desc, 15, $serializer_getInstance_5(), value.k5j_1);
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 16)) {
          tmp_3 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp_3 = !equals(value.l5j_1, tmp$ret$0);
        }
        if (tmp_3) {
          tmp1_output.c15(tmp0_desc, 16, tmp2_cached[16].f2(), value.l5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 17) ? true : !(value.m5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 17, IntSerializer_getInstance(), value.m5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 18) ? true : !(value.n5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 18, IntSerializer_getInstance(), value.n5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 19) ? true : !(value.o5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 19, IntSerializer_getInstance(), value.o5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 20) ? true : !(value.p5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 20, StringSerializer_getInstance(), value.p5j_1);
        }
        tmp1_output.a15(tmp0_desc, 21, value.q5j_1);
        tmp1_output.a15(tmp0_desc, 22, value.r5j_1);
        var tmp_4;
        if (tmp1_output.h15(tmp0_desc, 23)) {
          tmp_4 = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$1 = emptyList();
          tmp_4 = !equals(value.s5j_1, tmp$ret$1);
        }
        if (tmp_4) {
          tmp1_output.c15(tmp0_desc, 23, tmp2_cached[23].f2(), value.s5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 24) ? true : !value.t5j_1.equals(ContractorStatus_Registering_getInstance())) {
          tmp1_output.c15(tmp0_desc, 24, tmp2_cached[24].f2(), value.t5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 25) ? true : !(value.u5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 25, StringSerializer_getInstance(), value.u5j_1);
        }
        var tmp_5;
        if (tmp1_output.h15(tmp0_desc, 26)) {
          tmp_5 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$2 = get_default(Companion_instance_0).d1m();
          tmp_5 = !value.v5j_1.equals(tmp$ret$2);
        }
        if (tmp_5) {
          tmp1_output.c15(tmp0_desc, 26, tmp2_cached[26].f2(), value.v5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 27) ? true : !equals(value.w5j_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 27, tmp2_cached[27].f2(), value.w5j_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.w92(encoder, value instanceof Contractor() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.v92_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_local15 = null;
        var tmp20_local16 = null;
        var tmp21_local17 = null;
        var tmp22_local18 = null;
        var tmp23_local19 = null;
        var tmp24_local20 = null;
        var tmp25_local21 = null;
        var tmp26_local22 = null;
        var tmp27_local23 = null;
        var tmp28_local24 = null;
        var tmp29_local25 = null;
        var tmp30_local26 = null;
        var tmp31_local27 = null;
        var tmp32_input = decoder.l13(tmp0_desc);
        var tmp33_cached = Companion_getInstance_20().q5i_1;
        if (tmp32_input.a14()) {
          tmp4_local0 = tmp32_input.x13(tmp0_desc, 0, tmp33_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = $serializer_getInstance_58();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp32_input.x13(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (ShortId())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.n5n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp32_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp32_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp32_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp32_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp32_input.x13(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp_2 = tmp33_cached[7].f2();
          var tmp_3 = tmp11_local7;
          var tmp_4 = tmp32_input.z13(tmp0_desc, 7, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
          tmp11_local7 = tmp_4 == null ? null : tmp_4.n2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp32_input.x13(tmp0_desc, 8, tmp33_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp32_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp32_input.z13(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp32_input.v13(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp32_input.v13(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp32_input.v13(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp32_input.v13(tmp0_desc, 14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp32_input.x13(tmp0_desc, 15, $serializer_getInstance_5(), tmp19_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          tmp20_local16 = tmp32_input.x13(tmp0_desc, 16, tmp33_cached[16].f2(), tmp20_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          tmp21_local17 = tmp32_input.z13(tmp0_desc, 17, IntSerializer_getInstance(), tmp21_local17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          tmp22_local18 = tmp32_input.z13(tmp0_desc, 18, IntSerializer_getInstance(), tmp22_local18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          tmp23_local19 = tmp32_input.z13(tmp0_desc, 19, IntSerializer_getInstance(), tmp23_local19);
          tmp3_bitMask0 = tmp3_bitMask0 | 524288;
          tmp24_local20 = tmp32_input.z13(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
          tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
          tmp25_local21 = tmp32_input.v13(tmp0_desc, 21);
          tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
          tmp26_local22 = tmp32_input.v13(tmp0_desc, 22);
          tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
          tmp27_local23 = tmp32_input.x13(tmp0_desc, 23, tmp33_cached[23].f2(), tmp27_local23);
          tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
          tmp28_local24 = tmp32_input.x13(tmp0_desc, 24, tmp33_cached[24].f2(), tmp28_local24);
          tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
          tmp29_local25 = tmp32_input.z13(tmp0_desc, 25, StringSerializer_getInstance(), tmp29_local25);
          tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
          tmp30_local26 = tmp32_input.x13(tmp0_desc, 26, tmp33_cached[26].f2(), tmp30_local26);
          tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
          tmp31_local27 = tmp32_input.x13(tmp0_desc, 27, tmp33_cached[27].f2(), tmp31_local27);
          tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp32_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp32_input.x13(tmp0_desc, 0, tmp33_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_5 = $serializer_getInstance_58();
                var tmp_6 = tmp5_local1;
                var tmp_7 = tmp32_input.x13(tmp0_desc, 1, tmp_5, tmp_6 == null ? null : new (ShortId())(tmp_6));
                tmp5_local1 = tmp_7 == null ? null : tmp_7.n5n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp32_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp32_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp32_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp32_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp32_input.x13(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_8 = tmp33_cached[7].f2();
                var tmp_9 = tmp11_local7;
                var tmp_10 = tmp32_input.z13(tmp0_desc, 7, tmp_8, tmp_9 == null ? null : new (ServerFile())(tmp_9));
                tmp11_local7 = tmp_10 == null ? null : tmp_10.n2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp32_input.x13(tmp0_desc, 8, tmp33_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp32_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp32_input.z13(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp32_input.v13(tmp0_desc, 11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp32_input.v13(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp32_input.v13(tmp0_desc, 13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp32_input.v13(tmp0_desc, 14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp32_input.x13(tmp0_desc, 15, $serializer_getInstance_5(), tmp19_local15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              case 16:
                tmp20_local16 = tmp32_input.x13(tmp0_desc, 16, tmp33_cached[16].f2(), tmp20_local16);
                tmp3_bitMask0 = tmp3_bitMask0 | 65536;
                break;
              case 17:
                tmp21_local17 = tmp32_input.z13(tmp0_desc, 17, IntSerializer_getInstance(), tmp21_local17);
                tmp3_bitMask0 = tmp3_bitMask0 | 131072;
                break;
              case 18:
                tmp22_local18 = tmp32_input.z13(tmp0_desc, 18, IntSerializer_getInstance(), tmp22_local18);
                tmp3_bitMask0 = tmp3_bitMask0 | 262144;
                break;
              case 19:
                tmp23_local19 = tmp32_input.z13(tmp0_desc, 19, IntSerializer_getInstance(), tmp23_local19);
                tmp3_bitMask0 = tmp3_bitMask0 | 524288;
                break;
              case 20:
                tmp24_local20 = tmp32_input.z13(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
                tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
                break;
              case 21:
                tmp25_local21 = tmp32_input.v13(tmp0_desc, 21);
                tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
                break;
              case 22:
                tmp26_local22 = tmp32_input.v13(tmp0_desc, 22);
                tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
                break;
              case 23:
                tmp27_local23 = tmp32_input.x13(tmp0_desc, 23, tmp33_cached[23].f2(), tmp27_local23);
                tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
                break;
              case 24:
                tmp28_local24 = tmp32_input.x13(tmp0_desc, 24, tmp33_cached[24].f2(), tmp28_local24);
                tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
                break;
              case 25:
                tmp29_local25 = tmp32_input.z13(tmp0_desc, 25, StringSerializer_getInstance(), tmp29_local25);
                tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
                break;
              case 26:
                tmp30_local26 = tmp32_input.x13(tmp0_desc, 26, tmp33_cached[26].f2(), tmp30_local26);
                tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
                break;
              case 27:
                tmp31_local27 = tmp32_input.x13(tmp0_desc, 27, tmp33_cached[27].f2(), tmp31_local27);
                tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp32_input.m13(tmp0_desc);
        return Contractor().x92(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, tmp29_local25, tmp30_local26, tmp31_local27, null);
      }
      az() {
        return this.v92_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_20().q5i_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), $serializer_getInstance_58(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_5(), get_nullable(tmp0_cached[7].f2()), tmp0_cached[8].f2(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_5(), tmp0_cached[16].f2(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[23].f2(), tmp0_cached[24].f2(), get_nullable(StringSerializer_getInstance()), tmp0_cached[26].f2(), tmp0_cached[27].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_21() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
var ContractorClass;
function Contractor() {
  if (ContractorClass === VOID) {
    class $ {
      constructor(_id, shortId, name, legalName, email, phoneNumber, address, image, preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy) {
        Companion_getInstance_20();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        shortId = shortId === VOID ? Companion_instance_47.k5n() : shortId;
        image = image === VOID ? null : image;
        preferredTitle = preferredTitle === VOID ? PreferredTitle_Contractor_getInstance() : preferredTitle;
        trade = trade === VOID ? null : trade;
        entityType = entityType === VOID ? null : entityType;
        var tmp;
        if (operationStates === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = operationStates;
        }
        operationStates = tmp;
        annualRevenue = annualRevenue === VOID ? null : annualRevenue;
        averageJobSize = averageJobSize === VOID ? null : averageJobSize;
        employeeCount = employeeCount === VOID ? null : employeeCount;
        otherBusinessData = otherBusinessData === VOID ? null : otherBusinessData;
        var tmp_0;
        if (owners === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp_0 = emptyList();
        } else {
          tmp_0 = owners;
        }
        owners = tmp_0;
        status = status === VOID ? ContractorStatus_Registering_getInstance() : status;
        paymentId = paymentId === VOID ? null : paymentId;
        var tmp_1;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp_1 = get_default(Companion_instance_0).d1m();
        } else {
          tmp_1 = created;
        }
        created = tmp_1;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.v5i_1 = _id;
        this.w5i_1 = shortId;
        this.x5i_1 = name;
        this.y5i_1 = legalName;
        this.z5i_1 = email;
        this.a5j_1 = phoneNumber;
        this.b5j_1 = address;
        this.c5j_1 = image;
        this.d5j_1 = preferredTitle;
        this.e5j_1 = trade;
        this.f5j_1 = entityType;
        this.g5j_1 = contactFirstName;
        this.h5j_1 = contactLastName;
        this.i5j_1 = contactEmail;
        this.j5j_1 = contactPhoneNumber;
        this.k5j_1 = contactAddress;
        this.l5j_1 = operationStates;
        this.m5j_1 = annualRevenue;
        this.n5j_1 = averageJobSize;
        this.o5j_1 = employeeCount;
        this.p5j_1 = otherBusinessData;
        this.q5j_1 = stateEntityNumber;
        this.r5j_1 = ein;
        this.s5j_1 = owners;
        this.t5j_1 = status;
        this.u5j_1 = paymentId;
        this.v5j_1 = created;
        this.w5j_1 = readBy;
      }
      h40() {
        return this.v5i_1;
      }
      k20() {
        return this.x5i_1;
      }
      l92() {
        return this.z5i_1;
      }
      m92() {
        return this.a5j_1;
      }
      o92() {
        return this.c5j_1;
      }
      t91() {
        return this.w5j_1;
      }
      y92(_id, shortId, name, legalName, email, phoneNumber, address, image, preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy) {
        return new (Contractor())(_id, shortId, name, legalName, email, phoneNumber, address, image, preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy);
      }
      y5j(_id, shortId, name, legalName, email, phoneNumber, address, image, preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy, $super) {
        _id = _id === VOID ? this.v5i_1 : _id;
        shortId = shortId === VOID ? this.w5i_1 : shortId;
        name = name === VOID ? this.x5i_1 : name;
        legalName = legalName === VOID ? this.y5i_1 : legalName;
        email = email === VOID ? this.z5i_1 : email;
        phoneNumber = phoneNumber === VOID ? this.a5j_1 : phoneNumber;
        address = address === VOID ? this.b5j_1 : address;
        image = image === VOID ? this.c5j_1 : image;
        preferredTitle = preferredTitle === VOID ? this.d5j_1 : preferredTitle;
        trade = trade === VOID ? this.e5j_1 : trade;
        entityType = entityType === VOID ? this.f5j_1 : entityType;
        contactFirstName = contactFirstName === VOID ? this.g5j_1 : contactFirstName;
        contactLastName = contactLastName === VOID ? this.h5j_1 : contactLastName;
        contactEmail = contactEmail === VOID ? this.i5j_1 : contactEmail;
        contactPhoneNumber = contactPhoneNumber === VOID ? this.j5j_1 : contactPhoneNumber;
        contactAddress = contactAddress === VOID ? this.k5j_1 : contactAddress;
        operationStates = operationStates === VOID ? this.l5j_1 : operationStates;
        annualRevenue = annualRevenue === VOID ? this.m5j_1 : annualRevenue;
        averageJobSize = averageJobSize === VOID ? this.n5j_1 : averageJobSize;
        employeeCount = employeeCount === VOID ? this.o5j_1 : employeeCount;
        otherBusinessData = otherBusinessData === VOID ? this.p5j_1 : otherBusinessData;
        stateEntityNumber = stateEntityNumber === VOID ? this.q5j_1 : stateEntityNumber;
        ein = ein === VOID ? this.r5j_1 : ein;
        owners = owners === VOID ? this.s5j_1 : owners;
        status = status === VOID ? this.t5j_1 : status;
        paymentId = paymentId === VOID ? this.u5j_1 : paymentId;
        created = created === VOID ? this.v5j_1 : created;
        readBy = readBy === VOID ? this.w5j_1 : readBy;
        var tmp;
        if ($super === VOID) {
          tmp = this.y92(_id, shortId, name, legalName, email, phoneNumber, address, image, preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy);
        } else {
          var tmp_0 = $super.y92;
          var tmp_1 = image;
          tmp = tmp_0.call(this, _id, new (ShortId())(shortId), name, legalName, email, phoneNumber, address, tmp_1 == null ? null : new (ServerFile())(tmp_1), preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy);
        }
        return tmp;
      }
      toString() {
        var tmp = this.v5i_1.toString();
        var tmp_0 = ShortId__toString_impl_wslzee(this.w5i_1);
        var tmp_1 = this.b5j_1.toString();
        var tmp_2 = this.c5j_1;
        return 'Contractor(_id=' + tmp + ', shortId=' + tmp_0 + ', name=' + this.x5i_1 + ', legalName=' + this.y5i_1 + ', email=' + this.z5i_1 + ', phoneNumber=' + this.a5j_1 + ', address=' + tmp_1 + ', image=' + toString_0(tmp_2 == null ? null : new (ServerFile())(tmp_2)) + ', preferredTitle=' + this.d5j_1.toString() + ', trade=' + this.e5j_1 + ', entityType=' + this.f5j_1 + ', contactFirstName=' + this.g5j_1 + ', contactLastName=' + this.h5j_1 + ', contactEmail=' + this.i5j_1 + ', contactPhoneNumber=' + this.j5j_1 + ', contactAddress=' + this.k5j_1.toString() + ', operationStates=' + toString(this.l5j_1) + ', annualRevenue=' + this.m5j_1 + ', averageJobSize=' + this.n5j_1 + ', employeeCount=' + this.o5j_1 + ', otherBusinessData=' + this.p5j_1 + ', stateEntityNumber=' + this.q5j_1 + ', ein=' + this.r5j_1 + ', owners=' + toString(this.s5j_1) + ', status=' + toString(this.t5j_1) + ', paymentId=' + this.u5j_1 + ', created=' + this.v5j_1.toString() + ', readBy=' + toString(this.w5j_1) + ')';
      }
      hashCode() {
        var result = this.v5i_1.hashCode();
        result = imul(result, 31) + ShortId__hashCode_impl_ghc5rv(this.w5i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x5i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y5i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z5i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a5j_1) | 0;
        result = imul(result, 31) + this.b5j_1.hashCode() | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.c5j_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.c5j_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + this.d5j_1.hashCode() | 0;
        result = imul(result, 31) + (this.e5j_1 == null ? 0 : getStringHashCode(this.e5j_1)) | 0;
        result = imul(result, 31) + (this.f5j_1 == null ? 0 : getStringHashCode(this.f5j_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.g5j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h5j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i5j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j5j_1) | 0;
        result = imul(result, 31) + this.k5j_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.l5j_1) | 0;
        result = imul(result, 31) + (this.m5j_1 == null ? 0 : this.m5j_1) | 0;
        result = imul(result, 31) + (this.n5j_1 == null ? 0 : this.n5j_1) | 0;
        result = imul(result, 31) + (this.o5j_1 == null ? 0 : this.o5j_1) | 0;
        result = imul(result, 31) + (this.p5j_1 == null ? 0 : getStringHashCode(this.p5j_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.q5j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r5j_1) | 0;
        result = imul(result, 31) + hashCode(this.s5j_1) | 0;
        result = imul(result, 31) + this.t5j_1.hashCode() | 0;
        result = imul(result, 31) + (this.u5j_1 == null ? 0 : getStringHashCode(this.u5j_1)) | 0;
        result = imul(result, 31) + this.v5j_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.w5j_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Contractor()))
          return false;
        if (!this.v5i_1.equals(other.v5i_1))
          return false;
        if (!(this.w5i_1 === other.w5i_1))
          return false;
        if (!(this.x5i_1 === other.x5i_1))
          return false;
        if (!(this.y5i_1 === other.y5i_1))
          return false;
        if (!(this.z5i_1 === other.z5i_1))
          return false;
        if (!(this.a5j_1 === other.a5j_1))
          return false;
        if (!this.b5j_1.equals(other.b5j_1))
          return false;
        var tmp = this.c5j_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.c5j_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        if (!this.d5j_1.equals(other.d5j_1))
          return false;
        if (!(this.e5j_1 == other.e5j_1))
          return false;
        if (!(this.f5j_1 == other.f5j_1))
          return false;
        if (!(this.g5j_1 === other.g5j_1))
          return false;
        if (!(this.h5j_1 === other.h5j_1))
          return false;
        if (!(this.i5j_1 === other.i5j_1))
          return false;
        if (!(this.j5j_1 === other.j5j_1))
          return false;
        if (!this.k5j_1.equals(other.k5j_1))
          return false;
        if (!equals(this.l5j_1, other.l5j_1))
          return false;
        if (!(this.m5j_1 == other.m5j_1))
          return false;
        if (!(this.n5j_1 == other.n5j_1))
          return false;
        if (!(this.o5j_1 == other.o5j_1))
          return false;
        if (!(this.p5j_1 == other.p5j_1))
          return false;
        if (!(this.q5j_1 === other.q5j_1))
          return false;
        if (!(this.r5j_1 === other.r5j_1))
          return false;
        if (!equals(this.s5j_1, other.s5j_1))
          return false;
        if (!this.t5j_1.equals(other.t5j_1))
          return false;
        if (!(this.u5j_1 == other.u5j_1))
          return false;
        if (!this.v5j_1.equals(other.v5j_1))
          return false;
        if (!equals(this.w5j_1, other.w5j_1))
          return false;
        return true;
      }
      static x92(seen0, _id, shortId, name, legalName, email, phoneNumber, address, image, preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy, serializationConstructorMarker) {
        Companion_getInstance_20();
        if (!(6355068 === (6355068 & seen0))) {
          throwMissingFieldException(seen0, 6355068, $serializer_getInstance_21().v92_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.v5i_1 = Companion_getInstance().m2p();
        else
          $this.v5i_1 = _id;
        if (0 === (seen0 & 2))
          $this.w5i_1 = Companion_instance_47.k5n();
        else
          $this.w5i_1 = shortId;
        $this.x5i_1 = name;
        $this.y5i_1 = legalName;
        $this.z5i_1 = email;
        $this.a5j_1 = phoneNumber;
        $this.b5j_1 = address;
        if (0 === (seen0 & 128))
          $this.c5j_1 = null;
        else
          $this.c5j_1 = image;
        if (0 === (seen0 & 256))
          $this.d5j_1 = PreferredTitle_Contractor_getInstance();
        else
          $this.d5j_1 = preferredTitle;
        if (0 === (seen0 & 512))
          $this.e5j_1 = null;
        else
          $this.e5j_1 = trade;
        if (0 === (seen0 & 1024))
          $this.f5j_1 = null;
        else
          $this.f5j_1 = entityType;
        $this.g5j_1 = contactFirstName;
        $this.h5j_1 = contactLastName;
        $this.i5j_1 = contactEmail;
        $this.j5j_1 = contactPhoneNumber;
        $this.k5j_1 = contactAddress;
        if (0 === (seen0 & 65536)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.l5j_1 = emptySet();
        } else
          $this.l5j_1 = operationStates;
        if (0 === (seen0 & 131072))
          $this.m5j_1 = null;
        else
          $this.m5j_1 = annualRevenue;
        if (0 === (seen0 & 262144))
          $this.n5j_1 = null;
        else
          $this.n5j_1 = averageJobSize;
        if (0 === (seen0 & 524288))
          $this.o5j_1 = null;
        else
          $this.o5j_1 = employeeCount;
        if (0 === (seen0 & 1048576))
          $this.p5j_1 = null;
        else
          $this.p5j_1 = otherBusinessData;
        $this.q5j_1 = stateEntityNumber;
        $this.r5j_1 = ein;
        if (0 === (seen0 & 8388608)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp_0.s5j_1 = emptyList();
        } else
          $this.s5j_1 = owners;
        if (0 === (seen0 & 16777216))
          $this.t5j_1 = ContractorStatus_Registering_getInstance();
        else
          $this.t5j_1 = status;
        if (0 === (seen0 & 33554432))
          $this.u5j_1 = null;
        else
          $this.u5j_1 = paymentId;
        if (0 === (seen0 & 67108864)) {
          var tmp_1 = $this;
          // Inline function 'com.lightningkite.now' call
          tmp_1.v5j_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.v5j_1 = created;
        if (0 === (seen0 & 134217728))
          $this.w5j_1 = emptySet();
        else
          $this.w5j_1 = readBy;
        return $this;
      }
    }
    initMetadataForClass($, 'Contractor', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_21});
    ContractorClass = $;
  }
  return ContractorClass;
}
var Purpose_ArticleOfIncorporation_instance;
var Purpose_ProofOfEin_instance;
var Purpose_Other_instance;
function values_0() {
  return [Purpose_ArticleOfIncorporation_getInstance(), Purpose_ProofOfEin_getInstance(), Purpose_Other_getInstance()];
}
var Purpose_entriesInitialized;
function Purpose_initEntries() {
  if (Purpose_entriesInitialized)
    return Unit_instance;
  Purpose_entriesInitialized = true;
  Purpose_ArticleOfIncorporation_instance = Purpose().b93('ArticleOfIncorporation', 0);
  Purpose_ProofOfEin_instance = Purpose().b93('ProofOfEin', 1);
  Purpose_Other_instance = Purpose().b93('Other', 2);
}
function ContractorDocument$Companion$$childSerializers$_anonymous__bbujye() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_1() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_2() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_3() {
  return createSimpleEnumSerializer('com.crowpay.ContractorDocument.Purpose', values_0());
}
var PurposeClass;
function Purpose() {
  if (PurposeClass === VOID) {
    class $ extends Enum() {
      static b93(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'Purpose');
    PurposeClass = $;
  }
  return PurposeClass;
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      constructor() {
        Companion_instance_9 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ContractorDocument$Companion$$childSerializers$_anonymous__bbujye);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.y5g_1 = [tmp_1, tmp_3, null, null, tmp_5, tmp_7, lazy(tmp_8, ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_3)];
      }
      m2a() {
        return $serializer_getInstance_22();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_9;
function Companion_getInstance_21() {
  if (Companion_instance_9 === VOID)
    new (Companion_7())();
  return Companion_instance_9;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ContractorDocument', this, 7);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('contractor', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.c1b('name', false);
        tmp0_serialDesc.c1b('fileType', false);
        tmp0_serialDesc.c1b('file', false);
        tmp0_serialDesc.c1b('preview', true);
        tmp0_serialDesc.c1b('purpose', true);
        this.c93_1 = tmp0_serialDesc;
      }
      d93(encoder, value) {
        var tmp0_desc = this.c93_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_21().y5g_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.d5h_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.d5h_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.e5h_1);
        tmp1_output.a15(tmp0_desc, 2, value.f5h_1);
        tmp1_output.a15(tmp0_desc, 3, value.g5h_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), new (ServerFile())(value.h5h_1));
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          var tmp_0 = value.i5h_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = tmp2_cached[5].f2();
          var tmp_2 = value.i5h_1;
          tmp1_output.d15(tmp0_desc, 5, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !value.j5h_1.equals(Purpose_Other_getInstance())) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.j5h_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.d93(encoder, value instanceof ContractorDocument() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.c93_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.l13(tmp0_desc);
        var tmp12_cached = Companion_getInstance_21().y5g_1;
        if (tmp11_input.a14()) {
          tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, tmp12_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp = tmp12_cached[4].f2();
          var tmp_0 = tmp8_local4;
          var tmp_1 = tmp11_input.x13(tmp0_desc, 4, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp8_local4 = tmp_1 == null ? null : tmp_1.n2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp_2 = tmp12_cached[5].f2();
          var tmp_3 = tmp9_local5;
          var tmp_4 = tmp11_input.z13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
          tmp9_local5 = tmp_4 == null ? null : tmp_4.n2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.x13(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, tmp12_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_5 = tmp12_cached[4].f2();
                var tmp_6 = tmp8_local4;
                var tmp_7 = tmp11_input.x13(tmp0_desc, 4, tmp_5, tmp_6 == null ? null : new (ServerFile())(tmp_6));
                tmp8_local4 = tmp_7 == null ? null : tmp_7.n2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_8 = tmp12_cached[5].f2();
                var tmp_9 = tmp9_local5;
                var tmp_10 = tmp11_input.z13(tmp0_desc, 5, tmp_8, tmp_9 == null ? null : new (ServerFile())(tmp_9));
                tmp9_local5 = tmp_10 == null ? null : tmp_10.n2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.x13(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp11_input.m13(tmp0_desc);
        return ContractorDocument().e93(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      az() {
        return this.c93_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_21().y5g_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4].f2(), get_nullable(tmp0_cached[5].f2()), tmp0_cached[6].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_22() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
function Purpose_ArticleOfIncorporation_getInstance() {
  Purpose_initEntries();
  return Purpose_ArticleOfIncorporation_instance;
}
function Purpose_ProofOfEin_getInstance() {
  Purpose_initEntries();
  return Purpose_ProofOfEin_instance;
}
function Purpose_Other_getInstance() {
  Purpose_initEntries();
  return Purpose_Other_instance;
}
var ContractorDocumentClass;
function ContractorDocument() {
  if (ContractorDocumentClass === VOID) {
    class $ {
      constructor(_id, contractor, name, fileType, file, preview, purpose) {
        Companion_getInstance_21();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        preview = preview === VOID ? null : preview;
        purpose = purpose === VOID ? Purpose_Other_getInstance() : purpose;
        this.d5h_1 = _id;
        this.e5h_1 = contractor;
        this.f5h_1 = name;
        this.g5h_1 = fileType;
        this.h5h_1 = file;
        this.i5h_1 = preview;
        this.j5h_1 = purpose;
      }
      h40() {
        return this.d5h_1;
      }
      k20() {
        return this.f5h_1;
      }
      f93() {
        return this.g5h_1;
      }
      g93() {
        return this.h5h_1;
      }
      h93() {
        return this.i5h_1;
      }
      i93(_id, contractor, name, fileType, file, preview, purpose) {
        return new (ContractorDocument())(_id, contractor, name, fileType, file, preview, purpose);
      }
      l5h(_id, contractor, name, fileType, file, preview, purpose, $super) {
        _id = _id === VOID ? this.d5h_1 : _id;
        contractor = contractor === VOID ? this.e5h_1 : contractor;
        name = name === VOID ? this.f5h_1 : name;
        fileType = fileType === VOID ? this.g5h_1 : fileType;
        file = file === VOID ? this.h5h_1 : file;
        preview = preview === VOID ? this.i5h_1 : preview;
        purpose = purpose === VOID ? this.j5h_1 : purpose;
        var tmp;
        if ($super === VOID) {
          tmp = this.i93(_id, contractor, name, fileType, file, preview, purpose);
        } else {
          var tmp_0 = $super.i93;
          var tmp_1 = preview;
          tmp = tmp_0.call(this, _id, contractor, name, fileType, new (ServerFile())(file), tmp_1 == null ? null : new (ServerFile())(tmp_1), purpose);
        }
        return tmp;
      }
      toString() {
        var tmp = this.d5h_1.toString();
        var tmp_0 = this.e5h_1.toString();
        var tmp_1 = ServerFile__toString_impl_4rulpa(this.h5h_1);
        var tmp_2 = this.i5h_1;
        return 'ContractorDocument(_id=' + tmp + ', contractor=' + tmp_0 + ', name=' + this.f5h_1 + ', fileType=' + this.g5h_1 + ', file=' + tmp_1 + ', preview=' + toString_0(tmp_2 == null ? null : new (ServerFile())(tmp_2)) + ', purpose=' + this.j5h_1.toString() + ')';
      }
      hashCode() {
        var result = this.d5h_1.hashCode();
        result = imul(result, 31) + this.e5h_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.f5h_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g5h_1) | 0;
        result = imul(result, 31) + ServerFile__hashCode_impl_qj0ii5(this.h5h_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.i5h_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.i5h_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + this.j5h_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ContractorDocument()))
          return false;
        if (!this.d5h_1.equals(other.d5h_1))
          return false;
        if (!this.e5h_1.equals(other.e5h_1))
          return false;
        if (!(this.f5h_1 === other.f5h_1))
          return false;
        if (!(this.g5h_1 === other.g5h_1))
          return false;
        if (!(this.h5h_1 === other.h5h_1))
          return false;
        var tmp = this.i5h_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.i5h_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        if (!this.j5h_1.equals(other.j5h_1))
          return false;
        return true;
      }
      static e93(seen0, _id, contractor, name, fileType, file, preview, purpose, serializationConstructorMarker) {
        Companion_getInstance_21();
        if (!(30 === (30 & seen0))) {
          throwMissingFieldException(seen0, 30, $serializer_getInstance_22().c93_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.d5h_1 = Companion_getInstance().m2p();
        else
          $this.d5h_1 = _id;
        $this.e5h_1 = contractor;
        $this.f5h_1 = name;
        $this.g5h_1 = fileType;
        $this.h5h_1 = file;
        if (0 === (seen0 & 32))
          $this.i5h_1 = null;
        else
          $this.i5h_1 = preview;
        if (0 === (seen0 & 64))
          $this.j5h_1 = Purpose_Other_getInstance();
        else
          $this.j5h_1 = purpose;
        return $this;
      }
    }
    initMetadataForClass($, 'ContractorDocument', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_22});
    ContractorDocumentClass = $;
  }
  return ContractorDocumentClass;
}
function ContractorNote$Companion$$childSerializers$_anonymous__32pyqr() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_2() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      constructor() {
        Companion_instance_10 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ContractorNote$Companion$$childSerializers$_anonymous__32pyqr);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.y5o_1 = [tmp_1, tmp_3, tmp_5, null, tmp_7, tmp_9, lazy(tmp_10, ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_4)];
      }
      m2a() {
        return $serializer_getInstance_23();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_10;
function Companion_getInstance_22() {
  if (Companion_instance_10 === VOID)
    new (Companion_8())();
  return Companion_instance_10;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ContractorNote', this, 7);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('lineItem', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.c1b('message', false);
        tmp0_serialDesc.c1b('files', true);
        tmp0_serialDesc.c1b('at', true);
        tmp0_serialDesc.c1b('readBy', true);
        this.j93_1 = tmp0_serialDesc;
      }
      k93(encoder, value) {
        var tmp0_desc = this.j93_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_22().y5o_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.d5p_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.d5p_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.e5p_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.f5p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.f5p_1);
        }
        tmp1_output.a15(tmp0_desc, 3, value.g5p_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !equals(value.h5p_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.h5p_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp = !value.i5p_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.i5p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !equals(value.j5p_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.j5p_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.k93(encoder, value instanceof ContractorNote() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.j93_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.l13(tmp0_desc);
        var tmp12_cached = Companion_getInstance_22().y5o_1;
        if (tmp11_input.a14()) {
          tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, tmp12_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.z13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, tmp12_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.x13(tmp0_desc, 5, tmp12_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.x13(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, tmp12_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.z13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, tmp12_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.x13(tmp0_desc, 5, tmp12_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.x13(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp11_input.m13(tmp0_desc);
        return ContractorNote().l93(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      az() {
        return this.j93_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_22().y5o_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable(tmp0_cached[2].f2()), StringSerializer_getInstance(), tmp0_cached[4].f2(), tmp0_cached[5].f2(), tmp0_cached[6].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_23() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
var ContractorNoteClass;
function ContractorNote() {
  if (ContractorNoteClass === VOID) {
    class $ {
      constructor(_id, project, lineItem, message, files, at, readBy) {
        Companion_getInstance_22();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        lineItem = lineItem === VOID ? null : lineItem;
        files = files === VOID ? emptyList() : files;
        var tmp;
        if (at === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = at;
        }
        at = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.d5p_1 = _id;
        this.e5p_1 = project;
        this.f5p_1 = lineItem;
        this.g5p_1 = message;
        this.h5p_1 = files;
        this.i5p_1 = at;
        this.j5p_1 = readBy;
      }
      h40() {
        return this.d5p_1;
      }
      t91() {
        return this.j5p_1;
      }
      m93(_id, project, lineItem, message, files, at, readBy) {
        return new (ContractorNote())(_id, project, lineItem, message, files, at, readBy);
      }
      l5p(_id, project, lineItem, message, files, at, readBy, $super) {
        _id = _id === VOID ? this.d5p_1 : _id;
        project = project === VOID ? this.e5p_1 : project;
        lineItem = lineItem === VOID ? this.f5p_1 : lineItem;
        message = message === VOID ? this.g5p_1 : message;
        files = files === VOID ? this.h5p_1 : files;
        at = at === VOID ? this.i5p_1 : at;
        readBy = readBy === VOID ? this.j5p_1 : readBy;
        return $super === VOID ? this.m93(_id, project, lineItem, message, files, at, readBy) : $super.m93.call(this, _id, project, lineItem, message, files, at, readBy);
      }
      toString() {
        return 'ContractorNote(_id=' + this.d5p_1.toString() + ', project=' + this.e5p_1.toString() + ', lineItem=' + toString_0(this.f5p_1) + ', message=' + this.g5p_1 + ', files=' + toString(this.h5p_1) + ', at=' + this.i5p_1.toString() + ', readBy=' + toString(this.j5p_1) + ')';
      }
      hashCode() {
        var result = this.d5p_1.hashCode();
        result = imul(result, 31) + this.e5p_1.hashCode() | 0;
        result = imul(result, 31) + (this.f5p_1 == null ? 0 : this.f5p_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.g5p_1) | 0;
        result = imul(result, 31) + hashCode(this.h5p_1) | 0;
        result = imul(result, 31) + this.i5p_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.j5p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ContractorNote()))
          return false;
        if (!this.d5p_1.equals(other.d5p_1))
          return false;
        if (!this.e5p_1.equals(other.e5p_1))
          return false;
        if (!equals(this.f5p_1, other.f5p_1))
          return false;
        if (!(this.g5p_1 === other.g5p_1))
          return false;
        if (!equals(this.h5p_1, other.h5p_1))
          return false;
        if (!this.i5p_1.equals(other.i5p_1))
          return false;
        if (!equals(this.j5p_1, other.j5p_1))
          return false;
        return true;
      }
      static l93(seen0, _id, project, lineItem, message, files, at, readBy, serializationConstructorMarker) {
        Companion_getInstance_22();
        if (!(10 === (10 & seen0))) {
          throwMissingFieldException(seen0, 10, $serializer_getInstance_23().j93_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.d5p_1 = Companion_getInstance().m2p();
        else
          $this.d5p_1 = _id;
        $this.e5p_1 = project;
        if (0 === (seen0 & 4))
          $this.f5p_1 = null;
        else
          $this.f5p_1 = lineItem;
        $this.g5p_1 = message;
        if (0 === (seen0 & 16))
          $this.h5p_1 = emptyList();
        else
          $this.h5p_1 = files;
        if (0 === (seen0 & 32)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.i5p_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.i5p_1 = at;
        if (0 === (seen0 & 64))
          $this.j5p_1 = emptySet();
        else
          $this.j5p_1 = readBy;
        return $this;
      }
    }
    initMetadataForClass($, 'ContractorNote', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_23});
    ContractorNoteClass = $;
  }
  return ContractorNoteClass;
}
function Dispute$Companion$$childSerializers$_anonymous__k8vm1m() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Dispute$Companion$$childSerializers$_anonymous__k8vm1m_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Dispute$Companion$$childSerializers$_anonymous__k8vm1m_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Dispute$Companion$$childSerializers$_anonymous__k8vm1m_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function Dispute$Companion$$childSerializers$_anonymous__k8vm1m_3() {
  return Companion_getInstance_55().m2a();
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      constructor() {
        Companion_instance_11 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Dispute$Companion$$childSerializers$_anonymous__k8vm1m);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Dispute$Companion$$childSerializers$_anonymous__k8vm1m_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, Dispute$Companion$$childSerializers$_anonymous__k8vm1m_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, Dispute$Companion$$childSerializers$_anonymous__k8vm1m_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d5w_1 = [tmp_1, tmp_3, null, tmp_5, null, null, null, null, tmp_7, lazy(tmp_8, Dispute$Companion$$childSerializers$_anonymous__k8vm1m_3)];
      }
      m2a() {
        return $serializer_getInstance_24();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_11;
function Companion_getInstance_23() {
  if (Companion_instance_11 === VOID)
    new (Companion_9())();
  return Companion_instance_11;
}
var $serializerClass_8;
function $serializer_8() {
  if ($serializerClass_8 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Dispute', this, 10);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('lineItem', true);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.c1b('incident', true);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Incident())));
        tmp0_serialDesc.c1b('filed', false);
        tmp0_serialDesc.c1b('lockProject', true);
        tmp0_serialDesc.c1b('filedForArbitration', true);
        tmp0_serialDesc.c1b('resolved', true);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('state', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        this.n93_1 = tmp0_serialDesc;
      }
      o93(encoder, value) {
        var tmp0_desc = this.n93_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_23().d5w_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.k5w_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.k5w_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.l5w_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.m5w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, $serializer_getInstance_6(), value.m5w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.n5w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.n5w_1);
        }
        tmp1_output.c15(tmp0_desc, 4, $serializer_getInstance_4(), value.o5w_1);
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.p5w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, $serializer_getInstance_4(), value.p5w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.q5w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, $serializer_getInstance_7(), value.q5w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.r5w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, $serializer_getInstance_4(), value.r5w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.s5w_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.s5w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !value.t5w_1.equals(DisputeState_Ongoing_getInstance())) {
          tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.t5w_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.o93(encoder, value instanceof Dispute() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n93_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_input = decoder.l13(tmp0_desc);
        var tmp15_cached = Companion_getInstance_23().d5w_1;
        if (tmp14_input.a14()) {
          tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.z13(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.z13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.x13(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.z13(tmp0_desc, 5, $serializer_getInstance_4(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.z13(tmp0_desc, 6, $serializer_getInstance_7(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.x13(tmp0_desc, 9, tmp15_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.z13(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.z13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.x13(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.z13(tmp0_desc, 5, $serializer_getInstance_4(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.z13(tmp0_desc, 6, $serializer_getInstance_7(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.x13(tmp0_desc, 9, tmp15_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp14_input.m13(tmp0_desc);
        return Dispute().p93(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      az() {
        return this.n93_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_23().d5w_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable($serializer_getInstance_6()), get_nullable(tmp0_cached[3].f2()), $serializer_getInstance_4(), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_7()), get_nullable($serializer_getInstance_4()), tmp0_cached[8].f2(), tmp0_cached[9].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_8 = $;
  }
  return $serializerClass_8;
}
var $serializer_instance_8;
function $serializer_getInstance_24() {
  if ($serializer_instance_8 === VOID)
    new ($serializer_8())();
  return $serializer_instance_8;
}
var DisputeClass;
function Dispute() {
  if (DisputeClass === VOID) {
    class $ {
      constructor(_id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state) {
        Companion_getInstance_23();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        lineItem = lineItem === VOID ? null : lineItem;
        incident = incident === VOID ? null : incident;
        lockProject = lockProject === VOID ? null : lockProject;
        filedForArbitration = filedForArbitration === VOID ? null : filedForArbitration;
        resolved = resolved === VOID ? null : resolved;
        readBy = readBy === VOID ? emptySet() : readBy;
        state = state === VOID ? DisputeState_Ongoing_getInstance() : state;
        this.k5w_1 = _id;
        this.l5w_1 = project;
        this.m5w_1 = lineItem;
        this.n5w_1 = incident;
        this.o5w_1 = filed;
        this.p5w_1 = lockProject;
        this.q5w_1 = filedForArbitration;
        this.r5w_1 = resolved;
        this.s5w_1 = readBy;
        this.t5w_1 = state;
      }
      h40() {
        return this.k5w_1;
      }
      t91() {
        return this.s5w_1;
      }
      q93(_id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state) {
        return new (Dispute())(_id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state);
      }
      v5w(_id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state, $super) {
        _id = _id === VOID ? this.k5w_1 : _id;
        project = project === VOID ? this.l5w_1 : project;
        lineItem = lineItem === VOID ? this.m5w_1 : lineItem;
        incident = incident === VOID ? this.n5w_1 : incident;
        filed = filed === VOID ? this.o5w_1 : filed;
        lockProject = lockProject === VOID ? this.p5w_1 : lockProject;
        filedForArbitration = filedForArbitration === VOID ? this.q5w_1 : filedForArbitration;
        resolved = resolved === VOID ? this.r5w_1 : resolved;
        readBy = readBy === VOID ? this.s5w_1 : readBy;
        state = state === VOID ? this.t5w_1 : state;
        return $super === VOID ? this.q93(_id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state) : $super.q93.call(this, _id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state);
      }
      toString() {
        return 'Dispute(_id=' + this.k5w_1.toString() + ', project=' + this.l5w_1.toString() + ', lineItem=' + toString_0(this.m5w_1) + ', incident=' + toString_0(this.n5w_1) + ', filed=' + this.o5w_1.toString() + ', lockProject=' + toString_0(this.p5w_1) + ', filedForArbitration=' + toString_0(this.q5w_1) + ', resolved=' + toString_0(this.r5w_1) + ', readBy=' + toString(this.s5w_1) + ', state=' + this.t5w_1.toString() + ')';
      }
      hashCode() {
        var result = this.k5w_1.hashCode();
        result = imul(result, 31) + this.l5w_1.hashCode() | 0;
        result = imul(result, 31) + (this.m5w_1 == null ? 0 : this.m5w_1.hashCode()) | 0;
        result = imul(result, 31) + (this.n5w_1 == null ? 0 : this.n5w_1.hashCode()) | 0;
        result = imul(result, 31) + this.o5w_1.hashCode() | 0;
        result = imul(result, 31) + (this.p5w_1 == null ? 0 : this.p5w_1.hashCode()) | 0;
        result = imul(result, 31) + (this.q5w_1 == null ? 0 : this.q5w_1.hashCode()) | 0;
        result = imul(result, 31) + (this.r5w_1 == null ? 0 : this.r5w_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.s5w_1) | 0;
        result = imul(result, 31) + this.t5w_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Dispute()))
          return false;
        if (!this.k5w_1.equals(other.k5w_1))
          return false;
        if (!this.l5w_1.equals(other.l5w_1))
          return false;
        if (!equals(this.m5w_1, other.m5w_1))
          return false;
        if (!equals(this.n5w_1, other.n5w_1))
          return false;
        if (!this.o5w_1.equals(other.o5w_1))
          return false;
        if (!equals(this.p5w_1, other.p5w_1))
          return false;
        if (!equals(this.q5w_1, other.q5w_1))
          return false;
        if (!equals(this.r5w_1, other.r5w_1))
          return false;
        if (!equals(this.s5w_1, other.s5w_1))
          return false;
        if (!this.t5w_1.equals(other.t5w_1))
          return false;
        return true;
      }
      static p93(seen0, _id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state, serializationConstructorMarker) {
        Companion_getInstance_23();
        if (!(18 === (18 & seen0))) {
          throwMissingFieldException(seen0, 18, $serializer_getInstance_24().n93_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.k5w_1 = Companion_getInstance().m2p();
        else
          $this.k5w_1 = _id;
        $this.l5w_1 = project;
        if (0 === (seen0 & 4))
          $this.m5w_1 = null;
        else
          $this.m5w_1 = lineItem;
        if (0 === (seen0 & 8))
          $this.n5w_1 = null;
        else
          $this.n5w_1 = incident;
        $this.o5w_1 = filed;
        if (0 === (seen0 & 32))
          $this.p5w_1 = null;
        else
          $this.p5w_1 = lockProject;
        if (0 === (seen0 & 64))
          $this.q5w_1 = null;
        else
          $this.q5w_1 = filedForArbitration;
        if (0 === (seen0 & 128))
          $this.r5w_1 = null;
        else
          $this.r5w_1 = resolved;
        if (0 === (seen0 & 256))
          $this.s5w_1 = emptySet();
        else
          $this.s5w_1 = readBy;
        if (0 === (seen0 & 512))
          $this.t5w_1 = DisputeState_Ongoing_getInstance();
        else
          $this.t5w_1 = state;
        return $this;
      }
    }
    initMetadataForClass($, 'Dispute', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_24});
    DisputeClass = $;
  }
  return DisputeClass;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_25();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_12;
function Companion_getInstance_24() {
  return Companion_instance_12;
}
var $serializerClass_9;
function $serializer_9() {
  if ($serializerClass_9 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.EntityType', this, 1);
        tmp0_serialDesc.c1b('_id', false);
        this.r93_1 = tmp0_serialDesc;
      }
      s93(encoder, value) {
        var tmp0_desc = this.r93_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.n5z_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.s93(encoder, value instanceof EntityType() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.r93_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return EntityType().t93(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.r93_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_9 = $;
  }
  return $serializerClass_9;
}
var $serializer_instance_9;
function $serializer_getInstance_25() {
  if ($serializer_instance_9 === VOID)
    new ($serializer_9())();
  return $serializer_instance_9;
}
var EntityTypeClass;
function EntityType() {
  if (EntityTypeClass === VOID) {
    class $ {
      constructor(_id) {
        this.n5z_1 = _id;
      }
      h40() {
        return this.n5z_1;
      }
      p5z(_id) {
        return new (EntityType())(_id);
      }
      toString() {
        return 'EntityType(_id=' + this.n5z_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.n5z_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EntityType()))
          return false;
        if (!(this.n5z_1 === other.n5z_1))
          return false;
        return true;
      }
      static t93(seen0, _id, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_25().r93_1);
        }
        var $this = createThis(this);
        $this.n5z_1 = _id;
        return $this;
      }
    }
    initMetadataForClass($, 'EntityType', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_25});
    EntityTypeClass = $;
  }
  return EntityTypeClass;
}
function FundsRequest$Companion$$childSerializers$_anonymous__mmbn7b() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function FundsRequest$Companion$$childSerializers$_anonymous__mmbn7b_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function FundsRequest$Companion$$childSerializers$_anonymous__mmbn7b_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      constructor() {
        Companion_instance_13 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, FundsRequest$Companion$$childSerializers$_anonymous__mmbn7b);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, FundsRequest$Companion$$childSerializers$_anonymous__mmbn7b_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.a61_1 = [tmp_1, tmp_3, null, null, null, null, null, lazy(tmp_4, FundsRequest$Companion$$childSerializers$_anonymous__mmbn7b_1)];
      }
      m2a() {
        return $serializer_getInstance_26();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_13;
function Companion_getInstance_25() {
  if (Companion_instance_13 === VOID)
    new (Companion_11())();
  return Companion_instance_13;
}
var $serializerClass_10;
function $serializer_10() {
  if ($serializerClass_10 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_10 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.FundsRequest', this, 8);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('access', false);
        tmp0_serialDesc.c1b('amount', false);
        tmp0_serialDesc.c1b('summary', true);
        tmp0_serialDesc.c1b('pendingDeposits', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('deposits', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('funded', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        this.u93_1 = tmp0_serialDesc;
      }
      v93(encoder, value) {
        var tmp0_desc = this.u93_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_25().a61_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.f61_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.f61_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.g61_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance_4(), value.h61_1);
        tmp1_output.c15(tmp0_desc, 3, $serializer_getInstance_2(), new (MonetaryValue())(value.i61_1));
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.j61_1 === '')) {
          tmp1_output.a15(tmp0_desc, 4, value.j61_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.k61_1 === Companion_instance.o62(0))) {
          tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_2(), new (MonetaryValue())(value.k61_1));
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.l61_1 === Companion_instance.o62(0))) {
          tmp1_output.c15(tmp0_desc, 6, $serializer_getInstance_2(), new (MonetaryValue())(value.l61_1));
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 7)) {
          tmp = true;
        } else {
          var tmp_0;
          if (MonetaryValue__compareTo_impl_w7ul1r(value.l61_1, value.i61_1) >= 0) {
            // Inline function 'com.lightningkite.now' call
            tmp_0 = get_default(Companion_instance_0).d1m();
          } else {
            tmp_0 = null;
          }
          tmp = !equals(value.m61_1, tmp_0);
        }
        if (tmp) {
          tmp1_output.d15(tmp0_desc, 7, tmp2_cached[7].f2(), value.m61_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.v93(encoder, value instanceof FundsRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.u93_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.l13(tmp0_desc);
        var tmp13_cached = Companion_getInstance_25().a61_1;
        if (tmp12_input.a14()) {
          tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp7_local3;
          var tmp_1 = tmp12_input.x13(tmp0_desc, 3, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp7_local3 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp_2 = $serializer_getInstance_2();
          var tmp_3 = tmp9_local5;
          var tmp_4 = tmp12_input.x13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp9_local5 = tmp_4 == null ? null : tmp_4.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp_5 = $serializer_getInstance_2();
          var tmp_6 = tmp10_local6;
          var tmp_7 = tmp12_input.x13(tmp0_desc, 6, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
          tmp10_local6 = tmp_7 == null ? null : tmp_7.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.z13(tmp0_desc, 7, tmp13_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_8 = $serializer_getInstance_2();
                var tmp_9 = tmp7_local3;
                var tmp_10 = tmp12_input.x13(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
                tmp7_local3 = tmp_10 == null ? null : tmp_10.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_11 = $serializer_getInstance_2();
                var tmp_12 = tmp9_local5;
                var tmp_13 = tmp12_input.x13(tmp0_desc, 5, tmp_11, tmp_12 == null ? null : new (MonetaryValue())(tmp_12));
                tmp9_local5 = tmp_13 == null ? null : tmp_13.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_14 = $serializer_getInstance_2();
                var tmp_15 = tmp10_local6;
                var tmp_16 = tmp12_input.x13(tmp0_desc, 6, tmp_14, tmp_15 == null ? null : new (MonetaryValue())(tmp_15));
                tmp10_local6 = tmp_16 == null ? null : tmp_16.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.z13(tmp0_desc, 7, tmp13_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp12_input.m13(tmp0_desc);
        return FundsRequest().w93(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      az() {
        return this.u93_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_25().a61_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), $serializer_getInstance_4(), $serializer_getInstance_2(), StringSerializer_getInstance(), $serializer_getInstance_2(), $serializer_getInstance_2(), get_nullable(tmp0_cached[7].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_10 = $;
  }
  return $serializerClass_10;
}
var $serializer_instance_10;
function $serializer_getInstance_26() {
  if ($serializer_instance_10 === VOID)
    new ($serializer_10())();
  return $serializer_instance_10;
}
var FundsRequestClass;
function FundsRequest() {
  if (FundsRequestClass === VOID) {
    class $ {
      constructor(_id, project, access, amount, summary, pendingDeposits, deposits, funded) {
        Companion_getInstance_25();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        summary = summary === VOID ? '' : summary;
        pendingDeposits = pendingDeposits === VOID ? Companion_instance.o62(0) : pendingDeposits;
        deposits = deposits === VOID ? Companion_instance.o62(0) : deposits;
        var tmp;
        if (funded === VOID) {
          var tmp_0;
          if (MonetaryValue__compareTo_impl_w7ul1r(deposits, amount) >= 0) {
            // Inline function 'com.lightningkite.now' call
            tmp_0 = get_default(Companion_instance_0).d1m();
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        } else {
          tmp = funded;
        }
        funded = tmp;
        this.f61_1 = _id;
        this.g61_1 = project;
        this.h61_1 = access;
        this.i61_1 = amount;
        this.j61_1 = summary;
        this.k61_1 = pendingDeposits;
        this.l61_1 = deposits;
        this.m61_1 = funded;
      }
      h40() {
        return this.f61_1;
      }
      x93(_id, project, access, amount, summary, pendingDeposits, deposits, funded) {
        return new (FundsRequest())(_id, project, access, amount, summary, pendingDeposits, deposits, funded);
      }
      o61(_id, project, access, amount, summary, pendingDeposits, deposits, funded, $super) {
        _id = _id === VOID ? this.f61_1 : _id;
        project = project === VOID ? this.g61_1 : project;
        access = access === VOID ? this.h61_1 : access;
        amount = amount === VOID ? this.i61_1 : amount;
        summary = summary === VOID ? this.j61_1 : summary;
        pendingDeposits = pendingDeposits === VOID ? this.k61_1 : pendingDeposits;
        deposits = deposits === VOID ? this.l61_1 : deposits;
        funded = funded === VOID ? this.m61_1 : funded;
        return $super === VOID ? this.x93(_id, project, access, amount, summary, pendingDeposits, deposits, funded) : $super.x93.call(this, _id, project, access, new (MonetaryValue())(amount), summary, new (MonetaryValue())(pendingDeposits), new (MonetaryValue())(deposits), funded);
      }
      toString() {
        return 'FundsRequest(_id=' + this.f61_1.toString() + ', project=' + this.g61_1.toString() + ', access=' + this.h61_1.toString() + ', amount=' + MonetaryValue__toString_impl_xslc77(this.i61_1) + ', summary=' + this.j61_1 + ', pendingDeposits=' + MonetaryValue__toString_impl_xslc77(this.k61_1) + ', deposits=' + MonetaryValue__toString_impl_xslc77(this.l61_1) + ', funded=' + toString_0(this.m61_1) + ')';
      }
      hashCode() {
        var result = this.f61_1.hashCode();
        result = imul(result, 31) + this.g61_1.hashCode() | 0;
        result = imul(result, 31) + this.h61_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.i61_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j61_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.k61_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.l61_1) | 0;
        result = imul(result, 31) + (this.m61_1 == null ? 0 : this.m61_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FundsRequest()))
          return false;
        if (!this.f61_1.equals(other.f61_1))
          return false;
        if (!this.g61_1.equals(other.g61_1))
          return false;
        if (!this.h61_1.equals(other.h61_1))
          return false;
        if (!(this.i61_1 === other.i61_1))
          return false;
        if (!(this.j61_1 === other.j61_1))
          return false;
        if (!(this.k61_1 === other.k61_1))
          return false;
        if (!(this.l61_1 === other.l61_1))
          return false;
        if (!equals(this.m61_1, other.m61_1))
          return false;
        return true;
      }
      static w93(seen0, _id, project, access, amount, summary, pendingDeposits, deposits, funded, serializationConstructorMarker) {
        Companion_getInstance_25();
        if (!(14 === (14 & seen0))) {
          throwMissingFieldException(seen0, 14, $serializer_getInstance_26().u93_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.f61_1 = Companion_getInstance().m2p();
        else
          $this.f61_1 = _id;
        $this.g61_1 = project;
        $this.h61_1 = access;
        $this.i61_1 = amount;
        if (0 === (seen0 & 16))
          $this.j61_1 = '';
        else
          $this.j61_1 = summary;
        if (0 === (seen0 & 32))
          $this.k61_1 = Companion_instance.o62(0);
        else
          $this.k61_1 = pendingDeposits;
        if (0 === (seen0 & 64))
          $this.l61_1 = Companion_instance.o62(0);
        else
          $this.l61_1 = deposits;
        if (0 === (seen0 & 128)) {
          var tmp = $this;
          var tmp_0;
          if (MonetaryValue__compareTo_impl_w7ul1r($this.l61_1, $this.i61_1) >= 0) {
            // Inline function 'com.lightningkite.now' call
            tmp_0 = get_default(Companion_instance_0).d1m();
          } else {
            tmp_0 = null;
          }
          tmp.m61_1 = tmp_0;
        } else
          $this.m61_1 = funded;
        return $this;
      }
    }
    initMetadataForClass($, 'FundsRequest', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_26});
    FundsRequestClass = $;
  }
  return FundsRequestClass;
}
function Incident$Companion$$childSerializers$_anonymous__hwsgq0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Incident$Companion$$childSerializers$_anonymous__hwsgq0_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Incident$Companion$$childSerializers$_anonymous__hwsgq0_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function Incident$Companion$$childSerializers$_anonymous__hwsgq0_2() {
  return Companion_getInstance_11().m2a();
}
function Incident$Companion$$childSerializers$_anonymous__hwsgq0_3() {
  return Companion_getInstance_5().m2a();
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      constructor() {
        Companion_instance_14 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Incident$Companion$$childSerializers$_anonymous__hwsgq0);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Incident$Companion$$childSerializers$_anonymous__hwsgq0_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, Incident$Companion$$childSerializers$_anonymous__hwsgq0_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, Incident$Companion$$childSerializers$_anonymous__hwsgq0_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.y62_1 = [tmp_1, tmp_3, null, null, null, tmp_5, tmp_7, lazy(tmp_8, Incident$Companion$$childSerializers$_anonymous__hwsgq0_3), null, null];
      }
      m2a() {
        return $serializer_getInstance_27();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_14;
function Companion_getInstance_26() {
  if (Companion_instance_14 === VOID)
    new (Companion_12())();
  return Companion_instance_14;
}
var $serializerClass_11;
function $serializer_11() {
  if ($serializerClass_11 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_11 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Incident', this, 10);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('filed', false);
        tmp0_serialDesc.c1b('issue', true);
        tmp0_serialDesc.c1b('resolved', true);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('concern', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('state', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('canFileDispute', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('canLockProject', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        this.y93_1 = tmp0_serialDesc;
      }
      z93(encoder, value) {
        var tmp0_desc = this.y93_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_26().y62_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.d63_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.d63_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.e63_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance_4(), value.f63_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.g63_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, $serializer_getInstance_3(), value.g63_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.h63_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, $serializer_getInstance_4(), value.h63_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !equals(value.i63_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.i63_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !value.j63_1.equals(ClientConcern_Other_getInstance())) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.j63_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !value.k63_1.equals(IncidentState_Filed_getInstance())) {
          tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.k63_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.l63_1 === false)) {
          tmp1_output.s14(tmp0_desc, 8, value.l63_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.m63_1 === false)) {
          tmp1_output.s14(tmp0_desc, 9, value.m63_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.z93(encoder, value instanceof Incident() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.y93_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = false;
        var tmp13_local9 = false;
        var tmp14_input = decoder.l13(tmp0_desc);
        var tmp15_cached = Companion_getInstance_26().y62_1;
        if (tmp14_input.a14()) {
          tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.z13(tmp0_desc, 3, $serializer_getInstance_3(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.z13(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.x13(tmp0_desc, 5, tmp15_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.x13(tmp0_desc, 6, tmp15_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.x13(tmp0_desc, 7, tmp15_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.n13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.n13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.z13(tmp0_desc, 3, $serializer_getInstance_3(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.z13(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.x13(tmp0_desc, 5, tmp15_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.x13(tmp0_desc, 6, tmp15_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.x13(tmp0_desc, 7, tmp15_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.n13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.n13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp14_input.m13(tmp0_desc);
        return Incident().a94(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      az() {
        return this.y93_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_26().y62_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), $serializer_getInstance_4(), get_nullable($serializer_getInstance_3()), get_nullable($serializer_getInstance_4()), tmp0_cached[5].f2(), tmp0_cached[6].f2(), tmp0_cached[7].f2(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_11 = $;
  }
  return $serializerClass_11;
}
var $serializer_instance_11;
function $serializer_getInstance_27() {
  if ($serializer_instance_11 === VOID)
    new ($serializer_11())();
  return $serializer_instance_11;
}
var IncidentClass;
function Incident() {
  if (IncidentClass === VOID) {
    class $ {
      constructor(_id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject) {
        Companion_getInstance_26();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        issue = issue === VOID ? null : issue;
        resolved = resolved === VOID ? null : resolved;
        readBy = readBy === VOID ? emptySet() : readBy;
        concern = concern === VOID ? ClientConcern_Other_getInstance() : concern;
        state = state === VOID ? IncidentState_Filed_getInstance() : state;
        canFileDispute = canFileDispute === VOID ? false : canFileDispute;
        canLockProject = canLockProject === VOID ? false : canLockProject;
        this.d63_1 = _id;
        this.e63_1 = project;
        this.f63_1 = filed;
        this.g63_1 = issue;
        this.h63_1 = resolved;
        this.i63_1 = readBy;
        this.j63_1 = concern;
        this.k63_1 = state;
        this.l63_1 = canFileDispute;
        this.m63_1 = canLockProject;
      }
      h40() {
        return this.d63_1;
      }
      t91() {
        return this.i63_1;
      }
      b94(_id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject) {
        return new (Incident())(_id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject);
      }
      o63(_id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject, $super) {
        _id = _id === VOID ? this.d63_1 : _id;
        project = project === VOID ? this.e63_1 : project;
        filed = filed === VOID ? this.f63_1 : filed;
        issue = issue === VOID ? this.g63_1 : issue;
        resolved = resolved === VOID ? this.h63_1 : resolved;
        readBy = readBy === VOID ? this.i63_1 : readBy;
        concern = concern === VOID ? this.j63_1 : concern;
        state = state === VOID ? this.k63_1 : state;
        canFileDispute = canFileDispute === VOID ? this.l63_1 : canFileDispute;
        canLockProject = canLockProject === VOID ? this.m63_1 : canLockProject;
        return $super === VOID ? this.b94(_id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject) : $super.b94.call(this, _id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject);
      }
      toString() {
        return 'Incident(_id=' + this.d63_1.toString() + ', project=' + this.e63_1.toString() + ', filed=' + this.f63_1.toString() + ', issue=' + toString_0(this.g63_1) + ', resolved=' + toString_0(this.h63_1) + ', readBy=' + toString(this.i63_1) + ', concern=' + this.j63_1.toString() + ', state=' + toString(this.k63_1) + ', canFileDispute=' + this.l63_1 + ', canLockProject=' + this.m63_1 + ')';
      }
      hashCode() {
        var result = this.d63_1.hashCode();
        result = imul(result, 31) + this.e63_1.hashCode() | 0;
        result = imul(result, 31) + this.f63_1.hashCode() | 0;
        result = imul(result, 31) + (this.g63_1 == null ? 0 : this.g63_1.hashCode()) | 0;
        result = imul(result, 31) + (this.h63_1 == null ? 0 : this.h63_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.i63_1) | 0;
        result = imul(result, 31) + this.j63_1.hashCode() | 0;
        result = imul(result, 31) + this.k63_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.l63_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.m63_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Incident()))
          return false;
        if (!this.d63_1.equals(other.d63_1))
          return false;
        if (!this.e63_1.equals(other.e63_1))
          return false;
        if (!this.f63_1.equals(other.f63_1))
          return false;
        if (!equals(this.g63_1, other.g63_1))
          return false;
        if (!equals(this.h63_1, other.h63_1))
          return false;
        if (!equals(this.i63_1, other.i63_1))
          return false;
        if (!this.j63_1.equals(other.j63_1))
          return false;
        if (!this.k63_1.equals(other.k63_1))
          return false;
        if (!(this.l63_1 === other.l63_1))
          return false;
        if (!(this.m63_1 === other.m63_1))
          return false;
        return true;
      }
      static a94(seen0, _id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject, serializationConstructorMarker) {
        Companion_getInstance_26();
        if (!(6 === (6 & seen0))) {
          throwMissingFieldException(seen0, 6, $serializer_getInstance_27().y93_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.d63_1 = Companion_getInstance().m2p();
        else
          $this.d63_1 = _id;
        $this.e63_1 = project;
        $this.f63_1 = filed;
        if (0 === (seen0 & 8))
          $this.g63_1 = null;
        else
          $this.g63_1 = issue;
        if (0 === (seen0 & 16))
          $this.h63_1 = null;
        else
          $this.h63_1 = resolved;
        if (0 === (seen0 & 32))
          $this.i63_1 = emptySet();
        else
          $this.i63_1 = readBy;
        if (0 === (seen0 & 64))
          $this.j63_1 = ClientConcern_Other_getInstance();
        else
          $this.j63_1 = concern;
        if (0 === (seen0 & 128))
          $this.k63_1 = IncidentState_Filed_getInstance();
        else
          $this.k63_1 = state;
        if (0 === (seen0 & 256))
          $this.l63_1 = false;
        else
          $this.l63_1 = canFileDispute;
        if (0 === (seen0 & 512))
          $this.m63_1 = false;
        else
          $this.m63_1 = canLockProject;
        return $this;
      }
    }
    initMetadataForClass($, 'Incident', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_27});
    IncidentClass = $;
  }
  return IncidentClass;
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_3() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_5() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_13;
function Companion_13() {
  if (CompanionClass_13 === VOID) {
    class $ {
      constructor() {
        Companion_instance_15 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.r67_1 = [tmp_1, tmp_3, tmp_5, null, tmp_7, null, null, tmp_9, tmp_11, lazy(tmp_12, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_5), null];
      }
      m2a() {
        return $serializer_getInstance_28();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_13 = $;
  }
  return CompanionClass_13;
}
var Companion_instance_15;
function Companion_getInstance_27() {
  if (Companion_instance_15 === VOID)
    new (Companion_13())();
  return Companion_instance_15;
}
var $serializerClass_12;
function $serializer_12() {
  if ($serializerClass_12 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_12 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.IncidentMessage', this, 11);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('incident', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(Incident())));
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('clientMessage', false);
        tmp0_serialDesc.c1b('sender', false);
        tmp0_serialDesc.c1b('typeSerializable', false);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        tmp0_serialDesc.c1b('message', false);
        tmp0_serialDesc.c1b('attachments', true);
        tmp0_serialDesc.c1b('created', true);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('needsResponse', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        this.c94_1 = tmp0_serialDesc;
      }
      d94(encoder, value) {
        var tmp0_desc = this.c94_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_27().r67_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.w67_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.w67_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.x67_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.y67_1);
        tmp1_output.s14(tmp0_desc, 3, value.z67_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.a68_1);
        tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_13(), value.b68_1);
        tmp1_output.a15(tmp0_desc, 6, value.c68_1);
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !equals(value.d68_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.d68_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 8)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp = !value.e68_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.e68_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !equals(value.f68_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.f68_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.g68_1 === true)) {
          tmp1_output.s14(tmp0_desc, 10, value.g68_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.d94(encoder, value instanceof IncidentMessage() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.c94_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = false;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = false;
        var tmp16_input = decoder.l13(tmp0_desc);
        var tmp17_cached = Companion_getInstance_27().r67_1;
        if (tmp16_input.a14()) {
          tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp16_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp16_input.x13(tmp0_desc, 4, tmp17_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp16_input.x13(tmp0_desc, 5, $serializer_getInstance_13(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp16_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp16_input.x13(tmp0_desc, 7, tmp17_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp16_input.x13(tmp0_desc, 9, tmp17_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp16_input.n13(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp16_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp16_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp16_input.x13(tmp0_desc, 4, tmp17_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp16_input.x13(tmp0_desc, 5, $serializer_getInstance_13(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp16_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp16_input.x13(tmp0_desc, 7, tmp17_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp16_input.x13(tmp0_desc, 9, tmp17_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp16_input.n13(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp16_input.m13(tmp0_desc);
        return IncidentMessage().e94(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      az() {
        return this.c94_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_27().r67_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), BooleanSerializer_getInstance(), tmp0_cached[4].f2(), $serializer_getInstance_13(), StringSerializer_getInstance(), tmp0_cached[7].f2(), tmp0_cached[8].f2(), tmp0_cached[9].f2(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_12 = $;
  }
  return $serializerClass_12;
}
var $serializer_instance_12;
function $serializer_getInstance_28() {
  if ($serializer_instance_12 === VOID)
    new ($serializer_12())();
  return $serializer_instance_12;
}
function IncidentMessage$_get_type_$ref_ia9x1r() {
  return (p0) => p0.f94();
}
var IncidentMessageClass;
function IncidentMessage() {
  if (IncidentMessageClass === VOID) {
    class $ {
      constructor(_id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse) {
        Companion_getInstance_27();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        attachments = attachments === VOID ? emptyList() : attachments;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = created;
        }
        created = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        needsResponse = needsResponse === VOID ? true : needsResponse;
        this.w67_1 = _id;
        this.x67_1 = incident;
        this.y67_1 = project;
        this.z67_1 = clientMessage;
        this.a68_1 = sender;
        this.b68_1 = typeSerializable;
        this.c68_1 = message;
        this.d68_1 = attachments;
        this.e68_1 = created;
        this.f68_1 = readBy;
        this.g68_1 = needsResponse;
        var tmp_0 = this;
        tmp_0.h68_1 = lazy_0(() => parseResponse(this.b68_1));
      }
      h40() {
        return this.w67_1;
      }
      g94() {
        return this.z67_1;
      }
      h94() {
        return this.a68_1;
      }
      j() {
        return this.c68_1;
      }
      i94() {
        return this.e68_1;
      }
      t91() {
        return this.f68_1;
      }
      f94() {
        var tmp0 = this.h68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('type', 1, tmp, IncidentMessage$_get_type_$ref_ia9x1r(), null);
        return tmp0.f2();
      }
      j94(_id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse) {
        return new (IncidentMessage())(_id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse);
      }
      j68(_id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse, $super) {
        _id = _id === VOID ? this.w67_1 : _id;
        incident = incident === VOID ? this.x67_1 : incident;
        project = project === VOID ? this.y67_1 : project;
        clientMessage = clientMessage === VOID ? this.z67_1 : clientMessage;
        sender = sender === VOID ? this.a68_1 : sender;
        typeSerializable = typeSerializable === VOID ? this.b68_1 : typeSerializable;
        message = message === VOID ? this.c68_1 : message;
        attachments = attachments === VOID ? this.d68_1 : attachments;
        created = created === VOID ? this.e68_1 : created;
        readBy = readBy === VOID ? this.f68_1 : readBy;
        needsResponse = needsResponse === VOID ? this.g68_1 : needsResponse;
        return $super === VOID ? this.j94(_id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse) : $super.j94.call(this, _id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse);
      }
      toString() {
        return 'IncidentMessage(_id=' + this.w67_1.toString() + ', incident=' + this.x67_1.toString() + ', project=' + this.y67_1.toString() + ', clientMessage=' + this.z67_1 + ', sender=' + this.a68_1.toString() + ', typeSerializable=' + this.b68_1.toString() + ', message=' + this.c68_1 + ', attachments=' + toString(this.d68_1) + ', created=' + this.e68_1.toString() + ', readBy=' + toString(this.f68_1) + ', needsResponse=' + this.g68_1 + ')';
      }
      hashCode() {
        var result = this.w67_1.hashCode();
        result = imul(result, 31) + this.x67_1.hashCode() | 0;
        result = imul(result, 31) + this.y67_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.z67_1) | 0;
        result = imul(result, 31) + this.a68_1.hashCode() | 0;
        result = imul(result, 31) + this.b68_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.c68_1) | 0;
        result = imul(result, 31) + hashCode(this.d68_1) | 0;
        result = imul(result, 31) + this.e68_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.f68_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.g68_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IncidentMessage()))
          return false;
        if (!this.w67_1.equals(other.w67_1))
          return false;
        if (!this.x67_1.equals(other.x67_1))
          return false;
        if (!this.y67_1.equals(other.y67_1))
          return false;
        if (!(this.z67_1 === other.z67_1))
          return false;
        if (!this.a68_1.equals(other.a68_1))
          return false;
        if (!this.b68_1.equals(other.b68_1))
          return false;
        if (!(this.c68_1 === other.c68_1))
          return false;
        if (!equals(this.d68_1, other.d68_1))
          return false;
        if (!this.e68_1.equals(other.e68_1))
          return false;
        if (!equals(this.f68_1, other.f68_1))
          return false;
        if (!(this.g68_1 === other.g68_1))
          return false;
        return true;
      }
      static e94(seen0, _id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse, serializationConstructorMarker) {
        Companion_getInstance_27();
        if (!(126 === (126 & seen0))) {
          throwMissingFieldException(seen0, 126, $serializer_getInstance_28().c94_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.w67_1 = Companion_getInstance().m2p();
        else
          $this.w67_1 = _id;
        $this.x67_1 = incident;
        $this.y67_1 = project;
        $this.z67_1 = clientMessage;
        $this.a68_1 = sender;
        $this.b68_1 = typeSerializable;
        $this.c68_1 = message;
        if (0 === (seen0 & 128))
          $this.d68_1 = emptyList();
        else
          $this.d68_1 = attachments;
        if (0 === (seen0 & 256)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.e68_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.e68_1 = created;
        if (0 === (seen0 & 512))
          $this.f68_1 = emptySet();
        else
          $this.f68_1 = readBy;
        if (0 === (seen0 & 1024))
          $this.g68_1 = true;
        else
          $this.g68_1 = needsResponse;
        var tmp_0 = $this;
        tmp_0.h68_1 = lazy_0(() => parseResponse($this.b68_1));
        return $this;
      }
    }
    initMetadataForClass($, 'IncidentMessage', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_28});
    IncidentMessageClass = $;
  }
  return IncidentMessageClass;
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_3() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_5() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_14;
function Companion_14() {
  if (CompanionClass_14 === VOID) {
    class $ {
      constructor() {
        Companion_instance_16 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.n65_1 = [tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, null, null, null, tmp_11, lazy(tmp_12, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_5)];
      }
      m2a() {
        return $serializer_getInstance_29();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_14 = $;
  }
  return CompanionClass_14;
}
var Companion_instance_16;
function Companion_getInstance_28() {
  if (Companion_instance_16 === VOID)
    new (Companion_14())();
  return Companion_instance_16;
}
var $serializerClass_13;
function $serializer_13() {
  if ($serializerClass_13 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_13 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.IncidentMessageComment', this, 10);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('incidentMessage', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(IncidentMessage())));
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('incident', false);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Incident())));
        tmp0_serialDesc.c1b('sender', false);
        tmp0_serialDesc.c1b('senderName', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('clientMessage', false);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('message', false);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('created', true);
        this.k94_1 = tmp0_serialDesc;
      }
      l94(encoder, value) {
        var tmp0_desc = this.k94_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_28().n65_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.s65_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.s65_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.t65_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.u65_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.v65_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.w65_1);
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.x65_1 === '')) {
          tmp1_output.a15(tmp0_desc, 5, value.x65_1);
        }
        tmp1_output.s14(tmp0_desc, 6, value.y65_1);
        tmp1_output.a15(tmp0_desc, 7, value.z65_1);
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.a66_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.a66_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 9)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp = !value.b66_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.b66_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.l94(encoder, value instanceof IncidentMessageComment() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k94_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_input = decoder.l13(tmp0_desc);
        var tmp15_cached = Companion_getInstance_28().n65_1;
        if (tmp14_input.a14()) {
          tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.x13(tmp0_desc, 2, tmp15_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.x13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.x13(tmp0_desc, 4, tmp15_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.n13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.x13(tmp0_desc, 9, tmp15_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.x13(tmp0_desc, 2, tmp15_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.x13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.x13(tmp0_desc, 4, tmp15_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.n13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.x13(tmp0_desc, 9, tmp15_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp14_input.m13(tmp0_desc);
        return IncidentMessageComment().m94(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      az() {
        return this.k94_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_28().n65_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), tmp0_cached[4].f2(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[8].f2(), tmp0_cached[9].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_13 = $;
  }
  return $serializerClass_13;
}
var $serializer_instance_13;
function $serializer_getInstance_29() {
  if ($serializer_instance_13 === VOID)
    new ($serializer_13())();
  return $serializer_instance_13;
}
var IncidentMessageCommentClass;
function IncidentMessageComment() {
  if (IncidentMessageCommentClass === VOID) {
    class $ {
      constructor(_id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created) {
        Companion_getInstance_28();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        senderName = senderName === VOID ? '' : senderName;
        readBy = readBy === VOID ? emptySet() : readBy;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = created;
        }
        created = tmp;
        this.s65_1 = _id;
        this.t65_1 = incidentMessage;
        this.u65_1 = project;
        this.v65_1 = incident;
        this.w65_1 = sender;
        this.x65_1 = senderName;
        this.y65_1 = clientMessage;
        this.z65_1 = message;
        this.a66_1 = readBy;
        this.b66_1 = created;
      }
      h40() {
        return this.s65_1;
      }
      t91() {
        return this.a66_1;
      }
      t92() {
        return plus(this.a66_1, this.w65_1);
      }
      u92(_id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created) {
        return new (IncidentMessageComment())(_id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created);
      }
      d66(_id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created, $super) {
        _id = _id === VOID ? this.s65_1 : _id;
        incidentMessage = incidentMessage === VOID ? this.t65_1 : incidentMessage;
        project = project === VOID ? this.u65_1 : project;
        incident = incident === VOID ? this.v65_1 : incident;
        sender = sender === VOID ? this.w65_1 : sender;
        senderName = senderName === VOID ? this.x65_1 : senderName;
        clientMessage = clientMessage === VOID ? this.y65_1 : clientMessage;
        message = message === VOID ? this.z65_1 : message;
        readBy = readBy === VOID ? this.a66_1 : readBy;
        created = created === VOID ? this.b66_1 : created;
        return $super === VOID ? this.u92(_id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created) : $super.u92.call(this, _id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created);
      }
      toString() {
        return 'IncidentMessageComment(_id=' + this.s65_1.toString() + ', incidentMessage=' + this.t65_1.toString() + ', project=' + this.u65_1.toString() + ', incident=' + this.v65_1.toString() + ', sender=' + this.w65_1.toString() + ', senderName=' + this.x65_1 + ', clientMessage=' + this.y65_1 + ', message=' + this.z65_1 + ', readBy=' + toString(this.a66_1) + ', created=' + this.b66_1.toString() + ')';
      }
      hashCode() {
        var result = this.s65_1.hashCode();
        result = imul(result, 31) + this.t65_1.hashCode() | 0;
        result = imul(result, 31) + this.u65_1.hashCode() | 0;
        result = imul(result, 31) + this.v65_1.hashCode() | 0;
        result = imul(result, 31) + this.w65_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.x65_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.y65_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z65_1) | 0;
        result = imul(result, 31) + hashCode(this.a66_1) | 0;
        result = imul(result, 31) + this.b66_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IncidentMessageComment()))
          return false;
        if (!this.s65_1.equals(other.s65_1))
          return false;
        if (!this.t65_1.equals(other.t65_1))
          return false;
        if (!this.u65_1.equals(other.u65_1))
          return false;
        if (!this.v65_1.equals(other.v65_1))
          return false;
        if (!this.w65_1.equals(other.w65_1))
          return false;
        if (!(this.x65_1 === other.x65_1))
          return false;
        if (!(this.y65_1 === other.y65_1))
          return false;
        if (!(this.z65_1 === other.z65_1))
          return false;
        if (!equals(this.a66_1, other.a66_1))
          return false;
        if (!this.b66_1.equals(other.b66_1))
          return false;
        return true;
      }
      static m94(seen0, _id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created, serializationConstructorMarker) {
        Companion_getInstance_28();
        if (!(222 === (222 & seen0))) {
          throwMissingFieldException(seen0, 222, $serializer_getInstance_29().k94_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.s65_1 = Companion_getInstance().m2p();
        else
          $this.s65_1 = _id;
        $this.t65_1 = incidentMessage;
        $this.u65_1 = project;
        $this.v65_1 = incident;
        $this.w65_1 = sender;
        if (0 === (seen0 & 32))
          $this.x65_1 = '';
        else
          $this.x65_1 = senderName;
        $this.y65_1 = clientMessage;
        $this.z65_1 = message;
        if (0 === (seen0 & 256))
          $this.a66_1 = emptySet();
        else
          $this.a66_1 = readBy;
        if (0 === (seen0 & 512)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.b66_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.b66_1 = created;
        return $this;
      }
    }
    initMetadataForClass($, 'IncidentMessageComment', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_29});
    IncidentMessageCommentClass = $;
  }
  return IncidentMessageCommentClass;
}
function ItemChange$Companion$$childSerializers$_anonymous__pqnnuh() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_15;
function Companion_15() {
  if (CompanionClass_15 === VOID) {
    class $ {
      constructor() {
        Companion_instance_17 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ItemChange$Companion$$childSerializers$_anonymous__pqnnuh);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.s6a_1 = [tmp_1, tmp_3, tmp_5, tmp_7, null, null, null, null, tmp_9, null, lazy(tmp_10, ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_4)];
      }
      m2a() {
        return $serializer_getInstance_30();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_15 = $;
  }
  return CompanionClass_15;
}
var Companion_instance_17;
function Companion_getInstance_29() {
  if (Companion_instance_17 === VOID)
    new (Companion_15())();
  return Companion_instance_17;
}
var $serializerClass_14;
function $serializer_14() {
  if ($serializerClass_14 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_14 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ItemChange', this, 11);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('changeRequest', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(ChangeRequest())));
        tmp0_serialDesc.c1b('itemId', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.c1b('linked', true);
        tmp0_serialDesc.c1b('updatedDescription', true);
        tmp0_serialDesc.c1b('priceChange', true);
        tmp0_serialDesc.c1b('cancelled', true);
        tmp0_serialDesc.c1b('created', true);
        tmp0_serialDesc.c1b('itemNumber', true);
        tmp0_serialDesc.c1b('readBy', true);
        this.n94_1 = tmp0_serialDesc;
      }
      o94(encoder, value) {
        var tmp0_desc = this.n94_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_29().s6a_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.x6a_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.x6a_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.y6a_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.z6a_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.a6b_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.b6b_1 === false)) {
          tmp1_output.s14(tmp0_desc, 4, value.b6b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.c6b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, StringSerializer_getInstance(), value.c6b_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 6)) {
          tmp = true;
        } else {
          var tmp_0 = value.d6b_1;
          tmp = !((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_2();
          var tmp_2 = value.d6b_1;
          tmp1_output.d15(tmp0_desc, 6, tmp_1, tmp_2 == null ? null : new (MonetaryValue())(tmp_2));
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.e6b_1 === false)) {
          tmp1_output.s14(tmp0_desc, 7, value.e6b_1);
        }
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 8)) {
          tmp_3 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp_3 = !value.f6b_1.equals(tmp$ret$0);
        }
        if (tmp_3) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.f6b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.g6b_1 === '1')) {
          tmp1_output.a15(tmp0_desc, 9, value.g6b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !equals(value.h6b_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 10, tmp2_cached[10].f2(), value.h6b_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.o94(encoder, value instanceof ItemChange() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n94_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = false;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = false;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_input = decoder.l13(tmp0_desc);
        var tmp16_cached = Companion_getInstance_29().s6a_1;
        if (tmp15_input.a14()) {
          tmp4_local0 = tmp15_input.x13(tmp0_desc, 0, tmp16_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp15_input.x13(tmp0_desc, 1, tmp16_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp15_input.x13(tmp0_desc, 2, tmp16_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp15_input.x13(tmp0_desc, 3, tmp16_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp15_input.n13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp15_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp10_local6;
          var tmp_1 = tmp15_input.z13(tmp0_desc, 6, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp10_local6 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp15_input.n13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp15_input.x13(tmp0_desc, 8, tmp16_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp15_input.v13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp15_input.x13(tmp0_desc, 10, tmp16_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp15_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp15_input.x13(tmp0_desc, 0, tmp16_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp15_input.x13(tmp0_desc, 1, tmp16_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp15_input.x13(tmp0_desc, 2, tmp16_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp15_input.x13(tmp0_desc, 3, tmp16_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp15_input.n13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp15_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp10_local6;
                var tmp_4 = tmp15_input.z13(tmp0_desc, 6, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp10_local6 = tmp_4 == null ? null : tmp_4.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp15_input.n13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp15_input.x13(tmp0_desc, 8, tmp16_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp15_input.v13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp15_input.x13(tmp0_desc, 10, tmp16_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp15_input.m13(tmp0_desc);
        return ItemChange().p94(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      az() {
        return this.n94_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_29().s6a_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_2()), BooleanSerializer_getInstance(), tmp0_cached[8].f2(), StringSerializer_getInstance(), tmp0_cached[10].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_14 = $;
  }
  return $serializerClass_14;
}
var $serializer_instance_14;
function $serializer_getInstance_30() {
  if ($serializer_instance_14 === VOID)
    new ($serializer_14())();
  return $serializer_instance_14;
}
var ItemChangeClass;
function ItemChange() {
  if (ItemChangeClass === VOID) {
    class $ {
      constructor(_id, project, changeRequest, itemId, linked, updatedDescription, priceChange, cancelled, created, itemNumber, readBy) {
        Companion_getInstance_29();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        linked = linked === VOID ? false : linked;
        updatedDescription = updatedDescription === VOID ? null : updatedDescription;
        priceChange = priceChange === VOID ? null : priceChange;
        cancelled = cancelled === VOID ? false : cancelled;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = created;
        }
        created = tmp;
        itemNumber = itemNumber === VOID ? '1' : itemNumber;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.x6a_1 = _id;
        this.y6a_1 = project;
        this.z6a_1 = changeRequest;
        this.a6b_1 = itemId;
        this.b6b_1 = linked;
        this.c6b_1 = updatedDescription;
        this.d6b_1 = priceChange;
        this.e6b_1 = cancelled;
        this.f6b_1 = created;
        this.g6b_1 = itemNumber;
        this.h6b_1 = readBy;
      }
      h40() {
        return this.x6a_1;
      }
      q94() {
        return this.z6a_1;
      }
      r94() {
        return this.a6b_1;
      }
      s94() {
        return this.b6b_1;
      }
      t94() {
        return this.c6b_1;
      }
      u94() {
        return this.d6b_1;
      }
      v94() {
        return this.e6b_1;
      }
      w94() {
        return this.g6b_1;
      }
      t91() {
        return this.h6b_1;
      }
      x94() {
        return this.f6b_1;
      }
      y94() {
        return null;
      }
      z94() {
        return this.e6b_1 ? ChangeType_Remove_getInstance() : ChangeType_Modify_getInstance();
      }
      a95() {
        var tmp0_elvis_lhs = this.d6b_1;
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
          tmp = _MonetaryValue___init__impl__jsc11x(0n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      g26() {
        return this.g6b_1;
      }
      b95() {
        return this.f6b_1;
      }
      f94() {
        return this.z94().f95_1;
      }
      g95(_id, project, changeRequest, itemId, linked, updatedDescription, priceChange, cancelled, created, itemNumber, readBy) {
        return new (ItemChange())(_id, project, changeRequest, itemId, linked, updatedDescription, priceChange, cancelled, created, itemNumber, readBy);
      }
      j6b(_id, project, changeRequest, itemId, linked, updatedDescription, priceChange, cancelled, created, itemNumber, readBy, $super) {
        _id = _id === VOID ? this.x6a_1 : _id;
        project = project === VOID ? this.y6a_1 : project;
        changeRequest = changeRequest === VOID ? this.z6a_1 : changeRequest;
        itemId = itemId === VOID ? this.a6b_1 : itemId;
        linked = linked === VOID ? this.b6b_1 : linked;
        updatedDescription = updatedDescription === VOID ? this.c6b_1 : updatedDescription;
        priceChange = priceChange === VOID ? this.d6b_1 : priceChange;
        cancelled = cancelled === VOID ? this.e6b_1 : cancelled;
        created = created === VOID ? this.f6b_1 : created;
        itemNumber = itemNumber === VOID ? this.g6b_1 : itemNumber;
        readBy = readBy === VOID ? this.h6b_1 : readBy;
        var tmp;
        if ($super === VOID) {
          tmp = this.g95(_id, project, changeRequest, itemId, linked, updatedDescription, priceChange, cancelled, created, itemNumber, readBy);
        } else {
          var tmp_0 = $super.g95;
          var tmp_1 = priceChange;
          tmp = tmp_0.call(this, _id, project, changeRequest, itemId, linked, updatedDescription, tmp_1 == null ? null : new (MonetaryValue())(tmp_1), cancelled, created, itemNumber, readBy);
        }
        return tmp;
      }
      toString() {
        var tmp = this.x6a_1.toString();
        var tmp_0 = this.y6a_1.toString();
        var tmp_1 = this.z6a_1.toString();
        var tmp_2 = this.a6b_1.toString();
        var tmp_3 = this.d6b_1;
        return 'ItemChange(_id=' + tmp + ', project=' + tmp_0 + ', changeRequest=' + tmp_1 + ', itemId=' + tmp_2 + ', linked=' + this.b6b_1 + ', updatedDescription=' + this.c6b_1 + ', priceChange=' + toString_0(tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) + ', cancelled=' + this.e6b_1 + ', created=' + this.f6b_1.toString() + ', itemNumber=' + this.g6b_1 + ', readBy=' + toString(this.h6b_1) + ')';
      }
      hashCode() {
        var result = this.x6a_1.hashCode();
        result = imul(result, 31) + this.y6a_1.hashCode() | 0;
        result = imul(result, 31) + this.z6a_1.hashCode() | 0;
        result = imul(result, 31) + this.a6b_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.b6b_1) | 0;
        result = imul(result, 31) + (this.c6b_1 == null ? 0 : getStringHashCode(this.c6b_1)) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.d6b_1;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = MonetaryValue__hashCode_impl_fhcsz2(this.d6b_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + getBooleanHashCode(this.e6b_1) | 0;
        result = imul(result, 31) + this.f6b_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.g6b_1) | 0;
        result = imul(result, 31) + hashCode(this.h6b_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ItemChange()))
          return false;
        if (!this.x6a_1.equals(other.x6a_1))
          return false;
        if (!this.y6a_1.equals(other.y6a_1))
          return false;
        if (!this.z6a_1.equals(other.z6a_1))
          return false;
        if (!this.a6b_1.equals(other.a6b_1))
          return false;
        if (!(this.b6b_1 === other.b6b_1))
          return false;
        if (!(this.c6b_1 == other.c6b_1))
          return false;
        var tmp = this.d6b_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.d6b_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        if (!(this.e6b_1 === other.e6b_1))
          return false;
        if (!this.f6b_1.equals(other.f6b_1))
          return false;
        if (!(this.g6b_1 === other.g6b_1))
          return false;
        if (!equals(this.h6b_1, other.h6b_1))
          return false;
        return true;
      }
      static p94(seen0, _id, project, changeRequest, itemId, linked, updatedDescription, priceChange, cancelled, created, itemNumber, readBy, serializationConstructorMarker) {
        Companion_getInstance_29();
        if (!(14 === (14 & seen0))) {
          throwMissingFieldException(seen0, 14, $serializer_getInstance_30().n94_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.x6a_1 = Companion_getInstance().m2p();
        else
          $this.x6a_1 = _id;
        $this.y6a_1 = project;
        $this.z6a_1 = changeRequest;
        $this.a6b_1 = itemId;
        if (0 === (seen0 & 16))
          $this.b6b_1 = false;
        else
          $this.b6b_1 = linked;
        if (0 === (seen0 & 32))
          $this.c6b_1 = null;
        else
          $this.c6b_1 = updatedDescription;
        if (0 === (seen0 & 64))
          $this.d6b_1 = null;
        else
          $this.d6b_1 = priceChange;
        if (0 === (seen0 & 128))
          $this.e6b_1 = false;
        else
          $this.e6b_1 = cancelled;
        if (0 === (seen0 & 256)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.f6b_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.f6b_1 = created;
        if (0 === (seen0 & 512))
          $this.g6b_1 = '1';
        else
          $this.g6b_1 = itemNumber;
        if (0 === (seen0 & 1024))
          $this.h6b_1 = emptySet();
        else
          $this.h6b_1 = readBy;
        return $this;
      }
    }
    protoOf($).h95 = get_withdrawn;
    initMetadataForClass($, 'ItemChange', VOID, VOID, [HasId(), ItemChangeInterface(), ChangeRequestItem(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_30});
    ItemChangeClass = $;
  }
  return ItemChangeClass;
}
function LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_16;
function Companion_16() {
  if (CompanionClass_16 === VOID) {
    class $ {
      constructor() {
        Companion_instance_18 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.l6d_1 = [tmp_1, null, tmp_3, tmp_5, lazy(tmp_6, LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84_2)];
      }
      m2a() {
        return $serializer_getInstance_31();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_16 = $;
  }
  return CompanionClass_16;
}
var Companion_instance_18;
function Companion_getInstance_30() {
  if (Companion_instance_18 === VOID)
    new (Companion_16())();
  return Companion_instance_18;
}
var $serializerClass_15;
function $serializer_15() {
  if ($serializerClass_15 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_15 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.LegalDocumentAgreement', this, 5);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('accessInfo', false);
        tmp0_serialDesc.c1b('contractor', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.c1b('document', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(CrowPayLegalDocument())));
        tmp0_serialDesc.c1b('user', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.d1b(new (References())(getKClass(User())));
        this.i95_1 = tmp0_serialDesc;
      }
      j95(encoder, value) {
        var tmp0_desc = this.i95_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_30().l6d_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.s6d_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.s6d_1);
        }
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_4(), value.t6d_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.u6d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.u6d_1);
        }
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.v6d_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.w6d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.w6d_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.j95(encoder, value instanceof LegalDocumentAgreement() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.i95_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_30().l6d_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, tmp10_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.z13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, tmp10_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.z13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return LegalDocumentAgreement().k95(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.i95_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_30().l6d_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), $serializer_getInstance_4(), get_nullable(tmp0_cached[2].f2()), tmp0_cached[3].f2(), get_nullable(tmp0_cached[4].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_15 = $;
  }
  return $serializerClass_15;
}
var $serializer_instance_15;
function $serializer_getInstance_31() {
  if ($serializer_instance_15 === VOID)
    new ($serializer_15())();
  return $serializer_instance_15;
}
var LegalDocumentAgreementClass;
function LegalDocumentAgreement() {
  if (LegalDocumentAgreementClass === VOID) {
    class $ {
      constructor(_id, accessInfo, contractor, document, user) {
        Companion_getInstance_30();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        contractor = contractor === VOID ? null : contractor;
        user = user === VOID ? null : user;
        this.s6d_1 = _id;
        this.t6d_1 = accessInfo;
        this.u6d_1 = contractor;
        this.v6d_1 = document;
        this.w6d_1 = user;
      }
      h40() {
        return this.s6d_1;
      }
      l95(_id, accessInfo, contractor, document, user) {
        return new (LegalDocumentAgreement())(_id, accessInfo, contractor, document, user);
      }
      y6d(_id, accessInfo, contractor, document, user, $super) {
        _id = _id === VOID ? this.s6d_1 : _id;
        accessInfo = accessInfo === VOID ? this.t6d_1 : accessInfo;
        contractor = contractor === VOID ? this.u6d_1 : contractor;
        document = document === VOID ? this.v6d_1 : document;
        user = user === VOID ? this.w6d_1 : user;
        return $super === VOID ? this.l95(_id, accessInfo, contractor, document, user) : $super.l95.call(this, _id, accessInfo, contractor, document, user);
      }
      toString() {
        return 'LegalDocumentAgreement(_id=' + this.s6d_1.toString() + ', accessInfo=' + this.t6d_1.toString() + ', contractor=' + toString_0(this.u6d_1) + ', document=' + this.v6d_1.toString() + ', user=' + toString_0(this.w6d_1) + ')';
      }
      hashCode() {
        var result = this.s6d_1.hashCode();
        result = imul(result, 31) + this.t6d_1.hashCode() | 0;
        result = imul(result, 31) + (this.u6d_1 == null ? 0 : this.u6d_1.hashCode()) | 0;
        result = imul(result, 31) + this.v6d_1.hashCode() | 0;
        result = imul(result, 31) + (this.w6d_1 == null ? 0 : this.w6d_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LegalDocumentAgreement()))
          return false;
        if (!this.s6d_1.equals(other.s6d_1))
          return false;
        if (!this.t6d_1.equals(other.t6d_1))
          return false;
        if (!equals(this.u6d_1, other.u6d_1))
          return false;
        if (!this.v6d_1.equals(other.v6d_1))
          return false;
        if (!equals(this.w6d_1, other.w6d_1))
          return false;
        return true;
      }
      static k95(seen0, _id, accessInfo, contractor, document, user, serializationConstructorMarker) {
        Companion_getInstance_30();
        if (!(10 === (10 & seen0))) {
          throwMissingFieldException(seen0, 10, $serializer_getInstance_31().i95_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.s6d_1 = Companion_getInstance().m2p();
        else
          $this.s6d_1 = _id;
        $this.t6d_1 = accessInfo;
        if (0 === (seen0 & 4))
          $this.u6d_1 = null;
        else
          $this.u6d_1 = contractor;
        $this.v6d_1 = document;
        if (0 === (seen0 & 16))
          $this.w6d_1 = null;
        else
          $this.w6d_1 = user;
        return $this;
      }
    }
    initMetadataForClass($, 'LegalDocumentAgreement', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_31});
    LegalDocumentAgreementClass = $;
  }
  return LegalDocumentAgreementClass;
}
function License$Companion$$childSerializers$_anonymous__r2xgkp() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function License$Companion$$childSerializers$_anonymous__r2xgkp_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function License$Companion$$childSerializers$_anonymous__r2xgkp_1() {
  return Companion_getInstance_2().m2a();
}
function License$Companion$$childSerializers$_anonymous__r2xgkp_2() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function License$Companion$$childSerializers$_anonymous__r2xgkp_3() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function License$Companion$$childSerializers$_anonymous__r2xgkp_4() {
  return Companion_getInstance_6().m2a();
}
var CompanionClass_17;
function Companion_17() {
  if (CompanionClass_17 === VOID) {
    class $ {
      constructor() {
        Companion_instance_19 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, License$Companion$$childSerializers$_anonymous__r2xgkp);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, License$Companion$$childSerializers$_anonymous__r2xgkp_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, License$Companion$$childSerializers$_anonymous__r2xgkp_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, License$Companion$$childSerializers$_anonymous__r2xgkp_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, License$Companion$$childSerializers$_anonymous__r2xgkp_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.r6e_1 = [tmp_1, tmp_3, null, null, tmp_5, tmp_7, null, tmp_9, lazy(tmp_10, License$Companion$$childSerializers$_anonymous__r2xgkp_4)];
      }
      m2a() {
        return $serializer_getInstance_32();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_17 = $;
  }
  return CompanionClass_17;
}
var Companion_instance_19;
function Companion_getInstance_31() {
  if (Companion_instance_19 === VOID)
    new (Companion_17())();
  return Companion_instance_19;
}
var $serializerClass_16;
function $serializer_16() {
  if ($serializerClass_16 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_16 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.License', this, 9);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('contractor', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.c1b('number', false);
        tmp0_serialDesc.c1b('city', true);
        tmp0_serialDesc.c1b('state', false);
        tmp0_serialDesc.c1b('file', false);
        tmp0_serialDesc.c1b('fileType', false);
        tmp0_serialDesc.c1b('preview', true);
        tmp0_serialDesc.c1b('type', false);
        this.m95_1 = tmp0_serialDesc;
      }
      n95(encoder, value) {
        var tmp0_desc = this.m95_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_31().r6e_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.w6e_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.w6e_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.x6e_1);
        tmp1_output.a15(tmp0_desc, 2, value.y6e_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.z6e_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, StringSerializer_getInstance(), value.z6e_1);
        }
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.a6f_1);
        tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), new (ServerFile())(value.b6f_1));
        tmp1_output.a15(tmp0_desc, 6, value.c6f_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 7)) {
          tmp = true;
        } else {
          var tmp_0 = value.d6f_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = tmp2_cached[7].f2();
          var tmp_2 = value.d6f_1;
          tmp1_output.d15(tmp0_desc, 7, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.e6f_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.n95(encoder, value instanceof License() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.m95_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_input = decoder.l13(tmp0_desc);
        var tmp14_cached = Companion_getInstance_31().r6e_1;
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.x13(tmp0_desc, 4, tmp14_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = tmp14_cached[5].f2();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp13_input.x13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.n2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp_2 = tmp14_cached[7].f2();
          var tmp_3 = tmp11_local7;
          var tmp_4 = tmp13_input.z13(tmp0_desc, 7, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
          tmp11_local7 = tmp_4 == null ? null : tmp_4.n2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.x13(tmp0_desc, 8, tmp14_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.x13(tmp0_desc, 4, tmp14_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_5 = tmp14_cached[5].f2();
                var tmp_6 = tmp9_local5;
                var tmp_7 = tmp13_input.x13(tmp0_desc, 5, tmp_5, tmp_6 == null ? null : new (ServerFile())(tmp_6));
                tmp9_local5 = tmp_7 == null ? null : tmp_7.n2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_8 = tmp14_cached[7].f2();
                var tmp_9 = tmp11_local7;
                var tmp_10 = tmp13_input.z13(tmp0_desc, 7, tmp_8, tmp_9 == null ? null : new (ServerFile())(tmp_9));
                tmp11_local7 = tmp_10 == null ? null : tmp_10.n2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.x13(tmp0_desc, 8, tmp14_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return License().o95(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.m95_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_31().r6e_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[4].f2(), tmp0_cached[5].f2(), StringSerializer_getInstance(), get_nullable(tmp0_cached[7].f2()), tmp0_cached[8].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_16 = $;
  }
  return $serializerClass_16;
}
var $serializer_instance_16;
function $serializer_getInstance_32() {
  if ($serializer_instance_16 === VOID)
    new ($serializer_16())();
  return $serializer_instance_16;
}
var LicenseClass;
function License() {
  if (LicenseClass === VOID) {
    class $ {
      constructor(_id, contractor, number, city, state, file, fileType, preview, type) {
        Companion_getInstance_31();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        city = city === VOID ? null : city;
        preview = preview === VOID ? null : preview;
        this.w6e_1 = _id;
        this.x6e_1 = contractor;
        this.y6e_1 = number;
        this.z6e_1 = city;
        this.a6f_1 = state;
        this.b6f_1 = file;
        this.c6f_1 = fileType;
        this.d6f_1 = preview;
        this.e6f_1 = type;
      }
      h40() {
        return this.w6e_1;
      }
      g93() {
        return this.b6f_1;
      }
      f93() {
        return this.c6f_1;
      }
      h93() {
        return this.d6f_1;
      }
      k20() {
        return this.y6e_1;
      }
      p95(_id, contractor, number, city, state, file, fileType, preview, type) {
        return new (License())(_id, contractor, number, city, state, file, fileType, preview, type);
      }
      g6f(_id, contractor, number, city, state, file, fileType, preview, type, $super) {
        _id = _id === VOID ? this.w6e_1 : _id;
        contractor = contractor === VOID ? this.x6e_1 : contractor;
        number = number === VOID ? this.y6e_1 : number;
        city = city === VOID ? this.z6e_1 : city;
        state = state === VOID ? this.a6f_1 : state;
        file = file === VOID ? this.b6f_1 : file;
        fileType = fileType === VOID ? this.c6f_1 : fileType;
        preview = preview === VOID ? this.d6f_1 : preview;
        type = type === VOID ? this.e6f_1 : type;
        var tmp;
        if ($super === VOID) {
          tmp = this.p95(_id, contractor, number, city, state, file, fileType, preview, type);
        } else {
          var tmp_0 = $super.p95;
          var tmp_1 = preview;
          tmp = tmp_0.call(this, _id, contractor, number, city, state, new (ServerFile())(file), fileType, tmp_1 == null ? null : new (ServerFile())(tmp_1), type);
        }
        return tmp;
      }
      toString() {
        var tmp = this.w6e_1.toString();
        var tmp_0 = this.x6e_1.toString();
        var tmp_1 = this.a6f_1.toString();
        var tmp_2 = ServerFile__toString_impl_4rulpa(this.b6f_1);
        var tmp_3 = this.d6f_1;
        return 'License(_id=' + tmp + ', contractor=' + tmp_0 + ', number=' + this.y6e_1 + ', city=' + this.z6e_1 + ', state=' + tmp_1 + ', file=' + tmp_2 + ', fileType=' + this.c6f_1 + ', preview=' + toString_0(tmp_3 == null ? null : new (ServerFile())(tmp_3)) + ', type=' + this.e6f_1.toString() + ')';
      }
      hashCode() {
        var result = this.w6e_1.hashCode();
        result = imul(result, 31) + this.x6e_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.y6e_1) | 0;
        result = imul(result, 31) + (this.z6e_1 == null ? 0 : getStringHashCode(this.z6e_1)) | 0;
        result = imul(result, 31) + this.a6f_1.hashCode() | 0;
        result = imul(result, 31) + ServerFile__hashCode_impl_qj0ii5(this.b6f_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.c6f_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.d6f_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.d6f_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + this.e6f_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof License()))
          return false;
        if (!this.w6e_1.equals(other.w6e_1))
          return false;
        if (!this.x6e_1.equals(other.x6e_1))
          return false;
        if (!(this.y6e_1 === other.y6e_1))
          return false;
        if (!(this.z6e_1 == other.z6e_1))
          return false;
        if (!this.a6f_1.equals(other.a6f_1))
          return false;
        if (!(this.b6f_1 === other.b6f_1))
          return false;
        if (!(this.c6f_1 === other.c6f_1))
          return false;
        var tmp = this.d6f_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.d6f_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        if (!this.e6f_1.equals(other.e6f_1))
          return false;
        return true;
      }
      static o95(seen0, _id, contractor, number, city, state, file, fileType, preview, type, serializationConstructorMarker) {
        Companion_getInstance_31();
        if (!(374 === (374 & seen0))) {
          throwMissingFieldException(seen0, 374, $serializer_getInstance_32().m95_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.w6e_1 = Companion_getInstance().m2p();
        else
          $this.w6e_1 = _id;
        $this.x6e_1 = contractor;
        $this.y6e_1 = number;
        if (0 === (seen0 & 8))
          $this.z6e_1 = null;
        else
          $this.z6e_1 = city;
        $this.a6f_1 = state;
        $this.b6f_1 = file;
        $this.c6f_1 = fileType;
        if (0 === (seen0 & 128))
          $this.d6f_1 = null;
        else
          $this.d6f_1 = preview;
        $this.e6f_1 = type;
        return $this;
      }
    }
    initMetadataForClass($, 'License', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_32});
    LicenseClass = $;
  }
  return LicenseClass;
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_3() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_5() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_18;
function Companion_18() {
  if (CompanionClass_18 === VOID) {
    class $ {
      constructor() {
        Companion_instance_20 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.t6g_1 = [tmp_1, tmp_3, tmp_5, tmp_7, null, null, null, tmp_9, tmp_11, lazy(tmp_12, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_5), null];
      }
      m2a() {
        return $serializer_getInstance_33();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_18 = $;
  }
  return CompanionClass_18;
}
var Companion_instance_20;
function Companion_getInstance_32() {
  if (Companion_instance_20 === VOID)
    new (Companion_18())();
  return Companion_instance_20;
}
var $serializerClass_17;
function $serializer_17() {
  if ($serializerClass_17 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_17 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.LineItemCompletionMessage', this, 11);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('lineItem', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.c1b('sender', false);
        tmp0_serialDesc.c1b('clientMessage', false);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('responseTypeSerializable', false);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        tmp0_serialDesc.c1b('message', false);
        tmp0_serialDesc.c1b('attachments', true);
        tmp0_serialDesc.c1b('created', true);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('needsResponse', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        this.q95_1 = tmp0_serialDesc;
      }
      r95(encoder, value) {
        var tmp0_desc = this.q95_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_32().t6g_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.y6g_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.y6g_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.z6g_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.a6h_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.b6h_1);
        tmp1_output.s14(tmp0_desc, 4, value.c6h_1);
        tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_14(), value.d6h_1);
        tmp1_output.a15(tmp0_desc, 6, value.e6h_1);
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !equals(value.f6h_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.f6h_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 8)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp = !value.g6h_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.g6h_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !equals(value.h6h_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.h6h_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.i6h_1 === true)) {
          tmp1_output.s14(tmp0_desc, 10, value.i6h_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.r95(encoder, value instanceof LineItemCompletionMessage() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.q95_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = false;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = false;
        var tmp16_input = decoder.l13(tmp0_desc);
        var tmp17_cached = Companion_getInstance_32().t6g_1;
        if (tmp16_input.a14()) {
          tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp16_input.x13(tmp0_desc, 3, tmp17_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp16_input.n13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp16_input.x13(tmp0_desc, 5, $serializer_getInstance_14(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp16_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp16_input.x13(tmp0_desc, 7, tmp17_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp16_input.x13(tmp0_desc, 9, tmp17_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp16_input.n13(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp16_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp16_input.x13(tmp0_desc, 3, tmp17_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp16_input.n13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp16_input.x13(tmp0_desc, 5, $serializer_getInstance_14(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp16_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp16_input.x13(tmp0_desc, 7, tmp17_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp16_input.x13(tmp0_desc, 9, tmp17_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp16_input.n13(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp16_input.m13(tmp0_desc);
        return LineItemCompletionMessage().s95(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      az() {
        return this.q95_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_32().t6g_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), BooleanSerializer_getInstance(), $serializer_getInstance_14(), StringSerializer_getInstance(), tmp0_cached[7].f2(), tmp0_cached[8].f2(), tmp0_cached[9].f2(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_17 = $;
  }
  return $serializerClass_17;
}
var $serializer_instance_17;
function $serializer_getInstance_33() {
  if ($serializer_instance_17 === VOID)
    new ($serializer_17())();
  return $serializer_instance_17;
}
function LineItemCompletionMessage$_get_responseType_$ref_csbgtd() {
  return (p0) => p0.f8w();
}
var LineItemCompletionMessageClass;
function LineItemCompletionMessage() {
  if (LineItemCompletionMessageClass === VOID) {
    class $ {
      constructor(_id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse) {
        Companion_getInstance_32();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        attachments = attachments === VOID ? emptyList() : attachments;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = created;
        }
        created = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        needsResponse = needsResponse === VOID ? true : needsResponse;
        this.y6g_1 = _id;
        this.z6g_1 = project;
        this.a6h_1 = lineItem;
        this.b6h_1 = sender;
        this.c6h_1 = clientMessage;
        this.d6h_1 = responseTypeSerializable;
        this.e6h_1 = message;
        this.f6h_1 = attachments;
        this.g6h_1 = created;
        this.h6h_1 = readBy;
        this.i6h_1 = needsResponse;
        var tmp_0 = this;
        tmp_0.j6h_1 = lazy_0(() => parseResponse_0(this.d6h_1));
      }
      h40() {
        return this.y6g_1;
      }
      h94() {
        return this.b6h_1;
      }
      g94() {
        return this.c6h_1;
      }
      j() {
        return this.e6h_1;
      }
      i94() {
        return this.g6h_1;
      }
      t91() {
        return this.h6h_1;
      }
      f8w() {
        var tmp0 = this.j6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('responseType', 1, tmp, LineItemCompletionMessage$_get_responseType_$ref_csbgtd(), null);
        return tmp0.f2();
      }
      t95(_id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse) {
        return new (LineItemCompletionMessage())(_id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse);
      }
      l6h(_id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse, $super) {
        _id = _id === VOID ? this.y6g_1 : _id;
        project = project === VOID ? this.z6g_1 : project;
        lineItem = lineItem === VOID ? this.a6h_1 : lineItem;
        sender = sender === VOID ? this.b6h_1 : sender;
        clientMessage = clientMessage === VOID ? this.c6h_1 : clientMessage;
        responseTypeSerializable = responseTypeSerializable === VOID ? this.d6h_1 : responseTypeSerializable;
        message = message === VOID ? this.e6h_1 : message;
        attachments = attachments === VOID ? this.f6h_1 : attachments;
        created = created === VOID ? this.g6h_1 : created;
        readBy = readBy === VOID ? this.h6h_1 : readBy;
        needsResponse = needsResponse === VOID ? this.i6h_1 : needsResponse;
        return $super === VOID ? this.t95(_id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse) : $super.t95.call(this, _id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse);
      }
      toString() {
        return 'LineItemCompletionMessage(_id=' + this.y6g_1.toString() + ', project=' + this.z6g_1.toString() + ', lineItem=' + this.a6h_1.toString() + ', sender=' + this.b6h_1.toString() + ', clientMessage=' + this.c6h_1 + ', responseTypeSerializable=' + this.d6h_1.toString() + ', message=' + this.e6h_1 + ', attachments=' + toString(this.f6h_1) + ', created=' + this.g6h_1.toString() + ', readBy=' + toString(this.h6h_1) + ', needsResponse=' + this.i6h_1 + ')';
      }
      hashCode() {
        var result = this.y6g_1.hashCode();
        result = imul(result, 31) + this.z6g_1.hashCode() | 0;
        result = imul(result, 31) + this.a6h_1.hashCode() | 0;
        result = imul(result, 31) + this.b6h_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.c6h_1) | 0;
        result = imul(result, 31) + this.d6h_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.e6h_1) | 0;
        result = imul(result, 31) + hashCode(this.f6h_1) | 0;
        result = imul(result, 31) + this.g6h_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.h6h_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.i6h_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LineItemCompletionMessage()))
          return false;
        if (!this.y6g_1.equals(other.y6g_1))
          return false;
        if (!this.z6g_1.equals(other.z6g_1))
          return false;
        if (!this.a6h_1.equals(other.a6h_1))
          return false;
        if (!this.b6h_1.equals(other.b6h_1))
          return false;
        if (!(this.c6h_1 === other.c6h_1))
          return false;
        if (!this.d6h_1.equals(other.d6h_1))
          return false;
        if (!(this.e6h_1 === other.e6h_1))
          return false;
        if (!equals(this.f6h_1, other.f6h_1))
          return false;
        if (!this.g6h_1.equals(other.g6h_1))
          return false;
        if (!equals(this.h6h_1, other.h6h_1))
          return false;
        if (!(this.i6h_1 === other.i6h_1))
          return false;
        return true;
      }
      static s95(seen0, _id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse, serializationConstructorMarker) {
        Companion_getInstance_32();
        if (!(126 === (126 & seen0))) {
          throwMissingFieldException(seen0, 126, $serializer_getInstance_33().q95_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.y6g_1 = Companion_getInstance().m2p();
        else
          $this.y6g_1 = _id;
        $this.z6g_1 = project;
        $this.a6h_1 = lineItem;
        $this.b6h_1 = sender;
        $this.c6h_1 = clientMessage;
        $this.d6h_1 = responseTypeSerializable;
        $this.e6h_1 = message;
        if (0 === (seen0 & 128))
          $this.f6h_1 = emptyList();
        else
          $this.f6h_1 = attachments;
        if (0 === (seen0 & 256)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.g6h_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.g6h_1 = created;
        if (0 === (seen0 & 512))
          $this.h6h_1 = emptySet();
        else
          $this.h6h_1 = readBy;
        if (0 === (seen0 & 1024))
          $this.i6h_1 = true;
        else
          $this.i6h_1 = needsResponse;
        var tmp_0 = $this;
        tmp_0.j6h_1 = lazy_0(() => parseResponse_0($this.d6h_1));
        return $this;
      }
    }
    initMetadataForClass($, 'LineItemCompletionMessage', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_33});
    LineItemCompletionMessageClass = $;
  }
  return LineItemCompletionMessageClass;
}
var CompanionClass_19;
function Companion_19() {
  if (CompanionClass_19 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_34();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_19 = $;
  }
  return CompanionClass_19;
}
var Companion_instance_21;
function Companion_getInstance_33() {
  return Companion_instance_21;
}
var $serializerClass_18;
function $serializer_18() {
  if ($serializerClass_18 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_18 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.MailCheckPhysically.Request', this, 2);
        tmp0_serialDesc.c1b('name', false);
        tmp0_serialDesc.c1b('address', false);
        this.u95_1 = tmp0_serialDesc;
      }
      v95(encoder, value) {
        var tmp0_desc = this.u95_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.x7y_1);
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_5(), value.y7y_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.v95(encoder, value instanceof Request() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.u95_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, $serializer_getInstance_5(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, $serializer_getInstance_5(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return Request().w95(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.u95_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), $serializer_getInstance_5()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_18 = $;
  }
  return $serializerClass_18;
}
var $serializer_instance_18;
function $serializer_getInstance_34() {
  if ($serializer_instance_18 === VOID)
    new ($serializer_18())();
  return $serializer_instance_18;
}
function MailCheckPhysically$ConfirmedShipped$Companion$$childSerializers$_anonymous__o7pdax() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_20;
function Companion_20() {
  if (CompanionClass_20 === VOID) {
    class $ {
      constructor() {
        Companion_instance_22 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.z8r_1 = [null, null, lazy(tmp_0, MailCheckPhysically$ConfirmedShipped$Companion$$childSerializers$_anonymous__o7pdax)];
      }
      m2a() {
        return $serializer_getInstance_35();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_20 = $;
  }
  return CompanionClass_20;
}
var Companion_instance_22;
function Companion_getInstance_34() {
  if (Companion_instance_22 === VOID)
    new (Companion_20())();
  return Companion_instance_22;
}
var $serializerClass_19;
function $serializer_19() {
  if ($serializerClass_19 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_19 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.MailCheckPhysically.ConfirmedShipped', this, 3);
        tmp0_serialDesc.c1b('admin', false);
        tmp0_serialDesc.c1b('ip', false);
        tmp0_serialDesc.c1b('timestamp', false);
        this.x95_1 = tmp0_serialDesc;
      }
      y95(encoder, value) {
        var tmp0_desc = this.x95_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_34().z8r_1;
        tmp1_output.a15(tmp0_desc, 0, value.z95_1);
        tmp1_output.a15(tmp0_desc, 1, value.a96_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.b96_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.y95(encoder, value instanceof ConfirmedShipped() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.x95_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_34().z8r_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return ConfirmedShipped().c96(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.x95_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_34().z8r_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_19 = $;
  }
  return $serializerClass_19;
}
var $serializer_instance_19;
function $serializer_getInstance_35() {
  if ($serializer_instance_19 === VOID)
    new ($serializer_19())();
  return $serializer_instance_19;
}
function MailCheckPhysically$Companion$$childSerializers$_anonymous__v5r13p() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function MailCheckPhysically$Companion$$childSerializers$_anonymous__v5r13p_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function MailCheckPhysically$Companion$$childSerializers$_anonymous__v5r13p_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var RequestClass;
function Request() {
  if (RequestClass === VOID) {
    class $ {
      constructor(name, address) {
        this.x7y_1 = name;
        this.y7y_1 = address;
      }
      d96(name, address) {
        return new (Request())(name, address);
      }
      a7z(name, address, $super) {
        name = name === VOID ? this.x7y_1 : name;
        address = address === VOID ? this.y7y_1 : address;
        return $super === VOID ? this.d96(name, address) : $super.d96.call(this, name, address);
      }
      toString() {
        return 'Request(name=' + this.x7y_1 + ', address=' + this.y7y_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.x7y_1);
        result = imul(result, 31) + this.y7y_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Request()))
          return false;
        if (!(this.x7y_1 === other.x7y_1))
          return false;
        if (!this.y7y_1.equals(other.y7y_1))
          return false;
        return true;
      }
      static w95(seen0, name, address, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_34().u95_1);
        }
        var $this = createThis(this);
        $this.x7y_1 = name;
        $this.y7y_1 = address;
        return $this;
      }
    }
    initMetadataForClass($, 'Request', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_34});
    RequestClass = $;
  }
  return RequestClass;
}
var ConfirmedShippedClass;
function ConfirmedShipped() {
  if (ConfirmedShippedClass === VOID) {
    class $ {
      toString() {
        return 'ConfirmedShipped(admin=' + this.z95_1 + ', ip=' + this.a96_1 + ', timestamp=' + this.b96_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.z95_1);
        result = imul(result, 31) + getStringHashCode(this.a96_1) | 0;
        result = imul(result, 31) + this.b96_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ConfirmedShipped()))
          return false;
        if (!(this.z95_1 === other.z95_1))
          return false;
        if (!(this.a96_1 === other.a96_1))
          return false;
        if (!this.b96_1.equals(other.b96_1))
          return false;
        return true;
      }
      static c96(seen0, admin, ip, timestamp, serializationConstructorMarker) {
        Companion_getInstance_34();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_35().x95_1);
        }
        var $this = createThis(this);
        $this.z95_1 = admin;
        $this.a96_1 = ip;
        $this.b96_1 = timestamp;
        return $this;
      }
    }
    initMetadataForClass($, 'ConfirmedShipped', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_35});
    ConfirmedShippedClass = $;
  }
  return ConfirmedShippedClass;
}
var CompanionClass_21;
function Companion_21() {
  if (CompanionClass_21 === VOID) {
    class $ {
      constructor() {
        Companion_instance_23 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, MailCheckPhysically$Companion$$childSerializers$_anonymous__v5r13p);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, MailCheckPhysically$Companion$$childSerializers$_anonymous__v5r13p_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.y6q_1 = [tmp_1, tmp_3, lazy(tmp_4, MailCheckPhysically$Companion$$childSerializers$_anonymous__v5r13p_1), null, null, null, null];
      }
      m2a() {
        return $serializer_getInstance_36();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_21 = $;
  }
  return CompanionClass_21;
}
var Companion_instance_23;
function Companion_getInstance_35() {
  if (Companion_instance_23 === VOID)
    new (Companion_21())();
  return Companion_instance_23;
}
var $serializerClass_20;
function $serializer_20() {
  if ($serializerClass_20 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_20 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.MailCheckPhysically', this, 7);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('user', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(User())));
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.c1b('name', false);
        tmp0_serialDesc.c1b('address', false);
        tmp0_serialDesc.c1b('amount', false);
        tmp0_serialDesc.c1b('confirmed', true);
        this.e96_1 = tmp0_serialDesc;
      }
      f96(encoder, value) {
        var tmp0_desc = this.e96_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_35().y6q_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.f6r_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.f6r_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.g6r_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.h6r_1);
        tmp1_output.a15(tmp0_desc, 3, value.i6r_1);
        tmp1_output.c15(tmp0_desc, 4, $serializer_getInstance_5(), value.j6r_1);
        tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_2(), new (MonetaryValue())(value.k6r_1));
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.l6r_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, $serializer_getInstance_35(), value.l6r_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.f96(encoder, value instanceof MailCheckPhysically() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.e96_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.l13(tmp0_desc);
        var tmp12_cached = Companion_getInstance_35().y6q_1;
        if (tmp11_input.a14()) {
          tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, tmp12_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.x13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, $serializer_getInstance_5(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp11_input.x13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.z13(tmp0_desc, 6, $serializer_getInstance_35(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, tmp12_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.x13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, $serializer_getInstance_5(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp9_local5;
                var tmp_4 = tmp11_input.x13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp9_local5 = tmp_4 == null ? null : tmp_4.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.z13(tmp0_desc, 6, $serializer_getInstance_35(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp11_input.m13(tmp0_desc);
        return MailCheckPhysically().g96(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      az() {
        return this.e96_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_35().y6q_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), StringSerializer_getInstance(), $serializer_getInstance_5(), $serializer_getInstance_2(), get_nullable($serializer_getInstance_35())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_20 = $;
  }
  return $serializerClass_20;
}
var $serializer_instance_20;
function $serializer_getInstance_36() {
  if ($serializer_instance_20 === VOID)
    new ($serializer_20())();
  return $serializer_instance_20;
}
var MailCheckPhysicallyClass;
function MailCheckPhysically() {
  if (MailCheckPhysicallyClass === VOID) {
    class $ {
      constructor(_id, user, project, name, address, amount, confirmed) {
        Companion_getInstance_35();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        confirmed = confirmed === VOID ? null : confirmed;
        this.f6r_1 = _id;
        this.g6r_1 = user;
        this.h6r_1 = project;
        this.i6r_1 = name;
        this.j6r_1 = address;
        this.k6r_1 = amount;
        this.l6r_1 = confirmed;
      }
      h40() {
        return this.f6r_1;
      }
      h96(_id, user, project, name, address, amount, confirmed) {
        return new (MailCheckPhysically())(_id, user, project, name, address, amount, confirmed);
      }
      n6r(_id, user, project, name, address, amount, confirmed, $super) {
        _id = _id === VOID ? this.f6r_1 : _id;
        user = user === VOID ? this.g6r_1 : user;
        project = project === VOID ? this.h6r_1 : project;
        name = name === VOID ? this.i6r_1 : name;
        address = address === VOID ? this.j6r_1 : address;
        amount = amount === VOID ? this.k6r_1 : amount;
        confirmed = confirmed === VOID ? this.l6r_1 : confirmed;
        return $super === VOID ? this.h96(_id, user, project, name, address, amount, confirmed) : $super.h96.call(this, _id, user, project, name, address, new (MonetaryValue())(amount), confirmed);
      }
      toString() {
        return 'MailCheckPhysically(_id=' + this.f6r_1.toString() + ', user=' + this.g6r_1.toString() + ', project=' + this.h6r_1.toString() + ', name=' + this.i6r_1 + ', address=' + this.j6r_1.toString() + ', amount=' + MonetaryValue__toString_impl_xslc77(this.k6r_1) + ', confirmed=' + toString_0(this.l6r_1) + ')';
      }
      hashCode() {
        var result = this.f6r_1.hashCode();
        result = imul(result, 31) + this.g6r_1.hashCode() | 0;
        result = imul(result, 31) + this.h6r_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.i6r_1) | 0;
        result = imul(result, 31) + this.j6r_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.k6r_1) | 0;
        result = imul(result, 31) + (this.l6r_1 == null ? 0 : this.l6r_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MailCheckPhysically()))
          return false;
        if (!this.f6r_1.equals(other.f6r_1))
          return false;
        if (!this.g6r_1.equals(other.g6r_1))
          return false;
        if (!this.h6r_1.equals(other.h6r_1))
          return false;
        if (!(this.i6r_1 === other.i6r_1))
          return false;
        if (!this.j6r_1.equals(other.j6r_1))
          return false;
        if (!(this.k6r_1 === other.k6r_1))
          return false;
        if (!equals(this.l6r_1, other.l6r_1))
          return false;
        return true;
      }
      static g96(seen0, _id, user, project, name, address, amount, confirmed, serializationConstructorMarker) {
        Companion_getInstance_35();
        if (!(62 === (62 & seen0))) {
          throwMissingFieldException(seen0, 62, $serializer_getInstance_36().e96_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.f6r_1 = Companion_getInstance().m2p();
        else
          $this.f6r_1 = _id;
        $this.g6r_1 = user;
        $this.h6r_1 = project;
        $this.i6r_1 = name;
        $this.j6r_1 = address;
        $this.k6r_1 = amount;
        if (0 === (seen0 & 64))
          $this.l6r_1 = null;
        else
          $this.l6r_1 = confirmed;
        return $this;
      }
    }
    initMetadataForClass($, 'MailCheckPhysically', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_36});
    MailCheckPhysicallyClass = $;
  }
  return MailCheckPhysicallyClass;
}
function PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_22;
function Companion_22() {
  if (CompanionClass_22 === VOID) {
    class $ {
      constructor() {
        Companion_instance_24 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.l6v_1 = [tmp_1, tmp_3, tmp_5, null, null, null, null, tmp_7, tmp_9, null, lazy(tmp_10, PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_4)];
      }
      m2a() {
        return $serializer_getInstance_37();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_22 = $;
  }
  return CompanionClass_22;
}
var Companion_instance_24;
function Companion_getInstance_36() {
  if (Companion_instance_24 === VOID)
    new (Companion_22())();
  return Companion_instance_24;
}
var $serializerClass_21;
function $serializer_21() {
  if ($serializerClass_21 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_21 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PayAppItem', this, 11);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('payApp', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(PayApplication())));
        tmp0_serialDesc.c1b('lineItem', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.c1b('amount', false);
        tmp0_serialDesc.d1b(new (MonetaryRange())(0n, 2147483647n));
        tmp0_serialDesc.c1b('approved', true);
        tmp0_serialDesc.c1b('denied', true);
        tmp0_serialDesc.c1b('voided', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('submitted', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('accepted', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('readBy', true);
        this.i96_1 = tmp0_serialDesc;
      }
      j96(encoder, value) {
        var tmp0_desc = this.i96_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_36().l6v_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.q6v_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.q6v_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.r6v_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.s6v_1);
        tmp1_output.c15(tmp0_desc, 3, $serializer_getInstance_2(), new (MonetaryValue())(value.t6v_1));
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.u6v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, $serializer_getInstance_4(), value.u6v_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.v6v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, $serializer_getInstance_8(), value.v6v_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.w6v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, $serializer_getInstance_4(), value.w6v_1);
        }
        tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.x6v_1);
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.y6v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, tmp2_cached[8].f2(), value.y6v_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.z6v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, BooleanSerializer_getInstance(), value.z6v_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !equals(value.a6w_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 10, tmp2_cached[10].f2(), value.a6w_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.j96(encoder, value instanceof PayAppItem() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.i96_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp16_input = decoder.l13(tmp0_desc);
        var tmp17_cached = Companion_getInstance_36().l6v_1;
        if (tmp16_input.a14()) {
          tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp7_local3;
          var tmp_1 = tmp16_input.x13(tmp0_desc, 3, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp7_local3 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp16_input.z13(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp16_input.z13(tmp0_desc, 5, $serializer_getInstance_8(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp16_input.z13(tmp0_desc, 6, $serializer_getInstance_4(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp16_input.x13(tmp0_desc, 7, tmp17_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp16_input.z13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp16_input.z13(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp16_input.x13(tmp0_desc, 10, tmp17_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp16_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp7_local3;
                var tmp_4 = tmp16_input.x13(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp7_local3 = tmp_4 == null ? null : tmp_4.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp16_input.z13(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp16_input.z13(tmp0_desc, 5, $serializer_getInstance_8(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp16_input.z13(tmp0_desc, 6, $serializer_getInstance_4(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp16_input.x13(tmp0_desc, 7, tmp17_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp16_input.z13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp16_input.z13(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp16_input.x13(tmp0_desc, 10, tmp17_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp16_input.m13(tmp0_desc);
        return PayAppItem().k96(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      az() {
        return this.i96_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_36().l6v_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), $serializer_getInstance_2(), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_4()), tmp0_cached[7].f2(), get_nullable(tmp0_cached[8].f2()), get_nullable(BooleanSerializer_getInstance()), tmp0_cached[10].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_21 = $;
  }
  return $serializerClass_21;
}
var $serializer_instance_21;
function $serializer_getInstance_37() {
  if ($serializer_instance_21 === VOID)
    new ($serializer_21())();
  return $serializer_instance_21;
}
var PayAppItemClass;
function PayAppItem() {
  if (PayAppItemClass === VOID) {
    class $ {
      constructor(_id, payApp, lineItem, amount, approved, denied, voided, project, submitted, accepted, readBy) {
        Companion_getInstance_36();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        approved = approved === VOID ? null : approved;
        denied = denied === VOID ? null : denied;
        voided = voided === VOID ? null : voided;
        submitted = submitted === VOID ? null : submitted;
        accepted = accepted === VOID ? null : accepted;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.q6v_1 = _id;
        this.r6v_1 = payApp;
        this.s6v_1 = lineItem;
        this.t6v_1 = amount;
        this.u6v_1 = approved;
        this.v6v_1 = denied;
        this.w6v_1 = voided;
        this.x6v_1 = project;
        this.y6v_1 = submitted;
        this.z6v_1 = accepted;
        this.a6w_1 = readBy;
        this.b6w_1 = !!(!!(!!(!(this.y6v_1 == null) & this.u6v_1 == null) & this.w6v_1 == null) & this.v6v_1 == null);
      }
      h40() {
        return this.q6v_1;
      }
      t91() {
        return this.a6w_1;
      }
      l96() {
        var tmp0_safe_receiver = this.v6v_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b95();
        var tmp;
        if (tmp1_elvis_lhs == null) {
          var tmp2_safe_receiver = this.w6v_1;
          tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.q54_1;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp3_elvis_lhs = tmp;
        var tmp_0;
        if (tmp3_elvis_lhs == null) {
          var tmp4_safe_receiver = this.u6v_1;
          tmp_0 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.q54_1;
        } else {
          tmp_0 = tmp3_elvis_lhs;
        }
        return tmp_0;
      }
      m96() {
        var tmp0_elvis_lhs = this.y6v_1;
        return tmp0_elvis_lhs == null ? this.l96() : tmp0_elvis_lhs;
      }
      n96() {
        var tmp0_elvis_lhs = this.l96();
        return tmp0_elvis_lhs == null ? this.y6v_1 : tmp0_elvis_lhs;
      }
      o96() {
        return this.v6v_1;
      }
      p96(_id, payApp, lineItem, amount, approved, denied, voided, project, submitted, accepted, readBy) {
        return new (PayAppItem())(_id, payApp, lineItem, amount, approved, denied, voided, project, submitted, accepted, readBy);
      }
      d6w(_id, payApp, lineItem, amount, approved, denied, voided, project, submitted, accepted, readBy, $super) {
        _id = _id === VOID ? this.q6v_1 : _id;
        payApp = payApp === VOID ? this.r6v_1 : payApp;
        lineItem = lineItem === VOID ? this.s6v_1 : lineItem;
        amount = amount === VOID ? this.t6v_1 : amount;
        approved = approved === VOID ? this.u6v_1 : approved;
        denied = denied === VOID ? this.v6v_1 : denied;
        voided = voided === VOID ? this.w6v_1 : voided;
        project = project === VOID ? this.x6v_1 : project;
        submitted = submitted === VOID ? this.y6v_1 : submitted;
        accepted = accepted === VOID ? this.z6v_1 : accepted;
        readBy = readBy === VOID ? this.a6w_1 : readBy;
        return $super === VOID ? this.p96(_id, payApp, lineItem, amount, approved, denied, voided, project, submitted, accepted, readBy) : $super.p96.call(this, _id, payApp, lineItem, new (MonetaryValue())(amount), approved, denied, voided, project, submitted, accepted, readBy);
      }
      toString() {
        return 'PayAppItem(_id=' + this.q6v_1.toString() + ', payApp=' + this.r6v_1.toString() + ', lineItem=' + this.s6v_1.toString() + ', amount=' + MonetaryValue__toString_impl_xslc77(this.t6v_1) + ', approved=' + toString_0(this.u6v_1) + ', denied=' + toString_0(this.v6v_1) + ', voided=' + toString_0(this.w6v_1) + ', project=' + this.x6v_1.toString() + ', submitted=' + toString_0(this.y6v_1) + ', accepted=' + this.z6v_1 + ', readBy=' + toString(this.a6w_1) + ')';
      }
      hashCode() {
        var result = this.q6v_1.hashCode();
        result = imul(result, 31) + this.r6v_1.hashCode() | 0;
        result = imul(result, 31) + this.s6v_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.t6v_1) | 0;
        result = imul(result, 31) + (this.u6v_1 == null ? 0 : this.u6v_1.hashCode()) | 0;
        result = imul(result, 31) + (this.v6v_1 == null ? 0 : this.v6v_1.hashCode()) | 0;
        result = imul(result, 31) + (this.w6v_1 == null ? 0 : this.w6v_1.hashCode()) | 0;
        result = imul(result, 31) + this.x6v_1.hashCode() | 0;
        result = imul(result, 31) + (this.y6v_1 == null ? 0 : this.y6v_1.hashCode()) | 0;
        result = imul(result, 31) + (this.z6v_1 == null ? 0 : getBooleanHashCode(this.z6v_1)) | 0;
        result = imul(result, 31) + hashCode(this.a6w_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PayAppItem()))
          return false;
        if (!this.q6v_1.equals(other.q6v_1))
          return false;
        if (!this.r6v_1.equals(other.r6v_1))
          return false;
        if (!this.s6v_1.equals(other.s6v_1))
          return false;
        if (!(this.t6v_1 === other.t6v_1))
          return false;
        if (!equals(this.u6v_1, other.u6v_1))
          return false;
        if (!equals(this.v6v_1, other.v6v_1))
          return false;
        if (!equals(this.w6v_1, other.w6v_1))
          return false;
        if (!this.x6v_1.equals(other.x6v_1))
          return false;
        if (!equals(this.y6v_1, other.y6v_1))
          return false;
        if (!(this.z6v_1 == other.z6v_1))
          return false;
        if (!equals(this.a6w_1, other.a6w_1))
          return false;
        return true;
      }
      static k96(seen0, _id, payApp, lineItem, amount, approved, denied, voided, project, submitted, accepted, readBy, serializationConstructorMarker) {
        Companion_getInstance_36();
        if (!(142 === (142 & seen0))) {
          throwMissingFieldException(seen0, 142, $serializer_getInstance_37().i96_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.q6v_1 = Companion_getInstance().m2p();
        else
          $this.q6v_1 = _id;
        $this.r6v_1 = payApp;
        $this.s6v_1 = lineItem;
        $this.t6v_1 = amount;
        if (0 === (seen0 & 16))
          $this.u6v_1 = null;
        else
          $this.u6v_1 = approved;
        if (0 === (seen0 & 32))
          $this.v6v_1 = null;
        else
          $this.v6v_1 = denied;
        if (0 === (seen0 & 64))
          $this.w6v_1 = null;
        else
          $this.w6v_1 = voided;
        $this.x6v_1 = project;
        if (0 === (seen0 & 256))
          $this.y6v_1 = null;
        else
          $this.y6v_1 = submitted;
        if (0 === (seen0 & 512))
          $this.z6v_1 = null;
        else
          $this.z6v_1 = accepted;
        if (0 === (seen0 & 1024))
          $this.a6w_1 = emptySet();
        else
          $this.a6w_1 = readBy;
        $this.b6w_1 = !!(!!(!!(!($this.y6v_1 == null) & $this.u6v_1 == null) & $this.w6v_1 == null) & $this.v6v_1 == null);
        return $this;
      }
    }
    initMetadataForClass($, 'PayAppItem', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_37});
    PayAppItemClass = $;
  }
  return PayAppItemClass;
}
function PayApplication$Companion$$childSerializers$_anonymous__wo9p5u() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_2() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_3() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_23;
function Companion_23() {
  if (CompanionClass_23 === VOID) {
    class $ {
      constructor() {
        Companion_instance_25 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, PayApplication$Companion$$childSerializers$_anonymous__wo9p5u);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d6y_1 = [tmp_1, tmp_3, null, tmp_5, tmp_7, null, tmp_9, lazy(tmp_10, PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_4)];
      }
      m2a() {
        return $serializer_getInstance_38();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_23 = $;
  }
  return CompanionClass_23;
}
var Companion_instance_25;
function Companion_getInstance_37() {
  if (Companion_instance_25 === VOID)
    new (Companion_23())();
  return Companion_instance_25;
}
var $serializerClass_22;
function $serializer_22() {
  if ($serializerClass_22 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_22 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PayApplication', this, 8);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('number', false);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('created', true);
        tmp0_serialDesc.c1b('submitted', true);
        tmp0_serialDesc.c1b('description', true);
        tmp0_serialDesc.c1b('attachments', true);
        tmp0_serialDesc.c1b('readBy', true);
        this.q96_1 = tmp0_serialDesc;
      }
      r96(encoder, value) {
        var tmp0_desc = this.q96_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_37().d6y_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.i6y_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.i6y_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.j6y_1);
        tmp1_output.v14(tmp0_desc, 2, value.k6y_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 3)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp = !value.l6y_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.l6y_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.m6y_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.m6y_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.n6y_1 === '')) {
          tmp1_output.a15(tmp0_desc, 5, value.n6y_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !equals(value.o6y_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.o6y_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !equals(value.p6y_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.p6y_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.r96(encoder, value instanceof PayApplication() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.q96_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.l13(tmp0_desc);
        var tmp13_cached = Companion_getInstance_37().d6y_1;
        if (tmp12_input.a14()) {
          tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.q13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.x13(tmp0_desc, 3, tmp13_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.z13(tmp0_desc, 4, tmp13_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.x13(tmp0_desc, 6, tmp13_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.x13(tmp0_desc, 7, tmp13_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.q13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.x13(tmp0_desc, 3, tmp13_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.z13(tmp0_desc, 4, tmp13_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.x13(tmp0_desc, 6, tmp13_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.x13(tmp0_desc, 7, tmp13_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp12_input.m13(tmp0_desc);
        return PayApplication().s96(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      az() {
        return this.q96_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_37().d6y_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), IntSerializer_getInstance(), tmp0_cached[3].f2(), get_nullable(tmp0_cached[4].f2()), StringSerializer_getInstance(), tmp0_cached[6].f2(), tmp0_cached[7].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_22 = $;
  }
  return $serializerClass_22;
}
var $serializer_instance_22;
function $serializer_getInstance_38() {
  if ($serializer_instance_22 === VOID)
    new ($serializer_22())();
  return $serializer_instance_22;
}
var PayApplicationClass;
function PayApplication() {
  if (PayApplicationClass === VOID) {
    class $ {
      constructor(_id, project, number, created, submitted, description, attachments, readBy) {
        Companion_getInstance_37();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = created;
        }
        created = tmp;
        submitted = submitted === VOID ? null : submitted;
        description = description === VOID ? '' : description;
        attachments = attachments === VOID ? emptyList() : attachments;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.i6y_1 = _id;
        this.j6y_1 = project;
        this.k6y_1 = number;
        this.l6y_1 = created;
        this.m6y_1 = submitted;
        this.n6y_1 = description;
        this.o6y_1 = attachments;
        this.p6y_1 = readBy;
      }
      h40() {
        return this.i6y_1;
      }
      t91() {
        return this.p6y_1;
      }
      b95() {
        var tmp0_elvis_lhs = this.m6y_1;
        return tmp0_elvis_lhs == null ? this.l6y_1 : tmp0_elvis_lhs;
      }
      t96(_id, project, number, created, submitted, description, attachments, readBy) {
        return new (PayApplication())(_id, project, number, created, submitted, description, attachments, readBy);
      }
      r6y(_id, project, number, created, submitted, description, attachments, readBy, $super) {
        _id = _id === VOID ? this.i6y_1 : _id;
        project = project === VOID ? this.j6y_1 : project;
        number = number === VOID ? this.k6y_1 : number;
        created = created === VOID ? this.l6y_1 : created;
        submitted = submitted === VOID ? this.m6y_1 : submitted;
        description = description === VOID ? this.n6y_1 : description;
        attachments = attachments === VOID ? this.o6y_1 : attachments;
        readBy = readBy === VOID ? this.p6y_1 : readBy;
        return $super === VOID ? this.t96(_id, project, number, created, submitted, description, attachments, readBy) : $super.t96.call(this, _id, project, number, created, submitted, description, attachments, readBy);
      }
      toString() {
        return 'PayApplication(_id=' + this.i6y_1.toString() + ', project=' + this.j6y_1.toString() + ', number=' + this.k6y_1 + ', created=' + this.l6y_1.toString() + ', submitted=' + toString_0(this.m6y_1) + ', description=' + this.n6y_1 + ', attachments=' + toString(this.o6y_1) + ', readBy=' + toString(this.p6y_1) + ')';
      }
      hashCode() {
        var result = this.i6y_1.hashCode();
        result = imul(result, 31) + this.j6y_1.hashCode() | 0;
        result = imul(result, 31) + this.k6y_1 | 0;
        result = imul(result, 31) + this.l6y_1.hashCode() | 0;
        result = imul(result, 31) + (this.m6y_1 == null ? 0 : this.m6y_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.n6y_1) | 0;
        result = imul(result, 31) + hashCode(this.o6y_1) | 0;
        result = imul(result, 31) + hashCode(this.p6y_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PayApplication()))
          return false;
        if (!this.i6y_1.equals(other.i6y_1))
          return false;
        if (!this.j6y_1.equals(other.j6y_1))
          return false;
        if (!(this.k6y_1 === other.k6y_1))
          return false;
        if (!this.l6y_1.equals(other.l6y_1))
          return false;
        if (!equals(this.m6y_1, other.m6y_1))
          return false;
        if (!(this.n6y_1 === other.n6y_1))
          return false;
        if (!equals(this.o6y_1, other.o6y_1))
          return false;
        if (!equals(this.p6y_1, other.p6y_1))
          return false;
        return true;
      }
      static s96(seen0, _id, project, number, created, submitted, description, attachments, readBy, serializationConstructorMarker) {
        Companion_getInstance_37();
        if (!(6 === (6 & seen0))) {
          throwMissingFieldException(seen0, 6, $serializer_getInstance_38().q96_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.i6y_1 = Companion_getInstance().m2p();
        else
          $this.i6y_1 = _id;
        $this.j6y_1 = project;
        $this.k6y_1 = number;
        if (0 === (seen0 & 8)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.l6y_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.l6y_1 = created;
        if (0 === (seen0 & 16))
          $this.m6y_1 = null;
        else
          $this.m6y_1 = submitted;
        if (0 === (seen0 & 32))
          $this.n6y_1 = '';
        else
          $this.n6y_1 = description;
        if (0 === (seen0 & 64))
          $this.o6y_1 = emptyList();
        else
          $this.o6y_1 = attachments;
        if (0 === (seen0 & 128))
          $this.p6y_1 = emptySet();
        else
          $this.p6y_1 = readBy;
        return $this;
      }
    }
    initMetadataForClass($, 'PayApplication', VOID, VOID, [HasId(), ReadByDataModel(), DrawTableItem()], VOID, VOID, {0: $serializer_getInstance_38});
    PayApplicationClass = $;
  }
  return PayApplicationClass;
}
function Payout$Companion$$childSerializers$_anonymous__b2iidg() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_24;
function Companion_24() {
  if (CompanionClass_24 === VOID) {
    class $ {
      constructor() {
        Companion_instance_26 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.b71_1 = [lazy(tmp_0, Payout$Companion$$childSerializers$_anonymous__b2iidg), null, null];
      }
      m2a() {
        return $serializer_getInstance_39();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_24 = $;
  }
  return CompanionClass_24;
}
var Companion_instance_26;
function Companion_getInstance_38() {
  if (Companion_instance_26 === VOID)
    new (Companion_24())();
  return Companion_instance_26;
}
var $serializerClass_23;
function $serializer_23() {
  if ($serializerClass_23 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_23 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Payout', this, 3);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('totalOut', false);
        tmp0_serialDesc.c1b('onePercent', false);
        this.u96_1 = tmp0_serialDesc;
      }
      v96(encoder, value) {
        var tmp0_desc = this.u96_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_38().b71_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.i71_1.equals(System_instance.d1m())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.i71_1);
        }
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_2(), new (MonetaryValue())(value.j71_1));
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance_2(), new (MonetaryValue())(value.k71_1));
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.v96(encoder, value instanceof Payout() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.u96_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_38().b71_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp7_input.x13(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_2 = $serializer_getInstance_2();
          var tmp_3 = tmp6_local2;
          var tmp_4 = tmp7_input.x13(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp6_local2 = tmp_4 == null ? null : tmp_4.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_5 = $serializer_getInstance_2();
                var tmp_6 = tmp5_local1;
                var tmp_7 = tmp7_input.x13(tmp0_desc, 1, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
                tmp5_local1 = tmp_7 == null ? null : tmp_7.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_8 = $serializer_getInstance_2();
                var tmp_9 = tmp6_local2;
                var tmp_10 = tmp7_input.x13(tmp0_desc, 2, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
                tmp6_local2 = tmp_10 == null ? null : tmp_10.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return Payout().w96(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.u96_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_38().b71_1[0].f2(), $serializer_getInstance_2(), $serializer_getInstance_2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_23 = $;
  }
  return $serializerClass_23;
}
var $serializer_instance_23;
function $serializer_getInstance_39() {
  if ($serializer_instance_23 === VOID)
    new ($serializer_23())();
  return $serializer_instance_23;
}
var PayoutClass;
function Payout() {
  if (PayoutClass === VOID) {
    class $ {
      constructor(_id, totalOut, onePercent) {
        Companion_getInstance_38();
        _id = _id === VOID ? System_instance.d1m() : _id;
        this.i71_1 = _id;
        this.j71_1 = totalOut;
        this.k71_1 = onePercent;
      }
      h40() {
        return this.i71_1;
      }
      x96(_id, totalOut, onePercent) {
        return new (Payout())(_id, totalOut, onePercent);
      }
      m71(_id, totalOut, onePercent, $super) {
        _id = _id === VOID ? this.i71_1 : _id;
        totalOut = totalOut === VOID ? this.j71_1 : totalOut;
        onePercent = onePercent === VOID ? this.k71_1 : onePercent;
        return $super === VOID ? this.x96(_id, totalOut, onePercent) : $super.x96.call(this, _id, new (MonetaryValue())(totalOut), new (MonetaryValue())(onePercent));
      }
      toString() {
        return 'Payout(_id=' + this.i71_1.toString() + ', totalOut=' + MonetaryValue__toString_impl_xslc77(this.j71_1) + ', onePercent=' + MonetaryValue__toString_impl_xslc77(this.k71_1) + ')';
      }
      hashCode() {
        var result = this.i71_1.hashCode();
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.j71_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.k71_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Payout()))
          return false;
        if (!this.i71_1.equals(other.i71_1))
          return false;
        if (!(this.j71_1 === other.j71_1))
          return false;
        if (!(this.k71_1 === other.k71_1))
          return false;
        return true;
      }
      static w96(seen0, _id, totalOut, onePercent, serializationConstructorMarker) {
        Companion_getInstance_38();
        if (!(6 === (6 & seen0))) {
          throwMissingFieldException(seen0, 6, $serializer_getInstance_39().u96_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.i71_1 = System_instance.d1m();
        else
          $this.i71_1 = _id;
        $this.j71_1 = totalOut;
        $this.k71_1 = onePercent;
        return $this;
      }
    }
    initMetadataForClass($, 'Payout', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_39});
    PayoutClass = $;
  }
  return PayoutClass;
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_5() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_6() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_25;
function Companion_25() {
  if (CompanionClass_25 === VOID) {
    class $ {
      constructor() {
        Companion_instance_27 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.v71_1 = [tmp_1, tmp_3, tmp_5, tmp_7, null, null, null, null, null, null, tmp_9, tmp_11, null, tmp_13, lazy(tmp_14, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_6)];
      }
      m2a() {
        return $serializer_getInstance_40();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_25 = $;
  }
  return CompanionClass_25;
}
var Companion_instance_27;
function Companion_getInstance_39() {
  if (Companion_instance_27 === VOID)
    new (Companion_25())();
  return Companion_instance_27;
}
var $serializerClass_24;
function $serializer_24() {
  if ($serializerClass_24 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_24 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PendingItemChange', this, 15);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('changeRequest', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(ChangeRequest())));
        tmp0_serialDesc.c1b('itemId', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.c1b('updatedDescription', true);
        tmp0_serialDesc.c1b('priceChange', true);
        tmp0_serialDesc.c1b('cancelled', true);
        tmp0_serialDesc.c1b('accepted', true);
        tmp0_serialDesc.c1b('approved', true);
        tmp0_serialDesc.c1b('denied', true);
        tmp0_serialDesc.c1b('withdrawn', true);
        tmp0_serialDesc.c1b('created', true);
        tmp0_serialDesc.c1b('itemNumber', false);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('published', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        this.y96_1 = tmp0_serialDesc;
      }
      z96(encoder, value) {
        var tmp0_desc = this.y96_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_39().v71_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.c72_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.c72_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.d72_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.e72_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.f72_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.g72_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, StringSerializer_getInstance(), value.g72_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          var tmp_0 = value.h72_1;
          tmp = !((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_2();
          var tmp_2 = value.h72_1;
          tmp1_output.d15(tmp0_desc, 5, tmp_1, tmp_2 == null ? null : new (MonetaryValue())(tmp_2));
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.i72_1 === false)) {
          tmp1_output.s14(tmp0_desc, 6, value.i72_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.j72_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, $serializer_getInstance_4(), value.j72_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.k72_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, BooleanSerializer_getInstance(), value.k72_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.l72_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, $serializer_getInstance_8(), value.l72_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.m72_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, tmp2_cached[10].f2(), value.m72_1);
        }
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 11)) {
          tmp_3 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp_3 = !value.n72_1.equals(tmp$ret$0);
        }
        if (tmp_3) {
          tmp1_output.c15(tmp0_desc, 11, tmp2_cached[11].f2(), value.n72_1);
        }
        tmp1_output.a15(tmp0_desc, 12, value.o72_1);
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !equals(value.p72_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 13, tmp2_cached[13].f2(), value.p72_1);
        }
        if (tmp1_output.h15(tmp0_desc, 14) ? true : !(value.q72_1 == null)) {
          tmp1_output.d15(tmp0_desc, 14, tmp2_cached[14].f2(), value.q72_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.z96(encoder, value instanceof PendingItemChange() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.y96_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_input = decoder.l13(tmp0_desc);
        var tmp20_cached = Companion_getInstance_39().v71_1;
        if (tmp19_input.a14()) {
          tmp4_local0 = tmp19_input.x13(tmp0_desc, 0, tmp20_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp19_input.x13(tmp0_desc, 1, tmp20_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp19_input.x13(tmp0_desc, 2, tmp20_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp19_input.x13(tmp0_desc, 3, tmp20_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp19_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp19_input.z13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp19_input.n13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp19_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp19_input.z13(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp19_input.z13(tmp0_desc, 9, $serializer_getInstance_8(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp19_input.z13(tmp0_desc, 10, tmp20_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp19_input.x13(tmp0_desc, 11, tmp20_cached[11].f2(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp19_input.v13(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp19_input.x13(tmp0_desc, 13, tmp20_cached[13].f2(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp19_input.z13(tmp0_desc, 14, tmp20_cached[14].f2(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp19_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp19_input.x13(tmp0_desc, 0, tmp20_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp19_input.x13(tmp0_desc, 1, tmp20_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp19_input.x13(tmp0_desc, 2, tmp20_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp19_input.x13(tmp0_desc, 3, tmp20_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp19_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp9_local5;
                var tmp_4 = tmp19_input.z13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp9_local5 = tmp_4 == null ? null : tmp_4.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp19_input.n13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp19_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp19_input.z13(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp19_input.z13(tmp0_desc, 9, $serializer_getInstance_8(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp19_input.z13(tmp0_desc, 10, tmp20_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp19_input.x13(tmp0_desc, 11, tmp20_cached[11].f2(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp19_input.v13(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp19_input.x13(tmp0_desc, 13, tmp20_cached[13].f2(), tmp17_local13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp19_input.z13(tmp0_desc, 14, tmp20_cached[14].f2(), tmp18_local14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp19_input.m13(tmp0_desc);
        return PendingItemChange().a97(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, null);
      }
      az() {
        return this.y96_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_39().v71_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_2()), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_4()), get_nullable(BooleanSerializer_getInstance()), get_nullable($serializer_getInstance_8()), get_nullable(tmp0_cached[10].f2()), tmp0_cached[11].f2(), StringSerializer_getInstance(), tmp0_cached[13].f2(), get_nullable(tmp0_cached[14].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_24 = $;
  }
  return $serializerClass_24;
}
var $serializer_instance_24;
function $serializer_getInstance_40() {
  if ($serializer_instance_24 === VOID)
    new ($serializer_24())();
  return $serializer_instance_24;
}
var PendingItemChangeClass;
function PendingItemChange() {
  if (PendingItemChangeClass === VOID) {
    class $ {
      constructor(_id, project, changeRequest, itemId, updatedDescription, priceChange, cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published) {
        Companion_getInstance_39();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        updatedDescription = updatedDescription === VOID ? null : updatedDescription;
        priceChange = priceChange === VOID ? null : priceChange;
        cancelled = cancelled === VOID ? false : cancelled;
        accepted = accepted === VOID ? null : accepted;
        approved = approved === VOID ? null : approved;
        denied = denied === VOID ? null : denied;
        withdrawn = withdrawn === VOID ? null : withdrawn;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = created;
        }
        created = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        published = published === VOID ? null : published;
        this.c72_1 = _id;
        this.d72_1 = project;
        this.e72_1 = changeRequest;
        this.f72_1 = itemId;
        this.g72_1 = updatedDescription;
        this.h72_1 = priceChange;
        this.i72_1 = cancelled;
        this.j72_1 = accepted;
        this.k72_1 = approved;
        this.l72_1 = denied;
        this.m72_1 = withdrawn;
        this.n72_1 = created;
        this.o72_1 = itemNumber;
        this.p72_1 = readBy;
        this.q72_1 = published;
      }
      h40() {
        return this.c72_1;
      }
      q94() {
        return this.e72_1;
      }
      r94() {
        return this.f72_1;
      }
      t94() {
        return this.g72_1;
      }
      u94() {
        return this.h72_1;
      }
      v94() {
        return this.i72_1;
      }
      h95() {
        return this.m72_1;
      }
      w94() {
        return this.o72_1;
      }
      t91() {
        return this.p72_1;
      }
      x94() {
        var tmp0_safe_receiver = this.j72_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q54_1;
      }
      y94() {
        var tmp0_safe_receiver = this.l72_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b95();
      }
      s94() {
        return false;
      }
      z94() {
        return this.i72_1 ? ChangeType_Remove_getInstance() : ChangeType_Modify_getInstance();
      }
      o96() {
        return this.l72_1;
      }
      b97(_id, project, changeRequest, itemId, updatedDescription, priceChange, cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published) {
        return new (PendingItemChange())(_id, project, changeRequest, itemId, updatedDescription, priceChange, cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published);
      }
      s72(_id, project, changeRequest, itemId, updatedDescription, priceChange, cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published, $super) {
        _id = _id === VOID ? this.c72_1 : _id;
        project = project === VOID ? this.d72_1 : project;
        changeRequest = changeRequest === VOID ? this.e72_1 : changeRequest;
        itemId = itemId === VOID ? this.f72_1 : itemId;
        updatedDescription = updatedDescription === VOID ? this.g72_1 : updatedDescription;
        priceChange = priceChange === VOID ? this.h72_1 : priceChange;
        cancelled = cancelled === VOID ? this.i72_1 : cancelled;
        accepted = accepted === VOID ? this.j72_1 : accepted;
        approved = approved === VOID ? this.k72_1 : approved;
        denied = denied === VOID ? this.l72_1 : denied;
        withdrawn = withdrawn === VOID ? this.m72_1 : withdrawn;
        created = created === VOID ? this.n72_1 : created;
        itemNumber = itemNumber === VOID ? this.o72_1 : itemNumber;
        readBy = readBy === VOID ? this.p72_1 : readBy;
        published = published === VOID ? this.q72_1 : published;
        var tmp;
        if ($super === VOID) {
          tmp = this.b97(_id, project, changeRequest, itemId, updatedDescription, priceChange, cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published);
        } else {
          var tmp_0 = $super.b97;
          var tmp_1 = priceChange;
          tmp = tmp_0.call(this, _id, project, changeRequest, itemId, updatedDescription, tmp_1 == null ? null : new (MonetaryValue())(tmp_1), cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published);
        }
        return tmp;
      }
      toString() {
        var tmp = this.c72_1.toString();
        var tmp_0 = this.d72_1.toString();
        var tmp_1 = this.e72_1.toString();
        var tmp_2 = this.f72_1.toString();
        var tmp_3 = this.h72_1;
        return 'PendingItemChange(_id=' + tmp + ', project=' + tmp_0 + ', changeRequest=' + tmp_1 + ', itemId=' + tmp_2 + ', updatedDescription=' + this.g72_1 + ', priceChange=' + toString_0(tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) + ', cancelled=' + this.i72_1 + ', accepted=' + toString_0(this.j72_1) + ', approved=' + this.k72_1 + ', denied=' + toString_0(this.l72_1) + ', withdrawn=' + toString_0(this.m72_1) + ', created=' + this.n72_1.toString() + ', itemNumber=' + this.o72_1 + ', readBy=' + toString(this.p72_1) + ', published=' + toString_0(this.q72_1) + ')';
      }
      hashCode() {
        var result = this.c72_1.hashCode();
        result = imul(result, 31) + this.d72_1.hashCode() | 0;
        result = imul(result, 31) + this.e72_1.hashCode() | 0;
        result = imul(result, 31) + this.f72_1.hashCode() | 0;
        result = imul(result, 31) + (this.g72_1 == null ? 0 : getStringHashCode(this.g72_1)) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.h72_1;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = MonetaryValue__hashCode_impl_fhcsz2(this.h72_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + getBooleanHashCode(this.i72_1) | 0;
        result = imul(result, 31) + (this.j72_1 == null ? 0 : this.j72_1.hashCode()) | 0;
        result = imul(result, 31) + (this.k72_1 == null ? 0 : getBooleanHashCode(this.k72_1)) | 0;
        result = imul(result, 31) + (this.l72_1 == null ? 0 : this.l72_1.hashCode()) | 0;
        result = imul(result, 31) + (this.m72_1 == null ? 0 : this.m72_1.hashCode()) | 0;
        result = imul(result, 31) + this.n72_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.o72_1) | 0;
        result = imul(result, 31) + hashCode(this.p72_1) | 0;
        result = imul(result, 31) + (this.q72_1 == null ? 0 : this.q72_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PendingItemChange()))
          return false;
        if (!this.c72_1.equals(other.c72_1))
          return false;
        if (!this.d72_1.equals(other.d72_1))
          return false;
        if (!this.e72_1.equals(other.e72_1))
          return false;
        if (!this.f72_1.equals(other.f72_1))
          return false;
        if (!(this.g72_1 == other.g72_1))
          return false;
        var tmp = this.h72_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.h72_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        if (!(this.i72_1 === other.i72_1))
          return false;
        if (!equals(this.j72_1, other.j72_1))
          return false;
        if (!(this.k72_1 == other.k72_1))
          return false;
        if (!equals(this.l72_1, other.l72_1))
          return false;
        if (!equals(this.m72_1, other.m72_1))
          return false;
        if (!this.n72_1.equals(other.n72_1))
          return false;
        if (!(this.o72_1 === other.o72_1))
          return false;
        if (!equals(this.p72_1, other.p72_1))
          return false;
        if (!equals(this.q72_1, other.q72_1))
          return false;
        return true;
      }
      static a97(seen0, _id, project, changeRequest, itemId, updatedDescription, priceChange, cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published, serializationConstructorMarker) {
        Companion_getInstance_39();
        if (!(4110 === (4110 & seen0))) {
          throwMissingFieldException(seen0, 4110, $serializer_getInstance_40().y96_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.c72_1 = Companion_getInstance().m2p();
        else
          $this.c72_1 = _id;
        $this.d72_1 = project;
        $this.e72_1 = changeRequest;
        $this.f72_1 = itemId;
        if (0 === (seen0 & 16))
          $this.g72_1 = null;
        else
          $this.g72_1 = updatedDescription;
        if (0 === (seen0 & 32))
          $this.h72_1 = null;
        else
          $this.h72_1 = priceChange;
        if (0 === (seen0 & 64))
          $this.i72_1 = false;
        else
          $this.i72_1 = cancelled;
        if (0 === (seen0 & 128))
          $this.j72_1 = null;
        else
          $this.j72_1 = accepted;
        if (0 === (seen0 & 256))
          $this.k72_1 = null;
        else
          $this.k72_1 = approved;
        if (0 === (seen0 & 512))
          $this.l72_1 = null;
        else
          $this.l72_1 = denied;
        if (0 === (seen0 & 1024))
          $this.m72_1 = null;
        else
          $this.m72_1 = withdrawn;
        if (0 === (seen0 & 2048)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.n72_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.n72_1 = created;
        $this.o72_1 = itemNumber;
        if (0 === (seen0 & 8192))
          $this.p72_1 = emptySet();
        else
          $this.p72_1 = readBy;
        if (0 === (seen0 & 16384))
          $this.q72_1 = null;
        else
          $this.q72_1 = published;
        return $this;
      }
    }
    initMetadataForClass($, 'PendingItemChange', VOID, VOID, [HasId(), ItemChangeInterface(), ChangeRequestItem(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_40});
    PendingItemChangeClass = $;
  }
  return PendingItemChangeClass;
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_2() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_5() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_6() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_26;
function Companion_26() {
  if (CompanionClass_26 === VOID) {
    class $ {
      constructor() {
        Companion_instance_28 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.o75_1 = [tmp_1, tmp_3, tmp_5, null, null, null, tmp_7, null, null, null, tmp_9, null, tmp_11, null, tmp_13, lazy(tmp_14, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_6)];
      }
      m2a() {
        return $serializer_getInstance_41();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_26 = $;
  }
  return CompanionClass_26;
}
var Companion_instance_28;
function Companion_getInstance_40() {
  if (Companion_instance_28 === VOID)
    new (Companion_26())();
  return Companion_instance_28;
}
var $serializerClass_25;
function $serializer_25() {
  if ($serializerClass_25 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_25 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PendingLineItem', this, 16);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('changeRequest', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(ChangeRequest())));
        tmp0_serialDesc.c1b('name', true);
        tmp0_serialDesc.c1b('description', true);
        tmp0_serialDesc.c1b('price', true);
        tmp0_serialDesc.d1b(new (MonetaryRange())(0n, 2147483647n));
        tmp0_serialDesc.c1b('files', true);
        tmp0_serialDesc.c1b('linked', true);
        tmp0_serialDesc.c1b('accepted', true);
        tmp0_serialDesc.c1b('denied', true);
        tmp0_serialDesc.c1b('withdrawn', true);
        tmp0_serialDesc.c1b('approved', true);
        tmp0_serialDesc.c1b('created', true);
        tmp0_serialDesc.c1b('itemNumber', false);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('published', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        this.c97_1 = tmp0_serialDesc;
      }
      d97(encoder, value) {
        var tmp0_desc = this.c97_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_40().o75_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.v75_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.v75_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.w75_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.x75_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.y75_1 === '')) {
          tmp1_output.a15(tmp0_desc, 3, value.y75_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.z75_1 === '')) {
          tmp1_output.a15(tmp0_desc, 4, value.z75_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.a76_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_2(), new (MonetaryValue())(value.a76_1));
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 6)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.b76_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.b76_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.c76_1 === false)) {
          tmp1_output.s14(tmp0_desc, 7, value.c76_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.d76_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, $serializer_getInstance_4(), value.d76_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.e76_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, $serializer_getInstance_8(), value.e76_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.f76_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, tmp2_cached[10].f2(), value.f76_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.g76_1 == null)) {
          tmp1_output.d15(tmp0_desc, 11, BooleanSerializer_getInstance(), value.g76_1);
        }
        var tmp_0;
        if (tmp1_output.h15(tmp0_desc, 12)) {
          tmp_0 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$1 = get_default(Companion_instance_0).d1m();
          tmp_0 = !value.h76_1.equals(tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.c15(tmp0_desc, 12, tmp2_cached[12].f2(), value.h76_1);
        }
        tmp1_output.a15(tmp0_desc, 13, value.i76_1);
        if (tmp1_output.h15(tmp0_desc, 14) ? true : !equals(value.j76_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 14, tmp2_cached[14].f2(), value.j76_1);
        }
        if (tmp1_output.h15(tmp0_desc, 15) ? true : !(value.k76_1 == null)) {
          tmp1_output.d15(tmp0_desc, 15, tmp2_cached[15].f2(), value.k76_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.d97(encoder, value instanceof PendingLineItem() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.c97_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = false;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_local15 = null;
        var tmp20_input = decoder.l13(tmp0_desc);
        var tmp21_cached = Companion_getInstance_40().o75_1;
        if (tmp20_input.a14()) {
          tmp4_local0 = tmp20_input.x13(tmp0_desc, 0, tmp21_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp20_input.x13(tmp0_desc, 1, tmp21_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp20_input.x13(tmp0_desc, 2, tmp21_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp20_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp20_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp20_input.x13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp20_input.x13(tmp0_desc, 6, tmp21_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp20_input.n13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp20_input.z13(tmp0_desc, 8, $serializer_getInstance_4(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp20_input.z13(tmp0_desc, 9, $serializer_getInstance_8(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp20_input.z13(tmp0_desc, 10, tmp21_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp20_input.z13(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp20_input.x13(tmp0_desc, 12, tmp21_cached[12].f2(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp20_input.v13(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp20_input.x13(tmp0_desc, 14, tmp21_cached[14].f2(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp20_input.z13(tmp0_desc, 15, tmp21_cached[15].f2(), tmp19_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp20_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp20_input.x13(tmp0_desc, 0, tmp21_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp20_input.x13(tmp0_desc, 1, tmp21_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp20_input.x13(tmp0_desc, 2, tmp21_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp20_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp20_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp9_local5;
                var tmp_4 = tmp20_input.x13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp9_local5 = tmp_4 == null ? null : tmp_4.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp20_input.x13(tmp0_desc, 6, tmp21_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp20_input.n13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp20_input.z13(tmp0_desc, 8, $serializer_getInstance_4(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp20_input.z13(tmp0_desc, 9, $serializer_getInstance_8(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp20_input.z13(tmp0_desc, 10, tmp21_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp20_input.z13(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp20_input.x13(tmp0_desc, 12, tmp21_cached[12].f2(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp20_input.v13(tmp0_desc, 13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp20_input.x13(tmp0_desc, 14, tmp21_cached[14].f2(), tmp18_local14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp20_input.z13(tmp0_desc, 15, tmp21_cached[15].f2(), tmp19_local15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp20_input.m13(tmp0_desc);
        return PendingLineItem().e97(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, null);
      }
      az() {
        return this.c97_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_40().o75_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_2(), tmp0_cached[6].f2(), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_8()), get_nullable(tmp0_cached[10].f2()), get_nullable(BooleanSerializer_getInstance()), tmp0_cached[12].f2(), StringSerializer_getInstance(), tmp0_cached[14].f2(), get_nullable(tmp0_cached[15].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_25 = $;
  }
  return $serializerClass_25;
}
var $serializer_instance_25;
function $serializer_getInstance_41() {
  if ($serializer_instance_25 === VOID)
    new ($serializer_25())();
  return $serializer_instance_25;
}
var PendingLineItemClass;
function PendingLineItem() {
  if (PendingLineItemClass === VOID) {
    class $ {
      constructor(_id, project, changeRequest, name, description, price, files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published) {
        Companion_getInstance_40();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        name = name === VOID ? '' : name;
        description = description === VOID ? '' : description;
        price = price === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : price;
        var tmp;
        if (files === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = files;
        }
        files = tmp;
        linked = linked === VOID ? false : linked;
        accepted = accepted === VOID ? null : accepted;
        denied = denied === VOID ? null : denied;
        withdrawn = withdrawn === VOID ? null : withdrawn;
        approved = approved === VOID ? null : approved;
        var tmp_0;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance_0).d1m();
        } else {
          tmp_0 = created;
        }
        created = tmp_0;
        readBy = readBy === VOID ? emptySet() : readBy;
        published = published === VOID ? null : published;
        this.v75_1 = _id;
        this.w75_1 = project;
        this.x75_1 = changeRequest;
        this.y75_1 = name;
        this.z75_1 = description;
        this.a76_1 = price;
        this.b76_1 = files;
        this.c76_1 = linked;
        this.d76_1 = accepted;
        this.e76_1 = denied;
        this.f76_1 = withdrawn;
        this.g76_1 = approved;
        this.h76_1 = created;
        this.i76_1 = itemNumber;
        this.j76_1 = readBy;
        this.k76_1 = published;
      }
      h40() {
        return this.v75_1;
      }
      q94() {
        return this.x75_1;
      }
      k20() {
        return this.y75_1;
      }
      q91() {
        return this.z75_1;
      }
      v91() {
        return this.a76_1;
      }
      r91() {
        return this.b76_1;
      }
      s94() {
        return this.c76_1;
      }
      h95() {
        return this.f76_1;
      }
      w94() {
        return this.i76_1;
      }
      t91() {
        return this.j76_1;
      }
      r94() {
        return this.v75_1;
      }
      x94() {
        var tmp0_safe_receiver = this.d76_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q54_1;
      }
      y94() {
        var tmp0_safe_receiver = this.e76_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b95();
      }
      f97() {
        return this.a76_1;
      }
      u94() {
        return this.f97();
      }
      z94() {
        return ChangeType_New_getInstance();
      }
      o96() {
        return this.e76_1;
      }
      g97(_id, project, changeRequest, name, description, price, files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published) {
        return new (PendingLineItem())(_id, project, changeRequest, name, description, price, files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published);
      }
      m76(_id, project, changeRequest, name, description, price, files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published, $super) {
        _id = _id === VOID ? this.v75_1 : _id;
        project = project === VOID ? this.w75_1 : project;
        changeRequest = changeRequest === VOID ? this.x75_1 : changeRequest;
        name = name === VOID ? this.y75_1 : name;
        description = description === VOID ? this.z75_1 : description;
        price = price === VOID ? this.a76_1 : price;
        files = files === VOID ? this.b76_1 : files;
        linked = linked === VOID ? this.c76_1 : linked;
        accepted = accepted === VOID ? this.d76_1 : accepted;
        denied = denied === VOID ? this.e76_1 : denied;
        withdrawn = withdrawn === VOID ? this.f76_1 : withdrawn;
        approved = approved === VOID ? this.g76_1 : approved;
        created = created === VOID ? this.h76_1 : created;
        itemNumber = itemNumber === VOID ? this.i76_1 : itemNumber;
        readBy = readBy === VOID ? this.j76_1 : readBy;
        published = published === VOID ? this.k76_1 : published;
        return $super === VOID ? this.g97(_id, project, changeRequest, name, description, price, files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published) : $super.g97.call(this, _id, project, changeRequest, name, description, new (MonetaryValue())(price), files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published);
      }
      toString() {
        return 'PendingLineItem(_id=' + this.v75_1.toString() + ', project=' + this.w75_1.toString() + ', changeRequest=' + this.x75_1.toString() + ', name=' + this.y75_1 + ', description=' + this.z75_1 + ', price=' + MonetaryValue__toString_impl_xslc77(this.a76_1) + ', files=' + toString(this.b76_1) + ', linked=' + this.c76_1 + ', accepted=' + toString_0(this.d76_1) + ', denied=' + toString_0(this.e76_1) + ', withdrawn=' + toString_0(this.f76_1) + ', approved=' + this.g76_1 + ', created=' + this.h76_1.toString() + ', itemNumber=' + this.i76_1 + ', readBy=' + toString(this.j76_1) + ', published=' + toString_0(this.k76_1) + ')';
      }
      hashCode() {
        var result = this.v75_1.hashCode();
        result = imul(result, 31) + this.w75_1.hashCode() | 0;
        result = imul(result, 31) + this.x75_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.y75_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z75_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.a76_1) | 0;
        result = imul(result, 31) + hashCode(this.b76_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.c76_1) | 0;
        result = imul(result, 31) + (this.d76_1 == null ? 0 : this.d76_1.hashCode()) | 0;
        result = imul(result, 31) + (this.e76_1 == null ? 0 : this.e76_1.hashCode()) | 0;
        result = imul(result, 31) + (this.f76_1 == null ? 0 : this.f76_1.hashCode()) | 0;
        result = imul(result, 31) + (this.g76_1 == null ? 0 : getBooleanHashCode(this.g76_1)) | 0;
        result = imul(result, 31) + this.h76_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.i76_1) | 0;
        result = imul(result, 31) + hashCode(this.j76_1) | 0;
        result = imul(result, 31) + (this.k76_1 == null ? 0 : this.k76_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PendingLineItem()))
          return false;
        if (!this.v75_1.equals(other.v75_1))
          return false;
        if (!this.w75_1.equals(other.w75_1))
          return false;
        if (!this.x75_1.equals(other.x75_1))
          return false;
        if (!(this.y75_1 === other.y75_1))
          return false;
        if (!(this.z75_1 === other.z75_1))
          return false;
        if (!(this.a76_1 === other.a76_1))
          return false;
        if (!equals(this.b76_1, other.b76_1))
          return false;
        if (!(this.c76_1 === other.c76_1))
          return false;
        if (!equals(this.d76_1, other.d76_1))
          return false;
        if (!equals(this.e76_1, other.e76_1))
          return false;
        if (!equals(this.f76_1, other.f76_1))
          return false;
        if (!(this.g76_1 == other.g76_1))
          return false;
        if (!this.h76_1.equals(other.h76_1))
          return false;
        if (!(this.i76_1 === other.i76_1))
          return false;
        if (!equals(this.j76_1, other.j76_1))
          return false;
        if (!equals(this.k76_1, other.k76_1))
          return false;
        return true;
      }
      static e97(seen0, _id, project, changeRequest, name, description, price, files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published, serializationConstructorMarker) {
        Companion_getInstance_40();
        if (!(8198 === (8198 & seen0))) {
          throwMissingFieldException(seen0, 8198, $serializer_getInstance_41().c97_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.v75_1 = Companion_getInstance().m2p();
        else
          $this.v75_1 = _id;
        $this.w75_1 = project;
        $this.x75_1 = changeRequest;
        if (0 === (seen0 & 8))
          $this.y75_1 = '';
        else
          $this.y75_1 = name;
        if (0 === (seen0 & 16))
          $this.z75_1 = '';
        else
          $this.z75_1 = description;
        if (0 === (seen0 & 32))
          $this.a76_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.a76_1 = price;
        if (0 === (seen0 & 64)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.b76_1 = emptyList();
        } else
          $this.b76_1 = files;
        if (0 === (seen0 & 128))
          $this.c76_1 = false;
        else
          $this.c76_1 = linked;
        if (0 === (seen0 & 256))
          $this.d76_1 = null;
        else
          $this.d76_1 = accepted;
        if (0 === (seen0 & 512))
          $this.e76_1 = null;
        else
          $this.e76_1 = denied;
        if (0 === (seen0 & 1024))
          $this.f76_1 = null;
        else
          $this.f76_1 = withdrawn;
        if (0 === (seen0 & 2048))
          $this.g76_1 = null;
        else
          $this.g76_1 = approved;
        if (0 === (seen0 & 4096)) {
          var tmp_0 = $this;
          // Inline function 'com.lightningkite.now' call
          tmp_0.h76_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.h76_1 = created;
        $this.i76_1 = itemNumber;
        if (0 === (seen0 & 16384))
          $this.j76_1 = emptySet();
        else
          $this.j76_1 = readBy;
        if (0 === (seen0 & 32768))
          $this.k76_1 = null;
        else
          $this.k76_1 = published;
        return $this;
      }
    }
    initMetadataForClass($, 'PendingLineItem', VOID, VOID, [HasId(), LineItemInterface(), ChangeRequestItem(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_41});
    PendingLineItemClass = $;
  }
  return PendingLineItemClass;
}
var CompanionClass_27;
function Companion_27() {
  if (CompanionClass_27 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_42();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_27 = $;
  }
  return CompanionClass_27;
}
var Companion_instance_29;
function Companion_getInstance_41() {
  return Companion_instance_29;
}
var $serializerClass_26;
function $serializer_26() {
  if ($serializerClass_26 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_26 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Project.LockInfo', this, 2);
        tmp0_serialDesc.c1b('access', false);
        tmp0_serialDesc.c1b('clientLocked', false);
        this.h97_1 = tmp0_serialDesc;
      }
      i97(encoder, value) {
        var tmp0_desc = this.h97_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_4(), value.q6q_1);
        tmp1_output.s14(tmp0_desc, 1, value.r6q_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i97(encoder, value instanceof LockInfo() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.h97_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance_4(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.n13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance_4(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.n13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return LockInfo().j97(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.h97_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_4(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_26 = $;
  }
  return $serializerClass_26;
}
var $serializer_instance_26;
function $serializer_getInstance_42() {
  if ($serializer_instance_26 === VOID)
    new ($serializer_26())();
  return $serializer_instance_26;
}
function Project$Companion$$childSerializers$_anonymous__hx2clt() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_3() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_5() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_6() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_7() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_8() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_9() {
  return Companion_getInstance_7().m2a();
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_10() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_11() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_12() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_13() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_14() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var LockInfoClass;
function LockInfo() {
  if (LockInfoClass === VOID) {
    class $ {
      constructor(access, clientLocked) {
        this.q6q_1 = access;
        this.r6q_1 = clientLocked;
      }
      k97(access, clientLocked) {
        return new (LockInfo())(access, clientLocked);
      }
      t6q(access, clientLocked, $super) {
        access = access === VOID ? this.q6q_1 : access;
        clientLocked = clientLocked === VOID ? this.r6q_1 : clientLocked;
        return $super === VOID ? this.k97(access, clientLocked) : $super.k97.call(this, access, clientLocked);
      }
      toString() {
        return 'LockInfo(access=' + this.q6q_1.toString() + ', clientLocked=' + this.r6q_1 + ')';
      }
      hashCode() {
        var result = this.q6q_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.r6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LockInfo()))
          return false;
        if (!this.q6q_1.equals(other.q6q_1))
          return false;
        if (!(this.r6q_1 === other.r6q_1))
          return false;
        return true;
      }
      static j97(seen0, access, clientLocked, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_42().h97_1);
        }
        var $this = createThis(this);
        $this.q6q_1 = access;
        $this.r6q_1 = clientLocked;
        return $this;
      }
    }
    initMetadataForClass($, 'LockInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_42});
    LockInfoClass = $;
  }
  return LockInfoClass;
}
var CompanionClass_28;
function Companion_28() {
  if (CompanionClass_28 === VOID) {
    class $ {
      constructor() {
        Companion_instance_30 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Project$Companion$$childSerializers$_anonymous__hx2clt);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Project$Companion$$childSerializers$_anonymous__hx2clt_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, Project$Companion$$childSerializers$_anonymous__hx2clt_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, Project$Companion$$childSerializers$_anonymous__hx2clt_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, Project$Companion$$childSerializers$_anonymous__hx2clt_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, Project$Companion$$childSerializers$_anonymous__hx2clt_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, Project$Companion$$childSerializers$_anonymous__hx2clt_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_15 = lazy(tmp_14, Project$Companion$$childSerializers$_anonymous__hx2clt_6);
        var tmp_16 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_17 = lazy(tmp_16, Project$Companion$$childSerializers$_anonymous__hx2clt_7);
        var tmp_18 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_19 = lazy(tmp_18, Project$Companion$$childSerializers$_anonymous__hx2clt_8);
        var tmp_20 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_21 = lazy(tmp_20, Project$Companion$$childSerializers$_anonymous__hx2clt_9);
        var tmp_22 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_23 = lazy(tmp_22, Project$Companion$$childSerializers$_anonymous__hx2clt_10);
        var tmp_24 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_25 = lazy(tmp_24, Project$Companion$$childSerializers$_anonymous__hx2clt_11);
        var tmp_26 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_27 = lazy(tmp_26, Project$Companion$$childSerializers$_anonymous__hx2clt_12);
        var tmp_28 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_29 = lazy(tmp_28, Project$Companion$$childSerializers$_anonymous__hx2clt_13);
        var tmp_30 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.p7a_1 = [tmp_1, null, tmp_3, null, tmp_5, tmp_7, null, null, null, null, null, tmp_9, null, tmp_11, tmp_13, null, tmp_15, null, null, null, tmp_17, null, tmp_19, null, null, tmp_21, null, null, tmp_23, null, null, null, null, null, null, tmp_25, tmp_27, tmp_29, null, lazy(tmp_30, Project$Companion$$childSerializers$_anonymous__hx2clt_14)];
        this.q7a_1 = 0.05;
      }
      m2a() {
        return $serializer_getInstance_43();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_28 = $;
  }
  return CompanionClass_28;
}
var Companion_instance_30;
function Companion_getInstance_42() {
  if (Companion_instance_30 === VOID)
    new (Companion_28())();
  return Companion_instance_30;
}
var $serializerClass_27;
function $serializer_27() {
  if ($serializerClass_27 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_27 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Project', this, 40);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('shortId', true);
        tmp0_serialDesc.c1b('contractor', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.c1b('contractorShortId', false);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('customer', true);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(User())));
        tmp0_serialDesc.c1b('client', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(Client())));
        tmp0_serialDesc.c1b('name', false);
        tmp0_serialDesc.c1b('description', false);
        tmp0_serialDesc.c1b('address', false);
        tmp0_serialDesc.c1b('location', true);
        tmp0_serialDesc.c1b('jobNumber', true);
        tmp0_serialDesc.c1b('files', true);
        tmp0_serialDesc.c1b('retention', true);
        tmp0_serialDesc.c1b('published', true);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('feedback', true);
        tmp0_serialDesc.c1b('created', true);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        tmp0_serialDesc.c1b('cancelled', true);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        tmp0_serialDesc.c1b('abandoned', true);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        tmp0_serialDesc.c1b('archived', true);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        tmp0_serialDesc.c1b('viewedByCustomer', true);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        tmp0_serialDesc.c1b('approved', true);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        tmp0_serialDesc.c1b('terminated', true);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        tmp0_serialDesc.c1b('complete', true);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        tmp0_serialDesc.c1b('isArchived', true);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('state', true);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('originalPrice', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('activePrice', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('projectCredits', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('acceptedChangeAmount', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('fundingRequested', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('clientDeposits', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('pendingClientDeposits', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('contractorPayments', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('clientReturn', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('started', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('preSubstantialCompletion', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('substantialCompletion', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('locked', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('lastModifiedBy', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.d1b(new (References())(getKClass(User())));
        tmp0_serialDesc.e1b(new (IndexSet())(['contractor', 'customer']));
        tmp0_serialDesc.e1b(new (UniqueSet())(['shortId', 'contractorShortId']));
        this.l97_1 = tmp0_serialDesc;
      }
      m97(encoder, value) {
        var tmp0_desc = this.l97_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_42().p7a_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.x7a_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.x7a_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.y7a_1 === Companion_instance_47.k5n())) {
          tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_58(), new (ShortId())(value.y7a_1));
        }
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.z7a_1);
        tmp1_output.c15(tmp0_desc, 3, $serializer_getInstance_58(), new (ShortId())(value.a7b_1));
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.b7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.b7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.c7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, tmp2_cached[5].f2(), value.c7b_1);
        }
        tmp1_output.a15(tmp0_desc, 6, value.d7b_1);
        tmp1_output.a15(tmp0_desc, 7, value.e7b_1);
        tmp1_output.c15(tmp0_desc, 8, $serializer_getInstance_5(), value.f7b_1);
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.g7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, StringSerializer_getInstance(), value.g7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.h7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, StringSerializer_getInstance(), value.h7b_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 11)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.i7b_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 11, tmp2_cached[11].f2(), value.i7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 12) ? true : !(value.j7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 12, FloatSerializer_getInstance(), value.j7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !(value.k7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 13, tmp2_cached[13].f2(), value.k7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 14) ? true : !equals(value.l7b_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 14, tmp2_cached[14].f2(), value.l7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 15) ? true : !(value.m7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 15, $serializer_getInstance_9(), value.m7b_1);
        }
        var tmp_0;
        if (tmp1_output.h15(tmp0_desc, 16)) {
          tmp_0 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$1 = get_default(Companion_instance_0).d1m();
          tmp_0 = !value.n7b_1.equals(tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.c15(tmp0_desc, 16, tmp2_cached[16].f2(), value.n7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 17) ? true : !(value.o7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 17, $serializer_getInstance_4(), value.o7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 18) ? true : !(value.p7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 18, $serializer_getInstance_4(), value.p7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 19) ? true : !(value.q7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 19, $serializer_getInstance_4(), value.q7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 20) ? true : !(value.r7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 20, tmp2_cached[20].f2(), value.r7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 21) ? true : !(value.s7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 21, $serializer_getInstance_4(), value.s7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 22) ? true : !(value.t7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 22, tmp2_cached[22].f2(), value.t7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 23) ? true : !(value.u7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 23, $serializer_getInstance_10(), value.u7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 24) ? true : !(value.v7b_1 === false)) {
          tmp1_output.s14(tmp0_desc, 24, value.v7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 25) ? true : !value.w7b_1.equals(ProjectState_Creating_getInstance())) {
          tmp1_output.c15(tmp0_desc, 25, tmp2_cached[25].f2(), value.w7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 26) ? true : !(value.x7b_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 26, $serializer_getInstance_2(), new (MonetaryValue())(value.x7b_1));
        }
        if (tmp1_output.h15(tmp0_desc, 27) ? true : !(value.y7b_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 27, $serializer_getInstance_2(), new (MonetaryValue())(value.y7b_1));
        }
        if (tmp1_output.h15(tmp0_desc, 28) ? true : !equals(value.z7b_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 28, tmp2_cached[28].f2(), value.z7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 29) ? true : !(value.a7c_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 29, $serializer_getInstance_2(), new (MonetaryValue())(value.a7c_1));
        }
        if (tmp1_output.h15(tmp0_desc, 30) ? true : !(value.b7c_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 30, $serializer_getInstance_2(), new (MonetaryValue())(value.b7c_1));
        }
        if (tmp1_output.h15(tmp0_desc, 31) ? true : !(value.c7c_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 31, $serializer_getInstance_2(), new (MonetaryValue())(value.c7c_1));
        }
        if (tmp1_output.h15(tmp0_desc, 32) ? true : !(value.d7c_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 32, $serializer_getInstance_2(), new (MonetaryValue())(value.d7c_1));
        }
        if (tmp1_output.h15(tmp0_desc, 33) ? true : !(value.e7c_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 33, $serializer_getInstance_2(), new (MonetaryValue())(value.e7c_1));
        }
        if (tmp1_output.h15(tmp0_desc, 34) ? true : !(value.f7c_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 34, $serializer_getInstance_2(), new (MonetaryValue())(value.f7c_1));
        }
        if (tmp1_output.h15(tmp0_desc, 35) ? true : !(value.g7c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 35, tmp2_cached[35].f2(), value.g7c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 36) ? true : !(value.h7c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 36, tmp2_cached[36].f2(), value.h7c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 37) ? true : !(value.i7c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 37, tmp2_cached[37].f2(), value.i7c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 38) ? true : !(value.j7c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 38, $serializer_getInstance_42(), value.j7c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 39) ? true : !(value.k7c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 39, tmp2_cached[39].f2(), value.k7c_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.m97(encoder, value instanceof Project() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.l97_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_bitMask1 = 0;
        var tmp5_local0 = null;
        var tmp6_local1 = null;
        var tmp7_local2 = null;
        var tmp8_local3 = null;
        var tmp9_local4 = null;
        var tmp10_local5 = null;
        var tmp11_local6 = null;
        var tmp12_local7 = null;
        var tmp13_local8 = null;
        var tmp14_local9 = null;
        var tmp15_local10 = null;
        var tmp16_local11 = null;
        var tmp17_local12 = null;
        var tmp18_local13 = null;
        var tmp19_local14 = null;
        var tmp20_local15 = null;
        var tmp21_local16 = null;
        var tmp22_local17 = null;
        var tmp23_local18 = null;
        var tmp24_local19 = null;
        var tmp25_local20 = null;
        var tmp26_local21 = null;
        var tmp27_local22 = null;
        var tmp28_local23 = null;
        var tmp29_local24 = false;
        var tmp30_local25 = null;
        var tmp31_local26 = null;
        var tmp32_local27 = null;
        var tmp33_local28 = null;
        var tmp34_local29 = null;
        var tmp35_local30 = null;
        var tmp36_local31 = null;
        var tmp37_local32 = null;
        var tmp38_local33 = null;
        var tmp39_local34 = null;
        var tmp40_local35 = null;
        var tmp41_local36 = null;
        var tmp42_local37 = null;
        var tmp43_local38 = null;
        var tmp44_local39 = null;
        var tmp45_input = decoder.l13(tmp0_desc);
        var tmp46_cached = Companion_getInstance_42().p7a_1;
        if (tmp45_input.a14()) {
          tmp5_local0 = tmp45_input.x13(tmp0_desc, 0, tmp46_cached[0].f2(), tmp5_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = $serializer_getInstance_58();
          var tmp_0 = tmp6_local1;
          var tmp_1 = tmp45_input.x13(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (ShortId())(tmp_0));
          tmp6_local1 = tmp_1 == null ? null : tmp_1.n5n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp7_local2 = tmp45_input.x13(tmp0_desc, 2, tmp46_cached[2].f2(), tmp7_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_2 = $serializer_getInstance_58();
          var tmp_3 = tmp8_local3;
          var tmp_4 = tmp45_input.x13(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new (ShortId())(tmp_3));
          tmp8_local3 = tmp_4 == null ? null : tmp_4.n5n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp9_local4 = tmp45_input.z13(tmp0_desc, 4, tmp46_cached[4].f2(), tmp9_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp10_local5 = tmp45_input.z13(tmp0_desc, 5, tmp46_cached[5].f2(), tmp10_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp11_local6 = tmp45_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp12_local7 = tmp45_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp13_local8 = tmp45_input.x13(tmp0_desc, 8, $serializer_getInstance_5(), tmp13_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp14_local9 = tmp45_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp14_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp15_local10 = tmp45_input.z13(tmp0_desc, 10, StringSerializer_getInstance(), tmp15_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp16_local11 = tmp45_input.x13(tmp0_desc, 11, tmp46_cached[11].f2(), tmp16_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp17_local12 = tmp45_input.z13(tmp0_desc, 12, FloatSerializer_getInstance(), tmp17_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp18_local13 = tmp45_input.z13(tmp0_desc, 13, tmp46_cached[13].f2(), tmp18_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp19_local14 = tmp45_input.x13(tmp0_desc, 14, tmp46_cached[14].f2(), tmp19_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp20_local15 = tmp45_input.z13(tmp0_desc, 15, $serializer_getInstance_9(), tmp20_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          tmp21_local16 = tmp45_input.x13(tmp0_desc, 16, tmp46_cached[16].f2(), tmp21_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          tmp22_local17 = tmp45_input.z13(tmp0_desc, 17, $serializer_getInstance_4(), tmp22_local17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          tmp23_local18 = tmp45_input.z13(tmp0_desc, 18, $serializer_getInstance_4(), tmp23_local18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          tmp24_local19 = tmp45_input.z13(tmp0_desc, 19, $serializer_getInstance_4(), tmp24_local19);
          tmp3_bitMask0 = tmp3_bitMask0 | 524288;
          tmp25_local20 = tmp45_input.z13(tmp0_desc, 20, tmp46_cached[20].f2(), tmp25_local20);
          tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
          tmp26_local21 = tmp45_input.z13(tmp0_desc, 21, $serializer_getInstance_4(), tmp26_local21);
          tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
          tmp27_local22 = tmp45_input.z13(tmp0_desc, 22, tmp46_cached[22].f2(), tmp27_local22);
          tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
          tmp28_local23 = tmp45_input.z13(tmp0_desc, 23, $serializer_getInstance_10(), tmp28_local23);
          tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
          tmp29_local24 = tmp45_input.n13(tmp0_desc, 24);
          tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
          tmp30_local25 = tmp45_input.x13(tmp0_desc, 25, tmp46_cached[25].f2(), tmp30_local25);
          tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
          var tmp_5 = $serializer_getInstance_2();
          var tmp_6 = tmp31_local26;
          var tmp_7 = tmp45_input.x13(tmp0_desc, 26, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
          tmp31_local26 = tmp_7 == null ? null : tmp_7.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
          var tmp_8 = $serializer_getInstance_2();
          var tmp_9 = tmp32_local27;
          var tmp_10 = tmp45_input.x13(tmp0_desc, 27, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
          tmp32_local27 = tmp_10 == null ? null : tmp_10.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
          tmp33_local28 = tmp45_input.x13(tmp0_desc, 28, tmp46_cached[28].f2(), tmp33_local28);
          tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
          var tmp_11 = $serializer_getInstance_2();
          var tmp_12 = tmp34_local29;
          var tmp_13 = tmp45_input.x13(tmp0_desc, 29, tmp_11, tmp_12 == null ? null : new (MonetaryValue())(tmp_12));
          tmp34_local29 = tmp_13 == null ? null : tmp_13.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
          var tmp_14 = $serializer_getInstance_2();
          var tmp_15 = tmp35_local30;
          var tmp_16 = tmp45_input.x13(tmp0_desc, 30, tmp_14, tmp_15 == null ? null : new (MonetaryValue())(tmp_15));
          tmp35_local30 = tmp_16 == null ? null : tmp_16.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
          var tmp_17 = $serializer_getInstance_2();
          var tmp_18 = tmp36_local31;
          var tmp_19 = tmp45_input.x13(tmp0_desc, 31, tmp_17, tmp_18 == null ? null : new (MonetaryValue())(tmp_18));
          tmp36_local31 = tmp_19 == null ? null : tmp_19.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
          var tmp_20 = $serializer_getInstance_2();
          var tmp_21 = tmp37_local32;
          var tmp_22 = tmp45_input.x13(tmp0_desc, 32, tmp_20, tmp_21 == null ? null : new (MonetaryValue())(tmp_21));
          tmp37_local32 = tmp_22 == null ? null : tmp_22.a5s_1;
          tmp4_bitMask1 = tmp4_bitMask1 | 1;
          var tmp_23 = $serializer_getInstance_2();
          var tmp_24 = tmp38_local33;
          var tmp_25 = tmp45_input.x13(tmp0_desc, 33, tmp_23, tmp_24 == null ? null : new (MonetaryValue())(tmp_24));
          tmp38_local33 = tmp_25 == null ? null : tmp_25.a5s_1;
          tmp4_bitMask1 = tmp4_bitMask1 | 2;
          var tmp_26 = $serializer_getInstance_2();
          var tmp_27 = tmp39_local34;
          var tmp_28 = tmp45_input.x13(tmp0_desc, 34, tmp_26, tmp_27 == null ? null : new (MonetaryValue())(tmp_27));
          tmp39_local34 = tmp_28 == null ? null : tmp_28.a5s_1;
          tmp4_bitMask1 = tmp4_bitMask1 | 4;
          tmp40_local35 = tmp45_input.z13(tmp0_desc, 35, tmp46_cached[35].f2(), tmp40_local35);
          tmp4_bitMask1 = tmp4_bitMask1 | 8;
          tmp41_local36 = tmp45_input.z13(tmp0_desc, 36, tmp46_cached[36].f2(), tmp41_local36);
          tmp4_bitMask1 = tmp4_bitMask1 | 16;
          tmp42_local37 = tmp45_input.z13(tmp0_desc, 37, tmp46_cached[37].f2(), tmp42_local37);
          tmp4_bitMask1 = tmp4_bitMask1 | 32;
          tmp43_local38 = tmp45_input.z13(tmp0_desc, 38, $serializer_getInstance_42(), tmp43_local38);
          tmp4_bitMask1 = tmp4_bitMask1 | 64;
          tmp44_local39 = tmp45_input.z13(tmp0_desc, 39, tmp46_cached[39].f2(), tmp44_local39);
          tmp4_bitMask1 = tmp4_bitMask1 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp45_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp5_local0 = tmp45_input.x13(tmp0_desc, 0, tmp46_cached[0].f2(), tmp5_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_29 = $serializer_getInstance_58();
                var tmp_30 = tmp6_local1;
                var tmp_31 = tmp45_input.x13(tmp0_desc, 1, tmp_29, tmp_30 == null ? null : new (ShortId())(tmp_30));
                tmp6_local1 = tmp_31 == null ? null : tmp_31.n5n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp7_local2 = tmp45_input.x13(tmp0_desc, 2, tmp46_cached[2].f2(), tmp7_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_32 = $serializer_getInstance_58();
                var tmp_33 = tmp8_local3;
                var tmp_34 = tmp45_input.x13(tmp0_desc, 3, tmp_32, tmp_33 == null ? null : new (ShortId())(tmp_33));
                tmp8_local3 = tmp_34 == null ? null : tmp_34.n5n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp9_local4 = tmp45_input.z13(tmp0_desc, 4, tmp46_cached[4].f2(), tmp9_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp10_local5 = tmp45_input.z13(tmp0_desc, 5, tmp46_cached[5].f2(), tmp10_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp11_local6 = tmp45_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp12_local7 = tmp45_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp13_local8 = tmp45_input.x13(tmp0_desc, 8, $serializer_getInstance_5(), tmp13_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp14_local9 = tmp45_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp14_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp15_local10 = tmp45_input.z13(tmp0_desc, 10, StringSerializer_getInstance(), tmp15_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp16_local11 = tmp45_input.x13(tmp0_desc, 11, tmp46_cached[11].f2(), tmp16_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp17_local12 = tmp45_input.z13(tmp0_desc, 12, FloatSerializer_getInstance(), tmp17_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp18_local13 = tmp45_input.z13(tmp0_desc, 13, tmp46_cached[13].f2(), tmp18_local13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp19_local14 = tmp45_input.x13(tmp0_desc, 14, tmp46_cached[14].f2(), tmp19_local14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp20_local15 = tmp45_input.z13(tmp0_desc, 15, $serializer_getInstance_9(), tmp20_local15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              case 16:
                tmp21_local16 = tmp45_input.x13(tmp0_desc, 16, tmp46_cached[16].f2(), tmp21_local16);
                tmp3_bitMask0 = tmp3_bitMask0 | 65536;
                break;
              case 17:
                tmp22_local17 = tmp45_input.z13(tmp0_desc, 17, $serializer_getInstance_4(), tmp22_local17);
                tmp3_bitMask0 = tmp3_bitMask0 | 131072;
                break;
              case 18:
                tmp23_local18 = tmp45_input.z13(tmp0_desc, 18, $serializer_getInstance_4(), tmp23_local18);
                tmp3_bitMask0 = tmp3_bitMask0 | 262144;
                break;
              case 19:
                tmp24_local19 = tmp45_input.z13(tmp0_desc, 19, $serializer_getInstance_4(), tmp24_local19);
                tmp3_bitMask0 = tmp3_bitMask0 | 524288;
                break;
              case 20:
                tmp25_local20 = tmp45_input.z13(tmp0_desc, 20, tmp46_cached[20].f2(), tmp25_local20);
                tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
                break;
              case 21:
                tmp26_local21 = tmp45_input.z13(tmp0_desc, 21, $serializer_getInstance_4(), tmp26_local21);
                tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
                break;
              case 22:
                tmp27_local22 = tmp45_input.z13(tmp0_desc, 22, tmp46_cached[22].f2(), tmp27_local22);
                tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
                break;
              case 23:
                tmp28_local23 = tmp45_input.z13(tmp0_desc, 23, $serializer_getInstance_10(), tmp28_local23);
                tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
                break;
              case 24:
                tmp29_local24 = tmp45_input.n13(tmp0_desc, 24);
                tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
                break;
              case 25:
                tmp30_local25 = tmp45_input.x13(tmp0_desc, 25, tmp46_cached[25].f2(), tmp30_local25);
                tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
                break;
              case 26:
                var tmp_35 = $serializer_getInstance_2();
                var tmp_36 = tmp31_local26;
                var tmp_37 = tmp45_input.x13(tmp0_desc, 26, tmp_35, tmp_36 == null ? null : new (MonetaryValue())(tmp_36));
                tmp31_local26 = tmp_37 == null ? null : tmp_37.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
                break;
              case 27:
                var tmp_38 = $serializer_getInstance_2();
                var tmp_39 = tmp32_local27;
                var tmp_40 = tmp45_input.x13(tmp0_desc, 27, tmp_38, tmp_39 == null ? null : new (MonetaryValue())(tmp_39));
                tmp32_local27 = tmp_40 == null ? null : tmp_40.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
                break;
              case 28:
                tmp33_local28 = tmp45_input.x13(tmp0_desc, 28, tmp46_cached[28].f2(), tmp33_local28);
                tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
                break;
              case 29:
                var tmp_41 = $serializer_getInstance_2();
                var tmp_42 = tmp34_local29;
                var tmp_43 = tmp45_input.x13(tmp0_desc, 29, tmp_41, tmp_42 == null ? null : new (MonetaryValue())(tmp_42));
                tmp34_local29 = tmp_43 == null ? null : tmp_43.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
                break;
              case 30:
                var tmp_44 = $serializer_getInstance_2();
                var tmp_45 = tmp35_local30;
                var tmp_46 = tmp45_input.x13(tmp0_desc, 30, tmp_44, tmp_45 == null ? null : new (MonetaryValue())(tmp_45));
                tmp35_local30 = tmp_46 == null ? null : tmp_46.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
                break;
              case 31:
                var tmp_47 = $serializer_getInstance_2();
                var tmp_48 = tmp36_local31;
                var tmp_49 = tmp45_input.x13(tmp0_desc, 31, tmp_47, tmp_48 == null ? null : new (MonetaryValue())(tmp_48));
                tmp36_local31 = tmp_49 == null ? null : tmp_49.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
                break;
              case 32:
                var tmp_50 = $serializer_getInstance_2();
                var tmp_51 = tmp37_local32;
                var tmp_52 = tmp45_input.x13(tmp0_desc, 32, tmp_50, tmp_51 == null ? null : new (MonetaryValue())(tmp_51));
                tmp37_local32 = tmp_52 == null ? null : tmp_52.a5s_1;
                tmp4_bitMask1 = tmp4_bitMask1 | 1;
                break;
              case 33:
                var tmp_53 = $serializer_getInstance_2();
                var tmp_54 = tmp38_local33;
                var tmp_55 = tmp45_input.x13(tmp0_desc, 33, tmp_53, tmp_54 == null ? null : new (MonetaryValue())(tmp_54));
                tmp38_local33 = tmp_55 == null ? null : tmp_55.a5s_1;
                tmp4_bitMask1 = tmp4_bitMask1 | 2;
                break;
              case 34:
                var tmp_56 = $serializer_getInstance_2();
                var tmp_57 = tmp39_local34;
                var tmp_58 = tmp45_input.x13(tmp0_desc, 34, tmp_56, tmp_57 == null ? null : new (MonetaryValue())(tmp_57));
                tmp39_local34 = tmp_58 == null ? null : tmp_58.a5s_1;
                tmp4_bitMask1 = tmp4_bitMask1 | 4;
                break;
              case 35:
                tmp40_local35 = tmp45_input.z13(tmp0_desc, 35, tmp46_cached[35].f2(), tmp40_local35);
                tmp4_bitMask1 = tmp4_bitMask1 | 8;
                break;
              case 36:
                tmp41_local36 = tmp45_input.z13(tmp0_desc, 36, tmp46_cached[36].f2(), tmp41_local36);
                tmp4_bitMask1 = tmp4_bitMask1 | 16;
                break;
              case 37:
                tmp42_local37 = tmp45_input.z13(tmp0_desc, 37, tmp46_cached[37].f2(), tmp42_local37);
                tmp4_bitMask1 = tmp4_bitMask1 | 32;
                break;
              case 38:
                tmp43_local38 = tmp45_input.z13(tmp0_desc, 38, $serializer_getInstance_42(), tmp43_local38);
                tmp4_bitMask1 = tmp4_bitMask1 | 64;
                break;
              case 39:
                tmp44_local39 = tmp45_input.z13(tmp0_desc, 39, tmp46_cached[39].f2(), tmp44_local39);
                tmp4_bitMask1 = tmp4_bitMask1 | 128;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp45_input.m13(tmp0_desc);
        return Project().n97(tmp3_bitMask0, tmp4_bitMask1, tmp5_local0, tmp6_local1, tmp7_local2, tmp8_local3, tmp9_local4, tmp10_local5, tmp11_local6, tmp12_local7, tmp13_local8, tmp14_local9, tmp15_local10, tmp16_local11, tmp17_local12, tmp18_local13, tmp19_local14, tmp20_local15, tmp21_local16, tmp22_local17, tmp23_local18, tmp24_local19, tmp25_local20, tmp26_local21, tmp27_local22, tmp28_local23, tmp29_local24, tmp30_local25, tmp31_local26, tmp32_local27, tmp33_local28, tmp34_local29, tmp35_local30, tmp36_local31, tmp37_local32, tmp38_local33, tmp39_local34, tmp40_local35, tmp41_local36, tmp42_local37, tmp43_local38, tmp44_local39, null);
      }
      az() {
        return this.l97_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_42().p7a_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), $serializer_getInstance_58(), tmp0_cached[2].f2(), $serializer_getInstance_58(), get_nullable(tmp0_cached[4].f2()), get_nullable(tmp0_cached[5].f2()), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_5(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[11].f2(), get_nullable(FloatSerializer_getInstance()), get_nullable(tmp0_cached[13].f2()), tmp0_cached[14].f2(), get_nullable($serializer_getInstance_9()), tmp0_cached[16].f2(), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_4()), get_nullable(tmp0_cached[20].f2()), get_nullable($serializer_getInstance_4()), get_nullable(tmp0_cached[22].f2()), get_nullable($serializer_getInstance_10()), BooleanSerializer_getInstance(), tmp0_cached[25].f2(), $serializer_getInstance_2(), $serializer_getInstance_2(), tmp0_cached[28].f2(), $serializer_getInstance_2(), $serializer_getInstance_2(), $serializer_getInstance_2(), $serializer_getInstance_2(), $serializer_getInstance_2(), $serializer_getInstance_2(), get_nullable(tmp0_cached[35].f2()), get_nullable(tmp0_cached[36].f2()), get_nullable(tmp0_cached[37].f2()), get_nullable($serializer_getInstance_42()), get_nullable(tmp0_cached[39].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_27 = $;
  }
  return $serializerClass_27;
}
var $serializer_instance_27;
function $serializer_getInstance_43() {
  if ($serializer_instance_27 === VOID)
    new ($serializer_27())();
  return $serializer_instance_27;
}
var ProjectClass;
function Project() {
  if (ProjectClass === VOID) {
    class $ {
      constructor(_id, shortId, contractor, contractorShortId, customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, originalPrice, activePrice, projectCredits, acceptedChangeAmount, fundingRequested, clientDeposits, pendingClientDeposits, contractorPayments, clientReturn, started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy) {
        Companion_getInstance_42();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        shortId = shortId === VOID ? Companion_instance_47.k5n() : shortId;
        customer = customer === VOID ? null : customer;
        client = client === VOID ? null : client;
        location = location === VOID ? null : location;
        jobNumber = jobNumber === VOID ? null : jobNumber;
        var tmp;
        if (files === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = files;
        }
        files = tmp;
        retention = retention === VOID ? null : retention;
        published = published === VOID ? null : published;
        readBy = readBy === VOID ? emptySet() : readBy;
        feedback = feedback === VOID ? null : feedback;
        var tmp_0;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance_0).d1m();
        } else {
          tmp_0 = created;
        }
        created = tmp_0;
        cancelled = cancelled === VOID ? null : cancelled;
        abandoned = abandoned === VOID ? null : abandoned;
        archived = archived === VOID ? null : archived;
        viewedByCustomer = viewedByCustomer === VOID ? null : viewedByCustomer;
        approved = approved === VOID ? null : approved;
        terminated = terminated === VOID ? null : terminated;
        complete = complete === VOID ? null : complete;
        isArchived = isArchived === VOID ? false : isArchived;
        state = state === VOID ? ProjectState_Creating_getInstance() : state;
        originalPrice = originalPrice === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : originalPrice;
        activePrice = activePrice === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : activePrice;
        projectCredits = projectCredits === VOID ? emptyList() : projectCredits;
        acceptedChangeAmount = acceptedChangeAmount === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : acceptedChangeAmount;
        fundingRequested = fundingRequested === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : fundingRequested;
        clientDeposits = clientDeposits === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : clientDeposits;
        pendingClientDeposits = pendingClientDeposits === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : pendingClientDeposits;
        contractorPayments = contractorPayments === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : contractorPayments;
        clientReturn = clientReturn === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : clientReturn;
        started = started === VOID ? null : started;
        preSubstantialCompletion = preSubstantialCompletion === VOID ? null : preSubstantialCompletion;
        substantialCompletion = substantialCompletion === VOID ? null : substantialCompletion;
        locked = locked === VOID ? null : locked;
        lastModifiedBy = lastModifiedBy === VOID ? null : lastModifiedBy;
        this.x7a_1 = _id;
        this.y7a_1 = shortId;
        this.z7a_1 = contractor;
        this.a7b_1 = contractorShortId;
        this.b7b_1 = customer;
        this.c7b_1 = client;
        this.d7b_1 = name;
        this.e7b_1 = description;
        this.f7b_1 = address;
        this.g7b_1 = location;
        this.h7b_1 = jobNumber;
        this.i7b_1 = files;
        this.j7b_1 = retention;
        this.k7b_1 = published;
        this.l7b_1 = readBy;
        this.m7b_1 = feedback;
        this.n7b_1 = created;
        this.o7b_1 = cancelled;
        this.p7b_1 = abandoned;
        this.q7b_1 = archived;
        this.r7b_1 = viewedByCustomer;
        this.s7b_1 = approved;
        this.t7b_1 = terminated;
        this.u7b_1 = complete;
        this.v7b_1 = isArchived;
        this.w7b_1 = state;
        this.x7b_1 = originalPrice;
        this.y7b_1 = activePrice;
        this.z7b_1 = projectCredits;
        this.a7c_1 = acceptedChangeAmount;
        this.b7c_1 = fundingRequested;
        this.c7c_1 = clientDeposits;
        this.d7c_1 = pendingClientDeposits;
        this.e7c_1 = contractorPayments;
        this.f7c_1 = clientReturn;
        this.g7c_1 = started;
        this.h7c_1 = preSubstantialCompletion;
        this.i7c_1 = substantialCompletion;
        this.j7c_1 = locked;
        this.k7c_1 = lastModifiedBy;
      }
      h40() {
        return this.x7a_1;
      }
      t91() {
        return this.l7b_1;
      }
      o97() {
        return ShortId__toString_impl_wslzee(this.a7b_1) + '-' + ShortId__toString_impl_wslzee(this.y7a_1);
      }
      p97() {
        return coerceAtLeast(new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(MonetaryValue__minus_impl_jw9qyp(this.b7c_1, this.c7c_1), this.d7c_1)), new (MonetaryValue())(Companion_instance.o62(0))).a5s_1;
      }
      q97() {
        return coerceAtLeast(new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(this.y7b_1, this.c7c_1)), new (MonetaryValue())(Companion_instance.o62(0))).a5s_1;
      }
      r97() {
        return MonetaryValue__compareTo_impl_w7ul1r(this.c7c_1, this.y7b_1) >= 0;
      }
      s97() {
        return MonetaryValue__minus_impl_jw9qyp(MonetaryValue__minus_impl_jw9qyp(this.c7c_1, this.e7c_1), this.f7c_1);
      }
      t97() {
        return coerceAtLeast(new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(this.c7c_1, this.y7b_1)), new (MonetaryValue())(Companion_instance.p91(0n))).a5s_1;
      }
      u97() {
        var tmp0_safe_receiver = this.j7b_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_0;
          if (!(tmp0_safe_receiver < 0.05)) {
            tmp_0 = tmp0_safe_receiver;
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? 0.05 : tmp1_elvis_lhs;
      }
      s91() {
        return this.z7b_1;
      }
      v97(_id, shortId, contractor, contractorShortId, customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, originalPrice, activePrice, projectCredits, acceptedChangeAmount, fundingRequested, clientDeposits, pendingClientDeposits, contractorPayments, clientReturn, started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy) {
        return new (Project())(_id, shortId, contractor, contractorShortId, customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, originalPrice, activePrice, projectCredits, acceptedChangeAmount, fundingRequested, clientDeposits, pendingClientDeposits, contractorPayments, clientReturn, started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy);
      }
      m7c(_id, shortId, contractor, contractorShortId, customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, originalPrice, activePrice, projectCredits, acceptedChangeAmount, fundingRequested, clientDeposits, pendingClientDeposits, contractorPayments, clientReturn, started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy, $super) {
        _id = _id === VOID ? this.x7a_1 : _id;
        shortId = shortId === VOID ? this.y7a_1 : shortId;
        contractor = contractor === VOID ? this.z7a_1 : contractor;
        contractorShortId = contractorShortId === VOID ? this.a7b_1 : contractorShortId;
        customer = customer === VOID ? this.b7b_1 : customer;
        client = client === VOID ? this.c7b_1 : client;
        name = name === VOID ? this.d7b_1 : name;
        description = description === VOID ? this.e7b_1 : description;
        address = address === VOID ? this.f7b_1 : address;
        location = location === VOID ? this.g7b_1 : location;
        jobNumber = jobNumber === VOID ? this.h7b_1 : jobNumber;
        files = files === VOID ? this.i7b_1 : files;
        retention = retention === VOID ? this.j7b_1 : retention;
        published = published === VOID ? this.k7b_1 : published;
        readBy = readBy === VOID ? this.l7b_1 : readBy;
        feedback = feedback === VOID ? this.m7b_1 : feedback;
        created = created === VOID ? this.n7b_1 : created;
        cancelled = cancelled === VOID ? this.o7b_1 : cancelled;
        abandoned = abandoned === VOID ? this.p7b_1 : abandoned;
        archived = archived === VOID ? this.q7b_1 : archived;
        viewedByCustomer = viewedByCustomer === VOID ? this.r7b_1 : viewedByCustomer;
        approved = approved === VOID ? this.s7b_1 : approved;
        terminated = terminated === VOID ? this.t7b_1 : terminated;
        complete = complete === VOID ? this.u7b_1 : complete;
        isArchived = isArchived === VOID ? this.v7b_1 : isArchived;
        state = state === VOID ? this.w7b_1 : state;
        originalPrice = originalPrice === VOID ? this.x7b_1 : originalPrice;
        activePrice = activePrice === VOID ? this.y7b_1 : activePrice;
        projectCredits = projectCredits === VOID ? this.z7b_1 : projectCredits;
        acceptedChangeAmount = acceptedChangeAmount === VOID ? this.a7c_1 : acceptedChangeAmount;
        fundingRequested = fundingRequested === VOID ? this.b7c_1 : fundingRequested;
        clientDeposits = clientDeposits === VOID ? this.c7c_1 : clientDeposits;
        pendingClientDeposits = pendingClientDeposits === VOID ? this.d7c_1 : pendingClientDeposits;
        contractorPayments = contractorPayments === VOID ? this.e7c_1 : contractorPayments;
        clientReturn = clientReturn === VOID ? this.f7c_1 : clientReturn;
        started = started === VOID ? this.g7c_1 : started;
        preSubstantialCompletion = preSubstantialCompletion === VOID ? this.h7c_1 : preSubstantialCompletion;
        substantialCompletion = substantialCompletion === VOID ? this.i7c_1 : substantialCompletion;
        locked = locked === VOID ? this.j7c_1 : locked;
        lastModifiedBy = lastModifiedBy === VOID ? this.k7c_1 : lastModifiedBy;
        return $super === VOID ? this.v97(_id, shortId, contractor, contractorShortId, customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, originalPrice, activePrice, projectCredits, acceptedChangeAmount, fundingRequested, clientDeposits, pendingClientDeposits, contractorPayments, clientReturn, started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy) : $super.v97.call(this, _id, new (ShortId())(shortId), contractor, new (ShortId())(contractorShortId), customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, new (MonetaryValue())(originalPrice), new (MonetaryValue())(activePrice), projectCredits, new (MonetaryValue())(acceptedChangeAmount), new (MonetaryValue())(fundingRequested), new (MonetaryValue())(clientDeposits), new (MonetaryValue())(pendingClientDeposits), new (MonetaryValue())(contractorPayments), new (MonetaryValue())(clientReturn), started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy);
      }
      toString() {
        return 'Project(_id=' + this.x7a_1.toString() + ', shortId=' + ShortId__toString_impl_wslzee(this.y7a_1) + ', contractor=' + this.z7a_1.toString() + ', contractorShortId=' + ShortId__toString_impl_wslzee(this.a7b_1) + ', customer=' + toString_0(this.b7b_1) + ', client=' + toString_0(this.c7b_1) + ', name=' + this.d7b_1 + ', description=' + this.e7b_1 + ', address=' + this.f7b_1.toString() + ', location=' + this.g7b_1 + ', jobNumber=' + this.h7b_1 + ', files=' + toString(this.i7b_1) + ', retention=' + this.j7b_1 + ', published=' + toString_0(this.k7b_1) + ', readBy=' + toString(this.l7b_1) + ', feedback=' + toString_0(this.m7b_1) + ', created=' + this.n7b_1.toString() + ', cancelled=' + toString_0(this.o7b_1) + ', abandoned=' + toString_0(this.p7b_1) + ', archived=' + toString_0(this.q7b_1) + ', viewedByCustomer=' + toString_0(this.r7b_1) + ', approved=' + toString_0(this.s7b_1) + ', terminated=' + toString_0(this.t7b_1) + ', complete=' + toString_0(this.u7b_1) + ', isArchived=' + this.v7b_1 + ', state=' + toString(this.w7b_1) + ', originalPrice=' + MonetaryValue__toString_impl_xslc77(this.x7b_1) + ', activePrice=' + MonetaryValue__toString_impl_xslc77(this.y7b_1) + ', projectCredits=' + toString(this.z7b_1) + ', acceptedChangeAmount=' + MonetaryValue__toString_impl_xslc77(this.a7c_1) + ', fundingRequested=' + MonetaryValue__toString_impl_xslc77(this.b7c_1) + ', clientDeposits=' + MonetaryValue__toString_impl_xslc77(this.c7c_1) + ', pendingClientDeposits=' + MonetaryValue__toString_impl_xslc77(this.d7c_1) + ', contractorPayments=' + MonetaryValue__toString_impl_xslc77(this.e7c_1) + ', clientReturn=' + MonetaryValue__toString_impl_xslc77(this.f7c_1) + ', started=' + toString_0(this.g7c_1) + ', preSubstantialCompletion=' + toString_0(this.h7c_1) + ', substantialCompletion=' + toString_0(this.i7c_1) + ', locked=' + toString_0(this.j7c_1) + ', lastModifiedBy=' + toString_0(this.k7c_1) + ')';
      }
      hashCode() {
        var result = this.x7a_1.hashCode();
        result = imul(result, 31) + ShortId__hashCode_impl_ghc5rv(this.y7a_1) | 0;
        result = imul(result, 31) + this.z7a_1.hashCode() | 0;
        result = imul(result, 31) + ShortId__hashCode_impl_ghc5rv(this.a7b_1) | 0;
        result = imul(result, 31) + (this.b7b_1 == null ? 0 : this.b7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.c7b_1 == null ? 0 : this.c7b_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.d7b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e7b_1) | 0;
        result = imul(result, 31) + this.f7b_1.hashCode() | 0;
        result = imul(result, 31) + (this.g7b_1 == null ? 0 : getStringHashCode(this.g7b_1)) | 0;
        result = imul(result, 31) + (this.h7b_1 == null ? 0 : getStringHashCode(this.h7b_1)) | 0;
        result = imul(result, 31) + hashCode(this.i7b_1) | 0;
        result = imul(result, 31) + (this.j7b_1 == null ? 0 : getNumberHashCode(this.j7b_1)) | 0;
        result = imul(result, 31) + (this.k7b_1 == null ? 0 : this.k7b_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.l7b_1) | 0;
        result = imul(result, 31) + (this.m7b_1 == null ? 0 : this.m7b_1.hashCode()) | 0;
        result = imul(result, 31) + this.n7b_1.hashCode() | 0;
        result = imul(result, 31) + (this.o7b_1 == null ? 0 : this.o7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.p7b_1 == null ? 0 : this.p7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.q7b_1 == null ? 0 : this.q7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.r7b_1 == null ? 0 : this.r7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.s7b_1 == null ? 0 : this.s7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.t7b_1 == null ? 0 : this.t7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.u7b_1 == null ? 0 : this.u7b_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.v7b_1) | 0;
        result = imul(result, 31) + this.w7b_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.x7b_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.y7b_1) | 0;
        result = imul(result, 31) + hashCode(this.z7b_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.a7c_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.b7c_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.c7c_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.d7c_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.e7c_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.f7c_1) | 0;
        result = imul(result, 31) + (this.g7c_1 == null ? 0 : this.g7c_1.hashCode()) | 0;
        result = imul(result, 31) + (this.h7c_1 == null ? 0 : this.h7c_1.hashCode()) | 0;
        result = imul(result, 31) + (this.i7c_1 == null ? 0 : this.i7c_1.hashCode()) | 0;
        result = imul(result, 31) + (this.j7c_1 == null ? 0 : this.j7c_1.hashCode()) | 0;
        result = imul(result, 31) + (this.k7c_1 == null ? 0 : this.k7c_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Project()))
          return false;
        if (!this.x7a_1.equals(other.x7a_1))
          return false;
        if (!(this.y7a_1 === other.y7a_1))
          return false;
        if (!this.z7a_1.equals(other.z7a_1))
          return false;
        if (!(this.a7b_1 === other.a7b_1))
          return false;
        if (!equals(this.b7b_1, other.b7b_1))
          return false;
        if (!equals(this.c7b_1, other.c7b_1))
          return false;
        if (!(this.d7b_1 === other.d7b_1))
          return false;
        if (!(this.e7b_1 === other.e7b_1))
          return false;
        if (!this.f7b_1.equals(other.f7b_1))
          return false;
        if (!(this.g7b_1 == other.g7b_1))
          return false;
        if (!(this.h7b_1 == other.h7b_1))
          return false;
        if (!equals(this.i7b_1, other.i7b_1))
          return false;
        if (!equals(this.j7b_1, other.j7b_1))
          return false;
        if (!equals(this.k7b_1, other.k7b_1))
          return false;
        if (!equals(this.l7b_1, other.l7b_1))
          return false;
        if (!equals(this.m7b_1, other.m7b_1))
          return false;
        if (!this.n7b_1.equals(other.n7b_1))
          return false;
        if (!equals(this.o7b_1, other.o7b_1))
          return false;
        if (!equals(this.p7b_1, other.p7b_1))
          return false;
        if (!equals(this.q7b_1, other.q7b_1))
          return false;
        if (!equals(this.r7b_1, other.r7b_1))
          return false;
        if (!equals(this.s7b_1, other.s7b_1))
          return false;
        if (!equals(this.t7b_1, other.t7b_1))
          return false;
        if (!equals(this.u7b_1, other.u7b_1))
          return false;
        if (!(this.v7b_1 === other.v7b_1))
          return false;
        if (!this.w7b_1.equals(other.w7b_1))
          return false;
        if (!(this.x7b_1 === other.x7b_1))
          return false;
        if (!(this.y7b_1 === other.y7b_1))
          return false;
        if (!equals(this.z7b_1, other.z7b_1))
          return false;
        if (!(this.a7c_1 === other.a7c_1))
          return false;
        if (!(this.b7c_1 === other.b7c_1))
          return false;
        if (!(this.c7c_1 === other.c7c_1))
          return false;
        if (!(this.d7c_1 === other.d7c_1))
          return false;
        if (!(this.e7c_1 === other.e7c_1))
          return false;
        if (!(this.f7c_1 === other.f7c_1))
          return false;
        if (!equals(this.g7c_1, other.g7c_1))
          return false;
        if (!equals(this.h7c_1, other.h7c_1))
          return false;
        if (!equals(this.i7c_1, other.i7c_1))
          return false;
        if (!equals(this.j7c_1, other.j7c_1))
          return false;
        if (!equals(this.k7c_1, other.k7c_1))
          return false;
        return true;
      }
      static n97(seen0, seen1, _id, shortId, contractor, contractorShortId, customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, originalPrice, activePrice, projectCredits, acceptedChangeAmount, fundingRequested, clientDeposits, pendingClientDeposits, contractorPayments, clientReturn, started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy, serializationConstructorMarker) {
        Companion_getInstance_42();
        if (!!(!(460 === (460 & seen0)) | !(0 === (0 & seen1)))) {
          // Inline function 'kotlin.intArrayOf' call
          var tmp = new Int32Array([seen0, seen1]);
          // Inline function 'kotlin.intArrayOf' call
          var tmp$ret$1 = new Int32Array([460, 0]);
          throwArrayMissingFieldException(tmp, tmp$ret$1, $serializer_getInstance_43().l97_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.x7a_1 = Companion_getInstance().m2p();
        else
          $this.x7a_1 = _id;
        if (0 === (seen0 & 2))
          $this.y7a_1 = Companion_instance_47.k5n();
        else
          $this.y7a_1 = shortId;
        $this.z7a_1 = contractor;
        $this.a7b_1 = contractorShortId;
        if (0 === (seen0 & 16))
          $this.b7b_1 = null;
        else
          $this.b7b_1 = customer;
        if (0 === (seen0 & 32))
          $this.c7b_1 = null;
        else
          $this.c7b_1 = client;
        $this.d7b_1 = name;
        $this.e7b_1 = description;
        $this.f7b_1 = address;
        if (0 === (seen0 & 512))
          $this.g7b_1 = null;
        else
          $this.g7b_1 = location;
        if (0 === (seen0 & 1024))
          $this.h7b_1 = null;
        else
          $this.h7b_1 = jobNumber;
        if (0 === (seen0 & 2048)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp_0.i7b_1 = emptyList();
        } else
          $this.i7b_1 = files;
        if (0 === (seen0 & 4096))
          $this.j7b_1 = null;
        else
          $this.j7b_1 = retention;
        if (0 === (seen0 & 8192))
          $this.k7b_1 = null;
        else
          $this.k7b_1 = published;
        if (0 === (seen0 & 16384))
          $this.l7b_1 = emptySet();
        else
          $this.l7b_1 = readBy;
        if (0 === (seen0 & 32768))
          $this.m7b_1 = null;
        else
          $this.m7b_1 = feedback;
        if (0 === (seen0 & 65536)) {
          var tmp_1 = $this;
          // Inline function 'com.lightningkite.now' call
          tmp_1.n7b_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.n7b_1 = created;
        if (0 === (seen0 & 131072))
          $this.o7b_1 = null;
        else
          $this.o7b_1 = cancelled;
        if (0 === (seen0 & 262144))
          $this.p7b_1 = null;
        else
          $this.p7b_1 = abandoned;
        if (0 === (seen0 & 524288))
          $this.q7b_1 = null;
        else
          $this.q7b_1 = archived;
        if (0 === (seen0 & 1048576))
          $this.r7b_1 = null;
        else
          $this.r7b_1 = viewedByCustomer;
        if (0 === (seen0 & 2097152))
          $this.s7b_1 = null;
        else
          $this.s7b_1 = approved;
        if (0 === (seen0 & 4194304))
          $this.t7b_1 = null;
        else
          $this.t7b_1 = terminated;
        if (0 === (seen0 & 8388608))
          $this.u7b_1 = null;
        else
          $this.u7b_1 = complete;
        if (0 === (seen0 & 16777216))
          $this.v7b_1 = false;
        else
          $this.v7b_1 = isArchived;
        if (0 === (seen0 & 33554432))
          $this.w7b_1 = ProjectState_Creating_getInstance();
        else
          $this.w7b_1 = state;
        if (0 === (seen0 & 67108864))
          $this.x7b_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.x7b_1 = originalPrice;
        if (0 === (seen0 & 134217728))
          $this.y7b_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.y7b_1 = activePrice;
        if (0 === (seen0 & 268435456))
          $this.z7b_1 = emptyList();
        else
          $this.z7b_1 = projectCredits;
        if (0 === (seen0 & 536870912))
          $this.a7c_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.a7c_1 = acceptedChangeAmount;
        if (0 === (seen0 & 1073741824))
          $this.b7c_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.b7c_1 = fundingRequested;
        if (0 === (seen0 & -2147483648))
          $this.c7c_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.c7c_1 = clientDeposits;
        if (0 === (seen1 & 1))
          $this.d7c_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.d7c_1 = pendingClientDeposits;
        if (0 === (seen1 & 2))
          $this.e7c_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.e7c_1 = contractorPayments;
        if (0 === (seen1 & 4))
          $this.f7c_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.f7c_1 = clientReturn;
        if (0 === (seen1 & 8))
          $this.g7c_1 = null;
        else
          $this.g7c_1 = started;
        if (0 === (seen1 & 16))
          $this.h7c_1 = null;
        else
          $this.h7c_1 = preSubstantialCompletion;
        if (0 === (seen1 & 32))
          $this.i7c_1 = null;
        else
          $this.i7c_1 = substantialCompletion;
        if (0 === (seen1 & 64))
          $this.j7c_1 = null;
        else
          $this.j7c_1 = locked;
        if (0 === (seen1 & 128))
          $this.k7c_1 = null;
        else
          $this.k7c_1 = lastModifiedBy;
        return $this;
      }
    }
    initMetadataForClass($, 'Project', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_43});
    ProjectClass = $;
  }
  return ProjectClass;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.w97_1.f2();
}
function ProjectLedgerItem$ExternalDeposit$Type$Companion$_anonymous__vwkhit() {
  return createSimpleEnumSerializer('com.crowpay.ProjectLedgerItem.ExternalDeposit.Type', values_1());
}
var Type_Check_instance;
var Type_WireTransfer_instance;
function values_1() {
  return [Type_Check_getInstance(), Type_WireTransfer_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_1());
  return $ENTRIES_0;
}
var CompanionClass_29;
function Companion_29() {
  if (CompanionClass_29 === VOID) {
    class $ {
      constructor() {
        Companion_instance_31 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.w97_1 = lazy(tmp_0, ProjectLedgerItem$ExternalDeposit$Type$Companion$_anonymous__vwkhit);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_29 = $;
  }
  return CompanionClass_29;
}
var Companion_instance_31;
function Companion_getInstance_43() {
  Type_initEntries_0();
  if (Companion_instance_31 === VOID)
    new (Companion_29())();
  return Companion_instance_31;
}
var Type_entriesInitialized_0;
function Type_initEntries_0() {
  if (Type_entriesInitialized_0)
    return Unit_instance;
  Type_entriesInitialized_0 = true;
  Type_Check_instance = Type_0().a98('Check', 0, 'Check');
  Type_WireTransfer_instance = Type_0().a98('WireTransfer', 1, 'Wire Transfer');
  Companion_getInstance_43();
}
var $ENTRIES_0;
function ProjectLedgerItem$ExternalDeposit$Companion$$childSerializers$_anonymous__faz3ga() {
  return Companion_getInstance_43().m2a();
}
var TypeClass_0;
function Type_0() {
  if (TypeClass_0 === VOID) {
    class $ extends Enum() {
      static a98(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.z97_1 = displayName;
        return $this;
      }
      g90() {
        return this.z97_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'Type', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_43});
    TypeClass_0 = $;
  }
  return TypeClass_0;
}
var CompanionClass_30;
function Companion_30() {
  if (CompanionClass_30 === VOID) {
    class $ {
      constructor() {
        Companion_instance_32 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.q5z_1 = [null, null, lazy(tmp_0, ProjectLedgerItem$ExternalDeposit$Companion$$childSerializers$_anonymous__faz3ga), null];
      }
      m2a() {
        return $serializer_getInstance_44();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_30 = $;
  }
  return CompanionClass_30;
}
var Companion_instance_32;
function Companion_getInstance_44() {
  if (Companion_instance_32 === VOID)
    new (Companion_30())();
  return Companion_instance_32;
}
var $serializerClass_28;
function $serializer_28() {
  if ($serializerClass_28 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_28 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ProjectLedgerItem.ExternalDeposit', this, 4);
        tmp0_serialDesc.c1b('amount', false);
        tmp0_serialDesc.c1b('checkNumber', false);
        tmp0_serialDesc.c1b('type', false);
        tmp0_serialDesc.c1b('notes', false);
        this.b98_1 = tmp0_serialDesc;
      }
      c98(encoder, value) {
        var tmp0_desc = this.b98_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_44().q5z_1;
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_2(), new (MonetaryValue())(value.v5z_1));
        tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.w5z_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.x5z_1);
        tmp1_output.d15(tmp0_desc, 3, StringSerializer_getInstance(), value.y5z_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.c98(encoder, value instanceof ExternalDeposit() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.b98_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_44().q5z_1;
        if (tmp8_input.a14()) {
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp8_input.x13(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, tmp9_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp8_input.x13(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, tmp9_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return ExternalDeposit().d98(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.b98_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_44().q5z_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_2(), get_nullable(StringSerializer_getInstance()), tmp0_cached[2].f2(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_28 = $;
  }
  return $serializerClass_28;
}
var $serializer_instance_28;
function $serializer_getInstance_44() {
  if ($serializer_instance_28 === VOID)
    new ($serializer_28())();
  return $serializer_instance_28;
}
function Type_Check_getInstance() {
  Type_initEntries_0();
  return Type_Check_instance;
}
function Type_WireTransfer_getInstance() {
  Type_initEntries_0();
  return Type_WireTransfer_instance;
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_3() {
  return Companion_getInstance_8().m2a();
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_4() {
  return Companion_getInstance_9().m2a();
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_5() {
  return Companion_getInstance_12().m2a();
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_6() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_7() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_8() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_9() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_10() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var ExternalDepositClass;
function ExternalDeposit() {
  if (ExternalDepositClass === VOID) {
    class $ {
      constructor(amount, checkNumber, type, notes) {
        Companion_getInstance_44();
        this.v5z_1 = amount;
        this.w5z_1 = checkNumber;
        this.x5z_1 = type;
        this.y5z_1 = notes;
      }
      e98(amount, checkNumber, type, notes) {
        return new (ExternalDeposit())(amount, checkNumber, type, notes);
      }
      a60(amount, checkNumber, type, notes, $super) {
        amount = amount === VOID ? this.v5z_1 : amount;
        checkNumber = checkNumber === VOID ? this.w5z_1 : checkNumber;
        type = type === VOID ? this.x5z_1 : type;
        notes = notes === VOID ? this.y5z_1 : notes;
        return $super === VOID ? this.e98(amount, checkNumber, type, notes) : $super.e98.call(this, new (MonetaryValue())(amount), checkNumber, type, notes);
      }
      toString() {
        return 'ExternalDeposit(amount=' + MonetaryValue__toString_impl_xslc77(this.v5z_1) + ', checkNumber=' + this.w5z_1 + ', type=' + toString(this.x5z_1) + ', notes=' + this.y5z_1 + ')';
      }
      hashCode() {
        var result = MonetaryValue__hashCode_impl_fhcsz2(this.v5z_1);
        result = imul(result, 31) + (this.w5z_1 == null ? 0 : getStringHashCode(this.w5z_1)) | 0;
        result = imul(result, 31) + this.x5z_1.hashCode() | 0;
        result = imul(result, 31) + (this.y5z_1 == null ? 0 : getStringHashCode(this.y5z_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ExternalDeposit()))
          return false;
        if (!(this.v5z_1 === other.v5z_1))
          return false;
        if (!(this.w5z_1 == other.w5z_1))
          return false;
        if (!this.x5z_1.equals(other.x5z_1))
          return false;
        if (!(this.y5z_1 == other.y5z_1))
          return false;
        return true;
      }
      static d98(seen0, amount, checkNumber, type, notes, serializationConstructorMarker) {
        Companion_getInstance_44();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_44().b98_1);
        }
        var $this = createThis(this);
        $this.v5z_1 = amount;
        $this.w5z_1 = checkNumber;
        $this.x5z_1 = type;
        $this.y5z_1 = notes;
        return $this;
      }
    }
    initMetadataForClass($, 'ExternalDeposit', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_44});
    ExternalDepositClass = $;
  }
  return ExternalDepositClass;
}
var CompanionClass_31;
function Companion_31() {
  if (CompanionClass_31 === VOID) {
    class $ {
      constructor() {
        Companion_instance_33 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_15 = lazy(tmp_14, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_6);
        var tmp_16 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_17 = lazy(tmp_16, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_7);
        var tmp_18 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_19 = lazy(tmp_18, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_8);
        var tmp_20 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_21 = lazy(tmp_20, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_9);
        var tmp_22 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.k7k_1 = [tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, null, null, null, null, tmp_11, null, tmp_13, tmp_15, tmp_17, tmp_19, null, null, tmp_21, lazy(tmp_22, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_10)];
      }
      m2a() {
        return $serializer_getInstance_45();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_31 = $;
  }
  return CompanionClass_31;
}
var Companion_instance_33;
function Companion_getInstance_45() {
  if (Companion_instance_33 === VOID)
    new (Companion_31())();
  return Companion_instance_33;
}
var $serializerClass_29;
function $serializer_29() {
  if ($serializerClass_29 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_29 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ProjectLedgerItem', this, 19);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(Project()), 'Ledger Items'));
        tmp0_serialDesc.c1b('lineItem', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.c1b('payApp', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(PayApplication())));
        tmp0_serialDesc.c1b('party', false);
        tmp0_serialDesc.c1b('amount', true);
        tmp0_serialDesc.d1b(new (Description())('Positive indicates a payment into Stoze, negative indicates a payment out.'));
        tmp0_serialDesc.c1b('contractorFee', true);
        tmp0_serialDesc.c1b('platformFee', true);
        tmp0_serialDesc.c1b('processorFee', true);
        tmp0_serialDesc.c1b('state', false);
        tmp0_serialDesc.c1b('message', true);
        tmp0_serialDesc.c1b('method', true);
        tmp0_serialDesc.c1b('depositSucceeded', true);
        tmp0_serialDesc.c1b('payoutRequested', true);
        tmp0_serialDesc.c1b('payoutConfirmation', true);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.c1b('accountName', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('intentId', true);
        tmp0_serialDesc.c1b('check', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(MailCheckPhysically())));
        tmp0_serialDesc.c1b('created', true);
        tmp0_serialDesc.e1b(new (IndexSet())(['project', 'party']));
        tmp0_serialDesc.e1b(new (IndexSet())(['state', 'payoutRequested']));
        this.f98_1 = tmp0_serialDesc;
      }
      g98(encoder, value) {
        var tmp0_desc = this.f98_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_45().k7k_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.p7k_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.p7k_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.q7k_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.r7k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.r7k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.s7k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.s7k_1);
        }
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.t7k_1);
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.u7k_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_2(), new (MonetaryValue())(value.u7k_1));
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 6)) {
          tmp = true;
        } else {
          var tmp_0 = value.v7k_1;
          tmp = !((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_2();
          var tmp_2 = value.v7k_1;
          tmp1_output.d15(tmp0_desc, 6, tmp_1, tmp_2 == null ? null : new (MonetaryValue())(tmp_2));
        }
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 7)) {
          tmp_3 = true;
        } else {
          var tmp_4 = value.w7k_1;
          tmp_3 = !((tmp_4 == null ? null : new (MonetaryValue())(tmp_4)) == null);
        }
        if (tmp_3) {
          var tmp_5 = $serializer_getInstance_2();
          var tmp_6 = value.w7k_1;
          tmp1_output.d15(tmp0_desc, 7, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
        }
        var tmp_7;
        if (tmp1_output.h15(tmp0_desc, 8)) {
          tmp_7 = true;
        } else {
          var tmp_8 = value.x7k_1;
          tmp_7 = !((tmp_8 == null ? null : new (MonetaryValue())(tmp_8)) == null);
        }
        if (tmp_7) {
          var tmp_9 = $serializer_getInstance_2();
          var tmp_10 = value.x7k_1;
          tmp1_output.d15(tmp0_desc, 8, tmp_9, tmp_10 == null ? null : new (MonetaryValue())(tmp_10));
        }
        tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.y7k_1);
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.z7k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, StringSerializer_getInstance(), value.z7k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.a7l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 11, tmp2_cached[11].f2(), value.a7l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 12) ? true : !(value.b7l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 12, tmp2_cached[12].f2(), value.b7l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !(value.c7l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 13, tmp2_cached[13].f2(), value.c7l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 14) ? true : !(value.d7l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 14, tmp2_cached[14].f2(), value.d7l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 15) ? true : !(value.e7l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 15, StringSerializer_getInstance(), value.e7l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 16) ? true : !(value.f7l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 16, StringSerializer_getInstance(), value.f7l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 17) ? true : !(value.g7l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 17, tmp2_cached[17].f2(), value.g7l_1);
        }
        var tmp_11;
        if (tmp1_output.h15(tmp0_desc, 18)) {
          tmp_11 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp_11 = !value.h7l_1.equals(tmp$ret$0);
        }
        if (tmp_11) {
          tmp1_output.c15(tmp0_desc, 18, tmp2_cached[18].f2(), value.h7l_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.g98(encoder, value instanceof ProjectLedgerItem() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.f98_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_local15 = null;
        var tmp20_local16 = null;
        var tmp21_local17 = null;
        var tmp22_local18 = null;
        var tmp23_input = decoder.l13(tmp0_desc);
        var tmp24_cached = Companion_getInstance_45().k7k_1;
        if (tmp23_input.a14()) {
          tmp4_local0 = tmp23_input.x13(tmp0_desc, 0, tmp24_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp23_input.x13(tmp0_desc, 1, tmp24_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp23_input.z13(tmp0_desc, 2, tmp24_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp23_input.z13(tmp0_desc, 3, tmp24_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp23_input.x13(tmp0_desc, 4, tmp24_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp23_input.x13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp_2 = $serializer_getInstance_2();
          var tmp_3 = tmp10_local6;
          var tmp_4 = tmp23_input.z13(tmp0_desc, 6, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp10_local6 = tmp_4 == null ? null : tmp_4.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp_5 = $serializer_getInstance_2();
          var tmp_6 = tmp11_local7;
          var tmp_7 = tmp23_input.z13(tmp0_desc, 7, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
          tmp11_local7 = tmp_7 == null ? null : tmp_7.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          var tmp_8 = $serializer_getInstance_2();
          var tmp_9 = tmp12_local8;
          var tmp_10 = tmp23_input.z13(tmp0_desc, 8, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
          tmp12_local8 = tmp_10 == null ? null : tmp_10.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp23_input.x13(tmp0_desc, 9, tmp24_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp23_input.z13(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp23_input.z13(tmp0_desc, 11, tmp24_cached[11].f2(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp23_input.z13(tmp0_desc, 12, tmp24_cached[12].f2(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp23_input.z13(tmp0_desc, 13, tmp24_cached[13].f2(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp23_input.z13(tmp0_desc, 14, tmp24_cached[14].f2(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp23_input.z13(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          tmp20_local16 = tmp23_input.z13(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          tmp21_local17 = tmp23_input.z13(tmp0_desc, 17, tmp24_cached[17].f2(), tmp21_local17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          tmp22_local18 = tmp23_input.x13(tmp0_desc, 18, tmp24_cached[18].f2(), tmp22_local18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp23_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp23_input.x13(tmp0_desc, 0, tmp24_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp23_input.x13(tmp0_desc, 1, tmp24_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp23_input.z13(tmp0_desc, 2, tmp24_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp23_input.z13(tmp0_desc, 3, tmp24_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp23_input.x13(tmp0_desc, 4, tmp24_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_11 = $serializer_getInstance_2();
                var tmp_12 = tmp9_local5;
                var tmp_13 = tmp23_input.x13(tmp0_desc, 5, tmp_11, tmp_12 == null ? null : new (MonetaryValue())(tmp_12));
                tmp9_local5 = tmp_13 == null ? null : tmp_13.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_14 = $serializer_getInstance_2();
                var tmp_15 = tmp10_local6;
                var tmp_16 = tmp23_input.z13(tmp0_desc, 6, tmp_14, tmp_15 == null ? null : new (MonetaryValue())(tmp_15));
                tmp10_local6 = tmp_16 == null ? null : tmp_16.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_17 = $serializer_getInstance_2();
                var tmp_18 = tmp11_local7;
                var tmp_19 = tmp23_input.z13(tmp0_desc, 7, tmp_17, tmp_18 == null ? null : new (MonetaryValue())(tmp_18));
                tmp11_local7 = tmp_19 == null ? null : tmp_19.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                var tmp_20 = $serializer_getInstance_2();
                var tmp_21 = tmp12_local8;
                var tmp_22 = tmp23_input.z13(tmp0_desc, 8, tmp_20, tmp_21 == null ? null : new (MonetaryValue())(tmp_21));
                tmp12_local8 = tmp_22 == null ? null : tmp_22.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp23_input.x13(tmp0_desc, 9, tmp24_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp23_input.z13(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp23_input.z13(tmp0_desc, 11, tmp24_cached[11].f2(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp23_input.z13(tmp0_desc, 12, tmp24_cached[12].f2(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp23_input.z13(tmp0_desc, 13, tmp24_cached[13].f2(), tmp17_local13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp23_input.z13(tmp0_desc, 14, tmp24_cached[14].f2(), tmp18_local14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp23_input.z13(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              case 16:
                tmp20_local16 = tmp23_input.z13(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
                tmp3_bitMask0 = tmp3_bitMask0 | 65536;
                break;
              case 17:
                tmp21_local17 = tmp23_input.z13(tmp0_desc, 17, tmp24_cached[17].f2(), tmp21_local17);
                tmp3_bitMask0 = tmp3_bitMask0 | 131072;
                break;
              case 18:
                tmp22_local18 = tmp23_input.x13(tmp0_desc, 18, tmp24_cached[18].f2(), tmp22_local18);
                tmp3_bitMask0 = tmp3_bitMask0 | 262144;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp23_input.m13(tmp0_desc);
        return ProjectLedgerItem().h98(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, null);
      }
      az() {
        return this.f98_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_45().k7k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable(tmp0_cached[2].f2()), get_nullable(tmp0_cached[3].f2()), tmp0_cached[4].f2(), $serializer_getInstance_2(), get_nullable($serializer_getInstance_2()), get_nullable($serializer_getInstance_2()), get_nullable($serializer_getInstance_2()), tmp0_cached[9].f2(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[11].f2()), get_nullable(tmp0_cached[12].f2()), get_nullable(tmp0_cached[13].f2()), get_nullable(tmp0_cached[14].f2()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[17].f2()), tmp0_cached[18].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_29 = $;
  }
  return $serializerClass_29;
}
var $serializer_instance_29;
function $serializer_getInstance_45() {
  if ($serializer_instance_29 === VOID)
    new ($serializer_29())();
  return $serializer_instance_29;
}
var ProjectLedgerItemClass;
function ProjectLedgerItem() {
  if (ProjectLedgerItemClass === VOID) {
    class $ {
      constructor(_id, project, lineItem, payApp, party, amount, contractorFee, platformFee, processorFee, state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created) {
        Companion_getInstance_45();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        lineItem = lineItem === VOID ? null : lineItem;
        payApp = payApp === VOID ? null : payApp;
        amount = amount === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : amount;
        contractorFee = contractorFee === VOID ? null : contractorFee;
        platformFee = platformFee === VOID ? null : platformFee;
        processorFee = processorFee === VOID ? null : processorFee;
        message = message === VOID ? null : message;
        method = method === VOID ? null : method;
        depositSucceeded = depositSucceeded === VOID ? null : depositSucceeded;
        payoutRequested = payoutRequested === VOID ? null : payoutRequested;
        payoutConfirmation = payoutConfirmation === VOID ? null : payoutConfirmation;
        accountName = accountName === VOID ? null : accountName;
        intentId = intentId === VOID ? null : intentId;
        check = check === VOID ? null : check;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = created;
        }
        created = tmp;
        this.p7k_1 = _id;
        this.q7k_1 = project;
        this.r7k_1 = lineItem;
        this.s7k_1 = payApp;
        this.t7k_1 = party;
        this.u7k_1 = amount;
        this.v7k_1 = contractorFee;
        this.w7k_1 = platformFee;
        this.x7k_1 = processorFee;
        this.y7k_1 = state;
        this.z7k_1 = message;
        this.a7l_1 = method;
        this.b7l_1 = depositSucceeded;
        this.c7l_1 = payoutRequested;
        this.d7l_1 = payoutConfirmation;
        this.e7l_1 = accountName;
        this.f7l_1 = intentId;
        this.g7l_1 = check;
        this.h7l_1 = created;
      }
      h40() {
        return this.p7k_1;
      }
      i98(_id, project, lineItem, payApp, party, amount, contractorFee, platformFee, processorFee, state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created) {
        return new (ProjectLedgerItem())(_id, project, lineItem, payApp, party, amount, contractorFee, platformFee, processorFee, state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created);
      }
      j7l(_id, project, lineItem, payApp, party, amount, contractorFee, platformFee, processorFee, state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created, $super) {
        _id = _id === VOID ? this.p7k_1 : _id;
        project = project === VOID ? this.q7k_1 : project;
        lineItem = lineItem === VOID ? this.r7k_1 : lineItem;
        payApp = payApp === VOID ? this.s7k_1 : payApp;
        party = party === VOID ? this.t7k_1 : party;
        amount = amount === VOID ? this.u7k_1 : amount;
        contractorFee = contractorFee === VOID ? this.v7k_1 : contractorFee;
        platformFee = platformFee === VOID ? this.w7k_1 : platformFee;
        processorFee = processorFee === VOID ? this.x7k_1 : processorFee;
        state = state === VOID ? this.y7k_1 : state;
        message = message === VOID ? this.z7k_1 : message;
        method = method === VOID ? this.a7l_1 : method;
        depositSucceeded = depositSucceeded === VOID ? this.b7l_1 : depositSucceeded;
        payoutRequested = payoutRequested === VOID ? this.c7l_1 : payoutRequested;
        payoutConfirmation = payoutConfirmation === VOID ? this.d7l_1 : payoutConfirmation;
        accountName = accountName === VOID ? this.e7l_1 : accountName;
        intentId = intentId === VOID ? this.f7l_1 : intentId;
        check = check === VOID ? this.g7l_1 : check;
        created = created === VOID ? this.h7l_1 : created;
        var tmp;
        if ($super === VOID) {
          tmp = this.i98(_id, project, lineItem, payApp, party, amount, contractorFee, platformFee, processorFee, state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created);
        } else {
          var tmp_0 = $super.i98;
          var tmp_1 = contractorFee;
          var tmp_2 = tmp_1 == null ? null : new (MonetaryValue())(tmp_1);
          var tmp_3 = platformFee;
          var tmp_4 = tmp_3 == null ? null : new (MonetaryValue())(tmp_3);
          var tmp_5 = processorFee;
          tmp = tmp_0.call(this, _id, project, lineItem, payApp, party, new (MonetaryValue())(amount), tmp_2, tmp_4, tmp_5 == null ? null : new (MonetaryValue())(tmp_5), state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created);
        }
        return tmp;
      }
      toString() {
        var tmp = this.p7k_1.toString();
        var tmp_0 = this.q7k_1.toString();
        var tmp_1 = toString_0(this.r7k_1);
        var tmp_2 = toString_0(this.s7k_1);
        var tmp_3 = this.t7k_1.toString();
        var tmp_4 = MonetaryValue__toString_impl_xslc77(this.u7k_1);
        var tmp_5 = this.v7k_1;
        var tmp_6 = toString_0(tmp_5 == null ? null : new (MonetaryValue())(tmp_5));
        var tmp_7 = this.w7k_1;
        var tmp_8 = toString_0(tmp_7 == null ? null : new (MonetaryValue())(tmp_7));
        var tmp_9 = this.x7k_1;
        return 'ProjectLedgerItem(_id=' + tmp + ', project=' + tmp_0 + ', lineItem=' + tmp_1 + ', payApp=' + tmp_2 + ', party=' + tmp_3 + ', amount=' + tmp_4 + ', contractorFee=' + tmp_6 + ', platformFee=' + tmp_8 + ', processorFee=' + toString_0(tmp_9 == null ? null : new (MonetaryValue())(tmp_9)) + ', state=' + toString(this.y7k_1) + ', message=' + this.z7k_1 + ', method=' + toString_0(this.a7l_1) + ', depositSucceeded=' + toString_0(this.b7l_1) + ', payoutRequested=' + toString_0(this.c7l_1) + ', payoutConfirmation=' + toString_0(this.d7l_1) + ', accountName=' + this.e7l_1 + ', intentId=' + this.f7l_1 + ', check=' + toString_0(this.g7l_1) + ', created=' + this.h7l_1.toString() + ')';
      }
      hashCode() {
        var result = this.p7k_1.hashCode();
        result = imul(result, 31) + this.q7k_1.hashCode() | 0;
        result = imul(result, 31) + (this.r7k_1 == null ? 0 : this.r7k_1.hashCode()) | 0;
        result = imul(result, 31) + (this.s7k_1 == null ? 0 : this.s7k_1.hashCode()) | 0;
        result = imul(result, 31) + this.t7k_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.u7k_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.v7k_1;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = MonetaryValue__hashCode_impl_fhcsz2(this.v7k_1);
        }
        result = tmp + tmp_0 | 0;
        var tmp_2 = imul(result, 31);
        var tmp_3;
        var tmp_4 = this.w7k_1;
        if ((tmp_4 == null ? null : new (MonetaryValue())(tmp_4)) == null) {
          tmp_3 = 0;
        } else {
          tmp_3 = MonetaryValue__hashCode_impl_fhcsz2(this.w7k_1);
        }
        result = tmp_2 + tmp_3 | 0;
        var tmp_5 = imul(result, 31);
        var tmp_6;
        var tmp_7 = this.x7k_1;
        if ((tmp_7 == null ? null : new (MonetaryValue())(tmp_7)) == null) {
          tmp_6 = 0;
        } else {
          tmp_6 = MonetaryValue__hashCode_impl_fhcsz2(this.x7k_1);
        }
        result = tmp_5 + tmp_6 | 0;
        result = imul(result, 31) + this.y7k_1.hashCode() | 0;
        result = imul(result, 31) + (this.z7k_1 == null ? 0 : getStringHashCode(this.z7k_1)) | 0;
        result = imul(result, 31) + (this.a7l_1 == null ? 0 : this.a7l_1.hashCode()) | 0;
        result = imul(result, 31) + (this.b7l_1 == null ? 0 : this.b7l_1.hashCode()) | 0;
        result = imul(result, 31) + (this.c7l_1 == null ? 0 : this.c7l_1.hashCode()) | 0;
        result = imul(result, 31) + (this.d7l_1 == null ? 0 : this.d7l_1.hashCode()) | 0;
        result = imul(result, 31) + (this.e7l_1 == null ? 0 : getStringHashCode(this.e7l_1)) | 0;
        result = imul(result, 31) + (this.f7l_1 == null ? 0 : getStringHashCode(this.f7l_1)) | 0;
        result = imul(result, 31) + (this.g7l_1 == null ? 0 : this.g7l_1.hashCode()) | 0;
        result = imul(result, 31) + this.h7l_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectLedgerItem()))
          return false;
        if (!this.p7k_1.equals(other.p7k_1))
          return false;
        if (!this.q7k_1.equals(other.q7k_1))
          return false;
        if (!equals(this.r7k_1, other.r7k_1))
          return false;
        if (!equals(this.s7k_1, other.s7k_1))
          return false;
        if (!this.t7k_1.equals(other.t7k_1))
          return false;
        if (!(this.u7k_1 === other.u7k_1))
          return false;
        var tmp = this.v7k_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.v7k_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        var tmp_2 = this.w7k_1;
        var tmp_3 = tmp_2 == null ? null : new (MonetaryValue())(tmp_2);
        var tmp_4 = other.w7k_1;
        if (!equals(tmp_3, tmp_4 == null ? null : new (MonetaryValue())(tmp_4)))
          return false;
        var tmp_5 = this.x7k_1;
        var tmp_6 = tmp_5 == null ? null : new (MonetaryValue())(tmp_5);
        var tmp_7 = other.x7k_1;
        if (!equals(tmp_6, tmp_7 == null ? null : new (MonetaryValue())(tmp_7)))
          return false;
        if (!this.y7k_1.equals(other.y7k_1))
          return false;
        if (!(this.z7k_1 == other.z7k_1))
          return false;
        if (!equals(this.a7l_1, other.a7l_1))
          return false;
        if (!equals(this.b7l_1, other.b7l_1))
          return false;
        if (!equals(this.c7l_1, other.c7l_1))
          return false;
        if (!equals(this.d7l_1, other.d7l_1))
          return false;
        if (!(this.e7l_1 == other.e7l_1))
          return false;
        if (!(this.f7l_1 == other.f7l_1))
          return false;
        if (!equals(this.g7l_1, other.g7l_1))
          return false;
        if (!this.h7l_1.equals(other.h7l_1))
          return false;
        return true;
      }
      static h98(seen0, _id, project, lineItem, payApp, party, amount, contractorFee, platformFee, processorFee, state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created, serializationConstructorMarker) {
        Companion_getInstance_45();
        if (!(530 === (530 & seen0))) {
          throwMissingFieldException(seen0, 530, $serializer_getInstance_45().f98_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.p7k_1 = Companion_getInstance().m2p();
        else
          $this.p7k_1 = _id;
        $this.q7k_1 = project;
        if (0 === (seen0 & 4))
          $this.r7k_1 = null;
        else
          $this.r7k_1 = lineItem;
        if (0 === (seen0 & 8))
          $this.s7k_1 = null;
        else
          $this.s7k_1 = payApp;
        $this.t7k_1 = party;
        if (0 === (seen0 & 32))
          $this.u7k_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.u7k_1 = amount;
        if (0 === (seen0 & 64))
          $this.v7k_1 = null;
        else
          $this.v7k_1 = contractorFee;
        if (0 === (seen0 & 128))
          $this.w7k_1 = null;
        else
          $this.w7k_1 = platformFee;
        if (0 === (seen0 & 256))
          $this.x7k_1 = null;
        else
          $this.x7k_1 = processorFee;
        $this.y7k_1 = state;
        if (0 === (seen0 & 1024))
          $this.z7k_1 = null;
        else
          $this.z7k_1 = message;
        if (0 === (seen0 & 2048))
          $this.a7l_1 = null;
        else
          $this.a7l_1 = method;
        if (0 === (seen0 & 4096))
          $this.b7l_1 = null;
        else
          $this.b7l_1 = depositSucceeded;
        if (0 === (seen0 & 8192))
          $this.c7l_1 = null;
        else
          $this.c7l_1 = payoutRequested;
        if (0 === (seen0 & 16384))
          $this.d7l_1 = null;
        else
          $this.d7l_1 = payoutConfirmation;
        if (0 === (seen0 & 32768))
          $this.e7l_1 = null;
        else
          $this.e7l_1 = accountName;
        if (0 === (seen0 & 65536))
          $this.f7l_1 = null;
        else
          $this.f7l_1 = intentId;
        if (0 === (seen0 & 131072))
          $this.g7l_1 = null;
        else
          $this.g7l_1 = check;
        if (0 === (seen0 & 262144)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.h7l_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.h7l_1 = created;
        return $this;
      }
    }
    initMetadataForClass($, 'ProjectLedgerItem', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_45});
    ProjectLedgerItemClass = $;
  }
  return ProjectLedgerItemClass;
}
function ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_2() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_32;
function Companion_32() {
  if (CompanionClass_32 === VOID) {
    class $ {
      constructor() {
        Companion_instance_34 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d7p_1 = [tmp_1, tmp_3, tmp_5, null, tmp_7, null, tmp_9, null, lazy(tmp_10, ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_4), null, null, null];
      }
      m2a() {
        return $serializer_getInstance_46();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_32 = $;
  }
  return CompanionClass_32;
}
var Companion_instance_34;
function Companion_getInstance_46() {
  if (Companion_instance_34 === VOID)
    new (Companion_32())();
  return Companion_instance_34;
}
var $serializerClass_30;
function $serializer_30() {
  if ($serializerClass_30 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_30 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ProjectMessage', this, 12);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('sender', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(User())));
        tmp0_serialDesc.c1b('senderName', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('senderIcon', true);
        tmp0_serialDesc.c1b('clientMessage', false);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('sent', true);
        tmp0_serialDesc.c1b('message', false);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('replyingToMessage', true);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        tmp0_serialDesc.c1b('referencesChangeRequest', true);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        tmp0_serialDesc.c1b('referencesPayApp', true);
        tmp0_serialDesc.d1b(new (AdminViewOnly())());
        this.j98_1 = tmp0_serialDesc;
      }
      k98(encoder, value) {
        var tmp0_desc = this.j98_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_46().d7p_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.i7p_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.i7p_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.j7p_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.k7p_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.l7p_1 === '')) {
          tmp1_output.a15(tmp0_desc, 3, value.l7p_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 4)) {
          tmp = true;
        } else {
          var tmp_0 = value.m7p_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = tmp2_cached[4].f2();
          var tmp_2 = value.m7p_1;
          tmp1_output.d15(tmp0_desc, 4, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        tmp1_output.s14(tmp0_desc, 5, value.n7p_1);
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 6)) {
          tmp_3 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp_3 = !value.o7p_1.equals(tmp$ret$0);
        }
        if (tmp_3) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.o7p_1);
        }
        tmp1_output.a15(tmp0_desc, 7, value.p7p_1);
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.q7p_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.q7p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.r7p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, $serializer_getInstance_55(), value.r7p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.s7p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, $serializer_getInstance_57(), value.s7p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.t7p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 11, $serializer_getInstance_56(), value.t7p_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.k98(encoder, value instanceof ProjectMessage() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.j98_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = false;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_input = decoder.l13(tmp0_desc);
        var tmp17_cached = Companion_getInstance_46().d7p_1;
        if (tmp16_input.a14()) {
          tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp16_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp = tmp17_cached[4].f2();
          var tmp_0 = tmp8_local4;
          var tmp_1 = tmp16_input.z13(tmp0_desc, 4, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp8_local4 = tmp_1 == null ? null : tmp_1.n2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp16_input.n13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp16_input.x13(tmp0_desc, 6, tmp17_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp16_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp16_input.z13(tmp0_desc, 9, $serializer_getInstance_55(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp16_input.z13(tmp0_desc, 10, $serializer_getInstance_57(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp16_input.z13(tmp0_desc, 11, $serializer_getInstance_56(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp16_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp16_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_2 = tmp17_cached[4].f2();
                var tmp_3 = tmp8_local4;
                var tmp_4 = tmp16_input.z13(tmp0_desc, 4, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
                tmp8_local4 = tmp_4 == null ? null : tmp_4.n2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp16_input.n13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp16_input.x13(tmp0_desc, 6, tmp17_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp16_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp16_input.z13(tmp0_desc, 9, $serializer_getInstance_55(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp16_input.z13(tmp0_desc, 10, $serializer_getInstance_57(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp16_input.z13(tmp0_desc, 11, $serializer_getInstance_56(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp16_input.m13(tmp0_desc);
        return ProjectMessage().l98(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
      }
      az() {
        return this.j98_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_46().d7p_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), StringSerializer_getInstance(), get_nullable(tmp0_cached[4].f2()), BooleanSerializer_getInstance(), tmp0_cached[6].f2(), StringSerializer_getInstance(), tmp0_cached[8].f2(), get_nullable($serializer_getInstance_55()), get_nullable($serializer_getInstance_57()), get_nullable($serializer_getInstance_56())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_30 = $;
  }
  return $serializerClass_30;
}
var $serializer_instance_30;
function $serializer_getInstance_46() {
  if ($serializer_instance_30 === VOID)
    new ($serializer_30())();
  return $serializer_instance_30;
}
var ProjectMessageClass;
function ProjectMessage() {
  if (ProjectMessageClass === VOID) {
    class $ {
      constructor(_id, project, sender, senderName, senderIcon, clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp) {
        Companion_getInstance_46();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        senderName = senderName === VOID ? '' : senderName;
        senderIcon = senderIcon === VOID ? null : senderIcon;
        var tmp;
        if (sent === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = sent;
        }
        sent = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        replyingToMessage = replyingToMessage === VOID ? null : replyingToMessage;
        referencesChangeRequest = referencesChangeRequest === VOID ? null : referencesChangeRequest;
        referencesPayApp = referencesPayApp === VOID ? null : referencesPayApp;
        this.i7p_1 = _id;
        this.j7p_1 = project;
        this.k7p_1 = sender;
        this.l7p_1 = senderName;
        this.m7p_1 = senderIcon;
        this.n7p_1 = clientMessage;
        this.o7p_1 = sent;
        this.p7p_1 = message;
        this.q7p_1 = readBy;
        this.r7p_1 = replyingToMessage;
        this.s7p_1 = referencesChangeRequest;
        this.t7p_1 = referencesPayApp;
      }
      h40() {
        return this.i7p_1;
      }
      t91() {
        return this.q7p_1;
      }
      m98(_id, project, sender, senderName, senderIcon, clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp) {
        return new (ProjectMessage())(_id, project, sender, senderName, senderIcon, clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp);
      }
      v7p(_id, project, sender, senderName, senderIcon, clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp, $super) {
        _id = _id === VOID ? this.i7p_1 : _id;
        project = project === VOID ? this.j7p_1 : project;
        sender = sender === VOID ? this.k7p_1 : sender;
        senderName = senderName === VOID ? this.l7p_1 : senderName;
        senderIcon = senderIcon === VOID ? this.m7p_1 : senderIcon;
        clientMessage = clientMessage === VOID ? this.n7p_1 : clientMessage;
        sent = sent === VOID ? this.o7p_1 : sent;
        message = message === VOID ? this.p7p_1 : message;
        readBy = readBy === VOID ? this.q7p_1 : readBy;
        replyingToMessage = replyingToMessage === VOID ? this.r7p_1 : replyingToMessage;
        referencesChangeRequest = referencesChangeRequest === VOID ? this.s7p_1 : referencesChangeRequest;
        referencesPayApp = referencesPayApp === VOID ? this.t7p_1 : referencesPayApp;
        var tmp;
        if ($super === VOID) {
          tmp = this.m98(_id, project, sender, senderName, senderIcon, clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp);
        } else {
          var tmp_0 = $super.m98;
          var tmp_1 = senderIcon;
          tmp = tmp_0.call(this, _id, project, sender, senderName, tmp_1 == null ? null : new (ServerFile())(tmp_1), clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp);
        }
        return tmp;
      }
      toString() {
        var tmp = this.i7p_1.toString();
        var tmp_0 = this.j7p_1.toString();
        var tmp_1 = this.k7p_1.toString();
        var tmp_2 = this.m7p_1;
        return 'ProjectMessage(_id=' + tmp + ', project=' + tmp_0 + ', sender=' + tmp_1 + ', senderName=' + this.l7p_1 + ', senderIcon=' + toString_0(tmp_2 == null ? null : new (ServerFile())(tmp_2)) + ', clientMessage=' + this.n7p_1 + ', sent=' + this.o7p_1.toString() + ', message=' + this.p7p_1 + ', readBy=' + toString(this.q7p_1) + ', replyingToMessage=' + toString_0(this.r7p_1) + ', referencesChangeRequest=' + toString_0(this.s7p_1) + ', referencesPayApp=' + toString_0(this.t7p_1) + ')';
      }
      hashCode() {
        var result = this.i7p_1.hashCode();
        result = imul(result, 31) + this.j7p_1.hashCode() | 0;
        result = imul(result, 31) + this.k7p_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.l7p_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.m7p_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.m7p_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + getBooleanHashCode(this.n7p_1) | 0;
        result = imul(result, 31) + this.o7p_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.p7p_1) | 0;
        result = imul(result, 31) + hashCode(this.q7p_1) | 0;
        result = imul(result, 31) + (this.r7p_1 == null ? 0 : this.r7p_1.hashCode()) | 0;
        result = imul(result, 31) + (this.s7p_1 == null ? 0 : this.s7p_1.hashCode()) | 0;
        result = imul(result, 31) + (this.t7p_1 == null ? 0 : this.t7p_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectMessage()))
          return false;
        if (!this.i7p_1.equals(other.i7p_1))
          return false;
        if (!this.j7p_1.equals(other.j7p_1))
          return false;
        if (!this.k7p_1.equals(other.k7p_1))
          return false;
        if (!(this.l7p_1 === other.l7p_1))
          return false;
        var tmp = this.m7p_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.m7p_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        if (!(this.n7p_1 === other.n7p_1))
          return false;
        if (!this.o7p_1.equals(other.o7p_1))
          return false;
        if (!(this.p7p_1 === other.p7p_1))
          return false;
        if (!equals(this.q7p_1, other.q7p_1))
          return false;
        if (!equals(this.r7p_1, other.r7p_1))
          return false;
        if (!equals(this.s7p_1, other.s7p_1))
          return false;
        if (!equals(this.t7p_1, other.t7p_1))
          return false;
        return true;
      }
      static l98(seen0, _id, project, sender, senderName, senderIcon, clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp, serializationConstructorMarker) {
        Companion_getInstance_46();
        if (!(166 === (166 & seen0))) {
          throwMissingFieldException(seen0, 166, $serializer_getInstance_46().j98_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.i7p_1 = Companion_getInstance().m2p();
        else
          $this.i7p_1 = _id;
        $this.j7p_1 = project;
        $this.k7p_1 = sender;
        if (0 === (seen0 & 8))
          $this.l7p_1 = '';
        else
          $this.l7p_1 = senderName;
        if (0 === (seen0 & 16))
          $this.m7p_1 = null;
        else
          $this.m7p_1 = senderIcon;
        $this.n7p_1 = clientMessage;
        if (0 === (seen0 & 64)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.o7p_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.o7p_1 = sent;
        $this.p7p_1 = message;
        if (0 === (seen0 & 256))
          $this.q7p_1 = emptySet();
        else
          $this.q7p_1 = readBy;
        if (0 === (seen0 & 512))
          $this.r7p_1 = null;
        else
          $this.r7p_1 = replyingToMessage;
        if (0 === (seen0 & 1024))
          $this.s7p_1 = null;
        else
          $this.s7p_1 = referencesChangeRequest;
        if (0 === (seen0 & 2048))
          $this.t7p_1 = null;
        else
          $this.t7p_1 = referencesPayApp;
        return $this;
      }
    }
    initMetadataForClass($, 'ProjectMessage', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_46});
    ProjectMessageClass = $;
  }
  return ProjectMessageClass;
}
function ProjectSettlementDocumentation$Companion$$childSerializers$_anonymous__1375gy() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectSettlementDocumentation$Companion$$childSerializers$_anonymous__1375gy_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectSettlementDocumentation$Companion$$childSerializers$_anonymous__1375gy_1() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
var CompanionClass_33;
function Companion_33() {
  if (CompanionClass_33 === VOID) {
    class $ {
      constructor() {
        Companion_instance_35 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectSettlementDocumentation$Companion$$childSerializers$_anonymous__1375gy);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ProjectSettlementDocumentation$Companion$$childSerializers$_anonymous__1375gy_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.c7s_1 = [tmp_1, tmp_3, null, null, null, lazy(tmp_4, ProjectSettlementDocumentation$Companion$$childSerializers$_anonymous__1375gy_1)];
      }
      m2a() {
        return $serializer_getInstance_47();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_33 = $;
  }
  return CompanionClass_33;
}
var Companion_instance_35;
function Companion_getInstance_47() {
  if (Companion_instance_35 === VOID)
    new (Companion_33())();
  return Companion_instance_35;
}
var $serializerClass_31;
function $serializer_31() {
  if ($serializerClass_31 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_31 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ProjectSettlementDocumentation', this, 6);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('submitted', false);
        tmp0_serialDesc.c1b('submittedByClient', false);
        tmp0_serialDesc.c1b('summary', false);
        tmp0_serialDesc.c1b('documents', false);
        this.n98_1 = tmp0_serialDesc;
      }
      o98(encoder, value) {
        var tmp0_desc = this.n98_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_47().c7s_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.h7s_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.h7s_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.i7s_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance_4(), value.j7s_1);
        tmp1_output.s14(tmp0_desc, 3, value.k7s_1);
        tmp1_output.a15(tmp0_desc, 4, value.l7s_1);
        tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.m7s_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.o98(encoder, value instanceof ProjectSettlementDocumentation() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n98_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = false;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.l13(tmp0_desc);
        var tmp11_cached = Companion_getInstance_47().c7s_1;
        if (tmp10_input.a14()) {
          tmp4_local0 = tmp10_input.x13(tmp0_desc, 0, tmp11_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.x13(tmp0_desc, 1, tmp11_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.x13(tmp0_desc, 5, tmp11_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp10_input.x13(tmp0_desc, 0, tmp11_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.x13(tmp0_desc, 1, tmp11_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.x13(tmp0_desc, 5, tmp11_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp10_input.m13(tmp0_desc);
        return ProjectSettlementDocumentation().p98(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      az() {
        return this.n98_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_47().c7s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), $serializer_getInstance_4(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[5].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_31 = $;
  }
  return $serializerClass_31;
}
var $serializer_instance_31;
function $serializer_getInstance_47() {
  if ($serializer_instance_31 === VOID)
    new ($serializer_31())();
  return $serializer_instance_31;
}
var ProjectSettlementDocumentationClass;
function ProjectSettlementDocumentation() {
  if (ProjectSettlementDocumentationClass === VOID) {
    class $ {
      constructor(_id, project, submitted, submittedByClient, summary, documents) {
        Companion_getInstance_47();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        this.h7s_1 = _id;
        this.i7s_1 = project;
        this.j7s_1 = submitted;
        this.k7s_1 = submittedByClient;
        this.l7s_1 = summary;
        this.m7s_1 = documents;
      }
      h40() {
        return this.h7s_1;
      }
      q98(_id, project, submitted, submittedByClient, summary, documents) {
        return new (ProjectSettlementDocumentation())(_id, project, submitted, submittedByClient, summary, documents);
      }
      o7s(_id, project, submitted, submittedByClient, summary, documents, $super) {
        _id = _id === VOID ? this.h7s_1 : _id;
        project = project === VOID ? this.i7s_1 : project;
        submitted = submitted === VOID ? this.j7s_1 : submitted;
        submittedByClient = submittedByClient === VOID ? this.k7s_1 : submittedByClient;
        summary = summary === VOID ? this.l7s_1 : summary;
        documents = documents === VOID ? this.m7s_1 : documents;
        return $super === VOID ? this.q98(_id, project, submitted, submittedByClient, summary, documents) : $super.q98.call(this, _id, project, submitted, submittedByClient, summary, documents);
      }
      toString() {
        return 'ProjectSettlementDocumentation(_id=' + this.h7s_1.toString() + ', project=' + this.i7s_1.toString() + ', submitted=' + this.j7s_1.toString() + ', submittedByClient=' + this.k7s_1 + ', summary=' + this.l7s_1 + ', documents=' + toString(this.m7s_1) + ')';
      }
      hashCode() {
        var result = this.h7s_1.hashCode();
        result = imul(result, 31) + this.i7s_1.hashCode() | 0;
        result = imul(result, 31) + this.j7s_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.k7s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l7s_1) | 0;
        result = imul(result, 31) + hashCode(this.m7s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectSettlementDocumentation()))
          return false;
        if (!this.h7s_1.equals(other.h7s_1))
          return false;
        if (!this.i7s_1.equals(other.i7s_1))
          return false;
        if (!this.j7s_1.equals(other.j7s_1))
          return false;
        if (!(this.k7s_1 === other.k7s_1))
          return false;
        if (!(this.l7s_1 === other.l7s_1))
          return false;
        if (!equals(this.m7s_1, other.m7s_1))
          return false;
        return true;
      }
      static p98(seen0, _id, project, submitted, submittedByClient, summary, documents, serializationConstructorMarker) {
        Companion_getInstance_47();
        if (!(62 === (62 & seen0))) {
          throwMissingFieldException(seen0, 62, $serializer_getInstance_47().n98_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.h7s_1 = Companion_getInstance().m2p();
        else
          $this.h7s_1 = _id;
        $this.i7s_1 = project;
        $this.j7s_1 = submitted;
        $this.k7s_1 = submittedByClient;
        $this.l7s_1 = summary;
        $this.m7s_1 = documents;
        return $this;
      }
    }
    initMetadataForClass($, 'ProjectSettlementDocumentation', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_47});
    ProjectSettlementDocumentationClass = $;
  }
  return ProjectSettlementDocumentationClass;
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_3() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_5() {
  return Companion_getInstance_0().m2a();
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_6() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_34;
function Companion_34() {
  if (CompanionClass_34 === VOID) {
    class $ {
      constructor() {
        Companion_instance_36 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.k7t_1 = [tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, null, tmp_11, null, tmp_13, null, null, lazy(tmp_14, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_6)];
      }
      m2a() {
        return $serializer_getInstance_48();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_34 = $;
  }
  return CompanionClass_34;
}
var Companion_instance_36;
function Companion_getInstance_48() {
  if (Companion_instance_36 === VOID)
    new (Companion_34())();
  return Companion_instance_36;
}
var $serializerClass_32;
function $serializer_32() {
  if ($serializerClass_32 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_32 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ProjectTimer', this, 12);
        tmp0_serialDesc.c1b('_id', false);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('lineItem', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.c1b('incident', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(Incident())));
        tmp0_serialDesc.c1b('payApp', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(PayApplication())));
        tmp0_serialDesc.c1b('durationLeft', true);
        tmp0_serialDesc.c1b('executesAt', false);
        tmp0_serialDesc.c1b('pausedFromDispute', true);
        tmp0_serialDesc.c1b('action', false);
        tmp0_serialDesc.c1b('businessDaysOnly', true);
        tmp0_serialDesc.c1b('minimumTimeWhenResumed', true);
        tmp0_serialDesc.c1b('executed', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.e1b(new (AdminTableColumns())(['project', 'lineItem', 'executesAt', 'action']));
        this.r98_1 = tmp0_serialDesc;
      }
      s98(encoder, value) {
        var tmp0_desc = this.r98_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_48().k7t_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.r7t_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.s7t_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.t7t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.t7t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.u7t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.u7t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.v7t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.v7t_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          var tmp_0 = value.w7t_1;
          tmp = !((tmp_0 == null ? null : new (Duration())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = DurationSerializer_getInstance();
          var tmp_2 = value.w7t_1;
          tmp1_output.d15(tmp0_desc, 5, tmp_1, tmp_2 == null ? null : new (Duration())(tmp_2));
        }
        tmp1_output.d15(tmp0_desc, 6, tmp2_cached[6].f2(), value.x7t_1);
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.y7t_1 === false)) {
          tmp1_output.s14(tmp0_desc, 7, value.y7t_1);
        }
        tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.z7t_1);
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.a7u_1 === false)) {
          tmp1_output.s14(tmp0_desc, 9, value.a7u_1);
        }
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 10)) {
          tmp_3 = true;
        } else {
          var tmp_4 = value.b7u_1;
          tmp_3 = !((tmp_4 == null ? null : new (Duration())(tmp_4)) == null);
        }
        if (tmp_3) {
          var tmp_5 = DurationSerializer_getInstance();
          var tmp_6 = value.b7u_1;
          tmp1_output.d15(tmp0_desc, 10, tmp_5, tmp_6 == null ? null : new (Duration())(tmp_6));
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.c7u_1 == null)) {
          tmp1_output.d15(tmp0_desc, 11, tmp2_cached[11].f2(), value.c7u_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.s98(encoder, value instanceof ProjectTimer() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.r98_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = false;
        var tmp12_local8 = null;
        var tmp13_local9 = false;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_input = decoder.l13(tmp0_desc);
        var tmp17_cached = Companion_getInstance_48().k7t_1;
        if (tmp16_input.a14()) {
          tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp16_input.z13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp16_input.z13(tmp0_desc, 3, tmp17_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp16_input.z13(tmp0_desc, 4, tmp17_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = DurationSerializer_getInstance();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp16_input.z13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (Duration())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.nj_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp16_input.z13(tmp0_desc, 6, tmp17_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp16_input.n13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp16_input.n13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          var tmp_2 = DurationSerializer_getInstance();
          var tmp_3 = tmp14_local10;
          var tmp_4 = tmp16_input.z13(tmp0_desc, 10, tmp_2, tmp_3 == null ? null : new (Duration())(tmp_3));
          tmp14_local10 = tmp_4 == null ? null : tmp_4.nj_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp16_input.z13(tmp0_desc, 11, tmp17_cached[11].f2(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp16_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp16_input.z13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp16_input.z13(tmp0_desc, 3, tmp17_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp16_input.z13(tmp0_desc, 4, tmp17_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_5 = DurationSerializer_getInstance();
                var tmp_6 = tmp9_local5;
                var tmp_7 = tmp16_input.z13(tmp0_desc, 5, tmp_5, tmp_6 == null ? null : new (Duration())(tmp_6));
                tmp9_local5 = tmp_7 == null ? null : tmp_7.nj_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp16_input.z13(tmp0_desc, 6, tmp17_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp16_input.n13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp16_input.n13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                var tmp_8 = DurationSerializer_getInstance();
                var tmp_9 = tmp14_local10;
                var tmp_10 = tmp16_input.z13(tmp0_desc, 10, tmp_8, tmp_9 == null ? null : new (Duration())(tmp_9));
                tmp14_local10 = tmp_10 == null ? null : tmp_10.nj_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp16_input.z13(tmp0_desc, 11, tmp17_cached[11].f2(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp16_input.m13(tmp0_desc);
        return ProjectTimer().t98(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
      }
      az() {
        return this.r98_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_48().k7t_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable(tmp0_cached[2].f2()), get_nullable(tmp0_cached[3].f2()), get_nullable(tmp0_cached[4].f2()), get_nullable(DurationSerializer_getInstance()), get_nullable(tmp0_cached[6].f2()), BooleanSerializer_getInstance(), tmp0_cached[8].f2(), BooleanSerializer_getInstance(), get_nullable(DurationSerializer_getInstance()), get_nullable(tmp0_cached[11].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_32 = $;
  }
  return $serializerClass_32;
}
var $serializer_instance_32;
function $serializer_getInstance_48() {
  if ($serializer_instance_32 === VOID)
    new ($serializer_32())();
  return $serializer_instance_32;
}
var ProjectTimerClass;
function ProjectTimer() {
  if (ProjectTimerClass === VOID) {
    class $ {
      constructor(_id, project, lineItem, incident, payApp, durationLeft, executesAt, pausedFromDispute, action, businessDaysOnly, minimumTimeWhenResumed, executed) {
        Companion_getInstance_48();
        lineItem = lineItem === VOID ? null : lineItem;
        incident = incident === VOID ? null : incident;
        payApp = payApp === VOID ? null : payApp;
        durationLeft = durationLeft === VOID ? null : durationLeft;
        pausedFromDispute = pausedFromDispute === VOID ? false : pausedFromDispute;
        businessDaysOnly = businessDaysOnly === VOID ? false : businessDaysOnly;
        minimumTimeWhenResumed = minimumTimeWhenResumed === VOID ? null : minimumTimeWhenResumed;
        executed = executed === VOID ? null : executed;
        this.r7t_1 = _id;
        this.s7t_1 = project;
        this.t7t_1 = lineItem;
        this.u7t_1 = incident;
        this.v7t_1 = payApp;
        this.w7t_1 = durationLeft;
        this.x7t_1 = executesAt;
        this.y7t_1 = pausedFromDispute;
        this.z7t_1 = action;
        this.a7u_1 = businessDaysOnly;
        this.b7u_1 = minimumTimeWhenResumed;
        this.c7u_1 = executed;
      }
      h40() {
        return this.r7t_1;
      }
      u98() {
        return this.x7t_1 == null;
      }
      v98(_id, project, lineItem, incident, payApp, durationLeft, executesAt, pausedFromDispute, action, businessDaysOnly, minimumTimeWhenResumed, executed) {
        return new (ProjectTimer())(_id, project, lineItem, incident, payApp, durationLeft, executesAt, pausedFromDispute, action, businessDaysOnly, minimumTimeWhenResumed, executed);
      }
      e7u(_id, project, lineItem, incident, payApp, durationLeft, executesAt, pausedFromDispute, action, businessDaysOnly, minimumTimeWhenResumed, executed, $super) {
        _id = _id === VOID ? this.r7t_1 : _id;
        project = project === VOID ? this.s7t_1 : project;
        lineItem = lineItem === VOID ? this.t7t_1 : lineItem;
        incident = incident === VOID ? this.u7t_1 : incident;
        payApp = payApp === VOID ? this.v7t_1 : payApp;
        durationLeft = durationLeft === VOID ? this.w7t_1 : durationLeft;
        executesAt = executesAt === VOID ? this.x7t_1 : executesAt;
        pausedFromDispute = pausedFromDispute === VOID ? this.y7t_1 : pausedFromDispute;
        action = action === VOID ? this.z7t_1 : action;
        businessDaysOnly = businessDaysOnly === VOID ? this.a7u_1 : businessDaysOnly;
        minimumTimeWhenResumed = minimumTimeWhenResumed === VOID ? this.b7u_1 : minimumTimeWhenResumed;
        executed = executed === VOID ? this.c7u_1 : executed;
        var tmp;
        if ($super === VOID) {
          tmp = this.v98(_id, project, lineItem, incident, payApp, durationLeft, executesAt, pausedFromDispute, action, businessDaysOnly, minimumTimeWhenResumed, executed);
        } else {
          var tmp_0 = $super.v98;
          var tmp_1 = durationLeft;
          var tmp_2 = tmp_1 == null ? null : new (Duration())(tmp_1);
          var tmp_3 = minimumTimeWhenResumed;
          tmp = tmp_0.call(this, _id, project, lineItem, incident, payApp, tmp_2, executesAt, pausedFromDispute, action, businessDaysOnly, tmp_3 == null ? null : new (Duration())(tmp_3), executed);
        }
        return tmp;
      }
      toString() {
        var tmp = this.r7t_1.toString();
        var tmp_0 = this.s7t_1.toString();
        var tmp_1 = toString_0(this.t7t_1);
        var tmp_2 = toString_0(this.u7t_1);
        var tmp_3 = toString_0(this.v7t_1);
        var tmp_4 = this.w7t_1;
        var tmp_5 = toString_0(tmp_4 == null ? null : new (Duration())(tmp_4));
        var tmp_6 = toString_0(this.x7t_1);
        var tmp_7 = this.z7t_1.toString();
        var tmp_8 = this.b7u_1;
        return 'ProjectTimer(_id=' + tmp + ', project=' + tmp_0 + ', lineItem=' + tmp_1 + ', incident=' + tmp_2 + ', payApp=' + tmp_3 + ', durationLeft=' + tmp_5 + ', executesAt=' + tmp_6 + ', pausedFromDispute=' + this.y7t_1 + ', action=' + tmp_7 + ', businessDaysOnly=' + this.a7u_1 + ', minimumTimeWhenResumed=' + toString_0(tmp_8 == null ? null : new (Duration())(tmp_8)) + ', executed=' + toString_0(this.c7u_1) + ')';
      }
      hashCode() {
        var result = this.r7t_1.hashCode();
        result = imul(result, 31) + this.s7t_1.hashCode() | 0;
        result = imul(result, 31) + (this.t7t_1 == null ? 0 : this.t7t_1.hashCode()) | 0;
        result = imul(result, 31) + (this.u7t_1 == null ? 0 : this.u7t_1.hashCode()) | 0;
        result = imul(result, 31) + (this.v7t_1 == null ? 0 : this.v7t_1.hashCode()) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.w7t_1;
        if ((tmp_1 == null ? null : new (Duration())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = Duration__hashCode_impl_u4exz6(this.w7t_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + (this.x7t_1 == null ? 0 : this.x7t_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.y7t_1) | 0;
        result = imul(result, 31) + this.z7t_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.a7u_1) | 0;
        var tmp_2 = imul(result, 31);
        var tmp_3;
        var tmp_4 = this.b7u_1;
        if ((tmp_4 == null ? null : new (Duration())(tmp_4)) == null) {
          tmp_3 = 0;
        } else {
          tmp_3 = Duration__hashCode_impl_u4exz6(this.b7u_1);
        }
        result = tmp_2 + tmp_3 | 0;
        result = imul(result, 31) + (this.c7u_1 == null ? 0 : this.c7u_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectTimer()))
          return false;
        if (!this.r7t_1.equals(other.r7t_1))
          return false;
        if (!this.s7t_1.equals(other.s7t_1))
          return false;
        if (!equals(this.t7t_1, other.t7t_1))
          return false;
        if (!equals(this.u7t_1, other.u7t_1))
          return false;
        if (!equals(this.v7t_1, other.v7t_1))
          return false;
        var tmp = this.w7t_1;
        var tmp_0 = tmp == null ? null : new (Duration())(tmp);
        var tmp_1 = other.w7t_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (Duration())(tmp_1)))
          return false;
        if (!equals(this.x7t_1, other.x7t_1))
          return false;
        if (!(this.y7t_1 === other.y7t_1))
          return false;
        if (!this.z7t_1.equals(other.z7t_1))
          return false;
        if (!(this.a7u_1 === other.a7u_1))
          return false;
        var tmp_2 = this.b7u_1;
        var tmp_3 = tmp_2 == null ? null : new (Duration())(tmp_2);
        var tmp_4 = other.b7u_1;
        if (!equals(tmp_3, tmp_4 == null ? null : new (Duration())(tmp_4)))
          return false;
        if (!equals(this.c7u_1, other.c7u_1))
          return false;
        return true;
      }
      static t98(seen0, _id, project, lineItem, incident, payApp, durationLeft, executesAt, pausedFromDispute, action, businessDaysOnly, minimumTimeWhenResumed, executed, serializationConstructorMarker) {
        Companion_getInstance_48();
        if (!(323 === (323 & seen0))) {
          throwMissingFieldException(seen0, 323, $serializer_getInstance_48().r98_1);
        }
        var $this = createThis(this);
        $this.r7t_1 = _id;
        $this.s7t_1 = project;
        if (0 === (seen0 & 4))
          $this.t7t_1 = null;
        else
          $this.t7t_1 = lineItem;
        if (0 === (seen0 & 8))
          $this.u7t_1 = null;
        else
          $this.u7t_1 = incident;
        if (0 === (seen0 & 16))
          $this.v7t_1 = null;
        else
          $this.v7t_1 = payApp;
        if (0 === (seen0 & 32))
          $this.w7t_1 = null;
        else
          $this.w7t_1 = durationLeft;
        $this.x7t_1 = executesAt;
        if (0 === (seen0 & 128))
          $this.y7t_1 = false;
        else
          $this.y7t_1 = pausedFromDispute;
        $this.z7t_1 = action;
        if (0 === (seen0 & 512))
          $this.a7u_1 = false;
        else
          $this.a7u_1 = businessDaysOnly;
        if (0 === (seen0 & 1024))
          $this.b7u_1 = null;
        else
          $this.b7u_1 = minimumTimeWhenResumed;
        if (0 === (seen0 & 2048))
          $this.c7u_1 = null;
        else
          $this.c7u_1 = executed;
        return $this;
      }
    }
    initMetadataForClass($, 'ProjectTimer', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_48});
    ProjectTimerClass = $;
  }
  return ProjectTimerClass;
}
function PunchListItem$Companion$$childSerializers$_anonymous__18yzsl() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_3() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_35;
function Companion_35() {
  if (CompanionClass_35 === VOID) {
    class $ {
      constructor() {
        Companion_instance_37 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, PunchListItem$Companion$$childSerializers$_anonymous__18yzsl);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.g7w_1 = [tmp_1, tmp_3, tmp_5, tmp_7, null, null, null, null, lazy(tmp_8, PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_3), null];
      }
      m2a() {
        return $serializer_getInstance_49();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_35 = $;
  }
  return CompanionClass_35;
}
var Companion_instance_37;
function Companion_getInstance_49() {
  if (Companion_instance_37 === VOID)
    new (Companion_35())();
  return Companion_instance_37;
}
var $serializerClass_33;
function $serializer_33() {
  if ($serializerClass_33 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_33 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PunchListItem', this, 10);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('lineItem', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.c1b('scope', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(ScopeView())));
        tmp0_serialDesc.c1b('order', true);
        tmp0_serialDesc.c1b('content', false);
        tmp0_serialDesc.c1b('required', false);
        tmp0_serialDesc.c1b('complete', true);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('isMinorAdjustment', true);
        this.w98_1 = tmp0_serialDesc;
      }
      x98(encoder, value) {
        var tmp0_desc = this.w98_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_49().g7w_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.l7w_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.l7w_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.m7w_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.n7w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.n7w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.o7w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.o7w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !equals(value.p7w_1, 0.5)) {
          tmp1_output.y14(tmp0_desc, 4, value.p7w_1);
        }
        tmp1_output.a15(tmp0_desc, 5, value.q7w_1);
        tmp1_output.s14(tmp0_desc, 6, value.r7w_1);
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.s7w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, $serializer_getInstance_4(), value.s7w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.t7w_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.t7w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.u7w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, StringSerializer_getInstance(), value.u7w_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.x98(encoder, value instanceof PunchListItem() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.w98_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = 0.0;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_input = decoder.l13(tmp0_desc);
        var tmp15_cached = Companion_getInstance_49().g7w_1;
        if (tmp14_input.a14()) {
          tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.z13(tmp0_desc, 2, tmp15_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.z13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.t13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.n13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.z13(tmp0_desc, 2, tmp15_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.z13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.t13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.n13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp14_input.m13(tmp0_desc);
        return PunchListItem().y98(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      az() {
        return this.w98_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_49().g7w_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable(tmp0_cached[2].f2()), get_nullable(tmp0_cached[3].f2()), DoubleSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_4()), tmp0_cached[8].f2(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_33 = $;
  }
  return $serializerClass_33;
}
var $serializer_instance_33;
function $serializer_getInstance_49() {
  if ($serializer_instance_33 === VOID)
    new ($serializer_33())();
  return $serializer_instance_33;
}
var PunchListItemClass;
function PunchListItem() {
  if (PunchListItemClass === VOID) {
    class $ {
      constructor(_id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment) {
        Companion_getInstance_49();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        lineItem = lineItem === VOID ? null : lineItem;
        scope = scope === VOID ? null : scope;
        order = order === VOID ? 0.5 : order;
        complete = complete === VOID ? null : complete;
        readBy = readBy === VOID ? emptySet() : readBy;
        isMinorAdjustment = isMinorAdjustment === VOID ? null : isMinorAdjustment;
        this.l7w_1 = _id;
        this.m7w_1 = project;
        this.n7w_1 = lineItem;
        this.o7w_1 = scope;
        this.p7w_1 = order;
        this.q7w_1 = content;
        this.r7w_1 = required;
        this.s7w_1 = complete;
        this.t7w_1 = readBy;
        this.u7w_1 = isMinorAdjustment;
      }
      h40() {
        return this.l7w_1;
      }
      k8v() {
        return this.p7w_1;
      }
      t91() {
        return this.t7w_1;
      }
      l8v(order) {
        return this.w7w(VOID, VOID, VOID, VOID, order);
      }
      z98(_id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment) {
        return new (PunchListItem())(_id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment);
      }
      w7w(_id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment, $super) {
        _id = _id === VOID ? this.l7w_1 : _id;
        project = project === VOID ? this.m7w_1 : project;
        lineItem = lineItem === VOID ? this.n7w_1 : lineItem;
        scope = scope === VOID ? this.o7w_1 : scope;
        order = order === VOID ? this.p7w_1 : order;
        content = content === VOID ? this.q7w_1 : content;
        required = required === VOID ? this.r7w_1 : required;
        complete = complete === VOID ? this.s7w_1 : complete;
        readBy = readBy === VOID ? this.t7w_1 : readBy;
        isMinorAdjustment = isMinorAdjustment === VOID ? this.u7w_1 : isMinorAdjustment;
        return $super === VOID ? this.z98(_id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment) : $super.z98.call(this, _id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment);
      }
      toString() {
        return 'PunchListItem(_id=' + this.l7w_1.toString() + ', project=' + this.m7w_1.toString() + ', lineItem=' + toString_0(this.n7w_1) + ', scope=' + toString_0(this.o7w_1) + ', order=' + this.p7w_1 + ', content=' + this.q7w_1 + ', required=' + this.r7w_1 + ', complete=' + toString_0(this.s7w_1) + ', readBy=' + toString(this.t7w_1) + ', isMinorAdjustment=' + this.u7w_1 + ')';
      }
      hashCode() {
        var result = this.l7w_1.hashCode();
        result = imul(result, 31) + this.m7w_1.hashCode() | 0;
        result = imul(result, 31) + (this.n7w_1 == null ? 0 : this.n7w_1.hashCode()) | 0;
        result = imul(result, 31) + (this.o7w_1 == null ? 0 : this.o7w_1.hashCode()) | 0;
        result = imul(result, 31) + getNumberHashCode(this.p7w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q7w_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.r7w_1) | 0;
        result = imul(result, 31) + (this.s7w_1 == null ? 0 : this.s7w_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.t7w_1) | 0;
        result = imul(result, 31) + (this.u7w_1 == null ? 0 : getStringHashCode(this.u7w_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PunchListItem()))
          return false;
        if (!this.l7w_1.equals(other.l7w_1))
          return false;
        if (!this.m7w_1.equals(other.m7w_1))
          return false;
        if (!equals(this.n7w_1, other.n7w_1))
          return false;
        if (!equals(this.o7w_1, other.o7w_1))
          return false;
        if (!equals(this.p7w_1, other.p7w_1))
          return false;
        if (!(this.q7w_1 === other.q7w_1))
          return false;
        if (!(this.r7w_1 === other.r7w_1))
          return false;
        if (!equals(this.s7w_1, other.s7w_1))
          return false;
        if (!equals(this.t7w_1, other.t7w_1))
          return false;
        if (!(this.u7w_1 == other.u7w_1))
          return false;
        return true;
      }
      static y98(seen0, _id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment, serializationConstructorMarker) {
        Companion_getInstance_49();
        if (!(98 === (98 & seen0))) {
          throwMissingFieldException(seen0, 98, $serializer_getInstance_49().w98_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.l7w_1 = Companion_getInstance().m2p();
        else
          $this.l7w_1 = _id;
        $this.m7w_1 = project;
        if (0 === (seen0 & 4))
          $this.n7w_1 = null;
        else
          $this.n7w_1 = lineItem;
        if (0 === (seen0 & 8))
          $this.o7w_1 = null;
        else
          $this.o7w_1 = scope;
        if (0 === (seen0 & 16))
          $this.p7w_1 = 0.5;
        else
          $this.p7w_1 = order;
        $this.q7w_1 = content;
        $this.r7w_1 = required;
        if (0 === (seen0 & 128))
          $this.s7w_1 = null;
        else
          $this.s7w_1 = complete;
        if (0 === (seen0 & 256))
          $this.t7w_1 = emptySet();
        else
          $this.t7w_1 = readBy;
        if (0 === (seen0 & 512))
          $this.u7w_1 = null;
        else
          $this.u7w_1 = isMinorAdjustment;
        return $this;
      }
      d(other) {
        return this.m8v(other instanceof PunchListItem() ? other : THROW_CCE());
      }
    }
    protoOf($).m8v = compareTo;
    initMetadataForClass($, 'PunchListItem', VOID, VOID, [HasId(), ReadByDataModel(), Reorderable()], VOID, VOID, {0: $serializer_getInstance_49});
    PunchListItemClass = $;
  }
  return PunchListItemClass;
}
function ScopeView$Companion$$childSerializers$_anonymous__i9bl8x() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ScopeView$Companion$$childSerializers$_anonymous__i9bl8x_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ScopeView$Companion$$childSerializers$_anonymous__i9bl8x_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ScopeView$Companion$$childSerializers$_anonymous__i9bl8x_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_36;
function Companion_36() {
  if (CompanionClass_36 === VOID) {
    class $ {
      constructor() {
        Companion_instance_38 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ScopeView$Companion$$childSerializers$_anonymous__i9bl8x);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ScopeView$Companion$$childSerializers$_anonymous__i9bl8x_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ScopeView$Companion$$childSerializers$_anonymous__i9bl8x_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.f7z_1 = [tmp_1, tmp_3, null, null, null, null, tmp_5, null, lazy(tmp_6, ScopeView$Companion$$childSerializers$_anonymous__i9bl8x_2)];
      }
      m2a() {
        return $serializer_getInstance_50();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_36 = $;
  }
  return CompanionClass_36;
}
var Companion_instance_38;
function Companion_getInstance_50() {
  if (Companion_instance_38 === VOID)
    new (Companion_36())();
  return Companion_instance_38;
}
var $serializerClass_34;
function $serializer_34() {
  if ($serializerClass_34 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_34 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ScopeView', this, 9);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('scopeTitle', false);
        tmp0_serialDesc.c1b('description', true);
        tmp0_serialDesc.c1b('order', true);
        tmp0_serialDesc.c1b('scopeSet', true);
        tmp0_serialDesc.c1b('parentView', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(ScopeView())));
        tmp0_serialDesc.d1b(new (Index())());
        tmp0_serialDesc.c1b('fromChangeRequest', true);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.e1b(new (IndexSet())(['project', 'fromChangeRequest']));
        this.a99_1 = tmp0_serialDesc;
      }
      b99(encoder, value) {
        var tmp0_desc = this.a99_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_50().f7z_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.k7z_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.l7z_1);
        tmp1_output.a15(tmp0_desc, 2, value.m7z_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.n7z_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, StringSerializer_getInstance(), value.n7z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !equals(value.o7z_1, 0.5)) {
          tmp1_output.y14(tmp0_desc, 4, value.o7z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.p7z_1 === false)) {
          tmp1_output.s14(tmp0_desc, 5, value.p7z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.q7z_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, tmp2_cached[6].f2(), value.q7z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.r7z_1 === false)) {
          tmp1_output.s14(tmp0_desc, 7, value.r7z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.s7z_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.s7z_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.b99(encoder, value instanceof ScopeView() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.a99_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = 0.0;
        var tmp9_local5 = false;
        var tmp10_local6 = null;
        var tmp11_local7 = false;
        var tmp12_local8 = null;
        var tmp13_input = decoder.l13(tmp0_desc);
        var tmp14_cached = Companion_getInstance_50().f7z_1;
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.t13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.n13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, tmp14_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.n13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.x13(tmp0_desc, 8, tmp14_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.t13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.n13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, tmp14_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.n13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.x13(tmp0_desc, 8, tmp14_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return ScopeView().c99(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.a99_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_50().f7z_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), DoubleSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[6].f2()), BooleanSerializer_getInstance(), tmp0_cached[8].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_34 = $;
  }
  return $serializerClass_34;
}
var $serializer_instance_34;
function $serializer_getInstance_50() {
  if ($serializer_instance_34 === VOID)
    new ($serializer_34())();
  return $serializer_instance_34;
}
var ScopeViewClass;
function ScopeView() {
  if (ScopeViewClass === VOID) {
    class $ {
      constructor(_id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy) {
        Companion_getInstance_50();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        description = description === VOID ? null : description;
        order = order === VOID ? 0.5 : order;
        scopeSet = scopeSet === VOID ? false : scopeSet;
        parentView = parentView === VOID ? null : parentView;
        fromChangeRequest = fromChangeRequest === VOID ? false : fromChangeRequest;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.k7z_1 = _id;
        this.l7z_1 = project;
        this.m7z_1 = scopeTitle;
        this.n7z_1 = description;
        this.o7z_1 = order;
        this.p7z_1 = scopeSet;
        this.q7z_1 = parentView;
        this.r7z_1 = fromChangeRequest;
        this.s7z_1 = readBy;
      }
      h40() {
        return this.k7z_1;
      }
      d99() {
        return this.m7z_1;
      }
      q91() {
        return this.n7z_1;
      }
      k8v() {
        return this.o7z_1;
      }
      e99() {
        return this.p7z_1;
      }
      f99() {
        return this.q7z_1;
      }
      t91() {
        return this.s7z_1;
      }
      l8v(order) {
        return this.u7z(VOID, VOID, VOID, VOID, order);
      }
      g99(scopeTitle, description, scopeSet, parentView) {
        return this.u7z(this.k7z_1, VOID, scopeTitle, description, VOID, scopeSet, parentView);
      }
      h99(parentView) {
        return new (SpecView())(VOID, this.m7z_1, this.n7z_1, this.p7z_1, parentView);
      }
      i99(parentView, $super) {
        parentView = parentView === VOID ? null : parentView;
        return $super === VOID ? this.h99(parentView) : $super.h99.call(this, parentView);
      }
      j99(_id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy) {
        return new (ScopeView())(_id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy);
      }
      u7z(_id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy, $super) {
        _id = _id === VOID ? this.k7z_1 : _id;
        project = project === VOID ? this.l7z_1 : project;
        scopeTitle = scopeTitle === VOID ? this.m7z_1 : scopeTitle;
        description = description === VOID ? this.n7z_1 : description;
        order = order === VOID ? this.o7z_1 : order;
        scopeSet = scopeSet === VOID ? this.p7z_1 : scopeSet;
        parentView = parentView === VOID ? this.q7z_1 : parentView;
        fromChangeRequest = fromChangeRequest === VOID ? this.r7z_1 : fromChangeRequest;
        readBy = readBy === VOID ? this.s7z_1 : readBy;
        return $super === VOID ? this.j99(_id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy) : $super.j99.call(this, _id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy);
      }
      toString() {
        return 'ScopeView(_id=' + this.k7z_1.toString() + ', project=' + this.l7z_1.toString() + ', scopeTitle=' + this.m7z_1 + ', description=' + this.n7z_1 + ', order=' + this.o7z_1 + ', scopeSet=' + this.p7z_1 + ', parentView=' + toString_0(this.q7z_1) + ', fromChangeRequest=' + this.r7z_1 + ', readBy=' + toString(this.s7z_1) + ')';
      }
      hashCode() {
        var result = this.k7z_1.hashCode();
        result = imul(result, 31) + this.l7z_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.m7z_1) | 0;
        result = imul(result, 31) + (this.n7z_1 == null ? 0 : getStringHashCode(this.n7z_1)) | 0;
        result = imul(result, 31) + getNumberHashCode(this.o7z_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.p7z_1) | 0;
        result = imul(result, 31) + (this.q7z_1 == null ? 0 : this.q7z_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.r7z_1) | 0;
        result = imul(result, 31) + hashCode(this.s7z_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ScopeView()))
          return false;
        if (!this.k7z_1.equals(other.k7z_1))
          return false;
        if (!this.l7z_1.equals(other.l7z_1))
          return false;
        if (!(this.m7z_1 === other.m7z_1))
          return false;
        if (!(this.n7z_1 == other.n7z_1))
          return false;
        if (!equals(this.o7z_1, other.o7z_1))
          return false;
        if (!(this.p7z_1 === other.p7z_1))
          return false;
        if (!equals(this.q7z_1, other.q7z_1))
          return false;
        if (!(this.r7z_1 === other.r7z_1))
          return false;
        if (!equals(this.s7z_1, other.s7z_1))
          return false;
        return true;
      }
      static c99(seen0, _id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy, serializationConstructorMarker) {
        Companion_getInstance_50();
        if (!(6 === (6 & seen0))) {
          throwMissingFieldException(seen0, 6, $serializer_getInstance_50().a99_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.k7z_1 = Companion_getInstance().m2p();
        else
          $this.k7z_1 = _id;
        $this.l7z_1 = project;
        $this.m7z_1 = scopeTitle;
        if (0 === (seen0 & 8))
          $this.n7z_1 = null;
        else
          $this.n7z_1 = description;
        if (0 === (seen0 & 16))
          $this.o7z_1 = 0.5;
        else
          $this.o7z_1 = order;
        if (0 === (seen0 & 32))
          $this.p7z_1 = false;
        else
          $this.p7z_1 = scopeSet;
        if (0 === (seen0 & 64))
          $this.q7z_1 = null;
        else
          $this.q7z_1 = parentView;
        if (0 === (seen0 & 128))
          $this.r7z_1 = false;
        else
          $this.r7z_1 = fromChangeRequest;
        if (0 === (seen0 & 256))
          $this.s7z_1 = emptySet();
        else
          $this.s7z_1 = readBy;
        return $this;
      }
      d(other) {
        return this.m8v(other instanceof ScopeView() ? other : THROW_CCE());
      }
    }
    protoOf($).e80 = copy$default;
    protoOf($).m8v = compareTo;
    initMetadataForClass($, 'ScopeView', VOID, VOID, [HasId(), ScopeGroup(), ReadByDataModel(), Reorderable()], VOID, VOID, {0: $serializer_getInstance_50});
    ScopeViewClass = $;
  }
  return ScopeViewClass;
}
function Specification$Companion$$childSerializers$_anonymous__4x7813() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Specification$Companion$$childSerializers$_anonymous__4x7813_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Specification$Companion$$childSerializers$_anonymous__4x7813_1() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function Specification$Companion$$childSerializers$_anonymous__4x7813_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_37;
function Companion_37() {
  if (CompanionClass_37 === VOID) {
    class $ {
      constructor() {
        Companion_instance_39 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Specification$Companion$$childSerializers$_anonymous__4x7813);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Specification$Companion$$childSerializers$_anonymous__4x7813_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, Specification$Companion$$childSerializers$_anonymous__4x7813_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.p83_1 = [tmp_1, tmp_3, null, null, null, null, null, tmp_5, lazy(tmp_6, Specification$Companion$$childSerializers$_anonymous__4x7813_2)];
      }
      m2a() {
        return $serializer_getInstance_51();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_37 = $;
  }
  return CompanionClass_37;
}
var Companion_instance_39;
function Companion_getInstance_51() {
  if (Companion_instance_39 === VOID)
    new (Companion_37())();
  return Companion_instance_39;
}
var $serializerClass_35;
function $serializer_35() {
  if ($serializerClass_35 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_35 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Specification', this, 9);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('contractor', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.c1b('group', true);
        tmp0_serialDesc.c1b('title', true);
        tmp0_serialDesc.c1b('description', true);
        tmp0_serialDesc.c1b('price', true);
        tmp0_serialDesc.c1b('unit', true);
        tmp0_serialDesc.c1b('files', true);
        tmp0_serialDesc.c1b('readBy', true);
        this.k99_1 = tmp0_serialDesc;
      }
      l99(encoder, value) {
        var tmp0_desc = this.k99_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_51().p83_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.u83_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.u83_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.v83_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.w83_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, $serializer_getInstance_11(), value.w83_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.x83_1 === '')) {
          tmp1_output.a15(tmp0_desc, 3, value.x83_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.y83_1 === '')) {
          tmp1_output.a15(tmp0_desc, 4, value.y83_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          var tmp_0 = value.z83_1;
          tmp = !((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_2();
          var tmp_2 = value.z83_1;
          tmp1_output.d15(tmp0_desc, 5, tmp_1, tmp_2 == null ? null : new (MonetaryValue())(tmp_2));
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.a84_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, StringSerializer_getInstance(), value.a84_1);
        }
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 7)) {
          tmp_3 = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp_3 = !equals(value.b84_1, tmp$ret$0);
        }
        if (tmp_3) {
          tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.b84_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.c84_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.c84_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.l99(encoder, value instanceof Specification() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k99_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_input = decoder.l13(tmp0_desc);
        var tmp14_cached = Companion_getInstance_51().p83_1;
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.z13(tmp0_desc, 2, $serializer_getInstance_11(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp13_input.z13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.x13(tmp0_desc, 7, tmp14_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.x13(tmp0_desc, 8, tmp14_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.z13(tmp0_desc, 2, $serializer_getInstance_11(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp9_local5;
                var tmp_4 = tmp13_input.z13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp9_local5 = tmp_4 == null ? null : tmp_4.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.x13(tmp0_desc, 7, tmp14_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.x13(tmp0_desc, 8, tmp14_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return Specification().m99(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.k99_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_51().p83_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable($serializer_getInstance_11()), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance_2()), get_nullable(StringSerializer_getInstance()), tmp0_cached[7].f2(), tmp0_cached[8].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_35 = $;
  }
  return $serializerClass_35;
}
var $serializer_instance_35;
function $serializer_getInstance_51() {
  if ($serializer_instance_35 === VOID)
    new ($serializer_35())();
  return $serializer_instance_35;
}
var SpecificationClass;
function Specification() {
  if (SpecificationClass === VOID) {
    class $ {
      constructor(_id, contractor, group, title, description, price, unit, files, readBy) {
        Companion_getInstance_51();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        group = group === VOID ? null : group;
        title = title === VOID ? '' : title;
        description = description === VOID ? '' : description;
        price = price === VOID ? null : price;
        unit = unit === VOID ? null : unit;
        var tmp;
        if (files === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = files;
        }
        files = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.u83_1 = _id;
        this.v83_1 = contractor;
        this.w83_1 = group;
        this.x83_1 = title;
        this.y83_1 = description;
        this.z83_1 = price;
        this.a84_1 = unit;
        this.b84_1 = files;
        this.c84_1 = readBy;
      }
      h40() {
        return this.u83_1;
      }
      t91() {
        return this.c84_1;
      }
      n99(project, scopeView, scopeSet) {
        var tmp;
        // Inline function 'kotlin.text.isNullOrBlank' call
        var this_0 = this.a84_1;
        if (this_0 == null || isBlank(this_0)) {
          tmp = '';
        } else {
          tmp = ' (1 ' + this.a84_1 + ')';
        }
        var tmp3_name = this.x83_1 + tmp;
        var tmp4_description = this.y83_1;
        var tmp0_elvis_lhs = this.z83_1;
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = _MonetaryValue___init__impl__jsc11x(0n);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp5_originalPrice = tmp_0;
        var tmp6_scopeView = scopeView == null ? null : scopeView.k7z_1;
        var tmp7_scopeSet = scopeSet == null ? null : scopeSet.k7z_1;
        var tmp8_files = this.b84_1;
        return new (LineItem())(VOID, project, VOID, tmp6_scopeView, tmp7_scopeSet, tmp3_name, tmp4_description, tmp5_originalPrice, VOID, tmp8_files);
      }
      o99(_id, contractor, group, title, description, price, unit, files, readBy) {
        return new (Specification())(_id, contractor, group, title, description, price, unit, files, readBy);
      }
      e84(_id, contractor, group, title, description, price, unit, files, readBy, $super) {
        _id = _id === VOID ? this.u83_1 : _id;
        contractor = contractor === VOID ? this.v83_1 : contractor;
        group = group === VOID ? this.w83_1 : group;
        title = title === VOID ? this.x83_1 : title;
        description = description === VOID ? this.y83_1 : description;
        price = price === VOID ? this.z83_1 : price;
        unit = unit === VOID ? this.a84_1 : unit;
        files = files === VOID ? this.b84_1 : files;
        readBy = readBy === VOID ? this.c84_1 : readBy;
        var tmp;
        if ($super === VOID) {
          tmp = this.o99(_id, contractor, group, title, description, price, unit, files, readBy);
        } else {
          var tmp_0 = $super.o99;
          var tmp_1 = price;
          tmp = tmp_0.call(this, _id, contractor, group, title, description, tmp_1 == null ? null : new (MonetaryValue())(tmp_1), unit, files, readBy);
        }
        return tmp;
      }
      toString() {
        var tmp = this.u83_1.toString();
        var tmp_0 = this.v83_1.toString();
        var tmp_1 = toString_0(this.w83_1);
        var tmp_2 = this.z83_1;
        return 'Specification(_id=' + tmp + ', contractor=' + tmp_0 + ', group=' + tmp_1 + ', title=' + this.x83_1 + ', description=' + this.y83_1 + ', price=' + toString_0(tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) + ', unit=' + this.a84_1 + ', files=' + toString(this.b84_1) + ', readBy=' + toString(this.c84_1) + ')';
      }
      hashCode() {
        var result = this.u83_1.hashCode();
        result = imul(result, 31) + this.v83_1.hashCode() | 0;
        result = imul(result, 31) + (this.w83_1 == null ? 0 : this.w83_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.x83_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y83_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.z83_1;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = MonetaryValue__hashCode_impl_fhcsz2(this.z83_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + (this.a84_1 == null ? 0 : getStringHashCode(this.a84_1)) | 0;
        result = imul(result, 31) + hashCode(this.b84_1) | 0;
        result = imul(result, 31) + hashCode(this.c84_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Specification()))
          return false;
        if (!this.u83_1.equals(other.u83_1))
          return false;
        if (!this.v83_1.equals(other.v83_1))
          return false;
        if (!equals(this.w83_1, other.w83_1))
          return false;
        if (!(this.x83_1 === other.x83_1))
          return false;
        if (!(this.y83_1 === other.y83_1))
          return false;
        var tmp = this.z83_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.z83_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        if (!(this.a84_1 == other.a84_1))
          return false;
        if (!equals(this.b84_1, other.b84_1))
          return false;
        if (!equals(this.c84_1, other.c84_1))
          return false;
        return true;
      }
      static m99(seen0, _id, contractor, group, title, description, price, unit, files, readBy, serializationConstructorMarker) {
        Companion_getInstance_51();
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_51().k99_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.u83_1 = Companion_getInstance().m2p();
        else
          $this.u83_1 = _id;
        $this.v83_1 = contractor;
        if (0 === (seen0 & 4))
          $this.w83_1 = null;
        else
          $this.w83_1 = group;
        if (0 === (seen0 & 8))
          $this.x83_1 = '';
        else
          $this.x83_1 = title;
        if (0 === (seen0 & 16))
          $this.y83_1 = '';
        else
          $this.y83_1 = description;
        if (0 === (seen0 & 32))
          $this.z83_1 = null;
        else
          $this.z83_1 = price;
        if (0 === (seen0 & 64))
          $this.a84_1 = null;
        else
          $this.a84_1 = unit;
        if (0 === (seen0 & 128)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.b84_1 = emptyList();
        } else
          $this.b84_1 = files;
        if (0 === (seen0 & 256))
          $this.c84_1 = emptySet();
        else
          $this.c84_1 = readBy;
        return $this;
      }
    }
    initMetadataForClass($, 'Specification', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_51});
    SpecificationClass = $;
  }
  return SpecificationClass;
}
var CompanionClass_38;
function Companion_38() {
  if (CompanionClass_38 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_52();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_38 = $;
  }
  return CompanionClass_38;
}
var Companion_instance_40;
function Companion_getInstance_52() {
  return Companion_instance_40;
}
var $serializerClass_36;
function $serializer_36() {
  if ($serializerClass_36 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_36 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Trade', this, 1);
        tmp0_serialDesc.c1b('_id', false);
        this.p99_1 = tmp0_serialDesc;
      }
      q99(encoder, value) {
        var tmp0_desc = this.p99_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.e86_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.q99(encoder, value instanceof Trade() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.p99_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return Trade().r99(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.p99_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_36 = $;
  }
  return $serializerClass_36;
}
var $serializer_instance_36;
function $serializer_getInstance_52() {
  if ($serializer_instance_36 === VOID)
    new ($serializer_36())();
  return $serializer_instance_36;
}
var TradeClass;
function Trade() {
  if (TradeClass === VOID) {
    class $ {
      constructor(_id) {
        this.e86_1 = _id;
      }
      h40() {
        return this.e86_1;
      }
      p5z(_id) {
        return new (Trade())(_id);
      }
      toString() {
        return 'Trade(_id=' + this.e86_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.e86_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Trade()))
          return false;
        if (!(this.e86_1 === other.e86_1))
          return false;
        return true;
      }
      static r99(seen0, _id, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_52().p99_1);
        }
        var $this = createThis(this);
        $this.e86_1 = _id;
        return $this;
      }
    }
    initMetadataForClass($, 'Trade', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_52});
    TradeClass = $;
  }
  return TradeClass;
}
function UnlockProjectRequest$Companion$$childSerializers$_anonymous__eqe1dc() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function UnlockProjectRequest$Companion$$childSerializers$_anonymous__eqe1dc_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function UnlockProjectRequest$Companion$$childSerializers$_anonymous__eqe1dc_1() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
var CompanionClass_39;
function Companion_39() {
  if (CompanionClass_39 === VOID) {
    class $ {
      constructor() {
        Companion_instance_41 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, UnlockProjectRequest$Companion$$childSerializers$_anonymous__eqe1dc);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, UnlockProjectRequest$Companion$$childSerializers$_anonymous__eqe1dc_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.g86_1 = [tmp_1, tmp_3, null, null, null, null, lazy(tmp_4, UnlockProjectRequest$Companion$$childSerializers$_anonymous__eqe1dc_1), null];
      }
      m2a() {
        return $serializer_getInstance_53();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_39 = $;
  }
  return CompanionClass_39;
}
var Companion_instance_41;
function Companion_getInstance_53() {
  if (Companion_instance_41 === VOID)
    new (Companion_39())();
  return Companion_instance_41;
}
var $serializerClass_37;
function $serializer_37() {
  if ($serializerClass_37 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_37 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.UnlockProjectRequest', this, 8);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.c1b('lock', false);
        tmp0_serialDesc.c1b('submitted', false);
        tmp0_serialDesc.c1b('submittedByClient', false);
        tmp0_serialDesc.c1b('message', false);
        tmp0_serialDesc.c1b('attachments', false);
        tmp0_serialDesc.c1b('accepted', true);
        this.s99_1 = tmp0_serialDesc;
      }
      t99(encoder, value) {
        var tmp0_desc = this.s99_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_53().g86_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.l86_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.l86_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.m86_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance_42(), value.n86_1);
        tmp1_output.c15(tmp0_desc, 3, $serializer_getInstance_4(), value.o86_1);
        tmp1_output.s14(tmp0_desc, 4, value.p86_1);
        tmp1_output.a15(tmp0_desc, 5, value.q86_1);
        tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.r86_1);
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.s86_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, $serializer_getInstance_4(), value.s86_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.t99(encoder, value instanceof UnlockProjectRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.s99_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = false;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.l13(tmp0_desc);
        var tmp13_cached = Companion_getInstance_53().g86_1;
        if (tmp12_input.a14()) {
          tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.x13(tmp0_desc, 2, $serializer_getInstance_42(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.x13(tmp0_desc, 3, $serializer_getInstance_4(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.n13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.x13(tmp0_desc, 6, tmp13_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.x13(tmp0_desc, 2, $serializer_getInstance_42(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.x13(tmp0_desc, 3, $serializer_getInstance_4(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.n13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.x13(tmp0_desc, 6, tmp13_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp12_input.m13(tmp0_desc);
        return UnlockProjectRequest().u99(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      az() {
        return this.s99_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_53().g86_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), $serializer_getInstance_42(), $serializer_getInstance_4(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[6].f2(), get_nullable($serializer_getInstance_4())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_37 = $;
  }
  return $serializerClass_37;
}
var $serializer_instance_37;
function $serializer_getInstance_53() {
  if ($serializer_instance_37 === VOID)
    new ($serializer_37())();
  return $serializer_instance_37;
}
var UnlockProjectRequestClass;
function UnlockProjectRequest() {
  if (UnlockProjectRequestClass === VOID) {
    class $ {
      constructor(_id, project, lock, submitted, submittedByClient, message, attachments, accepted) {
        Companion_getInstance_53();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        accepted = accepted === VOID ? null : accepted;
        this.l86_1 = _id;
        this.m86_1 = project;
        this.n86_1 = lock;
        this.o86_1 = submitted;
        this.p86_1 = submittedByClient;
        this.q86_1 = message;
        this.r86_1 = attachments;
        this.s86_1 = accepted;
      }
      h40() {
        return this.l86_1;
      }
      v99(_id, project, lock, submitted, submittedByClient, message, attachments, accepted) {
        return new (UnlockProjectRequest())(_id, project, lock, submitted, submittedByClient, message, attachments, accepted);
      }
      u86(_id, project, lock, submitted, submittedByClient, message, attachments, accepted, $super) {
        _id = _id === VOID ? this.l86_1 : _id;
        project = project === VOID ? this.m86_1 : project;
        lock = lock === VOID ? this.n86_1 : lock;
        submitted = submitted === VOID ? this.o86_1 : submitted;
        submittedByClient = submittedByClient === VOID ? this.p86_1 : submittedByClient;
        message = message === VOID ? this.q86_1 : message;
        attachments = attachments === VOID ? this.r86_1 : attachments;
        accepted = accepted === VOID ? this.s86_1 : accepted;
        return $super === VOID ? this.v99(_id, project, lock, submitted, submittedByClient, message, attachments, accepted) : $super.v99.call(this, _id, project, lock, submitted, submittedByClient, message, attachments, accepted);
      }
      toString() {
        return 'UnlockProjectRequest(_id=' + this.l86_1.toString() + ', project=' + this.m86_1.toString() + ', lock=' + this.n86_1.toString() + ', submitted=' + this.o86_1.toString() + ', submittedByClient=' + this.p86_1 + ', message=' + this.q86_1 + ', attachments=' + toString(this.r86_1) + ', accepted=' + toString_0(this.s86_1) + ')';
      }
      hashCode() {
        var result = this.l86_1.hashCode();
        result = imul(result, 31) + this.m86_1.hashCode() | 0;
        result = imul(result, 31) + this.n86_1.hashCode() | 0;
        result = imul(result, 31) + this.o86_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.p86_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q86_1) | 0;
        result = imul(result, 31) + hashCode(this.r86_1) | 0;
        result = imul(result, 31) + (this.s86_1 == null ? 0 : this.s86_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UnlockProjectRequest()))
          return false;
        if (!this.l86_1.equals(other.l86_1))
          return false;
        if (!this.m86_1.equals(other.m86_1))
          return false;
        if (!this.n86_1.equals(other.n86_1))
          return false;
        if (!this.o86_1.equals(other.o86_1))
          return false;
        if (!(this.p86_1 === other.p86_1))
          return false;
        if (!(this.q86_1 === other.q86_1))
          return false;
        if (!equals(this.r86_1, other.r86_1))
          return false;
        if (!equals(this.s86_1, other.s86_1))
          return false;
        return true;
      }
      static u99(seen0, _id, project, lock, submitted, submittedByClient, message, attachments, accepted, serializationConstructorMarker) {
        Companion_getInstance_53();
        if (!(126 === (126 & seen0))) {
          throwMissingFieldException(seen0, 126, $serializer_getInstance_53().s99_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.l86_1 = Companion_getInstance().m2p();
        else
          $this.l86_1 = _id;
        $this.m86_1 = project;
        $this.n86_1 = lock;
        $this.o86_1 = submitted;
        $this.p86_1 = submittedByClient;
        $this.q86_1 = message;
        $this.r86_1 = attachments;
        if (0 === (seen0 & 128))
          $this.s86_1 = null;
        else
          $this.s86_1 = accepted;
        return $this;
      }
    }
    initMetadataForClass($, 'UnlockProjectRequest', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_53});
    UnlockProjectRequestClass = $;
  }
  return UnlockProjectRequestClass;
}
function User$Companion$$childSerializers$_anonymous__6nf9sv() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function User$Companion$$childSerializers$_anonymous__6nf9sv_0() {
  return new (ArrayListSerializer())(StringSerializer_getInstance());
}
function User$Companion$$childSerializers$_anonymous__6nf9sv_1() {
  return Companion_getInstance_10().m2a();
}
function User$Companion$$childSerializers$_anonymous__6nf9sv_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (ArrayListSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function User$Companion$$childSerializers$_anonymous__6nf9sv_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_40;
function Companion_40() {
  if (CompanionClass_40 === VOID) {
    class $ {
      constructor() {
        Companion_instance_42 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, User$Companion$$childSerializers$_anonymous__6nf9sv);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, User$Companion$$childSerializers$_anonymous__6nf9sv_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, User$Companion$$childSerializers$_anonymous__6nf9sv_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, User$Companion$$childSerializers$_anonymous__6nf9sv_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.a88_1 = [tmp_1, null, null, tmp_3, null, null, null, null, null, tmp_5, null, null, null, null, null, tmp_7, lazy(tmp_8, User$Companion$$childSerializers$_anonymous__6nf9sv_3)];
      }
      m2a() {
        return $serializer_getInstance_54();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_40 = $;
  }
  return CompanionClass_40;
}
var Companion_instance_42;
function Companion_getInstance_54() {
  if (Companion_instance_42 === VOID)
    new (Companion_40())();
  return Companion_instance_42;
}
var $serializerClass_38;
function $serializer_38() {
  if ($serializerClass_38 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_38 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.User', this, 17);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('email', false);
        tmp0_serialDesc.d1b(new (Unique())());
        tmp0_serialDesc.c1b('phoneNumber', false);
        tmp0_serialDesc.c1b('fcmTokens', true);
        tmp0_serialDesc.c1b('firstName', false);
        tmp0_serialDesc.c1b('lastName', false);
        tmp0_serialDesc.c1b('address', false);
        tmp0_serialDesc.c1b('membership', true);
        tmp0_serialDesc.c1b('paymentId', true);
        tmp0_serialDesc.c1b('role', false);
        tmp0_serialDesc.c1b('receivesNewContractorEmails', true);
        tmp0_serialDesc.c1b('mfaEnabled', true);
        tmp0_serialDesc.c1b('phoneVerified', true);
        tmp0_serialDesc.c1b('hasPaymentMethods', true);
        tmp0_serialDesc.d1b(new (Denormalized())());
        tmp0_serialDesc.c1b('sendNotifications', true);
        tmp0_serialDesc.c1b('viewingAnonymousProjects', true);
        tmp0_serialDesc.c1b('created', true);
        this.w99_1 = tmp0_serialDesc;
      }
      x99(encoder, value) {
        var tmp0_desc = this.w99_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_54().a88_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.f88_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.f88_1);
        }
        tmp1_output.c15(tmp0_desc, 1, EmailAddressSerializer_getInstance(), new (EmailAddress())(value.g88_1));
        tmp1_output.c15(tmp0_desc, 2, PhoneNumberSerializer_getInstance(), new (PhoneNumber())(value.h88_1));
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !equals(value.i88_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.i88_1);
        }
        tmp1_output.a15(tmp0_desc, 4, value.j88_1);
        tmp1_output.a15(tmp0_desc, 5, value.k88_1);
        tmp1_output.c15(tmp0_desc, 6, $serializer_getInstance_5(), value.l88_1);
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.m88_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, $serializer_getInstance_12(), value.m88_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.n88_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, StringSerializer_getInstance(), value.n88_1);
        }
        tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.o88_1);
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.p88_1 === false)) {
          tmp1_output.s14(tmp0_desc, 10, value.p88_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.q88_1 === false)) {
          tmp1_output.s14(tmp0_desc, 11, value.q88_1);
        }
        if (tmp1_output.h15(tmp0_desc, 12) ? true : !(value.r88_1 === false)) {
          tmp1_output.s14(tmp0_desc, 12, value.r88_1);
        }
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !(value.s88_1 === false)) {
          tmp1_output.s14(tmp0_desc, 13, value.s88_1);
        }
        if (tmp1_output.h15(tmp0_desc, 14) ? true : !(value.t88_1 === true)) {
          tmp1_output.s14(tmp0_desc, 14, value.t88_1);
        }
        if (tmp1_output.h15(tmp0_desc, 15) ? true : !equals(value.u88_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 15, tmp2_cached[15].f2(), value.u88_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 16)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).d1m();
          tmp = !value.v88_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 16, tmp2_cached[16].f2(), value.v88_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.x99(encoder, value instanceof User() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.w99_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = false;
        var tmp15_local11 = false;
        var tmp16_local12 = false;
        var tmp17_local13 = false;
        var tmp18_local14 = false;
        var tmp19_local15 = null;
        var tmp20_local16 = null;
        var tmp21_input = decoder.l13(tmp0_desc);
        var tmp22_cached = Companion_getInstance_54().a88_1;
        if (tmp21_input.a14()) {
          tmp4_local0 = tmp21_input.x13(tmp0_desc, 0, tmp22_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = EmailAddressSerializer_getInstance();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp21_input.x13(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (EmailAddress())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.c3n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_2 = PhoneNumberSerializer_getInstance();
          var tmp_3 = tmp6_local2;
          var tmp_4 = tmp21_input.x13(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new (PhoneNumber())(tmp_3));
          tmp6_local2 = tmp_4 == null ? null : tmp_4.h3n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp21_input.x13(tmp0_desc, 3, tmp22_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp21_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp21_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp21_input.x13(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp21_input.z13(tmp0_desc, 7, $serializer_getInstance_12(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp21_input.z13(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp21_input.x13(tmp0_desc, 9, tmp22_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp21_input.n13(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp21_input.n13(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp21_input.n13(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp21_input.n13(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp21_input.n13(tmp0_desc, 14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp21_input.x13(tmp0_desc, 15, tmp22_cached[15].f2(), tmp19_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          tmp20_local16 = tmp21_input.x13(tmp0_desc, 16, tmp22_cached[16].f2(), tmp20_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp21_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp21_input.x13(tmp0_desc, 0, tmp22_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_5 = EmailAddressSerializer_getInstance();
                var tmp_6 = tmp5_local1;
                var tmp_7 = tmp21_input.x13(tmp0_desc, 1, tmp_5, tmp_6 == null ? null : new (EmailAddress())(tmp_6));
                tmp5_local1 = tmp_7 == null ? null : tmp_7.c3n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_8 = PhoneNumberSerializer_getInstance();
                var tmp_9 = tmp6_local2;
                var tmp_10 = tmp21_input.x13(tmp0_desc, 2, tmp_8, tmp_9 == null ? null : new (PhoneNumber())(tmp_9));
                tmp6_local2 = tmp_10 == null ? null : tmp_10.h3n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp21_input.x13(tmp0_desc, 3, tmp22_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp21_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp21_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp21_input.x13(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp21_input.z13(tmp0_desc, 7, $serializer_getInstance_12(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp21_input.z13(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp21_input.x13(tmp0_desc, 9, tmp22_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp21_input.n13(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp21_input.n13(tmp0_desc, 11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp21_input.n13(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp21_input.n13(tmp0_desc, 13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp21_input.n13(tmp0_desc, 14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp21_input.x13(tmp0_desc, 15, tmp22_cached[15].f2(), tmp19_local15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              case 16:
                tmp20_local16 = tmp21_input.x13(tmp0_desc, 16, tmp22_cached[16].f2(), tmp20_local16);
                tmp3_bitMask0 = tmp3_bitMask0 | 65536;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp21_input.m13(tmp0_desc);
        return User().y99(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, null);
      }
      az() {
        return this.w99_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_54().a88_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), EmailAddressSerializer_getInstance(), PhoneNumberSerializer_getInstance(), tmp0_cached[3].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_5(), get_nullable($serializer_getInstance_12()), get_nullable(StringSerializer_getInstance()), tmp0_cached[9].f2(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[15].f2(), tmp0_cached[16].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_38 = $;
  }
  return $serializerClass_38;
}
var $serializer_instance_38;
function $serializer_getInstance_54() {
  if ($serializer_instance_38 === VOID)
    new ($serializer_38())();
  return $serializer_instance_38;
}
var UserClass;
function User() {
  if (UserClass === VOID) {
    class $ {
      constructor(_id, email, phoneNumber, fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created) {
        Companion_getInstance_54();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        fcmTokens = fcmTokens === VOID ? emptyList() : fcmTokens;
        membership = membership === VOID ? null : membership;
        paymentId = paymentId === VOID ? null : paymentId;
        receivesNewContractorEmails = receivesNewContractorEmails === VOID ? false : receivesNewContractorEmails;
        mfaEnabled = mfaEnabled === VOID ? false : mfaEnabled;
        phoneVerified = phoneVerified === VOID ? false : phoneVerified;
        hasPaymentMethods = hasPaymentMethods === VOID ? false : hasPaymentMethods;
        sendNotifications = sendNotifications === VOID ? true : sendNotifications;
        viewingAnonymousProjects = viewingAnonymousProjects === VOID ? emptyList() : viewingAnonymousProjects;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).d1m();
        } else {
          tmp = created;
        }
        created = tmp;
        this.f88_1 = _id;
        this.g88_1 = email;
        this.h88_1 = phoneNumber;
        this.i88_1 = fcmTokens;
        this.j88_1 = firstName;
        this.k88_1 = lastName;
        this.l88_1 = address;
        this.m88_1 = membership;
        this.n88_1 = paymentId;
        this.o88_1 = role;
        this.p88_1 = receivesNewContractorEmails;
        this.q88_1 = mfaEnabled;
        this.r88_1 = phoneVerified;
        this.s88_1 = hasPaymentMethods;
        this.t88_1 = sendNotifications;
        this.u88_1 = viewingAnonymousProjects;
        this.v88_1 = created;
      }
      h40() {
        return this.f88_1;
      }
      z99(_id, email, phoneNumber, fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created) {
        return new (User())(_id, email, phoneNumber, fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created);
      }
      x88(_id, email, phoneNumber, fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created, $super) {
        _id = _id === VOID ? this.f88_1 : _id;
        email = email === VOID ? this.g88_1 : email;
        phoneNumber = phoneNumber === VOID ? this.h88_1 : phoneNumber;
        fcmTokens = fcmTokens === VOID ? this.i88_1 : fcmTokens;
        firstName = firstName === VOID ? this.j88_1 : firstName;
        lastName = lastName === VOID ? this.k88_1 : lastName;
        address = address === VOID ? this.l88_1 : address;
        membership = membership === VOID ? this.m88_1 : membership;
        paymentId = paymentId === VOID ? this.n88_1 : paymentId;
        role = role === VOID ? this.o88_1 : role;
        receivesNewContractorEmails = receivesNewContractorEmails === VOID ? this.p88_1 : receivesNewContractorEmails;
        mfaEnabled = mfaEnabled === VOID ? this.q88_1 : mfaEnabled;
        phoneVerified = phoneVerified === VOID ? this.r88_1 : phoneVerified;
        hasPaymentMethods = hasPaymentMethods === VOID ? this.s88_1 : hasPaymentMethods;
        sendNotifications = sendNotifications === VOID ? this.t88_1 : sendNotifications;
        viewingAnonymousProjects = viewingAnonymousProjects === VOID ? this.u88_1 : viewingAnonymousProjects;
        created = created === VOID ? this.v88_1 : created;
        return $super === VOID ? this.z99(_id, email, phoneNumber, fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created) : $super.z99.call(this, _id, new (EmailAddress())(email), new (PhoneNumber())(phoneNumber), fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created);
      }
      toString() {
        return 'User(_id=' + this.f88_1.toString() + ', email=' + EmailAddress__toString_impl_artjh3(this.g88_1) + ', phoneNumber=' + PhoneNumber__toString_impl_7i2x3q(this.h88_1) + ', fcmTokens=' + toString(this.i88_1) + ', firstName=' + this.j88_1 + ', lastName=' + this.k88_1 + ', address=' + this.l88_1.toString() + ', membership=' + toString_0(this.m88_1) + ', paymentId=' + this.n88_1 + ', role=' + this.o88_1.toString() + ', receivesNewContractorEmails=' + this.p88_1 + ', mfaEnabled=' + this.q88_1 + ', phoneVerified=' + this.r88_1 + ', hasPaymentMethods=' + this.s88_1 + ', sendNotifications=' + this.t88_1 + ', viewingAnonymousProjects=' + toString(this.u88_1) + ', created=' + this.v88_1.toString() + ')';
      }
      hashCode() {
        var result = this.f88_1.hashCode();
        result = imul(result, 31) + EmailAddress__hashCode_impl_wizg9y(this.g88_1) | 0;
        result = imul(result, 31) + PhoneNumber__hashCode_impl_t98twl(this.h88_1) | 0;
        result = imul(result, 31) + hashCode(this.i88_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j88_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.k88_1) | 0;
        result = imul(result, 31) + this.l88_1.hashCode() | 0;
        result = imul(result, 31) + (this.m88_1 == null ? 0 : this.m88_1.hashCode()) | 0;
        result = imul(result, 31) + (this.n88_1 == null ? 0 : getStringHashCode(this.n88_1)) | 0;
        result = imul(result, 31) + this.o88_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.p88_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.q88_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.r88_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.s88_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.t88_1) | 0;
        result = imul(result, 31) + hashCode(this.u88_1) | 0;
        result = imul(result, 31) + this.v88_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof User()))
          return false;
        if (!this.f88_1.equals(other.f88_1))
          return false;
        if (!(this.g88_1 === other.g88_1))
          return false;
        if (!(this.h88_1 === other.h88_1))
          return false;
        if (!equals(this.i88_1, other.i88_1))
          return false;
        if (!(this.j88_1 === other.j88_1))
          return false;
        if (!(this.k88_1 === other.k88_1))
          return false;
        if (!this.l88_1.equals(other.l88_1))
          return false;
        if (!equals(this.m88_1, other.m88_1))
          return false;
        if (!(this.n88_1 == other.n88_1))
          return false;
        if (!this.o88_1.equals(other.o88_1))
          return false;
        if (!(this.p88_1 === other.p88_1))
          return false;
        if (!(this.q88_1 === other.q88_1))
          return false;
        if (!(this.r88_1 === other.r88_1))
          return false;
        if (!(this.s88_1 === other.s88_1))
          return false;
        if (!(this.t88_1 === other.t88_1))
          return false;
        if (!equals(this.u88_1, other.u88_1))
          return false;
        if (!this.v88_1.equals(other.v88_1))
          return false;
        return true;
      }
      static y99(seen0, _id, email, phoneNumber, fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created, serializationConstructorMarker) {
        Companion_getInstance_54();
        if (!(630 === (630 & seen0))) {
          throwMissingFieldException(seen0, 630, $serializer_getInstance_54().w99_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.f88_1 = Companion_getInstance().m2p();
        else
          $this.f88_1 = _id;
        $this.g88_1 = email;
        $this.h88_1 = phoneNumber;
        if (0 === (seen0 & 8))
          $this.i88_1 = emptyList();
        else
          $this.i88_1 = fcmTokens;
        $this.j88_1 = firstName;
        $this.k88_1 = lastName;
        $this.l88_1 = address;
        if (0 === (seen0 & 128))
          $this.m88_1 = null;
        else
          $this.m88_1 = membership;
        if (0 === (seen0 & 256))
          $this.n88_1 = null;
        else
          $this.n88_1 = paymentId;
        $this.o88_1 = role;
        if (0 === (seen0 & 1024))
          $this.p88_1 = false;
        else
          $this.p88_1 = receivesNewContractorEmails;
        if (0 === (seen0 & 2048))
          $this.q88_1 = false;
        else
          $this.q88_1 = mfaEnabled;
        if (0 === (seen0 & 4096))
          $this.r88_1 = false;
        else
          $this.r88_1 = phoneVerified;
        if (0 === (seen0 & 8192))
          $this.s88_1 = false;
        else
          $this.s88_1 = hasPaymentMethods;
        if (0 === (seen0 & 16384))
          $this.t88_1 = true;
        else
          $this.t88_1 = sendNotifications;
        if (0 === (seen0 & 32768))
          $this.u88_1 = emptyList();
        else
          $this.u88_1 = viewingAnonymousProjects;
        if (0 === (seen0 & 65536)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.v88_1 = get_default(Companion_instance_0).d1m();
        } else
          $this.v88_1 = created;
        return $this;
      }
    }
    initMetadataForClass($, 'User', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_54});
    UserClass = $;
  }
  return UserClass;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.v8r_1.f2();
}
function DisputeState$Companion$_anonymous__16xn8e() {
  return createSimpleEnumSerializer('com.crowpay.DisputeState', values_2());
}
var DisputeState_Ongoing_instance;
var DisputeState_ProjectLocked_instance;
var DisputeState_Resolved_instance;
function values_2() {
  return [DisputeState_Ongoing_getInstance(), DisputeState_ProjectLocked_getInstance(), DisputeState_Resolved_getInstance()];
}
var CompanionClass_41;
function Companion_41() {
  if (CompanionClass_41 === VOID) {
    class $ {
      constructor() {
        Companion_instance_43 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.v8r_1 = lazy(tmp_0, DisputeState$Companion$_anonymous__16xn8e);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj_1(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_41 = $;
  }
  return CompanionClass_41;
}
var Companion_instance_43;
function Companion_getInstance_55() {
  DisputeState_initEntries();
  if (Companion_instance_43 === VOID)
    new (Companion_41())();
  return Companion_instance_43;
}
var DisputeState_entriesInitialized;
function DisputeState_initEntries() {
  if (DisputeState_entriesInitialized)
    return Unit_instance;
  DisputeState_entriesInitialized = true;
  DisputeState_Ongoing_instance = DisputeState().c9a('Ongoing', 0);
  DisputeState_ProjectLocked_instance = DisputeState().c9a('ProjectLocked', 1);
  DisputeState_Resolved_instance = DisputeState().c9a('Resolved', 2);
  Companion_getInstance_55();
}
var DisputeStateClass;
function DisputeState() {
  if (DisputeStateClass === VOID) {
    class $ extends Enum() {
      static c9a(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'DisputeState', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_55});
    DisputeStateClass = $;
  }
  return DisputeStateClass;
}
function MessageReply$Companion$$childSerializers$_anonymous__7g03cp() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_42;
function Companion_42() {
  if (CompanionClass_42 === VOID) {
    class $ {
      constructor() {
        Companion_instance_44 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.w8r_1 = [lazy(tmp_0, MessageReply$Companion$$childSerializers$_anonymous__7g03cp), null];
      }
      m2a() {
        return $serializer_getInstance_55();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_42 = $;
  }
  return CompanionClass_42;
}
var Companion_instance_44;
function Companion_getInstance_56() {
  if (Companion_instance_44 === VOID)
    new (Companion_42())();
  return Companion_instance_44;
}
var $serializerClass_39;
function $serializer_39() {
  if ($serializerClass_39 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_39 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.MessageReply', this, 2);
        tmp0_serialDesc.c1b('id', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(ProjectMessage())));
        tmp0_serialDesc.c1b('message', false);
        this.d9a_1 = tmp0_serialDesc;
      }
      e9a(encoder, value) {
        var tmp0_desc = this.d9a_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_56().w8r_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.f9a_1);
        tmp1_output.a15(tmp0_desc, 1, value.g9a_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.e9a(encoder, value instanceof MessageReply() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.d9a_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_56().w8r_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return MessageReply().h9a(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.d9a_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_56().w8r_1[0].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_39 = $;
  }
  return $serializerClass_39;
}
var $serializer_instance_39;
function $serializer_getInstance_55() {
  if ($serializer_instance_39 === VOID)
    new ($serializer_39())();
  return $serializer_instance_39;
}
var MessageReplyClass;
function MessageReply() {
  if (MessageReplyClass === VOID) {
    class $ {
      static i9a(id, message) {
        Companion_getInstance_56();
        var $this = createThis(this);
        $this.f9a_1 = id;
        $this.g9a_1 = message;
        return $this;
      }
      static j9a(message) {
        Companion_getInstance_56();
        return this.i9a(message.i7p_1, message.p7p_1);
      }
      toString() {
        return 'MessageReply(id=' + this.f9a_1.toString() + ', message=' + this.g9a_1 + ')';
      }
      hashCode() {
        var result = this.f9a_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.g9a_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MessageReply()))
          return false;
        if (!this.f9a_1.equals(other.f9a_1))
          return false;
        if (!(this.g9a_1 === other.g9a_1))
          return false;
        return true;
      }
      static h9a(seen0, id, message, serializationConstructorMarker) {
        Companion_getInstance_56();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_55().d9a_1);
        }
        var $this = createThis(this);
        $this.f9a_1 = id;
        $this.g9a_1 = message;
        return $this;
      }
    }
    initMetadataForClass($, 'MessageReply', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_55});
    MessageReplyClass = $;
  }
  return MessageReplyClass;
}
function PayAppMessageReference$Companion$$childSerializers$_anonymous__eql5t9() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_43;
function Companion_43() {
  if (CompanionClass_43 === VOID) {
    class $ {
      constructor() {
        Companion_instance_45 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.y8r_1 = [lazy(tmp_0, PayAppMessageReference$Companion$$childSerializers$_anonymous__eql5t9), null];
      }
      m2a() {
        return $serializer_getInstance_56();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_43 = $;
  }
  return CompanionClass_43;
}
var Companion_instance_45;
function Companion_getInstance_57() {
  if (Companion_instance_45 === VOID)
    new (Companion_43())();
  return Companion_instance_45;
}
var $serializerClass_40;
function $serializer_40() {
  if ($serializerClass_40 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_40 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PayAppMessageReference', this, 2);
        tmp0_serialDesc.c1b('id', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(PayApplication())));
        tmp0_serialDesc.c1b('reason', false);
        this.k9a_1 = tmp0_serialDesc;
      }
      l9a(encoder, value) {
        var tmp0_desc = this.k9a_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_57().y8r_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.m9a_1);
        tmp1_output.a15(tmp0_desc, 1, value.n9a_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.l9a(encoder, value instanceof PayAppMessageReference() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k9a_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_57().y8r_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return PayAppMessageReference().o9a(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.k9a_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_57().y8r_1[0].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_40 = $;
  }
  return $serializerClass_40;
}
var $serializer_instance_40;
function $serializer_getInstance_56() {
  if ($serializer_instance_40 === VOID)
    new ($serializer_40())();
  return $serializer_instance_40;
}
var PayAppMessageReferenceClass;
function PayAppMessageReference() {
  if (PayAppMessageReferenceClass === VOID) {
    class $ {
      toString() {
        return 'PayAppMessageReference(id=' + this.m9a_1.toString() + ', reason=' + this.n9a_1 + ')';
      }
      hashCode() {
        var result = this.m9a_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.n9a_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PayAppMessageReference()))
          return false;
        if (!this.m9a_1.equals(other.m9a_1))
          return false;
        if (!(this.n9a_1 === other.n9a_1))
          return false;
        return true;
      }
      static o9a(seen0, id, reason, serializationConstructorMarker) {
        Companion_getInstance_57();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_56().k9a_1);
        }
        var $this = createThis(this);
        $this.m9a_1 = id;
        $this.n9a_1 = reason;
        return $this;
      }
    }
    initMetadataForClass($, 'PayAppMessageReference', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_56});
    PayAppMessageReferenceClass = $;
  }
  return PayAppMessageReferenceClass;
}
function ChangeRequestMessageReference$Companion$$childSerializers$_anonymous__9zm4qv() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_44;
function Companion_44() {
  if (CompanionClass_44 === VOID) {
    class $ {
      constructor() {
        Companion_instance_46 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.x8r_1 = [lazy(tmp_0, ChangeRequestMessageReference$Companion$$childSerializers$_anonymous__9zm4qv), null];
      }
      m2a() {
        return $serializer_getInstance_57();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_44 = $;
  }
  return CompanionClass_44;
}
var Companion_instance_46;
function Companion_getInstance_58() {
  if (Companion_instance_46 === VOID)
    new (Companion_44())();
  return Companion_instance_46;
}
var $serializerClass_41;
function $serializer_41() {
  if ($serializerClass_41 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_41 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ChangeRequestMessageReference', this, 2);
        tmp0_serialDesc.c1b('id', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(ChangeRequest())));
        tmp0_serialDesc.c1b('reason', false);
        this.p9a_1 = tmp0_serialDesc;
      }
      q9a(encoder, value) {
        var tmp0_desc = this.p9a_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_58().x8r_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.r9a_1);
        tmp1_output.a15(tmp0_desc, 1, value.s9a_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.q9a(encoder, value instanceof ChangeRequestMessageReference() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.p9a_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_58().x8r_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return ChangeRequestMessageReference().t9a(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.p9a_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_58().x8r_1[0].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_41 = $;
  }
  return $serializerClass_41;
}
var $serializer_instance_41;
function $serializer_getInstance_57() {
  if ($serializer_instance_41 === VOID)
    new ($serializer_41())();
  return $serializer_instance_41;
}
var ChangeRequestMessageReferenceClass;
function ChangeRequestMessageReference() {
  if (ChangeRequestMessageReferenceClass === VOID) {
    class $ {
      toString() {
        return 'ChangeRequestMessageReference(id=' + this.r9a_1.toString() + ', reason=' + this.s9a_1 + ')';
      }
      hashCode() {
        var result = this.r9a_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.s9a_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ChangeRequestMessageReference()))
          return false;
        if (!this.r9a_1.equals(other.r9a_1))
          return false;
        if (!(this.s9a_1 === other.s9a_1))
          return false;
        return true;
      }
      static t9a(seen0, id, reason, serializationConstructorMarker) {
        Companion_getInstance_58();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_57().p9a_1);
        }
        var $this = createThis(this);
        $this.r9a_1 = id;
        $this.s9a_1 = reason;
        return $this;
      }
    }
    initMetadataForClass($, 'ChangeRequestMessageReference', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_57});
    ChangeRequestMessageReferenceClass = $;
  }
  return ChangeRequestMessageReferenceClass;
}
function _ShortId___init__impl__tlblaa(raw) {
  return raw;
}
function _ShortId___get_raw__impl__8lcwip($this) {
  return $this;
}
function ShortId__compareTo_impl_18ek8s($this, other) {
  return compareTo_0(_ShortId___get_raw__impl__8lcwip($this), _ShortId___get_raw__impl__8lcwip(other));
}
function ShortId__compareTo_impl_18ek8s_0($this, other) {
  return ShortId__compareTo_impl_18ek8s($this.n5n_1, other instanceof ShortId() ? other.n5n_1 : THROW_CCE());
}
function ShortId__toString_impl_wslzee($this) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = toString_1(_ShortId___get_raw__impl__8lcwip($this), 16).toUpperCase();
  return padStart(tmp$ret$1, 4, _Char___init__impl__6a9atx(48));
}
var CompanionClass_45;
function Companion_45() {
  if (CompanionClass_45 === VOID) {
    class $ {
      k5n() {
        return _ShortId___init__impl__tlblaa(Default_getInstance().br(0, 65535));
      }
      m2a() {
        return $serializer_getInstance_58();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_45 = $;
  }
  return CompanionClass_45;
}
var Companion_instance_47;
function Companion_getInstance_59() {
  return Companion_instance_47;
}
var $serializerClass_42;
function $serializer_42() {
  if ($serializerClass_42 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_42 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.crowpay.ShortId', this);
        tmp0_serialDesc.c1b('raw', false);
        this.u9a_1 = tmp0_serialDesc;
      }
      v9a(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.u9a_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.k14(_ShortId___get_raw__impl__8lcwip(value));
        }
      }
      oz(encoder, value) {
        return this.v9a(encoder, value instanceof ShortId() ? value.n5n_1 : THROW_CCE());
      }
      w9a(decoder) {
        return _ShortId___init__impl__tlblaa(decoder.j13(this.u9a_1).c13());
      }
      pz(decoder) {
        return new (ShortId())(this.w9a(decoder));
      }
      az() {
        return this.u9a_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_42 = $;
  }
  return $serializerClass_42;
}
var $serializer_instance_42;
function $serializer_getInstance_58() {
  if ($serializer_instance_42 === VOID)
    new ($serializer_42())();
  return $serializer_instance_42;
}
function ShortId__hashCode_impl_ghc5rv($this) {
  return $this;
}
function ShortId__equals_impl_1l2c0n($this, other) {
  if (!(other instanceof ShortId()))
    return false;
  if (!($this === other.n5n_1))
    return false;
  return true;
}
var ShortIdClass;
function ShortId() {
  if (ShortIdClass === VOID) {
    class $ {
      constructor(raw) {
        this.n5n_1 = raw;
      }
      x9a(other) {
        return ShortId__compareTo_impl_18ek8s(this.n5n_1, other);
      }
      d(other) {
        return ShortId__compareTo_impl_18ek8s_0(this, other);
      }
      toString() {
        return ShortId__toString_impl_wslzee(this.n5n_1);
      }
      hashCode() {
        return ShortId__hashCode_impl_ghc5rv(this.n5n_1);
      }
      equals(other) {
        return ShortId__equals_impl_1l2c0n(this.n5n_1, other);
      }
    }
    initMetadataForClass($, 'ShortId', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_58});
    ShortIdClass = $;
  }
  return ShortIdClass;
}
function Owner$Companion$$childSerializers$_anonymous__2fi79l() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Owner$Companion$$childSerializers$_anonymous__2fi79l_0() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
var CompanionClass_46;
function Companion_46() {
  if (CompanionClass_46 === VOID) {
    class $ {
      constructor() {
        Companion_instance_48 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Owner$Companion$$childSerializers$_anonymous__2fi79l);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.n6s_1 = [tmp_1, null, null, null, null, null, null, null, null, null, null, lazy(tmp_2, Owner$Companion$$childSerializers$_anonymous__2fi79l_0)];
      }
      m2a() {
        return $serializer_getInstance_59();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_46 = $;
  }
  return CompanionClass_46;
}
var Companion_instance_48;
function Companion_getInstance_60() {
  if (Companion_instance_48 === VOID)
    new (Companion_46())();
  return Companion_instance_48;
}
var $serializerClass_43;
function $serializer_43() {
  if ($serializerClass_43 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_43 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Owner', this, 12);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('legalFirstName', false);
        tmp0_serialDesc.c1b('legalLastName', false);
        tmp0_serialDesc.c1b('email', false);
        tmp0_serialDesc.c1b('phoneNumber', false);
        tmp0_serialDesc.c1b('address', false);
        tmp0_serialDesc.c1b('title', true);
        tmp0_serialDesc.c1b('ssn', true);
        tmp0_serialDesc.c1b('ssnDisplay', true);
        tmp0_serialDesc.c1b('ownership', true);
        tmp0_serialDesc.c1b('birthDate', true);
        tmp0_serialDesc.c1b('document', true);
        this.y9a_1 = tmp0_serialDesc;
      }
      z9a(encoder, value) {
        var tmp0_desc = this.y9a_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_60().n6s_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.u6s_1.equals(Companion_getInstance().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.u6s_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.v6s_1);
        tmp1_output.a15(tmp0_desc, 2, value.w6s_1);
        tmp1_output.c15(tmp0_desc, 3, EmailAddressSerializer_getInstance(), new (EmailAddress())(value.x6s_1));
        tmp1_output.c15(tmp0_desc, 4, PhoneNumberSerializer_getInstance(), new (PhoneNumber())(value.y6s_1));
        tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_5(), value.z6s_1);
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.a6t_1 === '')) {
          tmp1_output.a15(tmp0_desc, 6, value.a6t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.b6t_1 === '')) {
          tmp1_output.a15(tmp0_desc, 7, value.b6t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.c6t_1 === '')) {
          tmp1_output.a15(tmp0_desc, 8, value.c6t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.d6t_1 === 100)) {
          tmp1_output.v14(tmp0_desc, 9, value.d6t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.e6t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, LocalDateIso8601Serializer_getInstance(), value.e6t_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 11)) {
          tmp = true;
        } else {
          var tmp_0 = value.f6t_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = tmp2_cached[11].f2();
          var tmp_2 = value.f6t_1;
          tmp1_output.d15(tmp0_desc, 11, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.z9a(encoder, value instanceof Owner() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.y9a_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = 0;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_input = decoder.l13(tmp0_desc);
        var tmp17_cached = Companion_getInstance_60().n6s_1;
        if (tmp16_input.a14()) {
          tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp16_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp16_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp = EmailAddressSerializer_getInstance();
          var tmp_0 = tmp7_local3;
          var tmp_1 = tmp16_input.x13(tmp0_desc, 3, tmp, tmp_0 == null ? null : new (EmailAddress())(tmp_0));
          tmp7_local3 = tmp_1 == null ? null : tmp_1.c3n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_2 = PhoneNumberSerializer_getInstance();
          var tmp_3 = tmp8_local4;
          var tmp_4 = tmp16_input.x13(tmp0_desc, 4, tmp_2, tmp_3 == null ? null : new (PhoneNumber())(tmp_3));
          tmp8_local4 = tmp_4 == null ? null : tmp_4.h3n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp16_input.x13(tmp0_desc, 5, $serializer_getInstance_5(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp16_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp16_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp16_input.v13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp16_input.q13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp16_input.z13(tmp0_desc, 10, LocalDateIso8601Serializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          var tmp_5 = tmp17_cached[11].f2();
          var tmp_6 = tmp15_local11;
          var tmp_7 = tmp16_input.z13(tmp0_desc, 11, tmp_5, tmp_6 == null ? null : new (ServerFile())(tmp_6));
          tmp15_local11 = tmp_7 == null ? null : tmp_7.n2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp16_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp16_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp16_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_8 = EmailAddressSerializer_getInstance();
                var tmp_9 = tmp7_local3;
                var tmp_10 = tmp16_input.x13(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new (EmailAddress())(tmp_9));
                tmp7_local3 = tmp_10 == null ? null : tmp_10.c3n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_11 = PhoneNumberSerializer_getInstance();
                var tmp_12 = tmp8_local4;
                var tmp_13 = tmp16_input.x13(tmp0_desc, 4, tmp_11, tmp_12 == null ? null : new (PhoneNumber())(tmp_12));
                tmp8_local4 = tmp_13 == null ? null : tmp_13.h3n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp16_input.x13(tmp0_desc, 5, $serializer_getInstance_5(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp16_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp16_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp16_input.v13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp16_input.q13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp16_input.z13(tmp0_desc, 10, LocalDateIso8601Serializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                var tmp_14 = tmp17_cached[11].f2();
                var tmp_15 = tmp15_local11;
                var tmp_16 = tmp16_input.z13(tmp0_desc, 11, tmp_14, tmp_15 == null ? null : new (ServerFile())(tmp_15));
                tmp15_local11 = tmp_16 == null ? null : tmp_16.n2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp16_input.m13(tmp0_desc);
        return Owner().a9b(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
      }
      az() {
        return this.y9a_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_60().n6s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), EmailAddressSerializer_getInstance(), PhoneNumberSerializer_getInstance(), $serializer_getInstance_5(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(LocalDateIso8601Serializer_getInstance()), get_nullable(tmp0_cached[11].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_43 = $;
  }
  return $serializerClass_43;
}
var $serializer_instance_43;
function $serializer_getInstance_59() {
  if ($serializer_instance_43 === VOID)
    new ($serializer_43())();
  return $serializer_instance_43;
}
var OwnerClass;
function Owner() {
  if (OwnerClass === VOID) {
    class $ {
      constructor(_id, legalFirstName, legalLastName, email, phoneNumber, address, title, ssn, ssnDisplay, ownership, birthDate, document) {
        Companion_getInstance_60();
        _id = _id === VOID ? Companion_getInstance().m2p() : _id;
        title = title === VOID ? '' : title;
        ssn = ssn === VOID ? '' : ssn;
        ssnDisplay = ssnDisplay === VOID ? '' : ssnDisplay;
        ownership = ownership === VOID ? 100 : ownership;
        birthDate = birthDate === VOID ? null : birthDate;
        document = document === VOID ? null : document;
        this.u6s_1 = _id;
        this.v6s_1 = legalFirstName;
        this.w6s_1 = legalLastName;
        this.x6s_1 = email;
        this.y6s_1 = phoneNumber;
        this.z6s_1 = address;
        this.a6t_1 = title;
        this.b6t_1 = ssn;
        this.c6t_1 = ssnDisplay;
        this.d6t_1 = ownership;
        this.e6t_1 = birthDate;
        this.f6t_1 = document;
      }
      h40() {
        return this.u6s_1;
      }
      b9b(_id, legalFirstName, legalLastName, email, phoneNumber, address, title, ssn, ssnDisplay, ownership, birthDate, document) {
        return new (Owner())(_id, legalFirstName, legalLastName, email, phoneNumber, address, title, ssn, ssnDisplay, ownership, birthDate, document);
      }
      h6t(_id, legalFirstName, legalLastName, email, phoneNumber, address, title, ssn, ssnDisplay, ownership, birthDate, document, $super) {
        _id = _id === VOID ? this.u6s_1 : _id;
        legalFirstName = legalFirstName === VOID ? this.v6s_1 : legalFirstName;
        legalLastName = legalLastName === VOID ? this.w6s_1 : legalLastName;
        email = email === VOID ? this.x6s_1 : email;
        phoneNumber = phoneNumber === VOID ? this.y6s_1 : phoneNumber;
        address = address === VOID ? this.z6s_1 : address;
        title = title === VOID ? this.a6t_1 : title;
        ssn = ssn === VOID ? this.b6t_1 : ssn;
        ssnDisplay = ssnDisplay === VOID ? this.c6t_1 : ssnDisplay;
        ownership = ownership === VOID ? this.d6t_1 : ownership;
        birthDate = birthDate === VOID ? this.e6t_1 : birthDate;
        document = document === VOID ? this.f6t_1 : document;
        var tmp;
        if ($super === VOID) {
          tmp = this.b9b(_id, legalFirstName, legalLastName, email, phoneNumber, address, title, ssn, ssnDisplay, ownership, birthDate, document);
        } else {
          var tmp_0 = $super.b9b;
          var tmp_1 = document;
          tmp = tmp_0.call(this, _id, legalFirstName, legalLastName, new (EmailAddress())(email), new (PhoneNumber())(phoneNumber), address, title, ssn, ssnDisplay, ownership, birthDate, tmp_1 == null ? null : new (ServerFile())(tmp_1));
        }
        return tmp;
      }
      toString() {
        var tmp = this.u6s_1.toString();
        var tmp_0 = EmailAddress__toString_impl_artjh3(this.x6s_1);
        var tmp_1 = PhoneNumber__toString_impl_7i2x3q(this.y6s_1);
        var tmp_2 = this.z6s_1.toString();
        var tmp_3 = toString_0(this.e6t_1);
        var tmp_4 = this.f6t_1;
        return 'Owner(_id=' + tmp + ', legalFirstName=' + this.v6s_1 + ', legalLastName=' + this.w6s_1 + ', email=' + tmp_0 + ', phoneNumber=' + tmp_1 + ', address=' + tmp_2 + ', title=' + this.a6t_1 + ', ssn=' + this.b6t_1 + ', ssnDisplay=' + this.c6t_1 + ', ownership=' + this.d6t_1 + ', birthDate=' + tmp_3 + ', document=' + toString_0(tmp_4 == null ? null : new (ServerFile())(tmp_4)) + ')';
      }
      hashCode() {
        var result = this.u6s_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.v6s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w6s_1) | 0;
        result = imul(result, 31) + EmailAddress__hashCode_impl_wizg9y(this.x6s_1) | 0;
        result = imul(result, 31) + PhoneNumber__hashCode_impl_t98twl(this.y6s_1) | 0;
        result = imul(result, 31) + this.z6s_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.a6t_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b6t_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.c6t_1) | 0;
        result = imul(result, 31) + this.d6t_1 | 0;
        result = imul(result, 31) + (this.e6t_1 == null ? 0 : this.e6t_1.hashCode()) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.f6t_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.f6t_1);
        }
        result = tmp + tmp_0 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Owner()))
          return false;
        if (!this.u6s_1.equals(other.u6s_1))
          return false;
        if (!(this.v6s_1 === other.v6s_1))
          return false;
        if (!(this.w6s_1 === other.w6s_1))
          return false;
        if (!(this.x6s_1 === other.x6s_1))
          return false;
        if (!(this.y6s_1 === other.y6s_1))
          return false;
        if (!this.z6s_1.equals(other.z6s_1))
          return false;
        if (!(this.a6t_1 === other.a6t_1))
          return false;
        if (!(this.b6t_1 === other.b6t_1))
          return false;
        if (!(this.c6t_1 === other.c6t_1))
          return false;
        if (!(this.d6t_1 === other.d6t_1))
          return false;
        if (!equals(this.e6t_1, other.e6t_1))
          return false;
        var tmp = this.f6t_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.f6t_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        return true;
      }
      static a9b(seen0, _id, legalFirstName, legalLastName, email, phoneNumber, address, title, ssn, ssnDisplay, ownership, birthDate, document, serializationConstructorMarker) {
        Companion_getInstance_60();
        if (!(62 === (62 & seen0))) {
          throwMissingFieldException(seen0, 62, $serializer_getInstance_59().y9a_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.u6s_1 = Companion_getInstance().m2p();
        else
          $this.u6s_1 = _id;
        $this.v6s_1 = legalFirstName;
        $this.w6s_1 = legalLastName;
        $this.x6s_1 = email;
        $this.y6s_1 = phoneNumber;
        $this.z6s_1 = address;
        if (0 === (seen0 & 64))
          $this.a6t_1 = '';
        else
          $this.a6t_1 = title;
        if (0 === (seen0 & 128))
          $this.b6t_1 = '';
        else
          $this.b6t_1 = ssn;
        if (0 === (seen0 & 256))
          $this.c6t_1 = '';
        else
          $this.c6t_1 = ssnDisplay;
        if (0 === (seen0 & 512))
          $this.d6t_1 = 100;
        else
          $this.d6t_1 = ownership;
        if (0 === (seen0 & 1024))
          $this.e6t_1 = null;
        else
          $this.e6t_1 = birthDate;
        if (0 === (seen0 & 2048))
          $this.f6t_1 = null;
        else
          $this.f6t_1 = document;
        return $this;
      }
    }
    initMetadataForClass($, 'Owner', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_59});
    OwnerClass = $;
  }
  return OwnerClass;
}
function DisputeState_Ongoing_getInstance() {
  DisputeState_initEntries();
  return DisputeState_Ongoing_instance;
}
function DisputeState_ProjectLocked_getInstance() {
  DisputeState_initEntries();
  return DisputeState_ProjectLocked_instance;
}
function DisputeState_Resolved_getInstance() {
  DisputeState_initEntries();
  return DisputeState_Resolved_instance;
}
//region block: init
Companion_instance_12 = new (Companion_10())();
Companion_instance_21 = new (Companion_19())();
Companion_instance_29 = new (Companion_27())();
Companion_instance_40 = new (Companion_38())();
Companion_instance_47 = new (Companion_45())();
//endregion
//region block: exports
export {
  ApprovedState as ApprovedState3hrsq7yllchx0,
  ChangeRequestMessageReference as ChangeRequestMessageReference3iran64qsoyry,
  ChangeRequest as ChangeRequesthd3ysa2j1i4f,
  Client as Clientuccelyr89ch8,
  CompletionMessageComment as CompletionMessageComment2phagw82v6lch,
  Purpose as Purpose22kmyfd0ayrve,
  ContractorDocument as ContractorDocument2jcw9hqg98amj,
  ContractorNote as ContractorNote59o6kpmrrw5h,
  Contractor as Contractor1wog4uk4l8u77,
  get_entries as get_entries19ryowjr3zlbs,
  Type as Typeqwc7utefu20x,
  CrowPayLegalDocument as CrowPayLegalDocumentvhqnf9xycsrg,
  DisputeState as DisputeState3oxdvb7g0kfjm,
  Dispute as Dispute39kejofcwuxch,
  EntityType as EntityType3jq9a4zvbs0nt,
  FundsRequest as FundsRequesthksopls9wk01,
  IncidentMessageComment as IncidentMessageComment1adwwkgdgyo0h,
  IncidentMessage as IncidentMessage1zg9aeg4hgwtu,
  Incident as Incident3aojs8cp7629c,
  ItemChange as ItemChangee3c665suy3yz,
  LegalDocumentAgreement as LegalDocumentAgreement2jq7u4nlw18u,
  License as License2dabzwgw7jcr2,
  LineItemCompletionMessage as LineItemCompletionMessage2zpi6q6jke1no,
  LineItem as LineItem2rt64afaiyloc,
  ConfirmedShipped as ConfirmedShippedhfotfv6hc5c1,
  Request as Request3h9l52knfhl5u,
  MailCheckPhysically as MailCheckPhysicallytriaqfbh0a67,
  MessageReply as MessageReply3razfyxlh5p4t,
  Owner as Owner3o3y53m8go5cb,
  PayAppItem as PayAppItemz8p3l02jgtr9,
  PayAppMessageReference as PayAppMessageReference2hrqvwim22vlh,
  PayApplication as PayApplicationmbkdcq3ut87x,
  Payout as Payout257apsotr6b9a,
  PendingItemChange as PendingItemChange1hwhwykx2kyit,
  PendingLineItem as PendingLineItem7uj25viy3ie8,
  LockInfo as LockInfo3qyh26jodrlpf,
  get_entries_0 as get_entries5hqvt5541yea,
  Type_0 as Typere4zxecw7uiw,
  ExternalDeposit as ExternalDepositoswk9ddf49t2,
  ProjectLedgerItem as ProjectLedgerItem1yul4cns1huli,
  ProjectMessage as ProjectMessage3vmbacgk5u7x3,
  ProjectSettlementDocumentation as ProjectSettlementDocumentation1o22wkmr8w8uo,
  ProjectTimer as ProjectTimerh0tihs6u35t6,
  Project as Projecto73xqbcrzskm,
  PunchListItem as PunchListItem1wbu5dz9rlo4k,
  ScopeView as ScopeView2pjeasrtqdymw,
  ShortId as ShortId1uz90q3uk7eoq,
  Specification as Specification3fgfbf7ihgj8v,
  Trade as Trade15v4llu79udze,
  UnlockProjectRequest as UnlockProjectRequestsb9zq5gbmeux,
  User as User8yb1tqk4kykg,
  Purpose_ArticleOfIncorporation_getInstance as Purpose_ArticleOfIncorporation_getInstance1fuetuxvqqp0v,
  Purpose_Other_getInstance as Purpose_Other_getInstancerlegdjt2kagb,
  Purpose_ProofOfEin_getInstance as Purpose_ProofOfEin_getInstance3u5kmocn55tdt,
  Type_PrivacyPolicy_getInstance as Type_PrivacyPolicy_getInstanceywyaqmy6sd2,
  Type_TermsAndConditions_getInstance as Type_TermsAndConditions_getInstance2t1zfiphym43,
  DisputeState_Ongoing_getInstance as DisputeState_Ongoing_getInstance2zn99spsjy3fz,
  Type_Check_getInstance as Type_Check_getInstance2g1thuyr3vd4k,
  _ShortId___init__impl__tlblaa as _ShortId___init__impl__tlblaa141394eujsnz4,
  ShortId__toString_impl_wslzee as ShortId__toString_impl_wslzee3f3nb044hwkm0,
  Companion_getInstance_16 as Companion_getInstance3bisd6gjnm0oz,
  Companion_getInstance_17 as Companion_getInstance307sotgyzbnou,
  Companion_getInstance_58 as Companion_getInstancese711cjybj43,
  $serializer_getInstance_19 as $serializer_getInstance2hd22g62jocd3,
  Companion_getInstance_18 as Companion_getInstance124t3fbljdbyi,
  Companion_getInstance_19 as Companion_getInstance1z8if8hzu5ng5,
  $serializer_getInstance_21 as $serializer_getInstance2yxo5k0co7dg6,
  Companion_getInstance_20 as Companion_getInstance1b21bhtdgqkve,
  Companion_getInstance_21 as Companion_getInstance3r9dph6rgwho0,
  Companion_getInstance_22 as Companion_getInstance12ven2xbljkm0,
  Companion_getInstance_14 as Companion_getInstancefq4vwlyjorqo,
  Companion_getInstance_13 as Companion_getInstance2uur5hs3fk4e5,
  Companion_getInstance_23 as Companion_getInstanceh1cmko92158x,
  Companion_getInstance_55 as Companion_getInstance2yrqgx0jqnq3c,
  Companion_instance_12 as Companion_instancevwupp4fz0ehs,
  Companion_getInstance_25 as Companion_getInstancexfdqyjk2ykmw,
  Companion_getInstance_26 as Companion_getInstance12sgbyys5mml7,
  Companion_getInstance_27 as Companion_getInstancezuwazqbeik8p,
  Companion_getInstance_28 as Companion_getInstance1up45os1rj3ws,
  Companion_getInstance_29 as Companion_getInstance20myouriyv3u,
  Companion_getInstance_30 as Companion_getInstance1t0noik4ocb5x,
  Companion_getInstance_31 as Companion_getInstancee6k6ib2dkotb,
  $serializer_getInstance_16 as $serializer_getInstancer4f83meamevp,
  Companion_getInstance_15 as Companion_getInstancex3rnna8pnr6f,
  Companion_getInstance_32 as Companion_getInstance1moufct3sbct9,
  Companion_getInstance_35 as Companion_getInstance19tkudxb52ql0,
  Companion_getInstance_34 as Companion_getInstance1mn08iy8k7084,
  Companion_instance_21 as Companion_instance3cy7oygvo3vp5,
  Companion_getInstance_56 as Companion_getInstance20w8n5s732u9i,
  Companion_getInstance_60 as Companion_getInstance14au1t142dbyp,
  Companion_getInstance_36 as Companion_getInstance28gwov6pby7lz,
  Companion_getInstance_57 as Companion_getInstance1852qti57cam2,
  Companion_getInstance_37 as Companion_getInstance1h9pz6hxur4uj,
  Companion_getInstance_38 as Companion_getInstance39he8wfhznx8z,
  Companion_getInstance_39 as Companion_getInstance30idiynnpnbn2,
  Companion_getInstance_40 as Companion_getInstance14mfei2uzw3x6,
  $serializer_getInstance_43 as $serializer_getInstance28bv3p4ron8x8,
  Companion_getInstance_42 as Companion_getInstance1cdih9ztewhpv,
  Companion_instance_29 as Companion_instance1x10wxdaspp9d,
  Companion_getInstance_45 as Companion_getInstance2m617r7l2yg9j,
  Companion_getInstance_44 as Companion_getInstance3g7lwy1meor8x,
  Companion_getInstance_46 as Companion_getInstance1cc7a4v9g7e6l,
  Companion_getInstance_47 as Companion_getInstance3ar1by5trsbn7,
  Companion_getInstance_48 as Companion_getInstance3lubwpz5lc00p,
  Companion_getInstance_49 as Companion_getInstance2eaghgpohvp5v,
  $serializer_getInstance_50 as $serializer_getInstance3sf4q4nbunlsv,
  Companion_getInstance_50 as Companion_getInstanceha7z78i7nvow,
  Companion_instance_47 as Companion_instance3eje2t5q7hpt,
  Companion_getInstance_51 as Companion_getInstance11rxtahezlto7,
  Companion_instance_40 as Companion_instance2x6o1nijtl11,
  Companion_getInstance_53 as Companion_getInstance241hfcdeiz4z5,
  $serializer_getInstance_54 as $serializer_getInstance1vmv5e6k1823y,
  Companion_getInstance_54 as Companion_getInstance21u335vgn0mpe,
};
//endregion

//# sourceMappingURL=databaseModels.mjs.map
